/*! shopify_app_compiler 2026-02-10 */
var requirejs, require, define;

!function(global, setTimeout) {
    var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.3.6", commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm, cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/, currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty, isBrowser = !("undefined" == typeof window || "undefined" == typeof navigator || !window.document), isWebWorker = !isBrowser && "undefined" != typeof importScripts, readyRegExp = isBrowser && "PLAYSTATION 3" === navigator.platform ? /^complete$/ : /^(complete|loaded)$/, defContextName = "_", isOpera = "undefined" != typeof opera && "[object Opera]" === opera.toString(), contexts = {}, cfg = {}, globalDefQueue = [], useInteractive = !1;
    function commentReplace(e, t) {
        return t || "";
    }
    function isFunction(e) {
        return "[object Function]" === ostring.call(e);
    }
    function isArray(e) {
        return "[object Array]" === ostring.call(e);
    }
    function each(e, t) {
        var i;
        if (e) for (i = 0; i < e.length && (!e[i] || !t(e[i], i, e)); i += 1);
    }
    function eachReverse(e, t) {
        var i;
        if (e) for (i = e.length - 1; -1 < i && (!e[i] || !t(e[i], i, e)); i -= 1);
    }
    function hasProp(e, t) {
        return hasOwn.call(e, t);
    }
    function getOwn(e, t) {
        return hasProp(e, t) && e[t];
    }
    function eachProp(e, t) {
        var i;
        for (i in e) if (hasProp(e, i) && t(e[i], i)) break;
    }
    function mixin(i, e, r, n) {
        return e && eachProp(e, function(e, t) {
            !r && hasProp(i, t) || (!n || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? i[t] = e : (i[t] || (i[t] = {}), 
            mixin(i[t], e, r, n)));
        }), i;
    }
    function bind(e, t) {
        return function() {
            return t.apply(e, arguments);
        };
    }
    function scripts() {
        return document.getElementsByTagName("script");
    }
    function defaultOnError(e) {
        throw e;
    }
    function getGlobal(e) {
        if (!e) return e;
        var t = global;
        return each(e.split("."), function(e) {
            t = t[e];
        }), t;
    }
    function makeError(e, t, i, r) {
        var n = new Error(t + "\nhttps://requirejs.org/docs/errors.html#" + e);
        return n.requireType = e, n.requireModules = r, i && (n.originalError = i), 
        n;
    }
    if (void 0 === define) {
        if (void 0 !== requirejs) {
            if (isFunction(requirejs)) return;
            cfg = requirejs, requirejs = void 0;
        }
        void 0 === require || isFunction(require) || (cfg = require, require = void 0), 
        req = requirejs = function(e, t, i, r) {
            var n, o, a = defContextName;
            return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, 
            t = i, i = r) : e = []), o && o.context && (a = o.context), (n = getOwn(contexts, a)) || (n = contexts[a] = req.s.newContext(a)), 
            o && n.configure(o), n.require(e, t, i);
        }, req.config = function(e) {
            return req(e);
        }, req.nextTick = void 0 !== setTimeout ? function(e) {
            setTimeout(e, 4);
        } : function(e) {
            e();
        }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, 
        req.isBrowser = isBrowser, s = req.s = {
            contexts: contexts,
            newContext: newContext
        }, req({}), each([ "toUrl", "undef", "defined", "specified" ], function(t) {
            req[t] = function() {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments);
            };
        }), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], 
        baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), 
        req.onError = defaultOnError, req.createNode = function(e, t, i) {
            var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
            return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", 
            r.async = !0, r;
        }, req.load = function(t, i, r) {
            var e, n = t && t.config || {};
            if (isBrowser) return (e = req.createNode(n, i, r)).setAttribute("data-requirecontext", t.contextName), 
            e.setAttribute("data-requiremodule", i), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf("[native code") < 0 || isOpera ? (e.addEventListener("load", t.onScriptLoad, !1), 
            e.addEventListener("error", t.onScriptError, !1)) : (useInteractive = !0, 
            e.attachEvent("onreadystatechange", t.onScriptLoad)), e.src = r, n.onNodeCreated && n.onNodeCreated(e, n, i, r), 
            currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), 
            currentlyAddingScript = null, e;
            if (isWebWorker) try {
                setTimeout(function() {}, 0), importScripts(r), t.completeLoad(i);
            } catch (e) {
                t.onError(makeError("importscripts", "importScripts failed for " + i + " at " + r, e, [ i ]));
            }
        }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function(e) {
            if (head || (head = e.parentNode), dataMain = e.getAttribute("data-main")) return mainScript = dataMain, 
            cfg.baseUrl || -1 !== mainScript.indexOf("!") || (mainScript = (src = mainScript.split("/")).pop(), 
            subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), 
            mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), 
            cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [ mainScript ], 
            !0;
        }), define = function(e, i, t) {
            var r, n;
            "string" != typeof e && (t = i, i = e, e = null), isArray(i) || (t = i, 
            i = null), !i && isFunction(t) && (i = [], t.length && (t.toString().replace(commentRegExp, commentReplace).replace(cjsRequireRegExp, function(e, t) {
                i.push(t);
            }), i = (1 === t.length ? [ "require" ] : [ "require", "exports", "module" ]).concat(i))), 
            useInteractive && (r = currentlyAddingScript || getInteractiveScript()) && (e || (e = r.getAttribute("data-requiremodule")), 
            n = contexts[r.getAttribute("data-requirecontext")]), n ? (n.defQueue.push([ e, i, t ]), 
            n.defQueueMap[e] = !0) : globalDefQueue.push([ e, i, t ]);
        }, define.amd = {
            jQuery: !0
        }, req.exec = function(text) {
            return eval(text);
        }, req(cfg);
    }
    function newContext(u) {
        var i, e, l, c, d, g = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {}
        }, p = {}, f = {}, r = {}, h = [], m = {}, n = {}, v = {}, x = 1, b = 1;
        function q(e, t, i) {
            var r, n, o, a, s, u, c, d, p, f, l = t && t.split("/"), h = g.map, m = h && h["*"];
            if (e && (u = (e = e.split("/")).length - 1, g.nodeIdCompat && jsSuffixRegExp.test(e[u]) && (e[u] = e[u].replace(jsSuffixRegExp, "")), 
            "." === e[0].charAt(0) && l && (e = l.slice(0, l.length - 1).concat(e)), 
            function(e) {
                var t, i;
                for (t = 0; t < e.length; t++) if ("." === (i = e[t])) e.splice(t, 1), 
                t -= 1; else if (".." === i) {
                    if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                    0 < t && (e.splice(t - 1, 2), t -= 2);
                }
            }(e), e = e.join("/")), i && h && (l || m)) {
                e: for (o = (n = e.split("/")).length; 0 < o; o -= 1) {
                    if (s = n.slice(0, o).join("/"), l) for (a = l.length; 0 < a; a -= 1) if ((r = getOwn(h, l.slice(0, a).join("/"))) && (r = getOwn(r, s))) {
                        c = r, d = o;
                        break e;
                    }
                    !p && m && getOwn(m, s) && (p = getOwn(m, s), f = o);
                }
                !c && p && (c = p, d = f), c && (n.splice(0, d, c), e = n.join("/"));
            }
            return getOwn(g.pkgs, e) || e;
        }
        function E(t) {
            isBrowser && each(scripts(), function(e) {
                if (e.getAttribute("data-requiremodule") === t && e.getAttribute("data-requirecontext") === l.contextName) return e.parentNode.removeChild(e), 
                !0;
            });
        }
        function w(e) {
            var t = getOwn(g.paths, e);
            if (t && isArray(t) && 1 < t.length) return t.shift(), l.require.undef(e), 
            l.makeRequire(null, {
                skipMap: !0
            })([ e ]), !0;
        }
        function y(e) {
            var t, i = e ? e.indexOf("!") : -1;
            return -1 < i && (t = e.substring(0, i), e = e.substring(i + 1, e.length)), 
            [ t, e ];
        }
        function S(e, t, i, r) {
            var n, o, a, s, u = null, c = t ? t.name : null, d = e, p = !0, f = "";
            return e || (p = !1, e = "_@r" + (x += 1)), u = (s = y(e))[0], e = s[1], 
            u && (u = q(u, c, r), o = getOwn(m, u)), e && (u ? f = i ? e : o && o.normalize ? o.normalize(e, function(e) {
                return q(e, c, r);
            }) : -1 === e.indexOf("!") ? q(e, c, r) : e : (u = (s = y(f = q(e, c, r)))[0], 
            f = s[1], i = !0, n = l.nameToUrl(f))), {
                prefix: u,
                name: f,
                parentMap: t,
                unnormalized: !!(a = !u || o || i ? "" : "_unnormalized" + (b += 1)),
                url: n,
                originalName: d,
                isDefine: p,
                id: (u ? u + "!" + f : f) + a
            };
        }
        function k(e) {
            var t = e.id, i = getOwn(p, t);
            return i || (i = p[t] = new l.Module(e)), i;
        }
        function M(e, t, i) {
            var r = e.id, n = getOwn(p, r);
            !hasProp(m, r) || n && !n.defineEmitComplete ? (n = k(e)).error && "error" === t ? i(n.error) : n.on(t, i) : "defined" === t && i(m[r]);
        }
        function O(i, e) {
            var t = i.requireModules, r = !1;
            e ? e(i) : (each(t, function(e) {
                var t = getOwn(p, e);
                t && (t.error = i, t.events.error && (r = !0, t.emit("error", i)));
            }), r || req.onError(i));
        }
        function j() {
            globalDefQueue.length && (each(globalDefQueue, function(e) {
                var t = e[0];
                "string" == typeof t && (l.defQueueMap[t] = !0), h.push(e);
            }), globalDefQueue = []);
        }
        function P(e) {
            delete p[e], delete f[e];
        }
        function R() {
            var e, r, t = 1e3 * g.waitSeconds, n = t && l.startTime + t < new Date().getTime(), o = [], a = [], s = !1, u = !0;
            if (!i) {
                if (i = !0, eachProp(f, function(e) {
                    var t = e.map, i = t.id;
                    if (e.enabled && (t.isDefine || a.push(e), !e.error)) if (!e.inited && n) w(i) ? s = r = !0 : (o.push(i), 
                    E(i)); else if (!e.inited && e.fetched && t.isDefine && (s = !0, 
                    !t.prefix)) return u = !1;
                }), n && o.length) return (e = makeError("timeout", "Load timeout for modules: " + o, null, o)).contextName = l.contextName, 
                O(e);
                u && each(a, function(e) {
                    !function n(o, a, s) {
                        var e = o.map.id;
                        o.error ? o.emit("error", o.error) : (a[e] = !0, each(o.depMaps, function(e, t) {
                            var i = e.id, r = getOwn(p, i);
                            !r || o.depMatched[t] || s[i] || (getOwn(a, i) ? (o.defineDep(t, m[i]), 
                            o.check()) : n(r, a, s));
                        }), s[e] = !0);
                    }(e, {}, {});
                }), n && !r || !s || !isBrowser && !isWebWorker || d || (d = setTimeout(function() {
                    d = 0, R();
                }, 50)), i = !1;
            }
        }
        function a(e) {
            hasProp(m, e[0]) || k(S(e[0], null, !0)).init(e[1], e[2]);
        }
        function o(e, t, i, r) {
            e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(i, t, !1);
        }
        function s(e) {
            var t = e.currentTarget || e.srcElement;
            return o(t, l.onScriptLoad, "load", "onreadystatechange"), o(t, l.onScriptError, "error"), 
            {
                node: t,
                id: t && t.getAttribute("data-requiremodule")
            };
        }
        function T() {
            var e;
            for (j(); h.length; ) {
                if (null === (e = h.shift())[0]) return O(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
                a(e);
            }
            l.defQueueMap = {};
        }
        return c = {
            require: function(e) {
                return e.require ? e.require : e.require = l.makeRequire(e.map);
            },
            exports: function(e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? m[e.map.id] = e.exports : e.exports = m[e.map.id] = {};
            },
            module: function(e) {
                return e.module ? e.module : e.module = {
                    id: e.map.id,
                    uri: e.map.url,
                    config: function() {
                        return getOwn(g.config, e.map.id) || {};
                    },
                    exports: e.exports || (e.exports = {})
                };
            }
        }, (e = function(e) {
            this.events = getOwn(r, e.id) || {}, this.map = e, this.shim = getOwn(g.shim, e.id), 
            this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, 
            this.depCount = 0;
        }).prototype = {
            init: function(e, t, i, r) {
                r = r || {}, this.inited || (this.factory = t, i ? this.on("error", i) : this.events.error && (i = bind(this, function(e) {
                    this.emit("error", e);
                })), this.depMaps = e && e.slice(0), this.errback = i, this.inited = !0, 
                this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function(e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, 
                this.depExports[e] = t);
            },
            fetch: function() {
                if (!this.fetched) {
                    this.fetched = !0, l.startTime = new Date().getTime();
                    var e = this.map;
                    if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                    l.makeRequire(this.map, {
                        enableBuildCallback: !0
                    })(this.shim.deps || [], bind(this, function() {
                        return e.prefix ? this.callPlugin() : this.load();
                    }));
                }
            },
            load: function() {
                var e = this.map.url;
                n[e] || (n[e] = !0, l.load(this.map.id, e));
            },
            check: function() {
                if (this.enabled && !this.enabling) {
                    var t, e, i = this.map.id, r = this.depExports, n = this.exports, o = this.factory;
                    if (this.inited) {
                        if (this.error) this.emit("error", this.error); else if (!this.defining) {
                            if (this.defining = !0, this.depCount < 1 && !this.defined) {
                                if (isFunction(o)) {
                                    if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
                                        n = l.execCb(i, o, r, n);
                                    } catch (e) {
                                        t = e;
                                    } else n = l.execCb(i, o, r, n);
                                    if (this.map.isDefine && void 0 === n && ((e = this.module) ? n = e.exports : this.usingExports && (n = this.exports)), 
                                    t) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [ this.map.id ] : null, 
                                    t.requireType = this.map.isDefine ? "define" : "require", 
                                    O(this.error = t);
                                } else n = o;
                                if (this.exports = n, this.map.isDefine && !this.ignore && (m[i] = n, 
                                req.onResourceLoad)) {
                                    var a = [];
                                    each(this.depMaps, function(e) {
                                        a.push(e.normalizedMap || e);
                                    }), req.onResourceLoad(l, this.map, a);
                                }
                                P(i), this.defined = !0;
                            }
                            this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, 
                            this.emit("defined", this.exports), this.defineEmitComplete = !0);
                        }
                    } else hasProp(l.defQueueMap, i) || this.fetch();
                }
            },
            callPlugin: function() {
                var u = this.map, c = u.id, e = S(u.prefix);
                this.depMaps.push(e), M(e, "defined", bind(this, function(e) {
                    var o, t, i, r = getOwn(v, this.map.id), n = this.map.name, a = this.map.parentMap ? this.map.parentMap.name : null, s = l.makeRequire(u.parentMap, {
                        enableBuildCallback: !0
                    });
                    return this.map.unnormalized ? (e.normalize && (n = e.normalize(n, function(e) {
                        return q(e, a, !0);
                    }) || ""), M(t = S(u.prefix + "!" + n, this.map.parentMap, !0), "defined", bind(this, function(e) {
                        this.map.normalizedMap = t, this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0,
                            ignore: !0
                        });
                    })), void ((i = getOwn(p, t.id)) && (this.depMaps.push(t), this.events.error && i.on("error", bind(this, function(e) {
                        this.emit("error", e);
                    })), i.enable()))) : r ? (this.map.url = l.nameToUrl(r), void this.load()) : ((o = bind(this, function(e) {
                        this.init([], function() {
                            return e;
                        }, null, {
                            enabled: !0
                        });
                    })).error = bind(this, function(e) {
                        this.inited = !0, (this.error = e).requireModules = [ c ], 
                        eachProp(p, function(e) {
                            0 === e.map.id.indexOf(c + "_unnormalized") && P(e.map.id);
                        }), O(e);
                    }), o.fromText = bind(this, function(e, t) {
                        var i = u.name, r = S(i), n = useInteractive;
                        t && (e = t), n && (useInteractive = !1), k(r), hasProp(g.config, c) && (g.config[i] = g.config[c]);
                        try {
                            req.exec(e);
                        } catch (e) {
                            return O(makeError("fromtexteval", "fromText eval for " + c + " failed: " + e, e, [ c ]));
                        }
                        n && (useInteractive = !0), this.depMaps.push(r), l.completeLoad(i), 
                        s([ i ], o);
                    }), void e.load(u.name, s, o, g));
                })), l.enable(e, this), this.pluginMaps[e.id] = e;
            },
            enable: function() {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function(e, t) {
                    var i, r, n;
                    if ("string" == typeof e) {
                        if (e = S(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), 
                        this.depMaps[t] = e, n = getOwn(c, e.id)) return void (this.depExports[t] = n(this));
                        this.depCount += 1, M(e, "defined", bind(this, function(e) {
                            this.undefed || (this.defineDep(t, e), this.check());
                        })), this.errback ? M(e, "error", bind(this, this.errback)) : this.events.error && M(e, "error", bind(this, function(e) {
                            this.emit("error", e);
                        }));
                    }
                    i = e.id, r = p[i], hasProp(c, i) || !r || r.enabled || l.enable(e, this);
                })), eachProp(this.pluginMaps, bind(this, function(e) {
                    var t = getOwn(p, e.id);
                    t && !t.enabled && l.enable(e, this);
                })), this.enabling = !1, this.check();
            },
            on: function(e, t) {
                var i = this.events[e];
                i || (i = this.events[e] = []), i.push(t);
            },
            emit: function(e, t) {
                each(this.events[e], function(e) {
                    e(t);
                }), "error" === e && delete this.events[e];
            }
        }, (l = {
            config: g,
            contextName: u,
            registry: p,
            defined: m,
            urlFetched: n,
            defQueue: h,
            defQueueMap: {},
            Module: e,
            makeModuleMap: S,
            nextTick: req.nextTick,
            onError: O,
            configure: function(e) {
                if (e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/"), 
                "string" == typeof e.urlArgs) {
                    var i = e.urlArgs;
                    e.urlArgs = function(e, t) {
                        return (-1 === t.indexOf("?") ? "?" : "&") + i;
                    };
                }
                var r = g.shim, n = {
                    paths: !0,
                    bundles: !0,
                    config: !0,
                    map: !0
                };
                eachProp(e, function(e, t) {
                    n[t] ? (g[t] || (g[t] = {}), mixin(g[t], e, !0, !0)) : g[t] = e;
                }), e.bundles && eachProp(e.bundles, function(e, t) {
                    each(e, function(e) {
                        e !== t && (v[e] = t);
                    });
                }), e.shim && (eachProp(e.shim, function(e, t) {
                    isArray(e) && (e = {
                        deps: e
                    }), !e.exports && !e.init || e.exportsFn || (e.exportsFn = l.makeShimExports(e)), 
                    r[t] = e;
                }), g.shim = r), e.packages && each(e.packages, function(e) {
                    var t;
                    t = (e = "string" == typeof e ? {
                        name: e
                    } : e).name, e.location && (g.paths[t] = e.location), g.pkgs[t] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "");
                }), eachProp(p, function(e, t) {
                    e.inited || e.map.unnormalized || (e.map = S(t, null, !0));
                }), (e.deps || e.callback) && l.require(e.deps || [], e.callback);
            },
            makeShimExports: function(t) {
                return function() {
                    var e;
                    return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports);
                };
            },
            makeRequire: function(o, a) {
                function s(e, t, i) {
                    var r, n;
                    return a.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), 
                    "string" == typeof e ? isFunction(t) ? O(makeError("requireargs", "Invalid require call"), i) : o && hasProp(c, e) ? c[e](p[o.id]) : req.get ? req.get(l, e, o, s) : (r = S(e, o, !1, !0).id, 
                    hasProp(m, r) ? m[r] : O(makeError("notloaded", 'Module name "' + r + '" has not been loaded yet for context: ' + u + (o ? "" : ". Use require([])")))) : (T(), 
                    l.nextTick(function() {
                        T(), (n = k(S(null, o))).skipMap = a.skipMap, n.init(e, t, i, {
                            enabled: !0
                        }), R();
                    }), s);
                }
                return a = a || {}, mixin(s, {
                    isBrowser: isBrowser,
                    toUrl: function(e) {
                        var t, i = e.lastIndexOf("."), r = e.split("/")[0];
                        return -1 !== i && (!("." === r || ".." === r) || 1 < i) && (t = e.substring(i, e.length), 
                        e = e.substring(0, i)), l.nameToUrl(q(e, o && o.id, !0), t, !0);
                    },
                    defined: function(e) {
                        return hasProp(m, S(e, o, !1, !0).id);
                    },
                    specified: function(e) {
                        return e = S(e, o, !1, !0).id, hasProp(m, e) || hasProp(p, e);
                    }
                }), o || (s.undef = function(i) {
                    j();
                    var e = S(i, o, !0), t = getOwn(p, i);
                    t.undefed = !0, E(i), delete m[i], delete n[e.url], delete r[i], 
                    eachReverse(h, function(e, t) {
                        e[0] === i && h.splice(t, 1);
                    }), delete l.defQueueMap[i], t && (t.events.defined && (r[i] = t.events), 
                    P(i));
                }), s;
            },
            enable: function(e) {
                getOwn(p, e.id) && k(e).enable();
            },
            completeLoad: function(e) {
                var t, i, r, n = getOwn(g.shim, e) || {}, o = n.exports;
                for (j(); h.length; ) {
                    if (null === (i = h.shift())[0]) {
                        if (i[0] = e, t) break;
                        t = !0;
                    } else i[0] === e && (t = !0);
                    a(i);
                }
                if (l.defQueueMap = {}, r = getOwn(p, e), !t && !hasProp(m, e) && r && !r.inited) {
                    if (!(!g.enforceDefine || o && getGlobal(o))) return w(e) ? void 0 : O(makeError("nodefine", "No define call for " + e, null, [ e ]));
                    a([ e, n.deps || [], n.exportsFn ]);
                }
                R();
            },
            nameToUrl: function(e, t, i) {
                var r, n, o, a, s, u, c = getOwn(g.pkgs, e);
                if (c && (e = c), u = getOwn(v, e)) return l.nameToUrl(u, t, i);
                if (req.jsExtRegExp.test(e)) a = e + (t || ""); else {
                    for (r = g.paths, o = (n = e.split("/")).length; 0 < o; o -= 1) if (s = getOwn(r, n.slice(0, o).join("/"))) {
                        isArray(s) && (s = s[0]), n.splice(0, o, s);
                        break;
                    }
                    a = n.join("/"), a = ("/" === (a += t || (/^data\:|^blob\:|\?/.test(a) || i ? "" : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/) ? "" : g.baseUrl) + a;
                }
                return g.urlArgs && !/^blob\:/.test(a) ? a + g.urlArgs(e, a) : a;
            },
            load: function(e, t) {
                req.load(l, e, t);
            },
            execCb: function(e, t, i, r) {
                return t.apply(r, i);
            },
            onScriptLoad: function(e) {
                if ("load" === e.type || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                    interactiveScript = null;
                    var t = s(e);
                    l.completeLoad(t.id);
                }
            },
            onScriptError: function(e) {
                var i = s(e);
                if (!w(i.id)) {
                    var r = [];
                    return eachProp(p, function(e, t) {
                        0 !== t.indexOf("_@r") && each(e.depMaps, function(e) {
                            if (e.id === i.id) return r.push(t), !0;
                        });
                    }), O(makeError("scripterror", 'Script error for "' + i.id + (r.length ? '", needed by: ' + r.join(", ") : '"'), e, [ i.id ]));
                }
            }
        }).require = l.makeRequire(), l;
    }
    function getInteractiveScript() {
        return interactiveScript && "interactive" === interactiveScript.readyState || eachReverse(scripts(), function(e) {
            if ("interactive" === e.readyState) return interactiveScript = e;
        }), interactiveScript;
    }
}(this, "undefined" == typeof setTimeout ? void 0 : setTimeout);

var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || {
            __proto__: []
        } instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, 
        new __());
    };
}();

var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var __generator = this && this.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        throw: verb(1),
        return: verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([ n, v ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 
            0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [ op[0] & 2, t.value ];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;

              case 4:
                _.label++;
                return {
                    value: op[1],
                    done: false
                };

              case 5:
                _.label++;
                y = op[1];
                op = [ 0 ];
                continue;

              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;

              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _ = 0;
                    continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                    _.label = op[1];
                    break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                    _.label = t[1];
                    t = op;
                    break;
                }
                if (t && _.label < t[2]) {
                    _.label = t[2];
                    _.ops.push(op);
                    break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [ 6, e ];
            y = 0;
        } finally {
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

define("core/shopify-app/st-modules/_general-methods/dom-loaded", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDOMLoaded = void 0;
    var StDOMLoaded = function() {
        function StDOMLoaded() {
            var _this = this;
            this.className = "DOMLoaded";
            this.domLoaded = false;
            this.domLoadedCallbacks = [];
            this.readyStateChange = function() {
                if (document.readyState === "interactive") {
                    _this.domLoaded = true;
                    _this.fireDOMLoadedCallbacks();
                }
            };
            this.fireDOMLoadedCallbacks = function() {
                for (var i = 0; i < _this.domLoadedCallbacks.length; i++) {
                    _this.domLoadedCallbacks[i]();
                }
            };
            this.subscribeDOMLoaded = function(cb) {
                if (_this.domLoaded) {
                    cb();
                } else {
                    _this.domLoadedCallbacks.push(cb);
                }
            };
        }
        StDOMLoaded.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StDOMLoaded.prototype.initDOMLoaded = function() {
            if (!StDOMLoaded.initStarted) {
                StDOMLoaded.initStarted = true;
                if (document.readyState === "interactive" || document.readyState === "complete") {
                    this.domLoaded = true;
                    this.fireDOMLoadedCallbacks();
                } else {
                    document.addEventListener("readystatechange", this.readyStateChange, false);
                }
            }
        };
        StDOMLoaded.initStarted = false;
        return StDOMLoaded;
    }();
    exports.StDOMLoaded = StDOMLoaded;
});

define("core/connector-app/_shared/routes.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.endpointData = void 0;
    exports.endpointData = {
        webalias: {
            repSite: "||-API-ROOT-||/webalias/sca/repSite"
        },
        webhook: {
            removeAll: "||-API-ROOT-||/webhook/gar/removeAll"
        },
        customer: {
            updatePersonalInfo: "||-API-ROOT-||/customer/sca/updatePersonalInfo",
            updateWebAlias: "||-API-ROOT-||/customer/sca/updateWebAlias",
            updateSponsor: "||-API-ROOT-||/customer/sca/updateSponsor",
            "get-rep-details": "||-API-ROOT-||/customer/gar/get-rep-details",
            "update-consultant-rank-webhook": "||-API-ROOT-||/customer/sca/update-consultant-rank-webhook",
            "customer-login": "||-API-ROOT-||/customer/gar/customer-login",
            "downgrade-consultant-webhook": "||-API-ROOT-||/customer/sca/downgrade-consultant-webhook",
            "shopping-on-behalf": "||-API-ROOT-||/customer/gar/shopping-on-behalf",
            tags: "||-API-ROOT-||/customer/gar/tags",
            "address-checkout": "||-API-ROOT-||/customer/gar/address-checkout",
            "address-my-account-shipping": "||-API-ROOT-||/customer/gar/address-my-account-shipping",
            "address-my-account-billing": "||-API-ROOT-||/customer/gar/address-my-account-billing",
            "postal-code": "||-API-ROOT-||/customer/gar/postal-code"
        },
        auth: {
            sso: "||-API-ROOT-||/auth/sca/sso"
        },
        order: {
            "order-details": "||-API-ROOT-||/order/gar/order-details",
            "orders-from-bdt": "||-API-ROOT-||/order/gar/orders-from-bdt",
            "orders-details-from-bdt": "||-API-ROOT-||/order/gar/orders-details-from-bdt",
            "order-invoice": "||-API-ROOT-||/order/gar/order-invoice"
        },
        "order-credits": {
            "get-customer-credits": "||-API-ROOT-||/order-credits/sca/get-customer-credits",
            "get-all-customer-ledger": "||-API-ROOT-||/order-credits/sca/get-all-customer-ledger",
            "get-all-credits-for-ledger": "||-API-ROOT-||/order-credits/sca/get-all-credits-for-ledger",
            "add-remove-credits-for-ledger": "||-API-ROOT-||/order-credits/sca/add-remove-credits-for-ledger"
        },
        party: {
            "party-validation": "||-API-ROOT-||/party/sca/party-validation",
            "party-banner-information": "||-API-ROOT-||/party/sca/party-banner-information"
        },
        product: {},
        enrollment: {
            "validate-data": "||-API-ROOT-||/enrollment/sca/validate-data",
            submit: "||-API-ROOT-||/enrollment/sca/submit",
            createAccount: "||-API-ROOT-||/enrollment/sca/createAccount"
        },
        searchSponsor: {
            getSponsorInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorInfo",
            getSponsorByPersonalInfo: "||-API-ROOT-||/searchSponsor/sca/getSponsorByPersonalInfo"
        },
        "market-type": {
            "get-market-type": "||-API-ROOT-||/market-type/sca/get-market-type"
        },
        mailing: {},
        cart: {
            "save-customer-cart": "||-API-ROOT-||/cart/gar/save-customer-cart",
            "get-customer-cart": "||-API-ROOT-||/cart/gar/get-customer-cart"
        },
        multipass: {
            "generate-link": "||-API-ROOT-||/multipass/sca/generate-link"
        }
    };
});

define("core/shopify-app/st-modules/_static/static", [ "require", "exports", "core/connector-app/_shared/routes.config" ], function(require, exports, routes_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StStatic = void 0;
    var StStatic = function() {
        function StStatic() {
            var _this = this;
            var _a, _b;
            this.className = "Static";
            this.shopConfig = window.stAppConfig;
            this.apiRoot = this.shopConfig.apiRoot;
            this.apiRootDev = (_a = this.shopConfig) === null || _a === void 0 ? void 0 : _a.apiRootDev;
            this.apiMode = (_b = this.shopConfig) === null || _b === void 0 ? void 0 : _b.apiMode;
            this.init = function() {};
            this.setup = function() {};
            this.obtainStaticEndpoints = function() {
                return _this.endpoint;
            };
            this.obtainMainScope = function() {
                return window.stApp;
            };
            this.obtainCart = function() {
                return window.shopifyCartData;
            };
            this.injectRootToEndpoints = function(endpoints) {
                var apiRoot = _this.getApiRoot();
                for (var controllerKey in endpoints) {
                    for (var endpoint in endpoints[controllerKey]) {
                        endpoints[controllerKey][endpoint] = endpoints[controllerKey][endpoint].replace(/\|\|-API-ROOT-\|\|/g, apiRoot);
                    }
                }
                return endpoints;
            };
            this.getApiRoot = function() {
                if (!_this.apiMode) {
                    return _this.apiRoot;
                }
                return _this.apiMode === "development" ? _this.apiRootDev : _this.apiRoot;
            };
            this.endpoint = this.injectRootToEndpoints(routes_config_1.endpointData);
        }
        StStatic.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StStatic;
    }();
    exports.StStatic = StStatic;
});

define("core/shopify-app/st-modules/_di-container/st.module", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/ajax", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, ajax_1, static_1, dom_loaded_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StModule = void 0;
    var StModule = function() {
        function StModule(args) {
            var _this = this;
            this.dependency = [];
            this.init = function() {};
            this.setup = function() {
                if (!_this.setupFlag) {
                    if (_this.hasOwnProperty("init")) {
                        console.log("Init : ", _this.className);
                        _this.setupFlag = true;
                        _this.init();
                        _this.dependency.forEach(function(dependency) {
                            dependency.setup();
                        });
                    }
                }
            };
            this.dependency = args && args.length > 0 ? __spreadArray([], args, true) : [];
            this.Static = static_1.StStatic.Instance();
            this.endpoint = this.Static.obtainStaticEndpoints();
            this.cart = this.Static.obtainCart();
            this.ajax = ajax_1.StAjax.Instance();
            this.subscribeDOMLoaded = dom_loaded_1.StDOMLoaded.Instance().subscribeDOMLoaded;
            this.setupFlag = false;
        }
        return StModule;
    }();
    exports.StModule = StModule;
});

define("core/shopify-app/st-modules/_general-methods/notification", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNotification = exports.ENotificationType = void 0;
    var ENotificationType;
    (function(ENotificationType) {
        ENotificationType["success"] = "success";
        ENotificationType["error"] = "error";
        ENotificationType["info"] = "info";
    })(ENotificationType = exports.ENotificationType || (exports.ENotificationType = {}));
    var StNotification = function(_super) {
        __extends(StNotification, _super);
        function StNotification() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Notification";
            _this.createNotification = function() {
                var element = document.createElement("div");
                element.setAttribute("class", "st_notification-wrapper");
                element.setAttribute("id", "st_notification");
                var trigger = document.createElement("button");
                trigger.setAttribute("type", "button");
                trigger.dataset.close = "notification";
                trigger.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 40 40"><path d="M23.868 20.015L39.117 4.78c1.11-1.108 1.11-2.77 0-3.877-1.109-1.108-2.773-1.108-3.882 0L19.986 16.137 4.737.904C3.628-.204 1.965-.204.856.904c-1.11 1.108-1.11 2.77 0 3.877l15.249 15.234L.855 35.248c-1.108 1.108-1.108 2.77 0 3.877.555.554 1.248.831 1.942.831s1.386-.277 1.94-.83l15.25-15.234 15.248 15.233c.555.554 1.248.831 1.941.831s1.387-.277 1.941-.83c1.11-1.109 1.11-2.77 0-3.878L23.868 20.015z" /></svg>';
                element.appendChild(trigger);
                var title = document.createElement("div");
                title.setAttribute("class", "st_notification-title");
                element.appendChild(title);
                var desc = document.createElement("div");
                desc.setAttribute("class", "st_notification-description");
                element.appendChild(desc);
                return element;
            };
            _this.assembleNotification = function(type, title, description) {
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                var typeClass = "";
                var notification = _this.createNotification();
                if (typeof description === "string") {
                    description = [ description ];
                }
                switch (type) {
                  case "success":
                    typeClass = "st_success";
                    break;

                  case "error":
                    typeClass = "st_error";
                    break;

                  case "info":
                    typeClass = "st_info";
                    break;
                }
                notification.classList.add(typeClass);
                var t = notification.querySelector(".st_notification-title");
                t.innerHTML = title;
                var d = notification.querySelector(".st_notification-description");
                var message = "";
                for (var i = 0; i < description.length; i++) {
                    if (i !== 0) {
                        message += "<hr>";
                    }
                    message += description[i];
                }
                d.innerHTML = message;
                return notification;
            };
            _this.showNotification = function(type, title, description, duration, preventDisappear) {
                if (type === void 0) {
                    type = ENotificationType.error;
                }
                if (title === void 0) {
                    title = "";
                }
                if (description === void 0) {
                    description = "";
                }
                if (duration === void 0) {
                    duration = 5e3;
                }
                if (preventDisappear === void 0) {
                    preventDisappear = false;
                }
                var notif = document.getElementById("st_notification");
                if (notif !== null) {
                    notif.remove();
                }
                var notification = _this.assembleNotification(type, title, description);
                var button = notification.querySelectorAll('button[data-close="notification"]')[0];
                button.addEventListener("click", function(e) {
                    var el = this.closest(".st_notification-wrapper");
                    body.removeChild(el);
                });
                var body = document.getElementsByTagName("body")[0];
                body.appendChild(notification);
                if (!preventDisappear) {
                    clearTimeout(_this.globalShowTimeout);
                    _this.globalShowTimeout = setTimeout(function() {
                        if (notification && notification.parentNode) {
                            notification.parentNode.removeChild(notification);
                        }
                    }, duration);
                }
            };
            return _this;
        }
        return StNotification;
    }(st_module_1.StModule);
    exports.StNotification = StNotification;
});

define("core/connector-app/_shared/models/auth/auth.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.ETokenType = void 0;
    var ETokenType;
    (function(ETokenType) {
        ETokenType["Access"] = "Access";
        ETokenType["Refresh"] = "Refresh";
    })(ETokenType = exports.ETokenType || (exports.ETokenType = {}));
});

define("core/shopify-app/st-modules/auth/auth", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAuth = void 0;
    var StAuth = function(_super) {
        __extends(StAuth, _super);
        function StAuth() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Auth";
            _this.init = function() {
                _this.ajax.tryGetTokens();
            };
            return _this;
        }
        return StAuth;
    }(st_module_2.StModule);
    exports.StAuth = StAuth;
});

define("core/shopify-app/st-modules/_general-methods/ajax", [ "require", "exports", "core/connector-app/_shared/models/auth/auth.request.model", "core/shopify-app/st-modules/_static/static" ], function(require, exports, auth_request_model_1, static_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAjax = void 0;
    var StAjax = function() {
        function StAjax() {
            this.refreshingToken = false;
        }
        StAjax.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        StAjax.prototype.setupFormatting = function(objectToQueryStringFn) {
            this.objectToQueryString = objectToQueryStringFn;
        };
        StAjax.prototype.determineContentType = function(contentType) {
            var output = {
                type: "application/x-www-form-urlencoded",
                prepFn: this.objectToQueryString
            };
            switch (contentType) {
              case "form":
                output.type = "application/x-www-form-urlencoded";
                output.prepFn = this.objectToQueryString;
                break;

              case "json":
                output.type = "application/json";
                output.prepFn = JSON.stringify;
                break;
            }
            return output;
        };
        StAjax.prototype.tokenExists = function() {
            return !!window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.removeTokensFromStorage = function() {
            var token = window.localStorage.getItem(auth_request_model_1.ETokenType.Access);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Access);
            token = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_1.ETokenType.Refresh);
        };
        StAjax.prototype.attachTokenToHeader = function(request, tokenType) {
            var token = window.localStorage.getItem(tokenType);
            if (!!token && token.length > 0) request.setRequestHeader("Authorization", token);
        };
        StAjax.prototype.send = function(options, refresh) {
            var _a;
            var fnReference = this;
            if (typeof options == "object") {
                var defaultOptions = {
                    endpoint: "",
                    method: "POST",
                    contentType: "json",
                    data: {},
                    callback: function() {},
                    callbackParams: [],
                    retried: (_a = options.retried) !== null && _a !== void 0 ? _a : false
                };
                var completeOptions_1 = __assign(__assign({}, defaultOptions), options);
                var contentTypeData = this.determineContentType(completeOptions_1.contentType);
                var requestMethod = completeOptions_1.method.toUpperCase();
                var allowedMethods = [ "POST", "GET", "PUT", "DELETE" ];
                completeOptions_1.method = allowedMethods.indexOf(requestMethod) >= 0 ? requestMethod : "POST";
                var request_1 = new XMLHttpRequest();
                request_1.open(completeOptions_1.method, completeOptions_1.endpoint, true);
                request_1.withCredentials = true;
                request_1.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                request_1.setRequestHeader("Content-Type", contentTypeData.type);
                request_1.setRequestHeader("credentials", "include");
                var tokenType = !!refresh ? auth_request_model_1.ETokenType.Refresh : auth_request_model_1.ETokenType.Access;
                this.attachTokenToHeader(request_1, tokenType);
                var _this_1 = this;
                request_1.onreadystatechange = function() {
                    if (request_1.readyState === 4) {
                        if (request_1.status === 401 && !completeOptions_1.retried) {
                            options.retried = true;
                            if (_this_1.refreshingToken) {
                                setTimeout(function() {
                                    if (_this_1.tokenExists()) {
                                        _this_1.send(options);
                                    } else {}
                                }, 3e3);
                            } else {
                                _this_1.refreshTokenAndRetry(options);
                            }
                        } else {
                            completeOptions_1.callbackParams.unshift(request_1);
                            completeOptions_1.callback.apply(fnReference, completeOptions_1.callbackParams);
                        }
                    }
                };
                console.log("request type");
                request_1.send(contentTypeData.prepFn(completeOptions_1.data));
                return request_1;
            }
        };
        StAjax.prototype.refreshTokenAndRetry = function(options) {
            var _this = this;
            this.refreshingToken = true;
            var refreshToken = window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh);
            if (refreshToken == undefined || refreshToken.length === 0) {
                console.error("Authentication required.");
                _this.tryGetTokens(options);
                return;
            }
            this.send({
                endpoint: static_2.StStatic.Instance().obtainStaticEndpoints()["auth"]["get-jwt"],
                method: "POST",
                contentType: "json",
                data: {},
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var accessToken = JSON.parse(response.response).data.accessToken;
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, accessToken);
                            _this.refreshingToken = false;
                            _this.send(options);
                        } else if (response.status == 401) {
                            _this.removeTokensFromStorage();
                            _this.tryGetTokens(options);
                            throw new Error("Authentication required.");
                        }
                    } catch (error) {
                        console.error(error);
                        _this.refreshingToken = false;
                    }
                }
            }, true);
        };
        StAjax.prototype.tryGetTokens = function(options) {
            if (this.shouldRequestToken()) {
                this.getTokens({
                    id: "".concat(window.customerShopifyId),
                    email: window.customerShopifyEmail
                }, options);
            }
        };
        StAjax.prototype.shouldRequestToken = function() {
            return window.localStorage.getItem(auth_request_model_1.ETokenType.Refresh) === null && !!window.customerShopifyId && !!window.customerShopifyEmail;
        };
        StAjax.prototype.getTokens = function(userInfo, options) {
            console.log("sent -------\x3e ", userInfo, __assign({}, userInfo));
            var _this = this;
            this.send({
                endpoint: window.stAppConfig.apiRoot + "/auth/sca/get-jwt",
                method: "POST",
                contentType: "json",
                data: userInfo,
                callback: function(response) {
                    try {
                        if (response.status == 200) {
                            var res = JSON.parse(response.response);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Refresh.toString(), res.data.refreshToken);
                            window.localStorage.setItem(auth_request_model_1.ETokenType.Access, res.data.accessToken);
                            if (options !== undefined) {
                                _this.send(options);
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            });
        };
        return StAjax;
    }();
    exports.StAjax = StAjax;
});

define("core/shopify-app/st-modules/_di-container/st.module.interface", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_di-container/di.container.public", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.DiContainerPublic = void 0;
    var DiContainerPublic = function() {
        function DiContainerPublic() {
            this.className = "DI";
            this.subscribeDOMLoaded = function(cb) {
                dom_loaded_2.StDOMLoaded.Instance().subscribeDOMLoaded(cb);
            };
            this.init = function() {};
            this.setup = function() {};
        }
        return DiContainerPublic;
    }();
    exports.DiContainerPublic = DiContainerPublic;
});

define("core/shopify-app/st-modules/_di-container/di.container.setup", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/dom-loaded" ], function(require, exports, dom_loaded_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainerSetup = void 0;
    var StDIContainerSetup = function() {
        function StDIContainerSetup(appName, StAppDIConfig) {
            var _this = this;
            this.className = "DI";
            this.getModules = function(appName) {
                return _this.StAppDIConfig.Instance.hierarchy(appName);
            };
            if (!window.stApp) window.stApp = {};
            this.StAppDIConfig = StAppDIConfig;
            this.init(appName);
        }
        StDIContainerSetup.prototype.init = function(appName) {
            document.querySelector("body").classList.add("st_app-".concat(appName));
            this.mainServices = this.getModules(appName);
            this.mainServices.forEach(function(service) {
                if (service.className) {
                    window.stApp[service.className] = service;
                    service.setup();
                } else {
                    console.error("Instance has no className: ", service);
                }
            });
            dom_loaded_3.StDOMLoaded.Instance().initDOMLoaded();
        };
        return StDIContainerSetup;
    }();
    exports.StDIContainerSetup = StDIContainerSetup;
});

define("core/shopify-app/st-modules/_general-methods/cookies/cookies", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCookies = void 0;
    var StCookies = function(_super) {
        __extends(StCookies, _super);
        function StCookies() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cookies";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.initCookieApi();
                    _this.onPrivacyBannerAction();
                });
            };
            _this_1.initCookieApi = function() {
                var wShopify = window.Shopify;
                if (!!wShopify) {
                    wShopify.loadFeatures([ {
                        name: "consent-tracking-api",
                        version: "0.1"
                    } ], function(error) {
                        if (error) {
                            throw error;
                        }
                        _this_1.showPrivacyBanner();
                    });
                }
            };
            _this_1.showPrivacyBanner = function() {
                var wShopify = window.Shopify;
                var shouldShowBanner = wShopify.customerPrivacy.shouldShowGDPRBanner();
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner && shouldShowBanner) {
                    banner.removeAttribute("hidden");
                }
            };
            _this_1.hidePrivacyBanner = function() {
                var banner = document.querySelector(".st_privacy-bar_JS");
                if (!!banner) {
                    banner.setAttribute("hidden", "");
                }
            };
            _this_1.onPrivacyBannerAction = function() {
                var _this = _this_1;
                var privacyBannerBtnList = document.querySelectorAll(".st_privacy-banner-btn_JS");
                if ((privacyBannerBtnList === null || privacyBannerBtnList === void 0 ? void 0 : privacyBannerBtnList.length) > 0) {
                    privacyBannerBtnList.forEach(function(btn) {
                        btn.addEventListener("click", function() {
                            var btnDataAction = btn.getAttribute("data-action");
                            var wShopify = window === null || window === void 0 ? void 0 : window.Shopify;
                            wShopify.customerPrivacy.setTrackingConsent(btnDataAction === "accept", _this.hidePrivacyBanner);
                        });
                    });
                }
            };
            _this_1.getCookie = function(cookieKey) {
                return window.localStorage.getItem(cookieKey);
            };
            _this_1.setCookies = function(cookieKey, cookieValue) {
                window.localStorage.setItem(cookieKey, cookieValue);
            };
            _this_1.clearCookie = function(cookieKey) {
                window.localStorage.removeItem(cookieKey);
            };
            _this_1.clearAllCookie = function() {
                window.localStorage.clear();
            };
            return _this_1;
        }
        return StCookies;
    }(st_module_3.StModule);
    exports.StCookies = StCookies;
});

define("_features.config", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.ESocialSite = exports.EOrderStatusId = exports.useCommissionEngineIdInRewardCode = exports.rewardItemCollectionId = exports.rewardDiscountMinimum = exports.rewardCodePrefix = exports.rewardAmount = exports.rewardType = exports.shareRefCodeFunctionality = exports.discountUsageLimit = exports.discountCollectionSpend = exports.discountMinimumRequirement = exports.discountSegmentConditionTag = exports.discountNamePrefix = exports.discountAmount = exports.discountType = exports.enrollmentParams = exports.reasonForRefundWhenReturnMoney = exports.availableRechargeUsage = exports.sponsorGenealogyTimeout = exports.downgradeRepresentativeByDesignWebhook = exports.cronJobReSyncOrders = exports.repDiscountWithPromoCode = exports.searchSponsorsMinNumOfResult = exports.searchSponsorsFetchAttemptsLimit = exports.representative = exports.commissionEngine = exports.autoshipItems = exports.STORE_FRONT_API_VERSION = exports.productVolumesConfig = exports.EProductPriceType = exports.createConsultantRankTag = exports.rankConsultantRegEx = exports.ECustomerType = exports.defaultCorporationImage = exports.additionalRepInfo = exports.time_zone_offset = exports.activeLastSponsorFeature = exports.canGoUnderCorporateSite = exports.lockedRepresentativeSite = exports.defaultEmail = exports.corporationName = exports.aliasQueryParam = exports.defaultWebAlias = void 0;
    exports.defaultWebAlias = "400560";
    exports.aliasQueryParam = "als";
    exports.corporationName = "L'BRI PURE n' NATURAL";
    exports.defaultEmail = "donotreply@lbri.com";
    exports.lockedRepresentativeSite = true;
    exports.canGoUnderCorporateSite = true;
    exports.activeLastSponsorFeature = true;
    exports.time_zone_offset = ".000-05:00";
    exports.additionalRepInfo = true;
    exports.defaultCorporationImage = "https://lbri.com/lbriweb/assets/img/LBRI-pure-n-natural-logo.png";
    var ECustomerType;
    (function(ECustomerType) {
        ECustomerType["retail"] = "retail";
        ECustomerType["representative"] = "consultant";
        ECustomerType["guest"] = "guest";
        ECustomerType["noType"] = "";
        ECustomerType["seniorConsultant"] = "Senior Consultant";
        ECustomerType["manager"] = "manager";
        ECustomerType["supervisor"] = "Supervisor";
        ECustomerType["executiveManager"] = "Executive Manager";
        ECustomerType["executive"] = "Executive";
        ECustomerType["seniorExecutiveManager"] = "Senior Executive Manager";
        ECustomerType["eliteExecutiveManager"] = "Elite Executive Manager";
        ECustomerType["diamondExecutiveManager"] = "Diamond Executive Manager";
        ECustomerType["doubleExecutiveManager"] = "Double Diamond Executive Manager";
    })(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
    exports.rankConsultantRegEx = /^rank\s*\[\s*(.+?)\s*\]$/i;
    exports.createConsultantRankTag = "Rank[consultant]";
    var EProductPriceType;
    (function(EProductPriceType) {
        EProductPriceType["retail"] = "retail";
        EProductPriceType["representative"] = "consultant";
        EProductPriceType["noSpecificType"] = "";
    })(EProductPriceType = exports.EProductPriceType || (exports.EProductPriceType = {}));
    exports.productVolumesConfig = {
        cv: true,
        qv: true,
        bv: false,
        rv: false,
        retailProfit: true,
        cvMetafieldKey: "cvolume",
        qvMetafieldKey: "qvolume",
        bvMetafieldKey: "bvolume",
        rvMetafieldKey: "rvolume",
        retailProfitMetafieldKey: "retailProfit",
        Volume: "cv",
        Volume2: "qv",
        Volume3: "bv",
        Volume4: "rv",
        calculatePriceAsVolume: false,
        generalPriceVolumePercentage: 1,
        retailVolumeAndPricePercentage: 1,
        representativeVolumeAndPricePercentage: 1
    };
    exports.STORE_FRONT_API_VERSION = "2025-07";
    exports.autoshipItems = [ "AUTOSHIP-1", "AUTOSHIP-2", "consultant-kit", "enrollment-bundle" ];
    exports.commissionEngine = "ByDesign";
    exports.representative = "representative";
    exports.searchSponsorsFetchAttemptsLimit = 3;
    exports.searchSponsorsMinNumOfResult = 3;
    exports.repDiscountWithPromoCode = true;
    exports.cronJobReSyncOrders = true;
    exports.downgradeRepresentativeByDesignWebhook = true;
    exports.sponsorGenealogyTimeout = 6e5;
    exports.availableRechargeUsage = false;
    exports.reasonForRefundWhenReturnMoney = "refundmoney";
    exports.enrollmentParams = [ "SSN", "dateOfBirth", "day", "email", "firstName", "lastName", "month", "optionalKitRecurring", "optionalKits", "phoneNumber", "requiredKitRecurring", "requiredKits", "shopifyId", "sponsorWebAlias", "sponsorsWebAlias", "webAlias", "year" ];
    exports.discountType = "fixed_amount";
    exports.discountAmount = 10;
    exports.discountNamePrefix = "Core_";
    exports.discountSegmentConditionTag = "no_order";
    exports.discountMinimumRequirement = "1.00";
    exports.discountCollectionSpend = 405622423800;
    exports.discountUsageLimit = 10;
    exports.shareRefCodeFunctionality = false;
    exports.rewardType = "fixed_amount";
    exports.rewardAmount = 20;
    exports.rewardCodePrefix = "RewardedFrom-";
    exports.rewardDiscountMinimum = 1;
    exports.rewardItemCollectionId = 405622423800;
    exports.useCommissionEngineIdInRewardCode = true;
    var EOrderStatusId;
    (function(EOrderStatusId) {
        EOrderStatusId[EOrderStatusId["entered"] = 1] = "entered";
        EOrderStatusId[EOrderStatusId["posted"] = 2] = "posted";
        EOrderStatusId[EOrderStatusId["shipped"] = 3] = "shipped";
        EOrderStatusId[EOrderStatusId["pbo"] = 4] = "pbo";
        EOrderStatusId[EOrderStatusId["bo"] = 5] = "bo";
        EOrderStatusId[EOrderStatusId["void"] = 6] = "void";
        EOrderStatusId[EOrderStatusId["canceled"] = 7] = "canceled";
        EOrderStatusId[EOrderStatusId["imported"] = 8] = "imported";
        EOrderStatusId[EOrderStatusId["fulfilled"] = 9] = "fulfilled";
        EOrderStatusId[EOrderStatusId["characterValidation"] = 10] = "characterValidation";
        EOrderStatusId[EOrderStatusId["addressLimitValidation"] = 11] = "addressLimitValidation";
        EOrderStatusId[EOrderStatusId["thirdPartyRejected"] = 12] = "thirdPartyRejected";
    })(EOrderStatusId = exports.EOrderStatusId || (exports.EOrderStatusId = {}));
    var ESocialSite;
    (function(ESocialSite) {
        ESocialSite[ESocialSite["Facebook"] = 2] = "Facebook";
        ESocialSite[ESocialSite["Twitter"] = 3] = "Twitter";
        ESocialSite[ESocialSite["LinkedIn"] = 4] = "LinkedIn";
        ESocialSite[ESocialSite["Instagram"] = 5] = "Instagram";
        ESocialSite[ESocialSite["TikTok"] = 6] = "TikTok";
        ESocialSite[ESocialSite["Pinterest"] = 7] = "Pinterest";
    })(ESocialSite = exports.ESocialSite || (exports.ESocialSite = {}));
});

define("core/shopify-app/st-modules/_general-methods/form/customer-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_4, _features_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCustomerType = void 0;
    var StCustomerType = function(_super) {
        __extends(StCustomerType, _super);
        function StCustomerType() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CustomerType";
            _this.init = function() {};
            _this.get = function() {
                var customerType;
                if (!!window.customerInfoMetafields.customerType) {
                    customerType = window.customerInfoMetafields.customerType;
                } else {
                    customerType = _features_config_1.ECustomerType.guest;
                }
                return customerType;
            };
            return _this;
        }
        return StCustomerType;
    }(st_module_4.StModule);
    exports.StCustomerType = StCustomerType;
});

define("core/shopify-app/st-modules/_general-methods/object-formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StObjectFormatting = void 0;
    var StObjectFormatting = function(_super) {
        __extends(StObjectFormatting, _super);
        function StObjectFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ObjectFormatting";
            _this.convertObjectToQueryString = function(object) {
                var string = "", i = 0;
                for (var j in object) {
                    var s = encodeURIComponent(j) + "=" + encodeURIComponent(object[j]);
                    string += i > 0 ? "&" + s : s;
                    i++;
                }
                return "?" + string;
            };
            _this.convertQueryStringToObject = function(query) {
                query = typeof query != "string" ? "" : query.substr(query.indexOf("?") + 1);
                var query_string = {};
                if (query !== "") {
                    var vars = query.split("&");
                    for (var i = 0; i < vars.length; i++) {
                        var pair = vars[i].split("=");
                        var key = decodeURIComponent(pair[0]);
                        var value = decodeURIComponent(pair[1]);
                        if (typeof query_string[key] === "undefined") {
                            query_string[key] = decodeURIComponent(value);
                        } else if (typeof query_string[key] === "string") {
                            query_string[key] = [ query_string[key], decodeURIComponent(value) ];
                        } else {
                            query_string[key].push(decodeURIComponent(value));
                        }
                    }
                } else {
                    console.warn("Invalid query string supplied to convertQueryStringToObject.");
                }
                return query_string;
            };
            _this.ajax.setupFormatting(_this.convertObjectToQueryString);
            return _this;
        }
        return StObjectFormatting;
    }(st_module_5.StModule);
    exports.StObjectFormatting = StObjectFormatting;
});

define("core/shopify-app/st-modules/_general-methods/browser-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBrowserHistory = void 0;
    var StBrowserHistory = function(_super) {
        __extends(StBrowserHistory, _super);
        function StBrowserHistory(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BrowserHistory";
            _this.pushHistory = function(rootURL, urlParams) {
                var serializedUrlParams = _this.objectFormatting.convertObjectToQueryString(urlParams);
                window.history.replaceState(urlParams, "", rootURL + serializedUrlParams);
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        return StBrowserHistory;
    }(st_module_6.StModule);
    exports.StBrowserHistory = StBrowserHistory;
});

define("core/connector-app/_shared/models/webalias/webalias.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/_general-methods/general-methods", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StGeneralMethods = void 0;
    var StGeneralMethods = function(_super) {
        __extends(StGeneralMethods, _super);
        function StGeneralMethods() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "GeneralMethods";
            _this.scrollTo = function(element, duration, offset) {
                if (offset === void 0) {
                    offset = 150;
                }
                var startingY = window.scrollY;
                var elementY = window.scrollY + element.getBoundingClientRect().top - offset;
                var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
                var diff = targetY - startingY;
                var easing = function(t) {
                    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                };
                var start;
                if (!diff) return;
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    var time = timestamp - start;
                    var percent = Math.min(time / duration, 1);
                    percent = easing(percent);
                    window.scrollTo(0, startingY + diff * percent);
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                });
            };
            return _this;
        }
        StGeneralMethods.prototype.getClosestByClass = function(el, cls) {
            var res = el;
            while ((res = res === null || res === void 0 ? void 0 : res.parentElement) && !res.classList.contains(cls));
            return res;
        };
        StGeneralMethods.prototype.getClosestByTag = function(el, tagName) {
            var res = el;
            while ((res = res.parentElement) && !res.tagName === tagName);
            return res;
        };
        return StGeneralMethods;
    }(st_module_7.StModule);
    exports.StGeneralMethods = StGeneralMethods;
});

define("core/shopify-app/st-modules/webalias/webalias-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_8) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfig = void 0;
    var StWebAliasClassConfig = function(_super) {
        __extends(StWebAliasClassConfig, _super);
        function StWebAliasClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StWebAliasClassConfig";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            return _this;
        }
        return StWebAliasClassConfig;
    }(st_module_8.StModule);
    exports.StWebAliasClassConfig = StWebAliasClassConfig;
});

define("core/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, _features_config_2, st_module_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfo = void 0;
    var StInjectRepresentativeInfo = function(_super) {
        __extends(StInjectRepresentativeInfo, _super);
        function StInjectRepresentativeInfo(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "InjectRepresentativeInfo";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToField(firstName, lastName, webAlias);
                }
                if (!!imageUrl && _features_config_2.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.injectSponsorInfoToField = function(firstName, lastName) {
                var repNameSelector = document.querySelector(_this.classConfig.selectorBusinessContentRepName);
                if (!!repNameSelector) {
                    repNameSelector.innerHTML = firstName + " " + lastName;
                }
                var personalInformationRep = document.querySelector(_this.classConfig.selectorPersonalInfoRepFullName);
                if (!!personalInformationRep) {
                    personalInformationRep.value = firstName + " " + lastName;
                }
            };
            _this.appendIdToField = function(id) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepId);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, id);
                }
            };
            _this.appendAlsToField = function(alias) {
                var repAliasFields = document.querySelectorAll(_this.classConfig.selectorRepAlias);
                if (repAliasFields.length > 0) {
                    _this.appendValueToFields(repAliasFields, alias);
                }
            };
            _this.appendRepSiteUrlToField = function(alias) {
                var repSiteFields = document.querySelectorAll(_this.classConfig.selectorRepSite);
                var repSite = window.location.origin + "/?+" + _features_config_2.aliasQueryParam + "=" + alias;
                if (repSiteFields.length > 0) {
                    _this.appendValueToFields(repSiteFields, repSite);
                }
            };
            _this.appendRepFullNameToField = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
            };
            _this.appendRepBioToField = function(imageUrl) {
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBio);
                var imageString = 'BIO: <img class="" style="width: 50px; height: auto;" alt="representatve image" src="' + imageUrl + '">';
                if (repImages.length > 0) {
                    repImages.forEach(function(field) {
                        return field.innerHTML = imageString;
                    });
                }
            };
            _this.getFullName = function(repFirstName, repLastName, webAlias) {
                var fullName = "";
                if (!!repFirstName) {
                    fullName = repFirstName;
                    if (!!repLastName) {
                        fullName += " " + repLastName;
                    }
                }
                if (webAlias === _features_config_2.defaultWebAlias) {
                    fullName = _features_config_2.corporationName;
                }
                return fullName;
            };
            _this.appendValueToFields = function(fields, value) {
                fields.forEach(function(field) {
                    if (field.tagName.toLowerCase() === "input") {
                        field.value = value;
                    } else if (field.tagName.toLowerCase() === "a") {
                        field.setAttribute("href", value);
                    } else {
                        field.innerHTML = value;
                    }
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfo;
    }(st_module_9.StModule);
    exports.StInjectRepresentativeInfo = StInjectRepresentativeInfo;
});

define("core/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_10) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Cart";
            _this_1.reloadSubscriber = [];
            _this_1.cartInterceptorEndpoints = [ "/cart/add.js", "/cart/add", "/cart/update.js", "/cart/update", "/cart/change.js", "/cart/change", "/cart/clear.js", "/cart/clear", "/wallets/checkouts/" ];
            _this_1.shopifyCartApiEndpoints = {
                "get-cart": "/cart.js",
                "add-to-cart": "/cart/add.js",
                "clear-cart": "/cart/clear.js",
                "change-cart": "/cart/change.js",
                "update-cart": "/cart/update.js"
            };
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.cartFetchInterceptorInit();
                });
            };
            _this_1.cartFetchInterceptorInit = function() {
                var originalFetch = window.fetch;
                window.fetch = function() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var resource, config, response;
                        return __generator(this, function(_a) {
                            switch (_a.label) {
                              case 0:
                                resource = args[0], config = args[1];
                                return [ 4, originalFetch(resource, config) ];

                              case 1:
                                response = _a.sent();
                                if (this.isCartChangeRequest(response.url)) {
                                    this.getCart(this.handleChangeCartInterceptor);
                                }
                                return [ 2, response ];
                            }
                        });
                    });
                };
            };
            _this_1.handleChangeCartInterceptor = function(cartObj) {
                try {
                    _this_1.setShopifyCartData(cartObj);
                    if (!!cartObj.attributes.sponsorWebAlias) {
                        _this_1.addOrEditPropertiesForWebAlias(cartObj.items, cartObj.attributes.sponsorWebAlias);
                    }
                    _this_1.fireAllCallbacks(cartObj);
                } catch (err) {
                    console.error("handleChangeCartInterceptor ---\x3e Error:", err);
                }
            };
            _this_1.initCartSetup = function() {
                _this_1.getCart(function(cartObj) {
                    _this_1.setShopifyCartData(cartObj);
                });
            };
            _this_1.fireAllCallbacks = function(cartObject) {
                _this_1.fireChangeCartCallbacks(cartObject);
                setTimeout(function() {
                    _this_1.fireRenderCartCallbacks();
                }, 1e3);
            };
            _this_1.subscribeChangeCart = function(callback) {
                _this_1.subCallbacks.push(callback);
            };
            _this_1.fireChangeCartCallbacks = function(cartObject) {
                if (_this_1.subCallbacks.length > 0) {
                    _this_1.subCallbacks.forEach(function(callback) {
                        callback(cartObject);
                    });
                }
            };
            _this_1.subscribeRenderCart = function(callback) {
                _this_1.subRenderCartCallbacks.push(callback);
            };
            _this_1.fireRenderCartCallbacks = function() {
                if (_this_1.subRenderCartCallbacks.length > 0) {
                    _this_1.subRenderCartCallbacks.forEach(function(callback) {
                        callback();
                    });
                }
            };
            _this_1.matchUrlSnippet = function(url, urlSnippetArr) {
                for (var i = 0; i < urlSnippetArr.length; i++) {
                    if (url.includes(urlSnippetArr[i])) {
                        return true;
                    }
                }
                return false;
            };
            _this_1.isGetCartRequest = function(url) {
                return url.endsWith("/cart.json");
            };
            _this_1.isCartChangeRequest = function(url) {
                return _this_1.matchUrlSnippet(url, _this_1.cartInterceptorEndpoints);
            };
            _this_1.setShopifyCartData = function(cartObj) {
                window.shopifyCartData = cartObj;
                _this_1.setCartInfo(cartObj);
            };
            _this_1.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    var cartRes_1 = JSON.parse(res.response);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this_1.requestCartRefresh(cartObj);
                        }
                        _this_1.fireAllCallbacks(cartObj);
                        handleFunc(cartRes_1);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this_1.getCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["get-cart"],
                        method: "GET",
                        contentType: "json",
                        callback: function(res) {
                            try {
                                var cartObj = JSON.parse(res.response);
                                responseHandle(cartObj);
                            } catch (err) {
                                console.log("Cart Api Error: ", err);
                            }
                        }
                    });
                } catch (err) {
                    console.log("Get Cart ---\x3e Error:", err);
                }
            };
            _this_1.clearCart = function(responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["clear-cart"],
                        method: "POST",
                        contentType: "json",
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Clear Cart ---\x3e Error:", err);
                }
            };
            _this_1.changeCart = function(changeData, responseHandle, cartRefresh) {
                if (cartRefresh === void 0) {
                    cartRefresh = true;
                }
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["change-cart"],
                        method: "POST",
                        contentType: "json",
                        data: changeData,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle, cartRefresh);
                        }
                    });
                } catch (err) {
                    console.log("Change Cart ---\x3e Error:", err);
                }
            };
            _this_1.updateCart = function(updateData, responseHandle) {
                try {
                    var data = Array.isArray(updateData) ? {
                        updates: updateData
                    } : updateData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.addCart = function(addData, responseHandle) {
                try {
                    var data = Array.isArray(addData) ? {
                        items: addData
                    } : addData;
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["add-to-cart"],
                        method: "POST",
                        contentType: "json",
                        data: data,
                        callback: function(res) {
                            _this_1.handleChangeCartResponseGeneric(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Add To Cart ---\x3e Error:", err);
                }
            };
            _this_1.requestCartRefresh = function(cart) {
                var isCartPage = location.pathname === "/cart";
                if (isCartPage) {
                    var _this_2 = _this_1;
                    var refreshIndex_1 = _this_1.subscribeCartReload();
                    setTimeout(function() {
                        _this_2.triggerCartReload(refreshIndex_1);
                    }, 500);
                }
                if (!isCartPage) {
                    _this_1.ajax.send({
                        endpoint: "".concat(window.Shopify.routes.root, "?section_id=cart-drawer"),
                        method: "GET",
                        callback: function(request) {
                            var cartDrawerTemplate = request.responseText;
                            _this_1.ajax.send({
                                endpoint: "".concat(window.Shopify.routes.root, "?section_id=variant-added"),
                                method: "GET",
                                callback: function(request) {
                                    var variantAddedTemplate = request.responseText;
                                    _this_1.triggerCartRefresh(cart, {
                                        "cart-drawer": cartDrawerTemplate,
                                        "variant-added": variantAddedTemplate
                                    });
                                }
                            });
                        }
                    });
                }
            };
            _this_1.triggerCartRefresh = function(cart, sections) {
                var addEvt = new CustomEvent("variant:add");
                var cartRefreshEvt = new CustomEvent("cart:refresh");
                var totalQuantity = cart.items.reduce(function(acc, item) {
                    return acc + item.quantity;
                }, 0);
                var cartChangeEvt = new CustomEvent("cart:change", {
                    detail: {
                        cart: __assign(__assign({}, cart), {
                            item_count: totalQuantity,
                            sections: sections
                        })
                    }
                });
                document.dispatchEvent(cartChangeEvt);
                document.dispatchEvent(cartRefreshEvt);
                document.dispatchEvent(addEvt);
            };
            _this_1.setCartInfo = function(shopifyCart) {
                _this_1.cart = __assign(__assign({}, _this_1.cart), shopifyCart);
            };
            _this_1.updateCartItemsProperies = function(alias) {
                _this_1.getCart(function(cartResponse) {
                    var attributes = cartResponse.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        sponsorWebAlias: !!alias ? alias : ""
                    });
                    var updateAttributes = {
                        attributes: attributes
                    };
                    _this_1.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        var items = cartRes.items;
                        _this_1.addOrEditPropertiesForWebAlias(items, alias);
                    });
                });
            };
            _this_1.addOrEditPropertiesForWebAlias = function(cartItems, alias) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    if (!!alias) {
                        _this_1.updateItemProperties(item, alias, refreshCart);
                    }
                }
            };
            _this_1.updateItemProperties = function(item, alias, refreshCart) {
                var updateData = {
                    id: "".concat(item.key),
                    quantity: item.quantity,
                    properties: __assign(__assign({}, item.properties), {
                        _sponsorWebAlias: alias
                    })
                };
                _this_1.changeCart(updateData, function(updatedCart) {
                    console.log("Updated Cart:", updatedCart);
                }, refreshCart);
            };
            _this_1.updateCartAttributesOrNote = function(updateData, responseHandle) {
                try {
                    _this_1.ajax.send({
                        endpoint: _this_1.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {}
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this_1.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    var cartRes = JSON.parse(res.response);
                    handleFunc(cartRes);
                    _this_1.getCart(function(cartObj) {
                        _this_1.setShopifyCartData(cartObj);
                        _this_1.handleChangeCartInterceptor(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this_1.subscribeCartReload = function() {
                _this_1.reloadSubscriber.push(false);
                return _this_1.reloadSubscriber.length - 1;
            };
            _this_1.triggerCartReload = function(index) {
                var shouldRefresh = true;
                _this_1.reloadSubscriber[index] = true;
                for (var i = 0; i < _this_1.reloadSubscriber.length; i++) {
                    if (_this_1.reloadSubscriber[i] === false) {
                        shouldRefresh = false;
                        break;
                    }
                }
                if (shouldRefresh) window.location.reload();
            };
            _this_1.subCallbacks = [];
            _this_1.subRenderCartCallbacks = [];
            return _this_1;
        }
        Object.defineProperty(StCart.prototype, "getShopifyCartData", {
            get: function() {
                return window.shopifyCartData;
            },
            enumerable: false,
            configurable: true
        });
        return StCart;
    }(st_module_10.StModule);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorClassConfig = void 0;
    var StSearchSponsorClassConfig = function(_super) {
        __extends(StSearchSponsorClassConfig, _super);
        function StSearchSponsorClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorClassConfig";
            _this.classNameSponsorId = "st_sponsor-id_JS";
            _this.selectorSponsorId = "." + _this.classNameSponsorId;
            _this.classNameSponsorAlias = "st_sponsor-alias_JS";
            _this.selectorSponsorAlias = "." + _this.classNameSponsorAlias;
            _this.classNameSponsorFullName = "st_sponsor-fullname_JS";
            _this.selectorSponsorFullName = "." + _this.classNameSponsorFullName;
            _this.classNameSponsorInitials = "st_sponsor-initials_JS";
            _this.selectorSponsorInitials = "." + _this.classNameSponsorInitials;
            _this.classNameSponsorAddress = "st_sponsor-address_JS";
            _this.selectorSponsorAddress = "." + _this.classNameSponsorAddress;
            _this.classNameSearchSponsorWrapperPage = "st_search-sponsor--wrapper_JS";
            _this.selectorSearchSponsorWrapperPage = "." + _this.classNameSearchSponsorWrapperPage;
            _this.classNameInputBoxPage = "st_search-sponsor--by-id_JS";
            _this.selectorInputBoxPage = "." + _this.classNameInputBoxPage;
            _this.classNameChangeSponsorWrapperlink = "st_change-sponsor--wrapper_JS";
            _this.selectorChangeSponsorWrapperLink = "." + _this.classNameChangeSponsorWrapperlink;
            _this.classNameChangeSponsorWrapper = "st_change-sponsor_JS";
            _this.selectorChangeSponsorWrapper = "." + _this.classNameChangeSponsorWrapper;
            _this.classNameSearchInput = "st_search-input_JS";
            _this.selectorSearchInput = "." + _this.classNameSearchInput;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classNameChooseSponsor = "st_choose-sponsor_JS";
            _this.selectorChooseSponsor = "." + _this.classNameChooseSponsor;
            _this.classNameSearchResult = "st_search-result_JS";
            _this.selectorSearchResult = "." + _this.classNameSearchResult;
            _this.classNameRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classNameRepresentativeAlias;
            _this.classNameRepresentativeFullName = "st_representative-fullname_JS";
            _this.selectorRepresentativeFullName = "." + _this.classNameRepresentativeFullName;
            _this.classNameSponsorData = "st_sponsor-data_JS";
            _this.selectorSponsorData = "." + _this.classNameSponsorData;
            _this.classNameSearchSponsor = "st_search-sponsors_JS";
            _this.selectorSearchSponsor = "." + _this.classNameSearchSponsor;
            _this.classNameFoundSponsor = "st_found-sponsors_JS";
            _this.selectorFoundSponsor = "." + _this.classNameFoundSponsor;
            _this.classNameSearchSponsorBy = "st_search-sponsor-by_JS";
            _this.selectorSearchSponsorBy = "." + _this.classNameSearchSponsorBy;
            _this.classNameRadioText = "st_radio-text";
            _this.selectorRadioText = "." + _this.classNameRadioText;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            return _this;
        }
        return StSearchSponsorClassConfig;
    }(st_module_11.StModule);
    exports.StSearchSponsorClassConfig = StSearchSponsorClassConfig;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_12, _features_config_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorGuard = void 0;
    var StSearchSponsorGuard = function(_super) {
        __extends(StSearchSponsorGuard, _super);
        function StSearchSponsorGuard(classConfig, browserHistory, objectFormatting, generalMethods, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorGuard";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.listenForSponsorChange();
                    _this.cartComponent.subscribeRenderCart(function() {
                        var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                        var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                        _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                    });
                });
            };
            _this.toggleElementVisibility = function(element, hideElement) {
                if (hideElement) {
                    _this.hideElement(element);
                } else {
                    _this.showElement(element);
                }
            };
            _this.showElement = function(element) {
                if (_this.isElementHidden(element)) {
                    element.classList.remove("st_hidden");
                }
            };
            _this.hideElement = function(element) {
                if (!_this.isElementHidden(element)) {
                    element.classList.add("st_hidden");
                }
            };
            _this.isElementHidden = function(element) {
                return element.classList.contains("st_hidden");
            };
            _this.toggleShoppingWith = function(hideElement) {
                var banner = document.querySelector(_this.classConfig.selectorRepresentativeBannerWrapper);
                _this.toggleElementVisibility(banner, hideElement);
            };
            _this.disableNonSponsor = function() {
                var nonSponsorBtn = document.querySelector(_this.classConfig.selectorNonSponsor);
                nonSponsorBtn === null || nonSponsorBtn === void 0 ? void 0 : nonSponsorBtn.remove();
            };
            _this.toggleBuying = function(hideBuying) {
                _this.toggleCheckoutButtons(hideBuying);
                _this.togglePaymentButtons(hideBuying);
                _this.toggleSearchSponsor(hideBuying);
            };
            _this.toggleSearchSponsor = function(hideElement) {
                var searchSponsorWrappers = document.querySelectorAll(".st_search-sponsor--wrapper_JS");
                searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    _this.toggleSearchSponsorInput(searchSponsorWrapper, !hideElement);
                    _this.toggleSearchSponsorResult(searchSponsorWrapper, hideElement);
                });
            };
            _this.toggleSearchSponsorResult = function(container, hideElement) {
                var searchSponsorResultWrapper = container.querySelector(".st_search-result_JS");
                if (!!searchSponsorResultWrapper) {
                    _this.toggleElementVisibility(searchSponsorResultWrapper, hideElement);
                }
            };
            _this.toggleSearchSponsorInput = function(container, hideElement) {
                var searchSponsorInputWrapper = container.querySelector(".st_search-input_JS");
                if (!!searchSponsorInputWrapper) {
                    _this.toggleElementVisibility(searchSponsorInputWrapper, hideElement);
                }
            };
            _this.toggleCheckoutButtons = function(hideElement) {
                var checkoutButtons = document.querySelectorAll('button[name="checkout"]');
                if (checkoutButtons.length > 0) {
                    checkoutButtons.forEach(function(btn) {
                        _this.toggleElementVisibility(btn, hideElement);
                    });
                }
            };
            _this.togglePaymentButtons = function(hideElement) {
                var paymentButtonsWrapper = document.querySelectorAll(".st_product-buy-now-wrapper_JS");
                if (paymentButtonsWrapper.length > 0) {
                    paymentButtonsWrapper.forEach(function(wrp) {
                        _this.toggleElementVisibility(wrp, hideElement);
                    });
                }
            };
            _this.toggleCantGoUnderCorporateSite = function(hideElements) {
                if (!_features_config_3.canGoUnderCorporateSite) {
                    _this.disableNonSponsor();
                    _this.toggleShoppingWith(hideElements);
                    _this.toggleBuying(hideElements);
                }
            };
            _this.listenForSponsorChange = function() {
                window.addEventListener("sponsorChange", function() {
                    var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                    var currentAlias = urlParams[_features_config_3.aliasQueryParam];
                    _this.toggleCantGoUnderCorporateSite(currentAlias === _features_config_3.defaultWebAlias);
                });
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.generalMethods = generalMethods;
            _this.cartComponent = cartComponent;
            return _this;
        }
        return StSearchSponsorGuard;
    }(st_module_12.StModule);
    exports.StSearchSponsorGuard = StSearchSponsorGuard;
});

define("core/connector-app/_shared/models/customer/sponsor/customer.update.sponsor.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/webalias/webalias.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/_general/account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountClassConfig = void 0;
    var StAccountClassConfig = function(_super) {
        __extends(StAccountClassConfig, _super);
        function StAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountClassConfig";
            _this.classNameProvinceSelector = "st_province-selector_JS";
            _this.selectorProvinceSelector = "." + _this.classNameProvinceSelector;
            _this.classNameProvinceSource = "st_province-source_JS";
            _this.selectorProvinceSource = "." + _this.classNameProvinceSource;
            _this.classNameAccountPage = "st_account_JS";
            _this.selectorAccountPage = "." + _this.classNameAccountPage;
            _this.classNameAccountSection = "st_account-page--section_JS";
            _this.selectorAccountSection = "." + _this.classNameAccountSection;
            _this.classNameAccountContent = "st_account-page_JS";
            _this.selectorAccountContent = "." + _this.classNameAccountContent;
            _this.classNameAccountNavWrapper = "st_account-nav--wrapper_JS";
            _this.selectorAccountNavWrapper = "." + _this.classNameAccountNavWrapper;
            _this.classNameAccountNavHolder = "st_account-nav--holder_JS";
            _this.selectorAccountNavHolder = "." + _this.classNameAccountNavHolder;
            _this.classNameAccountNavHolderSingle = "st_account-nav--holder-single_JS";
            _this.selectorAccountNavHolderSingle = "." + _this.classNameAccountNavHolderSingle;
            _this.classNameAccountNavButton = "st_account-button_JS";
            _this.selectorAccountNavButton = "." + _this.classNameAccountNavButton;
            _this.classNameAccountIcon = "st_account--nav-icon_JS";
            _this.selectorAccountIcon = "." + _this.classNameAccountIcon;
            _this.classNameAccountCopyText = "st_copy-repsite_JS";
            _this.selectorAccountIconCopyText = "." + _this.classNameAccountCopyText;
            _this.classNameAccountCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorAccountIconCopyTextWrapper = "." + _this.classNameAccountCopyTextWrapper;
            _this.classNameAccountLogout = "st_account-logout_JS";
            _this.selectorAccountLogout = "." + _this.classNameAccountLogout;
            _this.classNameAccountWebAlias = "st_input-wrapper_JS input";
            _this.selectorAccountWebAlias = "." + _this.classNameAccountWebAlias;
            _this.classNameAccountAddressesDropdown = "st_addresses-dots--button_JS";
            _this.selectorAccountAddressesDropdown = "." + _this.classNameAccountAddressesDropdown;
            _this.classNameAccountAddressesDropdownWrapper = "st_dropdown-address--wrapper";
            _this.selectorAccountAddressesDropdownWrapper = "." + _this.classNameAccountAddressesDropdownWrapper;
            _this.classNameAccountTabButton = "st_button-wrapper_JS";
            _this.selectorAccountTabButton = "." + _this.classNameAccountTabButton;
            _this.classNameAccountBackButton = "st_arrow-back--button_JS";
            _this.selectorAccountBackButton = "." + _this.classNameAccountBackButton;
            _this.classNameSingleOrder = "st_single-order_JS";
            _this.selectorSingleOrder = "." + _this.classNameSingleOrder;
            _this.classNameOpenOrderCSSClass = "st_open-single-order";
            _this.selectorOpenOrderCSSClass = "." + _this.classNameOpenOrderCSSClass;
            _this.classNameOpenSingleOrderButton = "st_open-single-order_JS";
            _this.selectorOpenSingleOrderButton = "." + _this.classNameOpenSingleOrderButton;
            _this.classNameOrderHistory = "st_order-history_JS";
            _this.selectorOrderHistory = "." + _this.classNameOrderHistory;
            _this.classNameBackToHistoryOrders = "st_back-to-history-orders_JS";
            _this.selectorBackToHistoryOrders = "." + _this.classNameBackToHistoryOrders;
            _this.classNameBackOfficeLink = "st_backoffice-link_JS";
            _this.selectorBackOfficeLink = "." + _this.classNameBackOfficeLink;
            _this.classNameWebAliasFormatting = "st_formatting-web-alias_JS";
            _this.selectorWebAliasFormatting = "." + _this.classNameWebAliasFormatting;
            _this.classNameWebAliasWrapper = "st_web-alias-wrapper_JS";
            _this.selectorWebAliasWrapper = "." + _this.classNameWebAliasWrapper;
            _this.classNameWebAliasValue = "st_web-alias-readonly-input_JS";
            _this.selectorWebAliasValue = "." + _this.classNameWebAliasValue;
            _this.classNameAddressesWrapper = "st_addresses--wrapper_JS";
            _this.selectorAddressesWrapper = "." + _this.classNameAddressesWrapper;
            _this.classNameEditWebAliasForm = "st_edit-webalias-form_JS";
            _this.selectorEditWebAliasForm = "." + _this.classNameEditWebAliasForm;
            _this.classNameSubmitButton = "st_submit--btn_JS";
            _this.selectorSubmitButton = "." + _this.classNameSubmitButton;
            _this.classNameProvinceWrapper = "st_province-wrapper_JS";
            _this.selectorProvinceWrapper = "." + _this.classNameProvinceWrapper;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNameBusinessContent = "st_account-business--content_JS";
            _this.selectorBusinessContent = "." + _this.classNameBusinessContent;
            _this.classNameBusinessContentName = "st_account-business--name_JS";
            _this.selectorBusinessContentName = "." + _this.classNameBusinessContentName;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNameBusinessContentEmail = "st_account-business--email_JS";
            _this.selectorBusinessContentEmail = "." + _this.classNameBusinessContentEmail;
            return _this;
        }
        return StAccountClassConfig;
    }(st_module_13.StModule);
    exports.StAccountClassConfig = StAccountClassConfig;
});

define("core/shopify-app/st-modules/account/blocks/personal-site/personal-site", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_14, _features_config_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalSite = void 0;
    var StAccountPersonalSite = function(_super) {
        __extends(StAccountPersonalSite, _super);
        function StAccountPersonalSite(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalSite";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyRefToClipboard(_this_1.classConfig.selectorAccountIconCopyText, ".st_representative-site-link_JS");
                    _this_1.getRefCode();
                });
            };
            _this_1.getRefCode = function() {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                if (_features_config_4.shareRefCodeFunctionality) {
                    _this_1.copyRefToClipboard(".st_referral-link-copy-clipboard_JS", ".st_retail-personal-promo-code-link_JS");
                    _this_1.createLinkWithRef;
                    _this_1.showIncludePromoCode();
                    _this_1.showPersonalSiteRetailBlock();
                    if (!customersRef) {
                        _this_1.createLinkWithoutRef;
                    }
                } else {
                    _this_1.hideIncludePromoCode();
                    _this_1.hidePersonalSiteRetailBlock();
                    _this_1.createLinkWithoutRef;
                }
            };
            _this_1.createLinkWithRef = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_retail-personal-promo-code-link_JS");
                retailInput.forEach(function(input) {
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + alias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRef = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var als = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + _features_config_4.aliasQueryParam + "=" + als;
                    });
                }
            };
            _this_1.hidePersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showPersonalSiteRetailBlock = function() {
                var personalSiteRetailBlockWrapper = document.querySelector(".st_personal-site-retail--wrapper_JS");
                if (!!personalSiteRetailBlockWrapper) {
                    personalSiteRetailBlockWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.createLinkWithRefRep = function(alias) {
                var propertyWrapper = document.querySelector(".st_get-ref-code_JS");
                var customersRef = propertyWrapper === null || propertyWrapper === void 0 ? void 0 : propertyWrapper.getAttribute("data-customer-tag");
                var retailInput = document.querySelectorAll(".st_representative-site-link_JS");
                retailInput.forEach(function(input) {
                    var hisAlias = localStorage.getItem("webAlias");
                    input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias + "&" + "ref=" + customersRef;
                });
            };
            _this_1.createLinkWithoutRefRep = function(als) {
                var inputEl = document.querySelectorAll(".st_representative-site-link_JS");
                if (inputEl) {
                    inputEl.forEach(function(input) {
                        var hisAlias = localStorage.getItem("webAlias");
                        input.value = window.location.protocol + "//" + window.location.host + "/?" + "als=" + hisAlias;
                    });
                }
            };
            _this_1.includePromoCode = function(als) {
                var _this = _this_1;
                var includeInput = document.querySelector(".st_include-promo-code-input_JS");
                if (!!includeInput) {
                    var inputEl_1 = document.querySelectorAll(".st_representative-site-link_JS");
                    if (includeInput.checked) {
                        _this.createLinkWithRefRep(als);
                    } else {
                        _this.createLinkWithoutRefRep(als);
                    }
                    includeInput.addEventListener("change", function(event) {
                        if (!!inputEl_1) {
                            if (includeInput.checked) {
                                _this.createLinkWithRefRep(als);
                            } else {
                                _this.createLinkWithoutRefRep(als);
                            }
                        }
                    });
                }
            };
            _this_1.hideIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.add("st_hidden");
                }
            };
            _this_1.showIncludePromoCode = function() {
                var includePromoCodeWrapper = document.querySelector(".st_include-promo-code-wrapper_JS");
                if (!!includePromoCodeWrapper) {
                    includePromoCodeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyRefToClipboard = function(button, input) {
                var copyRepSiteButtonAll = document.querySelectorAll(button);
                if (!!copyRepSiteButtonAll) {
                    copyRepSiteButtonAll.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelectorAll(input);
                            if (!!copyText) {
                                copyText.forEach(function(input) {
                                    if (!!input) {
                                        input.select();
                                        input.setSelectionRange(0, 99999);
                                        navigator.clipboard.writeText(input.value);
                                        input.style.backgroundColor = "rgb(217, 218, 220)";
                                        input.style.transition = "0.2s";
                                        setTimeout(function() {
                                            input.style.backgroundColor = "rgb(249, 249, 249)";
                                        }, 1e3);
                                    }
                                });
                            }
                        });
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalSite;
    }(st_module_14.StModule);
    exports.StAccountPersonalSite = StAccountPersonalSite;
});

define("core/shopify-app/st-modules/webalias/webalias", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_15, _features_config_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAlias = void 0;
    var StWebAlias = function(_super) {
        __extends(StWebAlias, _super);
        function StWebAlias(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "WebAlias";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.cookieNameImageUrl = "imageUrl";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    console.log("lockedRepresentativeSite: ", _features_config_5.lockedRepresentativeSite);
                    console.log("canGoUnderCorporateSite: ", _features_config_5.canGoUnderCorporateSite);
                    _this.getSponsorInformation();
                });
            };
            _this.initWebAliasFlow = function() {
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists) {
                    _this.getRepresentativesOwnInfo(currentAlias);
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_5.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists) {
                        _this.getRepresentativesOwnInfo(currentAlias);
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var data = response.data, status = response.status;
                var webAlias = data.webAlias, repId = data.repId;
                if (status !== 200) {
                    _this.nonExistentRepresentativeFlow();
                    return;
                }
                if (!webAlias && webAlias === "") {
                    data = __assign(__assign({}, data), {
                        webAlias: repId
                    });
                }
                _this.updateCurrentRepInfo(data);
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: false
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var repIdMetafield = window.customerInfoMetafields.representativeId;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName");
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                }
                _this.cartComponent.updateCartItemsProperies(webAlias);
                _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_5.defaultWebAlias);
                _this.injectRepresentativeInfo.injectToFields(repInfo);
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_5.defaultWebAlias,
                    firstName: _features_config_5.corporationName,
                    lastName: ""
                };
                if (_features_config_5.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_5.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.isAliasEqualToStored = function(alias) {
                return alias === _this.cookies.getCookie("webAlias");
            };
            _this.isAliasEqualToUrlAlias = function(alias) {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_5.aliasQueryParam];
                return currentAlias === alias;
            };
            _this.setNewAliasInUrl = function(alias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var newUrlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_5.aliasQueryParam] = alias, 
                _a));
                var newURL = window.location.href.replace(window.location.search, "");
                _this.browserHistory.pushHistory(newURL, newUrlParams);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                if (_features_config_5.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            _this.initSponsorCheck = function() {
                var shopifyCustomerId = _this.shopifyCustomerId;
                if (_this.isTimeForSponsorCheck() && shopifyCustomerId && shopifyCustomerId !== 0) {
                    _this.updateCustomerSponsor(shopifyCustomerId);
                }
            };
            _this.updateCustomerSponsor = function(shopifyCustomerId) {
                var updateSponsorData = {
                    shopifyCustomerId: shopifyCustomerId
                };
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["updateSponsor"],
                        method: "post",
                        contentType: "json",
                        data: updateSponsorData
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e " + error);
                }
            };
            _this.isTimeForSponsorCheck = function() {
                var timestamp = Date.now();
                var lastCheck = _this.customerSponsorLastCheck;
                var timeThreshold = _features_config_5.sponsorGenealogyTimeout ? _features_config_5.sponsorGenealogyTimeout : 9e5;
                return timestamp - lastCheck > timeThreshold;
            };
            _this.classConfig = classConfig;
            _this.browserHistory = browserHistory;
            _this.objectFormatting = objectFormatting;
            _this.cookies = cookies;
            _this.customerType = customerType;
            _this.generalMethods = generalMethods;
            _this.injectRepresentativeInfo = injectRepresentativeInfo;
            _this.cartComponent = cartComponent;
            _this.searchSponsorGuard = searchSponsorGuard;
            _this.accountPersonalSite = accountPersonalSite;
            return _this;
        }
        Object.defineProperty(StWebAlias.prototype, "isCustomerGuest", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.guest;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRetail", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.retail;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "isCustomerRepresentative", {
            get: function() {
                return this.customerType.get() === _features_config_5.ECustomerType.representative;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerIdFromMetafields", {
            get: function() {
                return window.customerInfoMetafields.customerId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "shopifyCustomerId", {
            get: function() {
                return window.customerShopifyId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StWebAlias.prototype, "customerSponsorLastCheck", {
            get: function() {
                return window.customerSponsorLastCheck;
            },
            enumerable: false,
            configurable: true
        });
        return StWebAlias;
    }(st_module_15.StModule);
    exports.StWebAlias = StWebAlias;
});

define("core/shopify-app/st-modules/_general-methods/form/form-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_16) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormClassConfig = void 0;
    var StFormClassConfig = function(_super) {
        __extends(StFormClassConfig, _super);
        function StFormClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FormClassConfig";
            _this.classNameDateWrp = "st_date_JS";
            _this.selectorDateWrp = "." + _this.classNameDateWrp;
            _this.classNameDateYearInput = "st_date--year_JS";
            _this.selectorDateYearInput = "." + _this.classNameDateYearInput;
            _this.classNameDateMonthInput = "st_date--month_JS";
            _this.selectorDateMonthInput = "." + _this.classNameDateMonthInput;
            _this.classNameDateDayInput = "st_date--day_JS";
            _this.selectorDateDayInput = "." + _this.classNameDateDayInput;
            _this.classNameDateCompleteInput = "st_date--complete_JS";
            _this.selectorDateCompleteInput = "." + _this.classNameDateCompleteInput;
            _this.months = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
            return _this;
        }
        return StFormClassConfig;
    }(st_module_16.StModule);
    exports.StFormClassConfig = StFormClassConfig;
});

define("core/shopify-app/st-modules/_general-methods/form/fields/date-input", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDateInput = void 0;
    var StDateInput = function(_super) {
        __extends(StDateInput, _super);
        function StDateInput(classConfig) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "DateInput";
            _this_1.setupDateFields = function() {
                var dateWraps = document.querySelectorAll(_this_1.classConfig.selectorDateWrp);
                dateWraps.forEach(function(dateWrp) {
                    _this_1.setupDateField(dateWrp);
                });
            };
            _this_1.setupDateField = function(dateWrap) {
                var _a;
                var dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var now = new Date();
                var yearNow = now.getUTCFullYear();
                _this_1.generateYears(dateYearInput, 1900, yearNow);
                dateYearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var defaultYear = dateYearInput.getAttribute("data-default");
                var defaultYearIndex = !!defaultYear ? parseInt(dateYearInput.querySelector('[value="'.concat(defaultYear, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateYearInput, defaultYearIndex);
                _this_1.generateMonths(dateMonthInput);
                dateMonthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var defaultMonth = dateMonthInput.getAttribute("data-default");
                var defaultMonthIndex = !!defaultMonth ? parseInt(dateMonthInput.querySelector('[value="'.concat(defaultMonth, '"]')).getAttribute("data-index")) : 0;
                _this_1.setSelectValue(dateMonthInput, defaultMonthIndex);
                _this_1.generateDays(dateDayInput, (_a = parseInt(dateYearInput.value)) !== null && _a !== void 0 ? _a : yearNow, defaultMonthIndex);
                var defaultDay = dateDayInput.getAttribute("data-default");
                var defaultDayIndex = !!defaultDay ? parseInt(dateDayInput.querySelector('[value="'.concat(defaultDay, '"]')).getAttribute("data-index")) : 0;
                dateDayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                _this_1.setSelectValue(dateDayInput, defaultDayIndex);
                _this_1.setupEvents(dateWrap, dateYearInput, dateMonthInput, dateDayInput);
            };
            _this_1.getDays = function(year, month) {
                return new Date(year, month + 1, 0).getDate();
            };
            _this_1.generateDays = function(holder, year, month) {
                var days = _this_1.getDays(year, month);
                holder.replaceChildren();
                for (var i = 1; i <= days; i++) {
                    var option = _this_1.generateOption(i, undefined, undefined, i - 1);
                    holder.appendChild(option);
                }
                return days;
            };
            _this_1.generateMonths = function(holder) {
                for (var i = 0; i < _this_1.classConfig.months.length; i++) {
                    var option = _this_1.generateOption(i, _this_1.classConfig.months[i], undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateYears = function(holder, startingYear, endYear) {
                for (var i = 0; i < endYear - startingYear; i++) {
                    var option = _this_1.generateOption(endYear - i, undefined, undefined, i);
                    holder.appendChild(option);
                }
            };
            _this_1.generateOption = function(value, displayValue, selected, elementIndex) {
                if (displayValue === void 0) {
                    displayValue = value;
                }
                if (selected === void 0) {
                    selected = false;
                }
                var option = document.createElement("option");
                option.value = "".concat(value);
                option.setAttribute("value", "".concat(value));
                option.innerHTML = "".concat(displayValue);
                if (selected) {
                    option.setAttribute("selected", "selected");
                }
                if (typeof elementIndex !== "undefined") {
                    option.setAttribute("data-index", "".concat(elementIndex));
                }
                return option;
            };
            _this_1.setSelectValue = function(holder, optionIndex) {
                var options = holder.querySelectorAll("option");
                var selected = options[holder.selectedIndex];
                if (!!selected) {
                    selected.removeAttribute("selected");
                    selected.selected = false;
                }
                optionIndex = optionIndex > options.length - 1 ? options.length - 1 : optionIndex;
                holder.selectedIndex = optionIndex;
                options[optionIndex].selected = true;
                options[optionIndex].setAttribute("selected", "selected");
            };
            _this_1.setInputValue = function(input, value) {
                input.value = value;
                input.setAttribute("value", value);
                input.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            _this_1.setupEvents = function(dateWrap, yearInput, monthInput, dayInput) {
                var _this = _this_1;
                monthInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                yearInput.addEventListener("change", function(e) {
                    _this.adaptDaysOnChange(dateWrap);
                    _this.completeDate(dateWrap);
                });
                dayInput.addEventListener("change", function(e) {
                    _this.completeDate(dateWrap);
                });
            };
            _this_1.completeDate = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var completeInput = dateWrap.querySelector(_this_1.classConfig.selectorDateCompleteInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var completeDate = "".concat(year, "-").concat(month + 1, "-").concat(day);
                _this_1.setInputValue(completeInput, completeDate);
            };
            _this_1.adaptDaysOnChange = function(dateWrap) {
                var yearInput = dateWrap.querySelector(_this_1.classConfig.selectorDateYearInput);
                var monthInput = dateWrap.querySelector(_this_1.classConfig.selectorDateMonthInput);
                var dayInput = dateWrap.querySelector(_this_1.classConfig.selectorDateDayInput);
                var year = parseInt(yearInput.querySelectorAll("option")[yearInput.selectedIndex].value);
                var month = parseInt(monthInput.querySelectorAll("option")[monthInput.selectedIndex].value);
                var day = parseInt(dayInput.querySelectorAll("option")[dayInput.selectedIndex].value);
                var maxDays = _this_1.generateDays(dayInput, year, month);
                var selectedIndex = day > maxDays ? maxDays : day;
                _this_1.setSelectValue(dayInput, selectedIndex - 1);
            };
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StDateInput;
    }(st_module_17.StModule);
    exports.StDateInput = StDateInput;
});

define("core/shopify-app/st-modules/_general-methods/form/form", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_18) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StForm = void 0;
    var StForm = function(_super) {
        __extends(StForm, _super);
        function StForm(classConfig, dateInput) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Form";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.dateInput.setupDateFields();
                });
            };
            _this_1.liveTrim = function(inputs) {
                inputs = inputs ? inputs : document.querySelectorAll(".st_input");
                var trimOperation = function(trigger) {
                    trigger.value = trigger.value.replace(/  +/g, " ");
                    trigger.value = trigger.value.trimStart();
                };
                inputs.forEach(function(input) {
                    input.addEventListener("keyup", function() {
                        trimOperation(this);
                    });
                    input.addEventListener("change", function() {
                        trimOperation(this);
                    });
                });
            };
            _this_1.collectFormData = function(form) {
                if (form === undefined || form === null) {
                    return false;
                }
                var data = {};
                for (var i = 0; i < form.elements.length; i++) {
                    var field = form.elements[i];
                    data = __assign(__assign({}, data), _this_1.collectField(field));
                }
                return data;
            };
            _this_1.collectField = function(field) {
                var data = {};
                if (!field.name || field.type === "file" || field.type === "reset" || field.type === "submit" || field.type === "button") return data;
                if (field.disabled && field.tagName !== "SELECT") return data;
                if (field.type === "select-multiple") {
                    data[field.name] = [];
                    for (var n = 0; n < field.options.length; n++) {
                        if (!field.options[n].selected) continue;
                        data[field.name].push(field.options[n].value);
                    }
                } else if (field.type !== "checkbox" && field.type !== "radio") {
                    data[field.name] = field.value;
                    if (field.value.toLowerCase() === "true") {
                        data[field.name] = true;
                    } else if (field.value.toLowerCase() === "false") {
                        data[field.name] = false;
                    }
                } else if (field.type === "checkbox") {
                    data[field.name] = !!field.checked;
                }
                if (field.getAttribute("data-parse") === "true") {
                    if (field.getAttribute("data-decode") !== "false") {
                        data[field.name] = decodeURIComponent(data[field.name]);
                    }
                    data[field.name] = JSON.parse(data[field.name]);
                }
                return data;
            };
            _this_1.markValidation = function(page, inputName, isValid, invalidMessage) {
                if (invalidMessage === void 0) {
                    invalidMessage = "";
                }
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    var errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                    if (isValid) {
                        validationVisual.classList.remove("st_input_invalid");
                        if (!!errorMessage) {
                            errorMessage.remove();
                        }
                    } else {
                        validationVisual.classList.add("st_input_invalid");
                        if (!errorMessage) {
                            var errorMessageBlock = document.createElement("span");
                            errorMessageBlock.className = "st_message-error st_message-error_JS";
                            validationVisual.parentElement.append(errorMessageBlock);
                            errorMessage = validationVisual.parentElement.querySelector(".st_message-error_JS");
                        }
                        errorMessage.innerHTML = invalidMessage;
                    }
                });
            };
            _this_1.markValidationResults = function(page, validationResponse) {
                if (Object.keys(validationResponse).length > 0) {
                    Object.keys(validationResponse).forEach(function(paramName) {
                        _this_1.markValidation(page, paramName, validationResponse[paramName].isValid, validationResponse[paramName].message);
                    });
                }
            };
            _this_1.numbersOnly = function() {
                var numberInputs = document.querySelectorAll(".nuv_only-number_JS");
                if (numberInputs && numberInputs.length > 0) {
                    for (var i = 0; i < numberInputs.length; i++) {
                        var inputSelector = numberInputs[i];
                        inputSelector.addEventListener("keyup", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("input", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                        inputSelector.addEventListener("change", function() {
                            this.value = isNaN(parseInt(this.value)) ? "" : parseInt(this.value);
                        });
                    }
                }
            };
            _this_1.formValidation = function() {
                var _this = _this_1;
                var taxId = document.querySelector('[name="enrollment[tax_id]"]');
                if (taxId && typeof taxId != "undefined") {
                    taxId.addEventListener("input", function(e) {
                        _this.applyFormatting(this);
                    });
                }
                var email = document.querySelector('[name="enrollment[email]"]');
                if (email && typeof email != "undefined") {
                    email.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
                var upgradeEmail = document.querySelector('[name="address[email]"]');
                if (upgradeEmail && typeof upgradeEmail != "undefined") {
                    upgradeEmail.addEventListener("input", function(e) {
                        _this.validateEmail(this);
                    });
                }
            };
            _this_1.validateDateOfBirth = function() {
                var currentYear = new Date().getFullYear();
                var dateOfBirtd = document.querySelector('[name="enrollment[date_of_birtd]"]');
                if (dateOfBirtd && typeof dateOfBirtd != "undefined") {
                    var date = new Date(dateOfBirtd.value);
                    var year = date.getFullYear();
                    return year < currentYear && year > 1900;
                } else {
                    return false;
                }
            };
            _this_1.validateEmail = function(field) {
                var valid = false;
                var val = field.value;
                var at = val.indexOf("@");
                if (at >= 2) {
                    val = val.substr(at);
                    var dot = val.indexOf(".");
                    if (dot >= 2) {
                        val = val.substr(dot);
                        if (val.length >= 2) {
                            valid = true;
                            if (field.classList.contains("st-bds_invalid_input")) {
                                field.classList.remove("st-bds_invalid_input");
                            }
                        }
                    } else {
                        if (!field.classList.contains("st-bds_invalid_input")) {
                            field.classList.add("st-bds_invalid_input");
                        }
                    }
                } else {
                    if (!field.classList.contains("st-bds_invalid_input")) {
                        field.classList.add("st-bds_invalid_input");
                    }
                }
                return valid;
            };
            _this_1.applyFormatting = function(field) {
                var val = field.value;
                var format = "";
                var formatData = {
                    separator: "-",
                    format: "XXX-XX-XXXX",
                    type: "numeric"
                };
                if (formatData.type === "numeric") {
                    val = val.replace(/[^0-9]/g, "");
                }
                if (typeof formatData.format === "object") {
                    format = formatData.format[field.name];
                } else {
                    format = formatData.format;
                    var segments = formatData.separator ? formatData.format.split(formatData.separator) : [ formatData.format ];
                    var disp = [];
                    for (var i = 0; i < segments.length; i++) {
                        var it = val.substr(0, segments[i].length);
                        if (it !== "") {
                            disp.push(it);
                        }
                        val = val.replace(it, "");
                    }
                    val = disp.join(formatData.separator);
                }
                if (format.length > val.length) {
                    field.classList.add("st-bds_invalid_input");
                } else if (format.length === val.length) {
                    field.classList.remove("st-bds_invalid_input");
                } else {
                    val = val.substr(0, format.length);
                }
                field.value = val;
            };
            _this_1.clearFormatting = function(page, inputNames) {
                var _this = _this_1;
                inputNames.forEach(function(inputName) {
                    _this.markValidation(page, inputName, true, "");
                });
            };
            _this_1.dateInput = dateInput;
            _this_1.classConfig = classConfig;
            return _this_1;
        }
        return StForm;
    }(st_module_18.StModule);
    exports.StForm = StForm;
});

define("core/shopify-app/st-modules/account/account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_19) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccount = void 0;
    var StAccount = function(_super) {
        __extends(StAccount, _super);
        function StAccount(form) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Account";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            return _this;
        }
        return StAccount;
    }(st_module_19.StModule);
    exports.StAccount = StAccount;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_20) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentClassConfig = void 0;
    var StEnrollmentClassConfig = function(_super) {
        __extends(StEnrollmentClassConfig, _super);
        function StEnrollmentClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentClassConfig";
            _this.classNameEnrollmentWrapper = "st_enrollment_JS";
            _this.selectorEnrollmentWrapper = "." + _this.classNameEnrollmentWrapper;
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameEnrollmentPageShow = "st_show";
            _this.selectorEnrollmentPageShow = "." + _this.classNameEnrollmentPageShow;
            _this.classNameEnrollmentForm = "st_enrollment-section--form_JS";
            _this.selectorEnrollmentForm = "." + _this.classNameEnrollmentForm;
            _this.classNameEnrollmentPrev = "st_enrollment--prev_JS";
            _this.selectorEnrollmentPrev = "." + _this.classNameEnrollmentPrev;
            _this.classNameEnrollmentNext = "st_enrollment--next_JS";
            _this.selectorEnrollmentNext = "." + _this.classNameEnrollmentNext;
            _this.classNameEnrollmentNavWrapper = "st_enrollment-nav--wrapper_JS";
            _this.selectorEnrollmentNavWrapper = "." + _this.classNameEnrollmentNavWrapper;
            _this.classNameEnrollmentNavHolder = "st_enrollment-nav--holder_JS";
            _this.selectorEnrollmentNavHolder = "." + _this.classNameEnrollmentNavHolder;
            _this.classNameEnrollmentNavHolderSingle = "st_enrollment-nav--holder-single_JS";
            _this.selectorEnrollmentNavHolderSingle = "." + _this.classNameEnrollmentNavHolderSingle;
            _this.classNameEnrollmentNavButton = "st_enrollment-button_JS";
            _this.selectorEnrollmentNavButton = "." + _this.classNameEnrollmentNavButton;
            _this.classNameInputInvalid = "st_input_invalid";
            _this.selectorInputInvalid = "." + _this.classNameInputInvalid;
            _this.classNameElementShow = "st_show";
            _this.selectorElementShow = "." + _this.classNameElementShow;
            _this.classNameElementHide = "st_hidden";
            _this.selectorElementHide = "." + _this.classNameElementHide;
            _this.textSubmit = "Submit";
            _this.textNext = "Next";
            _this.classNameEnrollmentPrivacyForm = "st_enrollment-section--privacy-form_JS";
            _this.selectorEnrollmentPrivacyForm = "." + _this.classNameEnrollmentPrivacyForm;
            _this.classNameEnrollmentTnCField = "st_enrollment--tnc-field_JS";
            _this.selectorEnrollmentTnCField = "." + _this.classNameEnrollmentTnCField;
            _this.classNameEnrollmentAccountDetailsForm = "st_enrollment-section--account-details-form_JS";
            _this.selectorEnrollmentAccountDetailsForm = "." + _this.classNameEnrollmentAccountDetailsForm;
            _this.classNameEnrollmentAccountDetailsPhone = "st_enrollment-section--account-details-phone_JS";
            _this.selectorEnrollmentAccountDetailsPhone = "." + _this.classNameEnrollmentAccountDetailsPhone;
            _this.classNameEnrollmentBusinessDetailsWebAlias = "st_enrollment-section--business-details-web-alias_JS";
            _this.selectorEnrollmentBusinessDetailsWebAlias = "." + _this.classNameEnrollmentBusinessDetailsWebAlias;
            _this.classNameEnrollmentBusinessDetailsWebAliasPresenter = "st_enrollment-web-alias-preview_JS";
            _this.selectorEnrollmentBusinessDetailsWebAliasPresenter = "." + _this.classNameEnrollmentBusinessDetailsWebAliasPresenter;
            _this.classNameEnrollmentBusinessDetailsSSN = "st_enrollment-section--business-details-ssn_JS";
            _this.selectorEnrollmentBusinessDetailsSSN = "." + _this.classNameEnrollmentBusinessDetailsSSN;
            _this.classEnrollmentRequiredKitVariantSelect = "st_enrollment-required-kits-select_JS";
            _this.selectorEnrollmentRequiredKitVariantSelect = "." + _this.classEnrollmentRequiredKitVariantSelect;
            _this.classEnrollmentRequiredKitVariantHeading = "st_enrollment-required-kit-variant-title_JS";
            _this.selectorEnrollmentRequiredKitVariantHeading = "." + _this.classEnrollmentRequiredKitVariantHeading;
            _this.classEnrollmentRequiredKitVariantPrice = "st_enrollment-required-kit-price_JS";
            _this.selectorEnrollmentRequiredKitVariantPrice = "." + _this.classEnrollmentRequiredKitVariantPrice;
            _this.classEnrollmentRequiredKitSelectedVariantTitle = "st_enrollment-required-kits-selected-variant-title_JS";
            _this.selectorEnrollmentRequiredKitSelectedVariantTitle = "." + _this.classEnrollmentRequiredKitSelectedVariantTitle;
            _this.classEnrollmentHiddenRequiredKitInput = "st_hidden-requiredKitInput_JS";
            _this.selectorEnrollmentHiddenRequiredKitInput = "." + _this.classEnrollmentHiddenRequiredKitInput;
            _this.classEnrollmentRequiredKitWrapper = "st_consultant-kit-order--wrapper";
            _this.selectorEnrollmentRequiredKitWrapper = "." + _this.classEnrollmentRequiredKitWrapper;
            _this.classEnrollmentRequiredKitsOptionsWrapper = "st_enrollment-required-kits-options-wrapper_JS";
            _this.selectorEnrollmentRequiredKitsOptionsWrapper = "." + _this.classEnrollmentRequiredKitsOptionsWrapper;
            _this.classEnrollmentRequiredKitsText = "st_consultant-kit-text_JS";
            _this.selectorEnrollmentRequiredKitsText = "." + _this.classEnrollmentRequiredKitsText;
            _this.classEnrollmentRequiredKitsImg = "st_enrollment-required-kit-img_JS";
            _this.selectorEnrollmentRequiredKitsImg = "." + _this.classEnrollmentRequiredKitsImg;
            _this.classNameEnrollmentOptionalKitsInput = "st_optional-kits--input_JS";
            _this.selectorEnrollmentOptionalKitsInput = "." + _this.classNameEnrollmentOptionalKitsInput;
            _this.classNameEnrollmentOptionalKitsTrigger = "st_enrollment--optional-bundle-trigger_JS";
            _this.selectorEnrollmentOptionalKitsTrigger = "." + _this.classNameEnrollmentOptionalKitsTrigger;
            _this.reviewEditText = "Edit";
            _this.classNameEnrollmentReviewWrapper = "st_enrollment--review-wrapper_JS";
            _this.selectorEnrollmentReviewWrapper = "." + _this.classNameEnrollmentReviewWrapper;
            _this.classNameEnrollmentReviewParamHolder = "st_enrollment--review-param-holder_JS";
            _this.selectorEnrollmentReviewParamHolder = "." + _this.classNameEnrollmentReviewParamHolder;
            _this.classNameEnrollmentReviewCartWrapper = "st_enrollment--review-cart-wrapper_JS";
            _this.selectorEnrollmentReviewCartWrapper = "." + _this.classNameEnrollmentReviewCartWrapper;
            _this.classNameEnrollmentReviewCartContentWrapper = "st_enrollment--review-cart-content-wrapper_JS";
            _this.selectorEnrollmentReviewCartContentWrapper = "." + _this.classNameEnrollmentReviewCartContentWrapper;
            _this.classNameEnrollmentReviewCartTotalWrapper = "st_enrollment--review-cart-total-wrapper_JS";
            _this.selectorEnrollmentReviewCartTotalWrapper = "." + _this.classNameEnrollmentReviewCartTotalWrapper;
            _this.classNameEnrollmentReviewCartTotal = "st_enrollment--review-cart-total_JS";
            _this.selectorEnrollmentReviewCartTotal = "." + _this.classNameEnrollmentReviewCartTotal;
            return _this;
        }
        return StEnrollmentClassConfig;
    }(st_module_20.StModule);
    exports.StEnrollmentClassConfig = StEnrollmentClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_21) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollment = void 0;
    var StEnrollment = function(_super) {
        __extends(StEnrollment, _super);
        function StEnrollment(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Enrollment";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.preventFormSubmit();
                });
            };
            _this.classConfig = classConfig;
            return _this;
        }
        StEnrollment.prototype.preventFormSubmit = function(forms) {
            forms = forms ? forms : document.querySelectorAll(this.classConfig.selectorEnrollmentForm);
            if (forms.length > 0) {
                forms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                    });
                });
            }
        };
        return StEnrollment;
    }(st_module_21.StModule);
    exports.StEnrollment = StEnrollment;
});

define("core/shopify-app/st-modules/_general-methods/form/cart-manipulation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_22) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartManipulation = void 0;
    var StCartManipulation = function(_super) {
        __extends(StCartManipulation, _super);
        function StCartManipulation() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CartManipulation";
            return _this;
        }
        return StCartManipulation;
    }(st_module_22.StModule);
    exports.StCartManipulation = StCartManipulation;
});

define("core/shopify-app/st-modules/_general-methods/form/loader", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_23) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StLoader = void 0;
    var StLoader = function(_super) {
        __extends(StLoader, _super);
        function StLoader() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Loader";
            _this.init = function() {};
            _this.on = function(triggerBtn) {
                if (!!triggerBtn && !triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.add("st_loader-active");
                }
            };
            _this.off = function(triggerBtn) {
                if (!!triggerBtn && triggerBtn.classList.contains("st_loader-active")) {
                    triggerBtn.classList.remove("st_loader-active");
                }
            };
            return _this;
        }
        return StLoader;
    }(st_module_23.StModule);
    exports.StLoader = StLoader;
});

define("core/shopify-app/st-modules/_general-methods/button/button-actions", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_24) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StButtonActions = exports.EButtonAction = void 0;
    var EButtonAction;
    (function(EButtonAction) {
        EButtonAction["enable"] = "enable";
        EButtonAction["disable"] = "disable";
        EButtonAction["toggleState"] = "toggleState";
        EButtonAction["prevent"] = "prevent";
        EButtonAction["allow"] = "allow";
        EButtonAction["addLoader"] = "addLoader";
        EButtonAction["removeLoader"] = "removeLoader";
        EButtonAction["toggleLoader"] = "toggleLoader";
    })(EButtonAction = exports.EButtonAction || (exports.EButtonAction = {}));
    var StButtonActions = function(_super) {
        __extends(StButtonActions, _super);
        function StButtonActions() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ButtonActions";
            _this.applyToMultiple = function(buttons, action) {
                buttons.forEach(function(button) {
                    _this[action](button);
                });
            };
            _this.enable = function(button) {
                if (!!button) {
                    button.removeAttribute("disabled");
                    button.classList.remove("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.disable = function(button) {
                if (!!button) {
                    button.setAttribute("disabled", "");
                    button.classList.add("st-disabled");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.addLoader = function(button) {
                if (!!button) {
                    button.classList.add("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.removeLoader = function(button) {
                if (!!button) {
                    button.classList.remove("st-loading");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleState = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-disabled")) {
                        _this.enable(button);
                    } else {
                        _this.disable(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.toggleLoader = function(button) {
                if (!!button) {
                    if (button.classList.contains("st-loading")) {
                        _this.removeLoader(button);
                    } else {
                        _this.addLoader(button);
                    }
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.prevent = function(button) {
                if (!!button) {
                    _this.disable(button);
                    _this.addLoader(button);
                    button.classList.add("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.allow = function(button) {
                if (!!button) {
                    _this.enable(button);
                    _this.removeLoader(button);
                    button.classList.remove("st-blocked");
                } else {
                    console.error("Can't perform button action!. Button is undefined.");
                }
            };
            _this.isBlocked = function(button) {
                return button.classList.contains("st-blocked");
            };
            _this.isLoading = function(button) {
                return button.classList.contains("st-loading");
            };
            _this.isDisabled = function(button) {
                return button.classList.contains("st-disabled") || button.classList.contains("st-disabled");
            };
            return _this;
        }
        return StButtonActions;
    }(st_module_24.StModule);
    exports.StButtonActions = StButtonActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-submit/enrollment.submit.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-submit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_25, notification_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentActions = void 0;
    var StEnrollmentActions = function(_super) {
        __extends(StEnrollmentActions, _super);
        function StEnrollmentActions(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentActions";
            _this_1.submit = function(dataToSubmit) {
                var _this = _this_1;
                console.log(dataToSubmit);
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["submit"],
                    method: "post",
                    contentType: "json",
                    data: dataToSubmit,
                    callback: function(response) {
                        try {
                            var submitResponse = JSON.parse(response.response);
                            if (response.status === 200) {
                                if (submitResponse.data.checkoutUrl && submitResponse.data.checkoutUrl !== "") {
                                    console.log(submitResponse.data.checkoutUrl);
                                    window.location.href = submitResponse.data.checkoutUrl;
                                } else {
                                    window.location.href = window.typagehandle;
                                }
                            } else {
                                _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", submitResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_1.ENotificationType.error, "An Error Occurred", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StEnrollmentActions;
    }(st_module_25.StModule);
    exports.StEnrollmentActions = StEnrollmentActions;
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/enrollment/enrollment-validation/enrollment.validation.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-models", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/enrollment/page/enrollment-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_26) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentPage = void 0;
    var StEnrollmentPage = function(_super) {
        __extends(StEnrollmentPage, _super);
        function StEnrollmentPage(classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentPage";
            _this.maxPage = 0;
            _this.currentIndex = 0;
            _this.setMaxPage = function(maxPage) {
                _this.maxPage = maxPage;
            };
            _this.getMaxPage = function() {
                return _this.maxPage;
            };
            _this.setCurrentIndex = function(index) {
                _this.currentIndex = index;
            };
            _this.getCurrentIndex = function() {
                return _this.currentIndex;
            };
            _this.getCurrentPage = function() {
                return _this.getPageByIndex(_this.currentIndex);
            };
            _this.setupPageIndex = function(pages) {
                pages.forEach(function(page, ind) {
                    page.setAttribute("data-page-index", "" + ind);
                });
            };
            _this.getPageByIndex = function(pageIndex) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                return pages[pageIndex];
            };
            _this.openPage = function(pageIndex) {
                if (pageIndex === void 0) {
                    pageIndex = 0;
                }
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var alreadyOpen = wrp.querySelector(_this.classConfig.selectorEnrollmentPage + _this.classConfig.selectorEnrollmentPageShow);
                var enrollmentPages = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this.classConfig.selectorEnrollmentNavHolder);
                var enrollmentNavElements = navHolder.querySelectorAll(_this.classConfig.selectorEnrollmentNavHolderSingle);
                var prevButtons = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentPrev);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove(_this.classConfig.classNameElementShow);
                }
                if (enrollmentPages.length > 0) {
                    enrollmentPages[pageIndex].classList.add(_this.classConfig.classNameElementShow);
                } else {
                    console.error("Invalid page index supplied to enrollment openPage method!");
                }
                enrollmentNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("active");
                    navElement.classList.remove("current");
                    if (index < pageIndex) {
                        navElement.classList.add("active");
                    } else if (index === pageIndex) {
                        navElement.classList.add("current");
                    }
                });
                _this.setCurrentIndex(pageIndex);
                _this.changeButtonText();
                _this.prevButtonVisibility(prevButtons, pageIndex);
                _this.generalMethods.scrollTo(_this.getCurrentPage(), 500);
            };
            _this.changeButtonText = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var selectorEnrollmentNext = wrp.querySelector(_this.classConfig.selectorEnrollmentNext);
                selectorEnrollmentNext.querySelector("span").innerHTML = _this.currentIndex === _this.maxPage - 1 ? _this.classConfig.textSubmit : _this.classConfig.textNext;
            };
            _this.prevButtonVisibility = function(prevButtons, pageIndex) {
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StEnrollmentPage;
    }(st_module_26.StModule);
    exports.StEnrollmentPage = StEnrollmentPage;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_27, notification_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidation = void 0;
    var StEnrollmentValidation = function(_super) {
        __extends(StEnrollmentValidation, _super);
        function StEnrollmentValidation(classConfig, notification, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentValidate";
            _this_1.validationMethods = {};
            _this_1.setupValidation = function(validationClasses) {
                validationClasses.forEach(function(validationClass) {
                    var methods = validationClass.setupValidationMethods();
                    if (!!methods) {
                        _this_1.validationMethods = __assign(__assign({}, _this_1.validationMethods), methods);
                    }
                });
            };
            _this_1.getValidation = function() {
                return __assign({}, _this_1.validationMethods);
            };
            _this_1.markInvalid = function(page, inputName) {
                page.querySelectorAll('[data-validation-visual="'.concat(inputName, '"]')).forEach(function(validationVisual) {
                    validationVisual.classList.add(_this_1.classConfig.classNameInputInvalid);
                });
            };
            _this_1.clearInvalid = function(page, specificElement) {
                if (!!specificElement) {
                    specificElement.classList.remove(_this_1.classConfig.classNameInputInvalid);
                } else {
                    page.querySelectorAll(_this_1.classConfig.selectorInputInvalid).forEach(function(element) {
                        element.classList.remove(_this_1.classConfig.classNameInputInvalid);
                    });
                }
            };
            _this_1.serverValidate = function(dataToValidate, validCB, invalidCB) {
                if (validCB === void 0) {
                    validCB = function() {};
                }
                if (invalidCB === void 0) {
                    invalidCB = function() {};
                }
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this.endpoint["enrollment"]["validate-data"],
                    method: "post",
                    contentType: "json",
                    data: dataToValidate,
                    callback: function(request) {
                        try {
                            var data = JSON.parse(request.response);
                            if (request.status === 200) {
                                validCB(request, data);
                            } else {
                                invalidCB({
                                    status: request.status,
                                    message: data.message
                                });
                                _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", data.message);
                            }
                        } catch (error) {
                            invalidCB({
                                status: 500,
                                message: error.message
                            });
                            console.error(error);
                            _this.notification.showNotification(notification_2.ENotificationType.error, "Validation Error", error);
                        }
                    }
                });
            };
            _this_1.basicValidate = function(pageIndex) {
                var page, forms;
                if (typeof pageIndex !== "undefined" && pageIndex !== -1) {
                    page = _this_1.enrollmentPage.getPageByIndex(pageIndex);
                    forms = page.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                } else {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    forms = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                }
                for (var i = 0; i < forms.length; i++) {
                    var form = forms[i];
                    var sectionName = form.getAttribute("data-name");
                    var validation = _this_1.getValidation();
                    if (validation[sectionName]) {
                        var basicValidationParams = validation[sectionName].basic();
                        for (var j = 0; j < basicValidationParams.length; j++) {
                            var validationParam = basicValidationParams[j];
                            var input = form.querySelector('[name="'.concat(validationParam, '"]'));
                            if (!!input) {
                                if (typeof input.value === "undefined" || input.value === "") {
                                    return false;
                                }
                            } else {
                                console.warn('Input with name: "'.concat(validationParam, "\" was added to basic validation but doesn't exist in DOM. Skipping this field for validation."));
                            }
                        }
                    }
                }
                return true;
            };
            _this_1.basicValidationDelay = 200;
            _this_1.setupBasicValidationEvents = function(inputSelector, afterValidation) {
                var _this = _this_1;
                afterValidation(_this.runBasicValidation());
                var eventListenerFn = function() {
                    clearTimeout(_this.basicValidationTimeout);
                    _this.basicValidationTimeout = setTimeout(function() {
                        afterValidation(_this.runBasicValidation());
                    }, _this.basicValidationDelay);
                };
                inputSelector.addEventListener("input", eventListenerFn);
                inputSelector.addEventListener("change", eventListenerFn);
                inputSelector.addEventListener("paste", eventListenerFn);
            };
            _this_1.runBasicValidation = function() {
                var pageIndex = _this_1.enrollmentPage.getCurrentIndex();
                return _this_1.basicValidate(pageIndex);
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            _this_1.enrollmentPage = enrollmentPage;
            return _this_1;
        }
        return StEnrollmentValidation;
    }(st_module_27.StModule);
    exports.StEnrollmentValidation = StEnrollmentValidation;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_28) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBase = void 0;
    var StEnrollmentSectionBase = function(_super) {
        __extends(StEnrollmentSectionBase, _super);
        function StEnrollmentSectionBase(args) {
            var _this = _super.call(this, args) || this;
            _this.setupValidationMethods = function() {
                var methods = {};
                methods[_this.validationName] = {
                    site: _this.validateOnSite,
                    server: _this.validateOnServer,
                    basic: _this.addToBasicValidation
                };
                return methods;
            };
            _this.addToBasicValidation = function() {
                return [];
            };
            _this.validateOnServer = function() {
                return [];
            };
            _this.validateOnSite = function() {
                return [];
            };
            return _this;
        }
        StEnrollmentSectionBase.prototype.initFields = function() {};
        StEnrollmentSectionBase.prototype.selectFields = function() {
            return [];
        };
        return StEnrollmentSectionBase;
    }(st_module_28.StModule);
    exports.StEnrollmentSectionBase = StEnrollmentSectionBase;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionPrivacy = void 0;
    var StEnrollmentSectionPrivacy = function(_super) {
        __extends(StEnrollmentSectionPrivacy, _super);
        function StEnrollmentSectionPrivacy(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentSectionPrivacy";
            _this.validationName = "privacy";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentTnCField);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isChecked = input.checked === true;
                        var isRequired = !!input.getAttribute("required");
                        var isValid = isChecked && isRequired || !isRequired;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "You must accept terms and conditions to continue!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentSectionPrivacy;
    }(enrollment_section_validation_base_1.StEnrollmentSectionBase);
    exports.StEnrollmentSectionPrivacy = StEnrollmentSectionPrivacy;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionAccountDetails = void 0;
    var StEnrollmentSectionAccountDetails = function(_super) {
        __extends(StEnrollmentSectionAccountDetails, _super);
        function StEnrollmentSectionAccountDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetails";
            _this.validationName = "account-details";
            _this.addToBasicValidation = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            _this.validateOnServer = function() {
                return [ "firstName", "lastName", "phoneNumber", "dateOfBirth" ];
            };
            return _this;
        }
        return StEnrollmentSectionAccountDetails;
    }(enrollment_section_validation_base_2.StEnrollmentSectionBase);
    exports.StEnrollmentSectionAccountDetails = StEnrollmentSectionAccountDetails;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", [ "require", "exports", "core/shopify-app/st-modules/enrollment/_validation/enrollment-section-validation-base" ], function(require, exports, enrollment_section_validation_base_3) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentSectionBusinessDetails = void 0;
    var StEnrollmentSectionBusinessDetails = function(_super) {
        __extends(StEnrollmentSectionBusinessDetails, _super);
        function StEnrollmentSectionBusinessDetails() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentBusinessDetails";
            _this.validationName = "business-details";
            _this.addToBasicValidation = function() {
                return [ "SSN", "webAlias" ];
            };
            _this.validateOnServer = function() {
                return [ "SSN", "webAlias" ];
            };
            return _this;
        }
        return StEnrollmentSectionBusinessDetails;
    }(enrollment_section_validation_base_3.StEnrollmentSectionBase);
    exports.StEnrollmentSectionBusinessDetails = StEnrollmentSectionBusinessDetails;
});

define("core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_29) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentValidationSetup = void 0;
    var StEnrollmentValidationSetup = function(_super) {
        __extends(StEnrollmentValidationSetup, _super);
        function StEnrollmentValidationSetup(enrollmentValidation, sectionPrivacy, sectionAccountDetails, sectionBusinessDetails) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentValidationSetup";
            _this.setupValidation = function() {
                _this.enrollmentValidation.setupValidation([ _this.sectionPrivacy, _this.sectionAccountDetails, _this.sectionBusinessDetails ]);
            };
            _this.enrollmentValidation = enrollmentValidation;
            _this.sectionPrivacy = sectionPrivacy;
            _this.sectionAccountDetails = sectionAccountDetails;
            _this.sectionBusinessDetails = sectionBusinessDetails;
            return _this;
        }
        return StEnrollmentValidationSetup;
    }(st_module_29.StModule);
    exports.StEnrollmentValidationSetup = StEnrollmentValidationSetup;
});

define("core/shopify-app/st-modules/enrollment/_general/enrollment-store", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_30) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentStore = void 0;
    var StEnrollmentStore = function(_super) {
        __extends(StEnrollmentStore, _super);
        function StEnrollmentStore(classConfig, cartHandler) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentStore";
            _this.dataStore = {
                shopifyId: undefined
            };
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                    var shopifyId = parseInt(shopifyIdHolder.value);
                    _this.saveData({
                        shopifyId: shopifyId
                    });
                });
            };
            _this.saveData = function(dataToSave) {
                _this.dataStore = __assign(__assign({}, _this.dataStore), dataToSave);
                _this.updateCart({
                    attributes: __assign({}, _this.dataStore)
                }, function(cart) {
                    console.log(cart);
                });
            };
            _this.loadData = function() {
                return __assign({}, _this.dataStore);
            };
            _this.updateCart = function(params, callback) {
                _this.ajax.send({
                    endpoint: _this.cartHandler.shopifyCartApiEndpoints["update-cart"],
                    method: "POST",
                    contentType: "json",
                    data: params,
                    callback: function(request) {
                        callback(JSON.parse(request.response));
                    }
                });
            };
            _this.classConfig = classConfig;
            _this.cartHandler = cartHandler;
            return _this;
        }
        return StEnrollmentStore;
    }(st_module_30.StModule);
    exports.StEnrollmentStore = StEnrollmentStore;
});

define("core/shopify-app/st-modules/_general-methods/currency", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_31) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCurrency = exports.EAmountType = exports.ECurrencyFormatType = void 0;
    var ECurrencyFormatType;
    (function(ECurrencyFormatType) {
        ECurrencyFormatType["withCurrency"] = "withCurrency";
        ECurrencyFormatType["withoutCurrency"] = "withoutCurrency";
    })(ECurrencyFormatType = exports.ECurrencyFormatType || (exports.ECurrencyFormatType = {}));
    var EAmountType;
    (function(EAmountType) {
        EAmountType["amount"] = "amount";
        EAmountType["amount_no_decimals"] = "amount_no_decimals";
        EAmountType["unknown"] = "unknown";
    })(EAmountType = exports.EAmountType || (exports.EAmountType = {}));
    var StCurrency = function(_super) {
        __extends(StCurrency, _super);
        function StCurrency() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Currency";
            _this.currencyFormat = window.stCurrencyFormat;
            _this.applyFormat = function(amount, formatType) {
                if (formatType === void 0) {
                    formatType = ECurrencyFormatType.withCurrency;
                }
                var format = _this.currencyFormat[formatType];
                var amountType = _this.determineAmountType(format);
                if (amountType !== EAmountType.unknown) {
                    return format.replace("{{" + amountType + "}}", "" + amount.toFixed(2));
                } else {
                    console.error("Unrecognized price format. Returning price without currency formatting.");
                    return "" + amount;
                }
            };
            _this.determineAmountType = function(format) {
                if (format.indexOf("{{amount}}") > -1) {
                    return EAmountType.amount;
                } else if (format.indexOf("{{amount_no_decimals}}") > -1) {
                    return EAmountType.amount_no_decimals;
                } else {
                    return EAmountType.unknown;
                }
            };
            return _this;
        }
        StCurrency.prototype.commaFormattedPrice = function(amount, decimalDelimiter, thousandsDelimiter) {
            if (decimalDelimiter === void 0) {
                decimalDelimiter = ".";
            }
            if (thousandsDelimiter === void 0) {
                thousandsDelimiter = ",";
            }
            var amountComponents = String(amount).split(".", 2);
            var wholeNumber = parseInt(amountComponents[0]);
            if (isNaN(wholeNumber)) {
                return "";
            }
            var decimal = amountComponents[1];
            var minus = wholeNumber < 0 ? "-" : "";
            wholeNumber = Math.abs(wholeNumber);
            var wholeString = String(wholeNumber);
            var amountSegmented = [];
            while (wholeString.length > 3) {
                amountSegmented.unshift(wholeString.substr(wholeString.length - 3));
                wholeString = wholeString.substr(0, wholeString.length - 3);
            }
            if (wholeString.length > 0) {
                amountSegmented.unshift(wholeString);
            }
            wholeString = amountSegmented.join(thousandsDelimiter);
            decimal = decimal.length < 1 ? "" : decimalDelimiter + decimal;
            return minus + wholeString + decimal;
        };
        return StCurrency;
    }(st_module_31.StModule);
    exports.StCurrency = StCurrency;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_32, currency_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReviewCart = void 0;
    var StEnrollmentReviewCart = function(_super) {
        __extends(StEnrollmentReviewCart, _super);
        function StEnrollmentReviewCart(classConfig, store, currency) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentReviewCart";
            _this.injectCart = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var cartContent = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartContentWrapper);
                var cartWrapper = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartWrapper);
                var storeData = _this.store.loadData();
                var reqKits = storeData.requiredKits ? storeData.requiredKits : [];
                var optKits = storeData.optionalKits ? storeData.optionalKits : [];
                var selectedProducts = __spreadArray(__spreadArray([], reqKits, true), optKits, true);
                if (selectedProducts.length > 0) {
                    !!cartWrapper && cartWrapper.classList.remove("st_hidden");
                    !!cartContent && cartContent.classList.remove("st_hidden");
                    !!cartContent && cartContent.replaceChildren();
                    var productPrices_1 = [];
                    selectedProducts.forEach(function(selectedProduct) {
                        var imageEl = wrp.querySelector('[data-image-holder="'.concat(selectedProduct.variantId, '"]'));
                        var titleEl = wrp.querySelector('[data-title-holder="'.concat(selectedProduct.variantId, '"]'));
                        var descriptionEl = wrp.querySelector('[data-description-holder="'.concat(selectedProduct.variantId, '"]'));
                        var priceEl = wrp.querySelector('[data-price-holder="'.concat(selectedProduct.variantId, '"]'));
                        var recurringEl = wrp.querySelector('[data-recurring-holder="'.concat(selectedProduct.variantId, '"]'));
                        var sellingPlanEl = wrp.querySelector('[data-selling-plan-holder="'.concat(selectedProduct.variantId, '"]'));
                        var imageURL = !!imageEl ? imageEl.src : "";
                        var title = !!titleEl ? titleEl.innerHTML : "";
                        var description = !!descriptionEl ? descriptionEl.innerHTML : "";
                        var price = !!priceEl ? priceEl.innerHTML : "";
                        var priceRaw = !!priceEl ? parseInt(priceEl.getAttribute("data-price-raw")) : 0;
                        var recurring = !!recurringEl ? recurringEl.value === "true" : false;
                        var sellingPlan = !!sellingPlanEl ? sellingPlanEl.value : "One Time Payment";
                        var printableReviewProduct = {
                            variantId: selectedProduct.variantId,
                            image: imageURL,
                            title: title,
                            description: description,
                            price: price,
                            recurring: recurring,
                            sellingPlan: sellingPlan
                        };
                        productPrices_1.push(priceRaw);
                        if (!!cartContent) {
                            var cartMember = _this.generateCartMember(printableReviewProduct);
                            cartContent.appendChild(cartMember);
                        }
                    });
                    var cartTotalEl = wrp.querySelector(_this.classConfig.selectorEnrollmentReviewCartTotal);
                    if (!!cartTotalEl) {
                        var total = productPrices_1.reduce(function(accumulator, value) {
                            return accumulator + parseInt("".concat(value));
                        });
                        cartTotalEl.innerHTML = _this.currency.applyFormat(total / 100, currency_1.ECurrencyFormatType.withCurrency);
                    }
                } else {
                    !!cartWrapper && cartWrapper.classList.add("st_hidden");
                    !!cartContent && cartContent.classList.add("st_hidden");
                }
            };
            _this.generateCartMembers = function(products) {
                var output = [];
                products.forEach(function(productInfo) {
                    var cartMember = _this.generateCartMember(productInfo);
                    output.push(cartMember);
                });
                return output;
            };
            _this.generateCartMember = function(productInfo) {
                var wrap = document.createElement("div");
                wrap.classList.add("st_enrollment-checkout-row");
                wrap.classList.add("st_flex");
                wrap.classList.add("st_align");
                var imageWrap = document.createElement("div");
                imageWrap.classList.add("st_enrollment-image--wrapper");
                var image = document.createElement("img");
                image.src = productInfo.image;
                image.alt = productInfo.title;
                var listWrapper = document.createElement("div");
                listWrapper.classList.add("st_enrollment-list--wrapper");
                var title = document.createElement("div");
                title.classList.add("st_title");
                title.innerHTML = productInfo.title;
                var description = document.createElement("div");
                description.innerHTML = productInfo.description;
                var priceWrapper = document.createElement("div");
                priceWrapper.classList.add("st_enrollment-price--wrapper");
                var recurring = document.createElement("div");
                recurring.classList.add("st_subscription");
                recurring.classList.add("st_subscription-review");
                recurring.innerText = productInfo.sellingPlan;
                var price = document.createElement("div");
                price.classList.add("st_price");
                price.innerHTML = productInfo.price;
                imageWrap.appendChild(image);
                listWrapper.appendChild(title);
                listWrapper.appendChild(description);
                priceWrapper.appendChild(recurring);
                priceWrapper.appendChild(price);
                wrap.appendChild(imageWrap);
                wrap.appendChild(listWrapper);
                wrap.appendChild(priceWrapper);
                return wrap;
            };
            _this.classConfig = classConfig;
            _this.store = store;
            _this.currency = currency;
            return _this;
        }
        return StEnrollmentReviewCart;
    }(st_module_32.StModule);
    exports.StEnrollmentReviewCart = StEnrollmentReviewCart;
});

define("core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_33) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentOptionalKits = void 0;
    var StEnrollmentOptionalKits = function(_super) {
        __extends(StEnrollmentOptionalKits, _super);
        function StEnrollmentOptionalKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentOptionalBundle";
            _this_1.setupButtons = function(buttons) {
                var _this = _this_1;
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        var variantId = this.getAttribute("data-variant-id");
                        var quantity = parseInt(this.getAttribute("data-quantity"));
                        var sellingPlan = this.getAttribute("data-selling-plan");
                        var selected = this.getAttribute("data-selected") === "true";
                        selected = !selected;
                        var bundleObject = {
                            variantId: "" + variantId,
                            quantity: quantity
                        };
                        if (sellingPlan && sellingPlan !== "") {
                            bundleObject.selling_plan = sellingPlan;
                        }
                        var span = this.querySelector(".st_text");
                        var icon = this.querySelector(".st_check-icon");
                        if (selected) {
                            icon.classList.remove("st_hidden");
                            span.classList.add("st_hidden");
                        } else {
                            icon.classList.add("st_hidden");
                            span.classList.remove("st_hidden");
                        }
                        _this.toggleBundleSelect(selected, bundleObject);
                        this.setAttribute("data-selected", selected);
                    });
                });
            };
            _this_1.toggleBundleSelect = function(makeSelected, bundleObject) {
                try {
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var optionalBundlesInput = wrp.querySelector(_this_1.classConfig.selectorEnrollmentOptionalKitsInput);
                    var selectedBundles = JSON.parse(optionalBundlesInput.value);
                    if (makeSelected) {
                        var itemAlreadySelected = false;
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId === "" + bundleObject.variantId) {
                                itemAlreadySelected = true;
                                break;
                            }
                        }
                        if (!itemAlreadySelected) {
                            selectedBundles.push(bundleObject);
                        }
                    } else {
                        var formattedBundles = [];
                        for (var i = 0; i < selectedBundles.length; i++) {
                            if ("" + selectedBundles[i].variantId !== "" + bundleObject.variantId) {
                                formattedBundles.push(selectedBundles[i]);
                            }
                        }
                        selectedBundles = formattedBundles;
                    }
                    optionalBundlesInput.value = JSON.stringify(selectedBundles);
                    optionalBundlesInput.setAttribute("value", optionalBundlesInput.value);
                    _this_1.store.saveData({
                        optionalKits: selectedBundles
                    });
                    _this_1.reviewCart.injectCart();
                } catch (e) {
                    console.error("An error occurred while processing toggleBundleSelect. Error message: " + e.message);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentOptionalKits;
    }(st_module_33.StModule);
    exports.StEnrollmentOptionalKits = StEnrollmentOptionalKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_34) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRequiredKits = void 0;
    var StEnrollmentRequiredKits = function(_super) {
        __extends(StEnrollmentRequiredKits, _super);
        function StEnrollmentRequiredKits(classConfig, store, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentRequiredBundle";
            _this_1.init = function() {
                var _this = _this_1;
                _this_1.subscribeDOMLoaded(function() {
                    _this.store.saveData({
                        requiredKits: _this.getRequiredKits()
                    });
                    _this_1.reviewCart.injectCart();
                    _this_1.onRequiredKitVariantSelect();
                });
            };
            _this_1.getRequiredKits = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var requiredKitsHolder = wrp.querySelector('[name="requiredKits"]');
                return requiredKitsHolder ? JSON.parse(decodeURIComponent(requiredKitsHolder.value)) : [];
            };
            _this_1.format = function(sourceData) {
                var formattedData = [];
                sourceData.forEach(function(item) {
                    if (typeof item.variantId !== "undefined") {
                        var formattedItem = {
                            variantId: item.variantId.toString(),
                            quantity: item.quantity
                        };
                        if (item.selling_plan && item.selling_plan !== "") {
                            formattedItem.selling_plan = item.selling_plan + "";
                        }
                        formattedData.push(formattedItem);
                    }
                });
                return formattedData;
            };
            _this_1.onRequiredKitVariantSelect = function() {
                var _this = _this_1;
                var requiredKitWrapperList = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentRequiredKitWrapper);
                if (!!requiredKitWrapperList) {
                    requiredKitWrapperList.forEach(function(requiredKitWrapper) {
                        var variantSelect = requiredKitWrapper.querySelector(_this_1.classConfig.selectorEnrollmentRequiredKitVariantSelect);
                        if (!!variantSelect) {
                            variantSelect.onchange = function() {
                                var variantValue = JSON.parse(decodeURI(variantSelect.value));
                                var optionValue = [];
                                optionValue.push(variantValue);
                                var variantHiddenWrapper = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsOptionsWrapper);
                                var requiredKitDescription = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsText);
                                var requiredKitImg = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitsImg);
                                var variantTitleHeading = document.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantHeading);
                                var variantTitle = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitSelectedVariantTitle);
                                var variantTitleHidden = variantHiddenWrapper.querySelector('input[data-title-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPrice = requiredKitWrapper.querySelector(_this.classConfig.selectorEnrollmentRequiredKitVariantPrice);
                                var variantPriceHidden = variantHiddenWrapper.querySelector('input[data-price-holder="'.concat(variantValue.variantId, '"]'));
                                var variantPriceRawHidden = variantHiddenWrapper.querySelector('input[data-price-raw-holder="'.concat(variantValue.variantId, '"]'));
                                var hiddenVariantInput = document.querySelector(_this.classConfig.selectorEnrollmentHiddenRequiredKitInput);
                                if (!!requiredKitDescription) {
                                    requiredKitDescription.setAttribute("data-description-holder", variantValue.variantId);
                                }
                                if (!!requiredKitImg) {
                                    requiredKitImg.setAttribute("data-image-holder", variantValue.variantId);
                                }
                                if (!!variantTitleHeading) {
                                    variantTitleHeading.innerHTML = variantTitleHidden.value;
                                    variantTitleHeading.setAttribute("data-title-holder", variantValue.variantId);
                                }
                                if (!!variantTitle) {
                                    variantTitle.innerHTML = variantTitleHidden.value;
                                }
                                if (!!variantPrice) {
                                    variantPrice.innerHTML = variantPriceHidden.value;
                                    variantPrice.setAttribute("data-price-holder", variantValue.variantId);
                                    variantPrice.setAttribute("data-price-raw", variantPriceRawHidden.value);
                                }
                                if (!!hiddenVariantInput) {
                                    delete optionValue[optionValue.length - 1].price;
                                    hiddenVariantInput.value = encodeURI(JSON.stringify(optionValue));
                                    hiddenVariantInput.setAttribute("value", JSON.stringify(optionValue));
                                    _this.store.saveData({
                                        requiredKits: optionValue
                                    });
                                    _this_1.reviewCart.injectCart();
                                }
                            };
                        }
                    });
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentRequiredKits;
    }(st_module_34.StModule);
    exports.StEnrollmentRequiredKits = StEnrollmentRequiredKits;
});

define("core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_35) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentReview = void 0;
    var EFormatType;
    (function(EFormatType) {
        EFormatType["date"] = "date";
    })(EFormatType || (EFormatType = {}));
    var StEnrollmentReview = function(_super) {
        __extends(StEnrollmentReview, _super);
        function StEnrollmentReview(classConfig, store, generalMethods, enrollmentPage, currency, form, reviewCart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentReview";
            _this_1.setupReview = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                if (_this_1.reviewBlockExists(wrp)) {
                    var holder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewParamHolder);
                    if (!!holder) {
                        _this_1.generateReviewParams(holder, _this_1.getParamInfo());
                    }
                    var paramSources = wrp.querySelectorAll("[data-review-param]");
                    _this_1.setupParamChangeEvents(paramSources);
                }
            };
            _this_1.reviewBlockExists = function(wrp) {
                var reviewSection = wrp.querySelector(_this_1.classConfig.selectorEnrollmentReviewWrapper);
                return !!reviewSection;
            };
            _this_1.getParamInfo = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramHolders = wrp.querySelectorAll("[data-review-param]");
                var params = [];
                var storedData = _this_1.store.loadData();
                paramHolders.forEach(function(paramHolder) {
                    var pageWrapper = _this_1.generalMethods.getClosestByClass(paramHolder, _this_1.classConfig.classNameEnrollmentPage);
                    var pageIndex = parseInt(pageWrapper.getAttribute("data-page-index"));
                    var inputName = paramHolder.getAttribute("name");
                    var formatName = paramHolder.getAttribute("data-format");
                    var param = {
                        name: paramHolder.getAttribute("data-review-param"),
                        inputName: inputName,
                        value: storedData[inputName] ? storedData[inputName] : "",
                        allowEdit: paramHolder.getAttribute("data-review-edit") !== "false",
                        pageIndex: pageIndex,
                        format: _this_1.getFormatByName(EFormatType[formatName])
                    };
                    params.push(param);
                });
                return params;
            };
            _this_1.getFormatByName = function(name) {
                if (name === EFormatType.date) {
                    return function(value) {
                        if (value && value !== "-") {
                            var dateComponents = value.split("-");
                            var days = dateComponents[2];
                            days = days.length === 1 ? "0".concat(days) : "".concat(days);
                            var months = dateComponents[1];
                            months = months.length === 1 ? "0".concat(months) : "".concat(months);
                            var years = dateComponents[0];
                            return "".concat(months, "/").concat(days, "/").concat(years);
                        } else {
                            return "";
                        }
                    };
                } else {
                    return function(value) {
                        return value;
                    };
                }
            };
            _this_1.generateReviewParams = function(holder, params) {
                var _this = _this_1;
                params.forEach(function(param, ind) {
                    var row = document.createElement("div");
                    row.classList.add("st_enrollment-business-info-row");
                    var col = document.createElement("div");
                    col.classList.add("st_info-column");
                    var colL = document.createElement("div");
                    colL.classList.add("st_col-left");
                    var colName = document.createElement("div");
                    colName.classList.add("st_name");
                    colName.innerText = param.name;
                    colL.appendChild(colName);
                    var value = typeof param.value !== "undefined" && param.value !== "" ? "" + param.value : "-";
                    var colValue = document.createElement("div");
                    colValue.classList.add("st_print-name");
                    if (param.inputName == "email") colValue.classList.add("st_email");
                    colValue.setAttribute("data-field-for", param.inputName);
                    colValue.innerText = param.format(value);
                    colL.appendChild(colValue);
                    col.appendChild(colL);
                    var colR = document.createElement("div");
                    colR.classList.add("st_col-right");
                    if (param.allowEdit) {
                        var editButton = document.createElement("button");
                        editButton.setAttribute("type", "button");
                        editButton.classList.add("st_enrollment-edit");
                        editButton.setAttribute("data-page-index", "" + param.pageIndex);
                        editButton.setAttribute("data-edit-for", param.inputName);
                        editButton.innerText = _this_1.classConfig.reviewEditText;
                        colR.appendChild(editButton);
                        editButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.edit(this.getAttribute("data-edit-for"), parseInt(this.getAttribute("data-page-index")));
                        });
                    }
                    col.appendChild(colR);
                    row.appendChild(col);
                    holder.appendChild(row);
                });
            };
            _this_1.setupParamChangeEvents = function(paramSources) {
                var _this = _this_1;
                paramSources.forEach(function(paramHolder) {
                    var fieldObj = _this.form.collectField(paramHolder);
                    var inputName = paramHolder.getAttribute("name");
                    var name = paramHolder.getAttribute("data-review-param");
                    var value = fieldObj[inputName];
                    _this.applyParamChange(name, inputName, value.toString());
                    paramHolder.addEventListener("keyup", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("input", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                    paramHolder.addEventListener("change", function(e) {
                        var fieldObj = _this.form.collectField(this);
                        var inputName = this.getAttribute("name");
                        var name = this.getAttribute("data-review-param");
                        var value = fieldObj[inputName];
                        _this.applyParamChange(name, inputName, value.toString());
                    });
                });
            };
            _this_1.applyParamChange = function(name, inputName, value) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var holder = wrp.querySelector('[data-review-param="'.concat(name, '"]'));
                var param = wrp.querySelector('[data-field-for="'.concat(inputName, '"]'));
                var formatName = holder.getAttribute("data-format");
                var format = _this_1.getFormatByName(EFormatType[formatName]);
                if (param) {
                    param.innerText = format(value.toString());
                } else {
                    console.error("Review template error. Couldn't find element to change parameter with name: ".concat(inputName, "."));
                }
            };
            _this_1.edit = function(holderName, pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var currentPage = _this_1.enrollmentPage.getCurrentPage();
                var holdersFirstVisual = currentPage.querySelector('[data-validation-visual="'.concat(holderName, '"]'));
                if (!!holdersFirstVisual) {
                    _this_1.generalMethods.scrollTo(holdersFirstVisual, 500);
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.store = store;
            _this_1.generalMethods = generalMethods;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.currency = currency;
            _this_1.form = form;
            _this_1.reviewCart = reviewCart;
            return _this_1;
        }
        return StEnrollmentReview;
    }(st_module_35.StModule);
    exports.StEnrollmentReview = StEnrollmentReview;
});

define("core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/button/button-actions" ], function(require, exports, st_module_36, notification_3, button_actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentNav = void 0;
    var StEnrollmentNav = function(_super) {
        __extends(StEnrollmentNav, _super);
        function StEnrollmentNav(classConfig, actions, optionalKits, requiredKits, store, form, buttonActions, enrollmentValidation, enrollmentValidationSetup, notification, enrollmentReview, enrollmentPage) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupNavPages();
                    _this_1.setupButtons();
                    _this_1.setupOptionalBundles();
                    _this_1.setupBasicValidation();
                });
            };
            _this_1.setupButtons = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                if (pages.length > 0) {
                    _this_1.enrollmentPage.setMaxPage(pages.length);
                    _this_1.enrollmentPage.setupPageIndex(pages);
                    _this_1.enrollmentReview.setupReview();
                    _this_1.openPage(_this_1.enrollmentPage.getCurrentIndex());
                    if (!!wrp) {
                        _this_1.bindEvents(wrp);
                    } else {
                        console.error("Enrollment wrapper does not exist! Cannot setup enrollment nav.");
                    }
                } else {
                    console.error("Enrollment doesn't have a page! Can't init enrollment!");
                }
            };
            _this_1.openPage = function(pageIndex) {
                _this_1.enrollmentPage.openPage(pageIndex);
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                if (pageIndex === 0) {
                    prevButtons.forEach(function(button) {
                        button.classList.add("st_hidden");
                    });
                } else {
                    prevButtons.forEach(function(button) {
                        button.classList.remove("st_hidden");
                    });
                }
            };
            _this_1.bindEvents = function(wrp) {
                var _this = _this_1;
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                nextButtons.forEach(function(nextButton) {
                    nextButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (!_this.buttonActions.isDisabled(this)) {
                            _this.nextOrSubmit();
                        }
                    });
                });
                prevButtons.forEach(function(prevButton) {
                    prevButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.prev();
                    });
                });
            };
            _this_1.setupOptionalBundles = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var optionalBundleTriggers = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentOptionalKitsTrigger);
                _this_1.optionalKits.setupButtons(optionalBundleTriggers);
            };
            _this_1.nextOrSubmit = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var enrollmentPages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var currentPage = enrollmentPages[_this_1.enrollmentPage.getCurrentIndex()];
                var forms = currentPage.querySelectorAll(_this_1.classConfig.selectorEnrollmentForm);
                var shopifyIdHolder = wrp.querySelector('[name="shopifyId"]');
                var shopifyId = parseInt(shopifyIdHolder.value);
                var serverValidationParams = {
                    shopifyId: shopifyId
                };
                var onSiteValidationFunctions = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var dataToSave = {};
                _this_1.enrollmentValidation.clearInvalid(currentPage);
                forms.forEach(function(form) {
                    var sectionName = form.getAttribute("data-name");
                    if (!!sectionName && sectionName !== "") {
                        var formData_1 = _this_1.form.collectFormData(form);
                        var paramsToValidate_1 = {};
                        dataToSave = __assign(__assign({}, dataToSave), formData_1);
                        if (validation.hasOwnProperty(sectionName)) {
                            var backendParamNames = validation[sectionName].server();
                            backendParamNames.forEach(function(param) {
                                if (typeof paramsToValidate_1[param] !== "undefined") {
                                    console.error("Duplicate setup of param with name: ".concat(param));
                                }
                                paramsToValidate_1[param] = formData_1[param];
                            });
                            serverValidationParams = __assign(__assign({}, serverValidationParams), paramsToValidate_1);
                            onSiteValidationFunctions.push(validation[sectionName].site);
                        } else {
                            console.log('Enrollment block with name "'.concat(sectionName, '" does not have registered validation class. Skipping validation.'));
                        }
                    }
                });
                var joinedValidationResponse = {};
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.prevent);
                _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.prevent);
                if (Object.keys(serverValidationParams).length > 0) {
                    _this_1.enrollmentValidation.serverValidate(serverValidationParams, function(response, validation) {
                        joinedValidationResponse = _this_1.validateOnSite(__assign({}, validation.data), onSiteValidationFunctions);
                        _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                    }, function(error) {
                        console.error("An error occurred with status: ".concat(error.status, ". Message: ").concat(error.message));
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    });
                } else {
                    joinedValidationResponse = _this_1.validateOnSite(joinedValidationResponse, onSiteValidationFunctions);
                    _this_1.afterValidation(joinedValidationResponse, dataToSave, currentPage);
                }
            };
            _this_1.validateOnSite = function(joinedValidationResponse, onSiteValidationFunctions) {
                if (onSiteValidationFunctions === void 0) {
                    onSiteValidationFunctions = [];
                }
                var output = joinedValidationResponse;
                onSiteValidationFunctions.forEach(function(paramValidationFunction) {
                    output = __assign(__assign({}, output), paramValidationFunction());
                });
                return output;
            };
            _this_1.afterValidation = function(validationResponse, dataToSave, page) {
                if (Object.keys(validationResponse).length > 0) {
                    var hasInvalid_1 = false;
                    var errorMessage_1 = [];
                    Object.keys(validationResponse).forEach(function(paramName) {
                        if (!validationResponse[paramName].isValid) {
                            _this_1.enrollmentValidation.markInvalid(page, paramName);
                            hasInvalid_1 = true;
                            errorMessage_1.push(validationResponse[paramName].message);
                        }
                    });
                    if (hasInvalid_1) {
                        _this_1.notification.showNotification(notification_3.ENotificationType.error, "Some fields are invalid!", errorMessage_1);
                        var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                        var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                        var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                        _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                        _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                    } else {
                        _this_1.store.saveData(dataToSave);
                        _this_1.next();
                    }
                } else {
                    _this_1.store.saveData(dataToSave);
                    _this_1.next();
                }
            };
            _this_1.setupBasicValidation = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var paramNames = [];
                var validation = _this_1.enrollmentValidation.getValidation();
                var allFormNames = Object.keys(validation);
                allFormNames.forEach(function(formName) {
                    if (validation[formName]) {
                        paramNames = paramNames.concat(validation[formName].basic());
                    }
                });
                for (var i = 0; i < paramNames.length; i++) {
                    var param = paramNames[i];
                    var input = wrp.querySelector('[name="'.concat(param, '"]'));
                    _this_1.enrollmentValidation.setupBasicValidationEvents(input, _this_1.afterBasicValidation);
                }
            };
            _this_1.afterBasicValidation = function(valid) {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                if (valid) {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.enable(nextButton);
                    });
                } else {
                    nextButtons.forEach(function(nextButton) {
                        _this_1.buttonActions.disable(nextButton);
                    });
                }
            };
            _this_1.next = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex + 1 < _this_1.enrollmentPage.getMaxPage()) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex + 1);
                    _this_1.openPage(currentIndex + 1);
                    var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                    var nextButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentNext);
                    var prevButtons = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPrev);
                    _this_1.buttonActions.applyToMultiple(nextButtons, button_actions_1.EButtonAction.allow);
                    _this_1.buttonActions.applyToMultiple(prevButtons, button_actions_1.EButtonAction.allow);
                } else {
                    var data = _this_1.store.loadData();
                    var items = data.requiredKits ? _this_1.requiredKits.format(data.requiredKits) : [];
                    items = data.optionalKits ? items.concat(data.optionalKits) : items;
                    var submit = {
                        shopifyId: data.shopifyId,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        phoneNumber: data.phoneNumber,
                        webAlias: data.webAlias,
                        sponsorsWebAlias: data.sponsorsWebAlias,
                        dateOfBirth: data.dateOfBirth,
                        SSN: data.SSN,
                        items: items
                    };
                    _this_1.actions.submit(submit);
                }
            };
            _this_1.prev = function() {
                var currentIndex = _this_1.enrollmentPage.getCurrentIndex();
                if (currentIndex - 1 >= 0) {
                    _this_1.enrollmentPage.setCurrentIndex(currentIndex - 1);
                    _this_1.openPage(currentIndex - 1);
                }
            };
            _this_1.setupNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorEnrollmentWrapper);
                var pages = wrp.querySelectorAll(_this_1.classConfig.selectorEnrollmentPage);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavHolder);
                if (!!navHolder) {
                    if (pages.length > 1) {
                        pages.forEach(function(page, pageIndex) {
                            var templateName = page.getAttribute("data-name");
                            var isActive = pageIndex === 0;
                            navHolder.appendChild(_this_1.navPageTemplate(pageIndex, templateName, isActive));
                        });
                    } else {
                        var navWrp = wrp.querySelector(_this_1.classConfig.selectorEnrollmentNavWrapper);
                        if (navWrp) {
                            navWrp.classList.add(_this_1.classConfig.classNameElementHide);
                        }
                    }
                } else {
                    console.error("Enrollment Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, isActive) {
                if (templateName === void 0) {
                    templateName = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-enrollment-single-column");
                templateNode.classList.add(_this_1.classConfig.classNameEnrollmentNavHolderSingle);
                if (isActive) {
                    templateNode.classList.add("active");
                }
                var innerWrapper = document.createElement("div");
                innerWrapper.classList.add("st_flex");
                innerWrapper.classList.add("st_align");
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-enrollment");
                button.classList.add(_this_1.classConfig.selectorEnrollmentNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName;
                var pageNumber = document.createElement("span");
                pageNumber.classList.add("st_number");
                pageNumber.innerHTML = "" + (pageIndex + 1);
                button.appendChild(pageNumber);
                innerWrapper.appendChild(button);
                innerWrapper.appendChild(text);
                templateNode.appendChild(innerWrapper);
                return templateNode;
            };
            _this_1.classConfig = classConfig;
            _this_1.actions = actions;
            _this_1.optionalKits = optionalKits;
            _this_1.requiredKits = requiredKits;
            _this_1.store = store;
            _this_1.form = form;
            _this_1.buttonActions = buttonActions;
            _this_1.enrollmentValidation = enrollmentValidation;
            _this_1.enrollmentValidationSetup = enrollmentValidationSetup;
            _this_1.notification = notification;
            _this_1.enrollmentReview = enrollmentReview;
            _this_1.enrollmentPage = enrollmentPage;
            _this_1.enrollmentValidationSetup.setupValidation();
            return _this_1;
        }
        return StEnrollmentNav;
    }(st_module_36.StModule);
    exports.StEnrollmentNav = StEnrollmentNav;
});

define("core/connector-app/_shared/models/search-sponsor/search.sponsor.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_37) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsorService = void 0;
    var StSearchSponsorService = function(_super) {
        __extends(StSearchSponsorService, _super);
        function StSearchSponsorService() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsorService";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.getSponsorByPersonalInfo = function(inputValue, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorByPersonalInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: inputValue
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, handleGetSponsorInfo) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["searchSponsor"]["getSponsorInfo"],
                        method: "post",
                        contentType: "json",
                        data: {
                            query: sponsorIdOrAlias
                        },
                        callback: handleGetSponsorInfo
                    });
                } catch (error) {
                    console.log("Error occurred while getting sponsor info ---\x3e", error);
                }
            };
            return _this;
        }
        return StSearchSponsorService;
    }(st_module_37.StModule);
    exports.StSearchSponsorService = StSearchSponsorService;
});

define("core/shopify-app/st-modules/search-sponsor/search-sponsor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_38, _features_config_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSearchSponsor = void 0;
    var SponsorRequestType;
    (function(SponsorRequestType) {
        SponsorRequestType[SponsorRequestType["GET_BY_ID_OR_ALIAS"] = 0] = "GET_BY_ID_OR_ALIAS";
        SponsorRequestType[SponsorRequestType["GET_BY_PERSONAL_INFORMATION"] = 1] = "GET_BY_PERSONAL_INFORMATION";
    })(SponsorRequestType || (SponsorRequestType = {}));
    var StSearchSponsor = function(_super) {
        __extends(StSearchSponsor, _super);
        function StSearchSponsor(generalMethods, objectFormatting, browserHistory, classConfig, cookies, cart, sponsorService) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SearchSponsor";
            _this.endpointString = [ "getSponsorInfo", "getSponsorByPersonalInfo" ];
            _this.MIN_CHAR_SEARCH_REQUIREMENT = 2;
            _this.REQUEST_DELAY = 1e3;
            _this.inputValue = "";
            _this.cookieNameWebAlias = "webAlias";
            _this.cookieNameRepId = "repId";
            _this.cookieNameFirstName = "firstName";
            _this.cookieNameLastName = "lastName";
            _this.retryWebAliasFetch = true;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initSearchBoxFunctionality();
                    _this.initRadioButtons();
                    _this.windowClick();
                    _this.triggerVisibilityOfSection();
                    _this.cart.subscribeRenderCart(function(callback) {
                        _this.changeCartEvents();
                    });
                });
            };
            _this.loaderOn = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && !label.classList.contains("st_loader-active")) {
                    label.classList.add("st_loader-active");
                }
            };
            _this.loaderOff = function(triggerBtn) {
                var label = _this.generalMethods.getClosestByTag(triggerBtn, "label");
                if (!!label && label.classList.contains("st_loader-active")) {
                    label.classList.remove("st_loader-active");
                }
            };
            _this.changeCartEvents = function() {
                _this.initSearchBoxFunctionality();
                _this.initRadioButtons();
                _this.triggerVisibilityOfSection();
            };
            _this.setRepCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
            };
            _this.triggerVisibilityOfSection = function() {
                var searchSponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                searchSponsorWrappers === null || searchSponsorWrappers === void 0 ? void 0 : searchSponsorWrappers.forEach(function(searchSponsorWrapper) {
                    var customerType = window.customerInfoMetafields.customerType;
                    if (customerType == _features_config_6.ECustomerType.retail && _features_config_6.lockedRepresentativeSite || customerType == _features_config_6.ECustomerType.representative) {
                        var searchSponsorWrapperLink = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapperLink);
                        searchSponsorWrapperLink === null || searchSponsorWrapperLink === void 0 ? void 0 : searchSponsorWrapperLink.classList.add("st_hidden");
                    } else {
                        var triggerForOpenSearchInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorChangeSponsorWrapper);
                        triggerForOpenSearchInput === null || triggerForOpenSearchInput === void 0 ? void 0 : triggerForOpenSearchInput.addEventListener("click", function(e) {
                            e.preventDefault();
                            searchSponsorWrappers.forEach(function(wrapper) {
                                _this.defaultVisibility(wrapper);
                            });
                            _this.showSearchInput(searchSponsorWrapper);
                            _this.hideSearchResults(searchSponsorWrapper);
                        });
                        _this.nonSponsors(searchSponsorWrapper);
                    }
                });
            };
            _this.nonSponsors = function(searchSponsorWrapper) {
                var triggerForDefaultSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorNonSponsor);
                triggerForDefaultSponsorInput === null || triggerForDefaultSponsorInput === void 0 ? void 0 : triggerForDefaultSponsorInput.addEventListener("click", function() {
                    _this.updateUrl(_features_config_6.defaultWebAlias);
                    _this.defaultVisibility(searchSponsorWrapper);
                    _this.getSponsorInfo(_features_config_6.defaultWebAlias);
                    _this.setSponsorWebAliasToForm(_features_config_6.defaultWebAlias);
                    _this.setNewSponsorInfoToHeader(_features_config_6.corporationName, "", _features_config_6.defaultWebAlias);
                });
            };
            _this.updateUrl = function(newAlias) {
                var _a;
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_6.aliasQueryParam];
                if (currentAlias !== newAlias) {
                    urlParams = __assign(__assign({}, urlParams), (_a = {}, _a[_features_config_6.aliasQueryParam] = newAlias, 
                    _a));
                    var newURL = window.location.href.replace(window.location.search, "");
                    _this.cart.updateCartItemsProperies(newAlias);
                    _this.browserHistory.pushHistory(newURL, urlParams);
                }
            };
            _this.windowClick = function() {
                document.addEventListener("click", function(e) {
                    var searchSponsorsResult = document.querySelector(_this.classConfig.selectorChooseSponsor);
                    if (!!searchSponsorsResult) {
                        if (!_this.generalMethods.getClosestByClass(e.target, "st_search-input-and-result")) {
                            var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                            sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                                _this.clearSponsorSuggestions(sponsorWrapper);
                            });
                        }
                    }
                });
            };
            _this.defaultVisibility = function(searchSponsorWrapper) {
                if (!!searchSponsorWrapper) {
                    _this.hideSearchInput(searchSponsorWrapper);
                    _this.showSearchResults(searchSponsorWrapper);
                }
            };
            _this.setSponsorWebAliasToForm = function(alias) {
                if (_features_config_6.canGoUnderCorporateSite || !_features_config_6.canGoUnderCorporateSite && alias !== _features_config_6.defaultWebAlias) {
                    var sponsorWebAliasFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeAlias);
                    sponsorWebAliasFields === null || sponsorWebAliasFields === void 0 ? void 0 : sponsorWebAliasFields.forEach(function(field) {
                        _this.appendValueToField(field, alias);
                    });
                }
            };
            _this.getSponsorInfo = function(sponsorIdOrAlias, retryCount) {
                if (retryCount === void 0) {
                    retryCount = 0;
                }
                if (retryCount >= 5) {
                    console.warn("Sponsor Info call exceeded retry count!");
                    return;
                }
                if (_this.lastSponsorInfo && (_this.lastSponsorInfo.webAlias === sponsorIdOrAlias || _this.lastSponsorInfo.repId === sponsorIdOrAlias)) {
                    _this.injectSponsorInfo(_this.lastSponsorInfo);
                    return;
                }
                _this.loadersOnForSponsorInfo();
                _this.sponsorService.getSponsorInfo(sponsorIdOrAlias, function(request) {
                    try {
                        if (request.status === 200) {
                            var sponsorInfoResponse = JSON.parse(request.response);
                            var sponsorInformation = sponsorInfoResponse.data.sponsors[0];
                            if (!sponsorInformation.webAlias && sponsorInformation.webAlias === "") {
                                sponsorInformation.webAlias = sponsorInformation.repId;
                            }
                            _this.lastSponsorInfo = sponsorInformation;
                            _this.injectSponsorInfo(sponsorInformation);
                            _this.setRepCookies(sponsorInformation);
                        } else {
                            if (_this.retryWebAliasFetch) {
                                _this.retryWebAliasFetch = false;
                                _this.getSponsorInfo(_features_config_6.defaultWebAlias, ++retryCount);
                            }
                        }
                    } catch (error) {
                        console.log(error);
                        console.log("catch --- getSponsorInfo", _features_config_6.defaultWebAlias);
                        _this.getSponsorInfo(_features_config_6.defaultWebAlias, ++retryCount);
                    }
                });
            };
            _this.loadersOnForSponsorInfo = function() {
                var sponsorsData = document.querySelectorAll(_this.classConfig.selectorSponsorData);
                var svg = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st_loader">\n                        <g fill="none" fill-rule="evenodd">\n                            <g transform="translate(1 1)" stroke-width="2">\n                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>\n                                <path d="M36 18c0-9.94-8.06-18-18-18">\n                                    <animateTransform\n                                            attributeName="transform"\n                                            type="rotate"\n                                            from="0 18 18"\n                                            to="360 18 18"\n                                            dur="1s"\n                                            repeatCount="indefinite"/>\n                                </path>\n                            </g>\n                        </g>\n                    </svg>';
                sponsorsData === null || sponsorsData === void 0 ? void 0 : sponsorsData.forEach(function(sponsorData) {
                    sponsorData.innerHTML = svg;
                });
            };
            _this.injectSponsorInfo = function(sponsorInformation) {
                var sponsorIdFields = document.querySelectorAll(_this.classConfig.selectorSponsorId);
                var sponsorAliasFields = document.querySelectorAll(_this.classConfig.selectorSponsorAlias);
                var sponsorFullNameFields = document.querySelectorAll(_this.classConfig.selectorSponsorFullName);
                var sponsorInitialsFields = document.querySelectorAll(_this.classConfig.selectorSponsorInitials);
                var sponsorAddressFields = document.querySelectorAll(_this.classConfig.selectorSponsorAddress);
                _this.injectTextIntoFields(sponsorIdFields, sponsorInformation.repId);
                _this.injectTextIntoFields(sponsorAliasFields, sponsorInformation.webAlias);
                _this.injectTextIntoFields(sponsorFullNameFields, "".concat(sponsorInformation.firstName, " ").concat(sponsorInformation.lastName));
                _this.injectTextIntoFields(sponsorInitialsFields, "".concat(sponsorInformation.firstName.charAt(0)).concat(sponsorInformation.lastName.charAt(0)));
                var address = sponsorInformation.address.state && sponsorInformation.address.state !== "" ? sponsorInformation.address.state + ", " + sponsorInformation.address.city : sponsorInformation.address.city;
                _this.injectTextIntoFields(sponsorAddressFields, address);
            };
            _this.searchSponsors = function(searchWrapper) {
                var input = searchWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!input) {
                    input.addEventListener("keyup", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("input", function(e) {
                        _this.getSponsors(input);
                    });
                    input.addEventListener("paste", function(e) {
                        _this.getSponsors(input);
                    });
                }
            };
            _this.getSponsors = function(input) {
                var value = input.value;
                if (_this.inputValue === value) return;
                if (value.length < _this.MIN_CHAR_SEARCH_REQUIREMENT) {
                    var searchSponsorInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                    _this.clearSponsorSuggestions(searchSponsorInputWrapper);
                    _this.enableRadioButtons(input);
                    return;
                }
                _this.inputValue = value;
                var requestType = _this.getCurrentRoute(input);
                _this.loaderOn(input);
                _this.disableRadioButtons(input);
                if (requestType === SponsorRequestType.GET_BY_ID_OR_ALIAS) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
                if (requestType === SponsorRequestType.GET_BY_PERSONAL_INFORMATION) {
                    _this.subscribeToTimeout(input, function() {
                        _this.sponsorService.getSponsorByPersonalInfo(value, function(request) {
                            return _this.handleGetSponsorsResponse(request, input);
                        });
                    });
                }
            };
            _this.getCurrentRoute = function(input) {
                var route;
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton, index) {
                    if (radioButton.classList.contains("st_checked")) {
                        route = index;
                    }
                });
                return route;
            };
            _this.enableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.removeAttribute("disabled");
                });
            };
            _this.disableRadioButtons = function(input) {
                var sponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var radioButtons = sponsorWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                    radioButton.setAttribute("disabled", "disabled");
                });
            };
            _this.initRadioButtons = function() {
                var radioButtonsWrappers = document.querySelectorAll(_this.classConfig.selectorSearchInput);
                radioButtonsWrappers === null || radioButtonsWrappers === void 0 ? void 0 : radioButtonsWrappers.forEach(function(radioButtonsWrapper) {
                    var radioButtons = radioButtonsWrapper.querySelectorAll(_this.classConfig.selectorSearchSponsorBy);
                    radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(input) {
                        input.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.handleRadioButtonStatusChange(radioButtons, radioButtonsWrapper);
                            _this.clearSearchSponsorInputValueAndSuggestions(input);
                        });
                    });
                });
            };
            _this.setChecked = function(element) {
                if (!element.classList.contains("st_checked")) {
                    element.classList.add("st_checked");
                }
                element.setAttribute("checked", "checked");
            };
            _this.removeChecked = function(element) {
                if (element.classList.contains("st_checked")) {
                    element.classList.remove("st_checked");
                }
                element.removeAttribute("checked");
            };
            _this.renderPlaceholderText = function(radioButton, wrapper) {
                var label = _this.generalMethods.getClosestByTag(radioButton, "label");
                var text = label.querySelector(_this.classConfig.selectorRadioText).textContent;
                var placeholder = wrapper.querySelector(".st_search-input .st_placeholder-text");
                placeholder.innerHTML = text;
            };
            _this.clearSearchSponsorInputValueAndSuggestions = function(input) {
                var searchSponsorWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!searchSponsorWrapper) {
                    _this.clearSearchSponsorInputValue(searchSponsorWrapper);
                    _this.clearSponsorSuggestions(searchSponsorWrapper);
                }
            };
            _this.clearSearchSponsorInputValue = function(searchSponsorWrapper) {
                var searchSponsorInput = searchSponsorWrapper.querySelector(_this.classConfig.selectorSearchSponsor);
                if (!!searchSponsorInput) {
                    searchSponsorInput.value = "";
                    searchSponsorInput.replaceChildren();
                }
            };
            _this.clearSponsorSuggestions = function(searchSponsorWrapper) {
                var searchSponsorResult = searchSponsorWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                searchSponsorResult === null || searchSponsorResult === void 0 ? void 0 : searchSponsorResult.replaceChildren();
            };
            _this.renderSuggestionsWrapper = function(sponsorsList, input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                if (!!sponsorsInputWrapper) {
                    var sponsorsWrapper_1 = sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                    if (!!sponsorsWrapper_1) {
                        sponsorsWrapper_1.classList.remove("st_hidden");
                        sponsorsWrapper_1.replaceChildren();
                        sponsorsList === null || sponsorsList === void 0 ? void 0 : sponsorsList.forEach(function(sponsor) {
                            var sponsorJson = JSON.stringify(sponsor);
                            var buttonWithSponsorInfo = _this.createDOMElement("button", "st_search-sponsor-button--result st_choose-sponsor_JS", sponsorsWrapper_1);
                            buttonWithSponsorInfo.setAttribute("type", "button");
                            buttonWithSponsorInfo.setAttribute("data-sponsor-info", sponsorJson);
                            var leftPart = _this.createDOMElement("span", "st_result-left-part", buttonWithSponsorInfo);
                            var addressPart = _this.createDOMElement("span", "st_result-address", buttonWithSponsorInfo);
                            var credentialsSection = _this.createDOMElement("span", "st_account-sponsor-credentials-section", leftPart);
                            var sponsorResultName = _this.createDOMElement("span", "st_result-name", leftPart);
                            var addressPartData = _this.createDOMElement("span", "st_sponsor-address_JS", addressPart);
                            var state = sponsor.address.state;
                            var city = sponsor.address.city;
                            var address = state && state !== "" ? state + ", " + city : city;
                            addressPartData.innerHTML = address;
                            var initialsSection = _this.createDOMElement("span", "st_account-sponsor-initials", credentialsSection);
                            var initialsJSSection = _this.createDOMElement("span", "st_sponsor-initials_JS", initialsSection);
                            initialsJSSection.innerHTML = "".concat(sponsor.firstName.charAt(0)).concat(sponsor.lastName.charAt(0));
                            var colWrapper = _this.createDOMElement("span", "st_span-full-width", sponsorResultName);
                            var fullName = _this.createDOMElement("span", "st_sponsor-fullname_JS", colWrapper);
                            fullName.innerHTML = sponsor.firstName + " " + sponsor.lastName;
                            var sponsorIdWrapper = _this.createDOMElement("span", "st_sponsor-id", colWrapper);
                            var sponsorIdNumber = _this.createDOMElement("span", "st_sponsor-id_JS", sponsorIdWrapper);
                            sponsorIdNumber.innerHTML = " (ID: " + sponsor.repId + ")";
                            var aliasWrapper = _this.createDOMElement("span", "st_sponsor-alias", sponsorResultName);
                            var aliasWrapperData = _this.createDOMElement("span", "st_sponsor-alias_JS", aliasWrapper);
                            aliasWrapperData.innerHTML = sponsor.webAlias;
                        });
                    }
                    _this.chooseSponsor(sponsorsInputWrapper);
                }
            };
            _this.createDOMElement = function(element, classNames, parentElement) {
                var newElement = document.createElement(element);
                newElement.className = classNames;
                parentElement.appendChild(newElement);
                return newElement;
            };
            _this.chooseSponsor = function(sponsorsInputWrapper) {
                var sponsorButtons = sponsorsInputWrapper.querySelectorAll(_this.classConfig.selectorChooseSponsor);
                sponsorButtons === null || sponsorButtons === void 0 ? void 0 : sponsorButtons.forEach(function(sponsor) {
                    sponsor.addEventListener("click", function(e) {
                        e.preventDefault();
                        var newSponsorJson = sponsor.getAttribute("data-sponsor-info");
                        var newSponsor = JSON.parse(newSponsorJson);
                        var sponsorWrappers = document.querySelectorAll(_this.classConfig.selectorSearchSponsorWrapperPage);
                        sponsorWrappers === null || sponsorWrappers === void 0 ? void 0 : sponsorWrappers.forEach(function(sponsorWrapper) {
                            _this.defaultVisibility(sponsorWrapper);
                        });
                        _this.updateUrl(newSponsor.webAlias);
                        _this.clearSearchSponsorInputValueAndSuggestions(e.target);
                        _this.injectSponsorInfo(newSponsor);
                        _this.setRepCookies(newSponsor);
                        _this.setSponsorWebAliasToForm(newSponsor.webAlias);
                        _this.setNewSponsorInfoToHeader(newSponsor.firstName, newSponsor.lastName, newSponsor.webAlias);
                        window.dispatchEvent(new Event("sponsorChange"));
                    });
                });
            };
            _this.setNewSponsorInfoToHeader = function(repFirstName, repLastName, webAlias) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepresentativeFullName);
                var fullName = _this.getFullName(repFirstName, repLastName, webAlias);
                repFullNameFields === null || repFullNameFields === void 0 ? void 0 : repFullNameFields.forEach(function(field) {
                    _this.appendValueToField(field, fullName);
                });
            };
            _this.appendValueToField = function(field, value) {
                if (field.tagName.toLowerCase() === "input") {
                    field.value = value;
                } else {
                    field.innerHTML = value;
                }
            };
            _this.hideSuggestionsWrapper = function(input) {
                var sponsorsInputWrapper = _this.generalMethods.getClosestByClass(input, _this.classConfig.classNameSearchInput);
                var sponsorsWrapper = sponsorsInputWrapper === null || sponsorsInputWrapper === void 0 ? void 0 : sponsorsInputWrapper.querySelector(_this.classConfig.selectorFoundSponsor);
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.replaceChildren();
                sponsorsWrapper === null || sponsorsWrapper === void 0 ? void 0 : sponsorsWrapper.classList.add("st_hidden");
            };
            _this.generalMethods = generalMethods;
            _this.objectFormatting = objectFormatting;
            _this.browserHistory = browserHistory;
            _this.classConfig = classConfig;
            _this.cookies = cookies;
            _this.cart = cart;
            _this.sponsorService = sponsorService;
            return _this;
        }
        StSearchSponsor.prototype.hideSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden"))) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchResults = function(searchWrapper) {
            var searchResult = searchWrapper.querySelector(this.classConfig.selectorSearchResult);
            if (searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.contains("st_hidden")) {
                searchResult === null || searchResult === void 0 ? void 0 : searchResult.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.hideSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (!(searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden"))) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.add("st_hidden");
            }
        };
        StSearchSponsor.prototype.showSearchInput = function(searchWrapper) {
            var searchInput = searchWrapper.querySelector(this.classConfig.selectorSearchInput);
            if (searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.contains("st_hidden")) {
                searchInput === null || searchInput === void 0 ? void 0 : searchInput.classList.remove("st_hidden");
            }
        };
        StSearchSponsor.prototype.initSearchBoxFunctionality = function() {
            var _this = this;
            var searchWrappers = document.querySelectorAll(this.classConfig.selectorSearchSponsorWrapperPage);
            if (searchWrappers.length > 0) {
                var customerID = window.customerInfoMetafields.customerId;
                var sponsorRepID = window.customerInfoMetafields.representativeId;
                var customerType = window.customerInfoMetafields.customerType;
                var repSite = void 0;
                if (!!customerID && _features_config_6.lockedRepresentativeSite && customerType !== _features_config_6.ECustomerType.noType) {
                    repSite = customerType === _features_config_6.ECustomerType.representative ? customerID : sponsorRepID;
                } else {
                    var webAlias = this.objectFormatting.convertQueryStringToObject(window.location.search);
                    if (!!webAlias.als) {
                        repSite = webAlias.als;
                    } else {
                        if (!!this.cookies.getCookie("webAlias")) {
                            repSite = this.cookies.getCookie("webAlias");
                        }
                    }
                }
                this.getSponsorInfo(repSite);
            }
            searchWrappers === null || searchWrappers === void 0 ? void 0 : searchWrappers.forEach(function(wrapper) {
                _this.searchSponsors(wrapper);
            });
        };
        StSearchSponsor.prototype.injectTextIntoFields = function(fields, text) {
            fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
                field.innerHTML = text;
            });
        };
        StSearchSponsor.prototype.subscribeToTimeout = function(input, request) {
            var value = input.value;
            if (value.length > 1) {
                clearTimeout(this.requestTimeout);
                this.requestTimeout = setTimeout(request, this.REQUEST_DELAY);
            } else {
                var searchSponsorInputWrapper = this.generalMethods.getClosestByClass(input, this.classConfig.classNameSearchInput);
                this.clearSponsorSuggestions(searchSponsorInputWrapper);
                this.enableRadioButtons(input);
            }
        };
        StSearchSponsor.prototype.handleGetSponsorsResponse = function(request, input) {
            var res = JSON.parse(request.response);
            if (res.status === 200) {
                var sponsorsList = res.data.sponsors;
                if (sponsorsList.length > 0) {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.renderSuggestionsWrapper(sponsorsList, input);
                } else {
                    this.loaderOff(input);
                    this.enableRadioButtons(input);
                    this.hideSuggestionsWrapper(input);
                }
            } else {
                this.loaderOff(input);
                this.enableRadioButtons(input);
                this.hideSuggestionsWrapper(input);
            }
        };
        StSearchSponsor.prototype.handleRadioButtonStatusChange = function(radioButtons, radioButtonsWrapper) {
            var _this = this;
            radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.forEach(function(radioButton) {
                if (!!radioButton.checked) {
                    _this.setChecked(radioButton);
                    _this.renderPlaceholderText(radioButton, radioButtonsWrapper);
                } else {
                    _this.removeChecked(radioButton);
                }
            });
        };
        StSearchSponsor.prototype.getFullName = function(repFirstName, repLastName, webAlias) {
            var fullName = !!repLastName ? repFirstName : "";
            fullName = !!repLastName ? fullName.concat(" ".concat(repLastName)) : fullName;
            if (webAlias === _features_config_6.defaultWebAlias) fullName = _features_config_6.corporationName;
            return fullName;
        };
        return StSearchSponsor;
    }(st_module_38.StModule);
    exports.StSearchSponsor = StSearchSponsor;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_39) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountClassConfig = void 0;
    var StEnrollmentAccountClassConfig = function(_super) {
        __extends(StEnrollmentAccountClassConfig, _super);
        function StEnrollmentAccountClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classNameEnrollmentAccountPageWrp = "st_enrollment-account-page_JS";
            _this.selectorEnrollmentAccountPageWrp = "." + _this.classNameEnrollmentAccountPageWrp;
            _this.classNameEnrollmentLoginForm = "st_enrollment-login_JS";
            _this.selectorEnrollmentLoginForm = "." + _this.classNameEnrollmentLoginForm;
            _this.classNameEnrollmentCreateAccountWrp = "st_enrollment-create-account_JS";
            _this.selectorEnrollmentCreateAccountWrp = "." + _this.classNameEnrollmentCreateAccountWrp;
            _this.classNameEnrollmentCreateAccountForm = "st_enrollment-create-account--form_JS";
            _this.selectorEnrollmentCreateAccountForm = "." + _this.classNameEnrollmentCreateAccountForm;
            _this.classNameEnrollmentCreateAccountOpenButton = "st_enrollment-create-account--open_JS";
            _this.selectorEnrollmentCreateAccountOpenButton = "." + _this.classNameEnrollmentCreateAccountOpenButton;
            _this.classNameEnrollmentCreateAccountSubmit = "st_submit--btn_JS";
            _this.selectorEnrollmentCreateAccountSubmit = "." + _this.classNameEnrollmentCreateAccountSubmit;
            _this.classNameEnrollmentAccountPassword = "st_enrollment-account-create-password_JS";
            _this.selectorEnrollmentAccountPassword = "." + _this.classNameEnrollmentAccountPassword;
            _this.classNameEnrollmentAccountRepeatPassword = "st_enrollment-account-create-repeat-password_JS";
            _this.selectorEnrollmentAccountRepeatPassword = "." + _this.classNameEnrollmentAccountRepeatPassword;
            _this.classNamePrimaryInput = "st_primary-input_JS";
            _this.selectorPrimaryInput = "." + _this.classNamePrimaryInput;
            return _this;
        }
        return StEnrollmentAccountClassConfig;
    }(st_module_39.StModule);
    exports.StEnrollmentAccountClassConfig = StEnrollmentAccountClassConfig;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_40, _features_config_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanup = void 0;
    var StEnrollmentCleanup = function(_super) {
        __extends(StEnrollmentCleanup, _super);
        function StEnrollmentCleanup(cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanup";
            _this.init = function() {};
            _this.clearCartAttributes = function(callback) {
                if (callback === void 0) {
                    callback = function() {};
                }
                _this.cart.getCart(function(cartData) {
                    var paramsToClear = _features_config_7.enrollmentParams !== null && _features_config_7.enrollmentParams !== void 0 ? _features_config_7.enrollmentParams : [];
                    if (cartData.attributes) {
                        var attributesFormatted_1 = __assign({}, cartData.attributes);
                        Object.keys(attributesFormatted_1).forEach(function(param) {
                            if (paramsToClear.indexOf(param) > -1) {
                                attributesFormatted_1[param] = "";
                            }
                        });
                        _this.cart.updateCart({
                            attributes: attributesFormatted_1
                        }, callback);
                    }
                });
            };
            _this.cart = cart;
            return _this;
        }
        return StEnrollmentCleanup;
    }(st_module_40.StModule);
    exports.StEnrollmentCleanup = StEnrollmentCleanup;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_41, notification_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccount = void 0;
    var StEnrollmentAccount = function(_super) {
        __extends(StEnrollmentAccount, _super);
        function StEnrollmentAccount(classConfig, buttonActions, notification, form, generalMethod, enrollmentCleanup, cart) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "EnrollmentAccount";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.enrollmentLoginPreventDefault();
                    _this_1.toggleCreateAccount();
                    _this_1.enrollmentCreateAccountForm();
                });
            };
            _this_1.enrollmentLoginPreventDefault = function() {
                var _this = _this_1;
                var enrollmentForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentLoginForm);
                enrollmentForms.forEach(function(form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentLogin(form, _this.prepareForLogin(form));
                    });
                });
            };
            _this_1.prepareForLogin = function(form) {
                var formData = _this_1.form.collectFormData(form);
                return {
                    email: formData["customer[email]"],
                    password: formData["customer[password]"]
                };
            };
            _this_1.enrollmentLogin = function(form, formData) {
                var _this = _this_1;
                var redirectUrl = form.getAttribute("data-url");
                var submitBtn = form.querySelector(".st_submit--btn_JS");
                _this.buttonActions.prevent(submitBtn);
                var loginRequest = {};
                loginRequest.form_type = "customer_login";
                loginRequest["customer[email]"] = formData.email;
                loginRequest["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginRequest,
                    callback: function(request) {
                        try {
                            if (request.status == 200) {
                                var redirectUrlResponse = request.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.buttonActions.allow(submitBtn);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    var cartData = _this.stCart.getShopifyCartData;
                                    if (cartData.attributes.email !== formData.email) {
                                        _this.enrollmentCleanup.clearCartAttributes(function() {
                                            window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                        });
                                    } else {
                                        window.location.assign(window.location.protocol + "//" + window.location.hostname + redirectUrl);
                                    }
                                }
                            } else {
                                window.location.reload();
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.buttonActions.allow(submitBtn);
                            _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.toggleCreateAccount = function() {
                var _this = _this_1;
                var createAccountBtns = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountOpenButton);
                createAccountBtns.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showEnrollmentCreateAccount(this);
                    });
                });
            };
            _this_1.showEnrollmentCreateAccount = function(triggerBtn) {
                var enrollmentCreateAccount = document.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountWrp);
                if (!!enrollmentCreateAccount) {
                    enrollmentCreateAccount.classList.remove("st_visibility-hidden");
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var enrollmentAccountPage = _this_1.generalMethod.getClosestByClass(triggerBtn, _this_1.classConfig.classNameEnrollmentAccountPageWrp);
                    if (!!enrollmentAccountPage) {
                        enrollmentAccountPage.classList.add("st_visibility-hidden");
                    }
                }
            };
            _this_1.enrollmentCreateAccountForm = function() {
                var _this = _this_1;
                var enrollmentCreateAccountForms = document.querySelectorAll(_this_1.classConfig.selectorEnrollmentCreateAccountForm);
                enrollmentCreateAccountForms.forEach(function(form) {
                    _this.onRepeatPassword(form);
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.enrollmentCreateAccountFormSubmit(form);
                    });
                });
            };
            _this_1.enrollmentCreateAccountFormSubmit = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorEnrollmentCreateAccountSubmit);
                _this.form.clearFormatting(form, [ "repeatPassword" ]);
                _this.buttonActions.prevent(submitBtn);
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                if (passwordInputElement.value.length > 40) {
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                    _this.buttonActions.allow(submitBtn);
                } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["enrollment"]["createAccount"],
                        method: "post",
                        contentType: "json",
                        data: formData,
                        callback: function(response) {
                            try {
                                var createAccountResponse = JSON.parse(response.response);
                                if (createAccountResponse.status === 200) {
                                    _this.buttonActions.allow(submitBtn);
                                    var formDataLogin = {
                                        email: formData.email,
                                        password: formData.password
                                    };
                                    _this.enrollmentLogin(form, formDataLogin);
                                } else if (createAccountResponse.status === 400) {
                                    var validationErrors = _this.prepareErrorArray(createAccountResponse.data);
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", validationErrors);
                                    _this.buttonActions.allow(submitBtn);
                                    var errors = [];
                                    for (var validationParam in createAccountResponse.data) {
                                        var validationResult = createAccountResponse.data[validationParam];
                                        if (!validationResult.isValid) {
                                            errors.push(validationResult.message);
                                        }
                                    }
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", errors);
                                    _this.buttonActions.allow(submitBtn);
                                } else {
                                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", createAccountResponse.message);
                                    _this.buttonActions.allow(submitBtn);
                                }
                            } catch (error) {
                                console.error(error);
                                _this.notification.showNotification(notification_4.ENotificationType.error, "Server Error", error);
                                _this.buttonActions.allow(submitBtn);
                            }
                        }
                    });
                } else {
                    _this.form.markValidationResults(form, _this.checkPasswordMatch({}));
                    _this.notification.showNotification(notification_4.ENotificationType.error, "Validation Error", "Passwords not matching!");
                    _this.buttonActions.allow(submitBtn);
                }
            };
            _this_1.onRepeatPassword = function(form) {
                var _this = _this_1;
                var passwordInputElement = document.querySelector('input[name="password"]');
                var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                passwordInputElement.oninput = function(e) {
                    var validationProperties = _this.checkPasswordMatch({});
                    if (Object.keys(validationProperties).length === 0) {
                        _this.form.clearFormatting(form, [ "repeatPassword" ]);
                    } else {
                        _this.form.markValidationResults(form, validationProperties);
                    }
                };
                if (repeatPasswordInputElement) {
                    repeatPasswordInputElement.oninput = function() {
                        var validationProperties = _this.checkPasswordMatch({});
                        if (Object.keys(validationProperties).length === 0) {
                            _this.form.clearFormatting(form, [ "repeatPassword" ]);
                        } else {
                            _this.form.markValidationResults(form, validationProperties);
                        }
                    };
                }
            };
            _this_1.checkPasswordMatch = function(validationProperties) {
                var passwordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountPassword);
                var repeatPasswordInputElement = document.querySelector(_this_1.classConfig.selectorEnrollmentAccountRepeatPassword);
                if (repeatPasswordInputElement) {
                    if (passwordInputElement.value !== repeatPasswordInputElement.value) {
                        return __assign(__assign({}, validationProperties), {
                            repeatPassword: {
                                isValid: false,
                                message: "Passwords not matching!"
                            }
                        });
                    }
                }
                return validationProperties;
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.classConfig = classConfig;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.form = form;
            _this_1.generalMethod = generalMethod;
            _this_1.enrollmentCleanup = enrollmentCleanup;
            _this_1.stCart = cart;
            return _this_1;
        }
        return StEnrollmentAccount;
    }(st_module_41.StModule);
    exports.StEnrollmentAccount = StEnrollmentAccount;
});

define("core/shopify-app/st-modules/_general-methods/form/formatting", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_42) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFormFormatting = void 0;
    var StFormFormatting = function(_super) {
        __extends(StFormFormatting, _super);
        function StFormFormatting() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "Formatting";
            _this.setupFormatting = function(collectionToIterate, formattingFn, callbackFn) {
                if (callbackFn === void 0) {
                    callbackFn = function(value) {};
                }
                collectionToIterate.forEach(function(input) {
                    var formattedVal = formattingFn(input.value);
                    input.value = formattedVal;
                    input.setAttribute("value", formattedVal);
                    callbackFn(formattedVal);
                    input.addEventListener("input", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("keyup", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                    input.addEventListener("paste", function(e) {
                        var formattedVal = formattingFn(this.value);
                        this.value = formattedVal;
                        this.setAttribute("value", formattedVal);
                        callbackFn(this.value);
                    });
                });
            };
            _this.formatPhoneNumber = function(phone) {
                var phoneString = ("" + phone).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 6);
                var segment3 = phoneString.slice(6, 10);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            _this.formatWebAlias = function(webAlias) {
                return webAlias.replace(/[^A-Za-z0-9\-_]/g, "");
            };
            _this.formatSSN = function(ssn) {
                var phoneString = ("" + ssn).replace(/\D/g, "");
                var segment1 = phoneString.slice(0, 3);
                var segment2 = phoneString.slice(3, 5);
                var segment3 = phoneString.slice(5, 9);
                return segment1 + (segment2.length > 0 ? "-" + segment2 : "") + (segment3.length > 0 ? "-" + segment3 : "");
            };
            return _this;
        }
        return StFormFormatting;
    }(st_module_42.StModule);
    exports.StFormFormatting = StFormFormatting;
});

define("core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_43) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentAccountDetailsHelpers = void 0;
    var StEnrollmentAccountDetailsHelpers = function(_super) {
        __extends(StEnrollmentAccountDetailsHelpers, _super);
        function StEnrollmentAccountDetailsHelpers(formFormatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupPhoneFormatting();
                });
            };
            _this.setupPhoneFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountDetailsPhone);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatPhoneNumber);
            };
            _this.formFormatting = formFormatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentAccountDetailsHelpers;
    }(st_module_43.StModule);
    exports.StEnrollmentAccountDetailsHelpers = StEnrollmentAccountDetailsHelpers;
});

define("core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_44) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentBusinessDetailsHelpers = void 0;
    var StEnrollmentBusinessDetailsHelpers = function(_super) {
        __extends(StEnrollmentBusinessDetailsHelpers, _super);
        function StEnrollmentBusinessDetailsHelpers(formatting, classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "BusinessDetailsHelpers";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.setupWebAliasFormatting();
                    _this.setupSSNFormatting();
                });
            };
            _this.setupWebAliasFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsWebAlias);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatWebAlias, function(value) {
                    var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                    var webAliasPresenter = wrp.querySelector(_this.classConfig.selectorEnrollmentBusinessDetailsWebAliasPresenter);
                    if (!!webAliasPresenter) {
                        webAliasPresenter.innerText = value;
                    }
                });
            };
            _this.setupSSNFormatting = function(inputs) {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentWrapper);
                var collectionToIterate = !!inputs ? inputs : wrp.querySelectorAll(_this.classConfig.selectorEnrollmentBusinessDetailsSSN);
                _this.formFormatting.setupFormatting(collectionToIterate, _this.formFormatting.formatSSN);
            };
            _this.formFormatting = formatting;
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentBusinessDetailsHelpers;
    }(st_module_44.StModule);
    exports.StEnrollmentBusinessDetailsHelpers = StEnrollmentBusinessDetailsHelpers;
});

define("core/shopify-app/st-modules/account/header/nav/account-nav", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/connector-app/_shared/models/auth/auth.request.model" ], function(require, exports, st_module_45, auth_request_model_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNav = void 0;
    var StAccountNav = function(_super) {
        __extends(StAccountNav, _super);
        function StAccountNav(classConfig, objectFormatting, browserHistory, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountNav";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupAccountNavPages();
                    _this_1.openPage();
                    _this_1.bindNavEvents();
                    _this_1.logout();
                });
            };
            _this_1.setupAccountNavPages = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var pageWrappers = wrp.querySelectorAll(_this_1.classConfig.selectorAccountContent);
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var navWrp = wrp.querySelector(_this_1.classConfig.selectorAccountNavWrapper);
                if (!!navHolder) {
                    if (pageWrappers.length > 1) {
                        pageWrappers.forEach(function(pageWrapper, pageIndex) {
                            var templateName = pageWrapper.getAttribute("data-name");
                            var svgIcon = pageWrapper.querySelector(_this_1.classConfig.selectorAccountIcon).innerHTML;
                            var page = _this_1.navPageTemplate(pageIndex, templateName, svgIcon);
                            navHolder.appendChild(page);
                        });
                        if (navWrp) {
                            navWrp.classList.remove("st_hidden");
                        }
                    } else {
                        if (navWrp) {
                            navWrp.classList.add("st_hidden");
                        }
                    }
                } else {
                    console.error("Account Nav holder not present! Navigation won't setup");
                }
            };
            _this_1.navPageTemplate = function(pageIndex, templateName, svgIcon) {
                if (templateName === void 0) {
                    templateName = "";
                }
                if (svgIcon === void 0) {
                    svgIcon = "";
                }
                var templateNode;
                templateNode = document.createElement("div");
                templateNode.classList.add("st_header-account-nav-link");
                templateNode.classList.add(_this_1.classConfig.classNameAccountNavHolderSingle);
                var button = document.createElement("button");
                button.classList.add("st_header-navigation-account", "st_account--button");
                button.classList.add(_this_1.classConfig.classNameAccountNavButton);
                button.setAttribute("data-index", "".concat(pageIndex));
                button.innerHTML = svgIcon;
                var text = document.createElement("span");
                text.classList.add("st_header-text");
                text.innerHTML = templateName.charAt(0).toUpperCase() + templateName.slice(1);
                button.appendChild(text);
                templateNode.appendChild(button);
                return templateNode;
            };
            _this_1.bindNavEvents = function() {
                var _this = _this_1;
                var navLinks = document.querySelectorAll(_this.classConfig.selectorAccountNavButton);
                navLinks.forEach(function(navLink) {
                    navLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        var pageIndex = parseInt(this.getAttribute("data-index"));
                        _this.openPage(pageIndex);
                        _this.closeAddressEdit();
                        _this.closeSingleOrder();
                    });
                });
            };
            _this_1.closeAddressEdit = function() {
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                if (!!editAddressButtons) {
                    editAddressButtons.forEach(function(editAddressButton) {
                        var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                        if (!!addressWrapper) {
                            var buttonDropdown = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdown);
                            var buttonDropdownContent = addressWrapper.querySelector(_this_1.classConfig.selectorAccountAddressesDropdownWrapper);
                            addressWrapper.classList.remove("st_hide");
                            if (!!buttonDropdown && !!buttonDropdownContent) {
                                buttonDropdown.classList.remove("active");
                                buttonDropdownContent.classList.remove("active");
                            }
                        }
                    });
                }
            };
            _this_1.closeSingleOrder = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    var singleOrderWrapper = document.querySelector(".st_single-order_JS");
                    if (!!singleOrderWrapper) {
                        singleOrderWrapper.style.display = "none";
                    }
                    var orderWrapper = document.querySelector(".st_order-history_JS");
                    if (!!orderWrapper) {
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    }
                });
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.updateTabToUrl = function(activeTab) {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                urlParams.tab = "" + activeTab;
                var newURL = window.location.href.replace(window.location.search, "");
                _this_1.browserHistory.pushHistory(newURL, urlParams);
            };
            _this_1.logout = function() {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                var _this = _this_1;
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.removeTokens();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this_1.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_2.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_2.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_2.ETokenType.Refresh);
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountNav;
    }(st_module_45.StModule);
    exports.StAccountNav = StAccountNav;
});

define("core/connector-app/_shared/models/auth/sso.request.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/connector-app/_shared/models/auth/sso.response.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_46, notification_5) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StBackofficeSSO = void 0;
    var StBackofficeSSO = function(_super) {
        __extends(StBackofficeSSO, _super);
        function StBackofficeSSO(classConfig, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "BackofficeSSO";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getSSOLinkEvent();
                });
            };
            _this_1.getSSOLinkEvent = function() {
                var _this = _this_1;
                var ssoLinks = document.querySelectorAll(_this_1.classConfig.selectorBackOfficeLink);
                for (var i = 0; i < ssoLinks.length; i++) {
                    var ssoLink = ssoLinks[i];
                    ssoLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.getSSOLink();
                    });
                }
            };
            _this_1.getSSOLink = function() {
                var _this = _this_1;
                var customerInfoMetafields = window.customerInfoMetafields;
                var ssoLinkRequest = {
                    customerId: customerInfoMetafields.customerId,
                    sponsorId: customerInfoMetafields.representativeId,
                    isAutoship: false,
                    customerType: customerInfoMetafields.customerType
                };
                _this_1.ajax.send({
                    endpoint: _this.endpoint["auth"]["sso"],
                    method: "post",
                    contentType: "json",
                    data: ssoLinkRequest,
                    callback: function(response) {
                        try {
                            var ssoLinkResponse = JSON.parse(response.response);
                            if (ssoLinkResponse.status === 200) {
                                var ssoLinkData = ssoLinkResponse.data;
                                if (!!ssoLinkData.ssoLink && ssoLinkData.ssoLink !== "") {
                                    window.location.href = ssoLinkData.ssoLink;
                                }
                            } else {
                                _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", ssoLinkResponse.message);
                            }
                        } catch (error) {
                            _this.notification.showNotification(notification_5.ENotificationType.error, "An Error Occurred!", error);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.notification = notification;
            return _this_1;
        }
        return StBackofficeSSO;
    }(st_module_46.StModule);
    exports.StBackofficeSSO = StBackofficeSSO;
});

define("core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_47, notification_6) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountWebAliasEdit = void 0;
    var StAccountWebAliasEdit = function(_super) {
        __extends(StAccountWebAliasEdit, _super);
        function StAccountWebAliasEdit(classConfig, generalMethods, notification, buttonActions, form, formFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountWebAliasEdit";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.setupWebAliasInputEvents();
                    _this_1.editWebAlias();
                });
            };
            _this_1.setupWebAliasInputEvents = function() {
                var _this = _this_1;
                var webAliasInputsFields = document.querySelectorAll(_this_1.classConfig.selectorAccountWebAlias);
                webAliasInputsFields.forEach(function(webAliasInput) {
                    _this.injectWebAlias(webAliasInput);
                    webAliasInput.addEventListener("keyup", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("input", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                    webAliasInput.addEventListener("paste", function() {
                        this.value = _this.formFormatting.formatWebAlias(this.value);
                        _this.injectWebAlias(this);
                    });
                });
            };
            _this_1.injectWebAlias = function(webAliasInput) {
                var inputValue = webAliasInput.value;
                var webAliasWrapper = _this_1.generalMethods.getClosestByClass(webAliasInput, _this_1.classConfig.classNameWebAliasWrapper);
                var readOnlyInput = webAliasWrapper.querySelector(_this_1.classConfig.selectorWebAliasValue);
                readOnlyInput.value = inputValue;
            };
            _this_1.editWebAlias = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorEditWebAliasForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitWebAlias(this);
                    });
                }
            };
            _this_1.submitWebAlias = function(form) {
                var _this = _this_1;
                var formData = _this.form.collectFormData(form);
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updateWebAlias"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editWebAliasResponse = JSON.parse(response.response);
                            if (editWebAliasResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                window.location.reload();
                            } else if (editWebAliasResponse.status === 400) {
                                var validationProperties = editWebAliasResponse.data;
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.notification.showNotification(notification_6.ENotificationType.error, "An Error Occurred", editWebAliasResponse.message);
                                _this.buttonActions.allow(submitBtn);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_6.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            return _this_1;
        }
        return StAccountWebAliasEdit;
    }(st_module_47.StModule);
    exports.StAccountWebAliasEdit = StAccountWebAliasEdit;
});

define("core/shopify-app/st-modules/account/blocks/addresses/addresses", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_48) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddresses = void 0;
    var StAccountAddresses = function(_super) {
        __extends(StAccountAddresses, _super);
        function StAccountAddresses(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountAddress";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openAddressDropDown();
                    _this_1.setupAddressEdit();
                    _this_1.setupAddressProvinceField();
                });
            };
            _this_1.openAddressDropDown = function() {
                var _this = _this_1;
                var dropDownButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountAddressesDropdown);
                dropDownButtons.forEach(function(dropDownButton) {
                    dropDownButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.openAddressActiveState(dropDownButton);
                    });
                });
            };
            _this_1.openAddressActiveState = function(dropDownButton) {
                dropDownButton.classList.toggle("active");
            };
            _this_1.setupAddressEdit = function() {
                var _this = _this_1;
                var addressTabButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountTabButton);
                addressTabButtons.forEach(function(addressTabButton) {
                    addressTabButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.showAddressEdit(addressTabButton);
                    });
                });
                var editAddressButtons = document.querySelectorAll(_this_1.classConfig.selectorAccountBackButton);
                editAddressButtons.forEach(function(editAddressButton) {
                    editAddressButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.hideAddressEdit(editAddressButton);
                    });
                });
            };
            _this_1.showAddressEdit = function(addressTabButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(addressTabButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    addressWrapper.classList.add("st_hide");
                }
            };
            _this_1.hideAddressEdit = function(editAddressButton) {
                var addressWrapper = _this_1.generalMethods.getClosestByClass(editAddressButton, _this_1.classConfig.classNameAddressesWrapper);
                if (!!addressWrapper) {
                    var buttonDropdown = addressWrapper.querySelector(".st_addresses-dots--button_JS");
                    var buttonDropdownContent = addressWrapper.querySelector(".st_dropdown-address--wrapper");
                    addressWrapper.classList.remove("st_hide");
                    buttonDropdown.classList.remove("active");
                    buttonDropdownContent.classList.remove("active");
                }
            };
            _this_1.setupAddressProvinceField = function() {
                var _this = _this_1;
                var provinceSelector = document.querySelector(_this_1.classConfig.selectorProvinceSelector);
                var provinceSource = document.querySelector(_this_1.classConfig.selectorProvinceSource);
                if (!!provinceSelector && !!provinceSource) {
                    _this_1.addProvinceOptions(provinceSelector, provinceSource);
                    provinceSource.addEventListener("change", function(e) {
                        _this.addProvinceOptions(provinceSelector, provinceSource);
                    });
                }
            };
            _this_1.addProvinceOptions = function(provinceSelector, provinceSource) {
                var selectedCountry = (provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.value) ? provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.value : provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.getAttribute("data-default");
                var provinceSelectedOption = provinceSource === null || provinceSource === void 0 ? void 0 : provinceSource.querySelector('option[value="'.concat(selectedCountry, '"]'));
                var provinceWrapper = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                if (!!provinceWrapper) {
                    provinceWrapper.classList.remove("st_hidden");
                }
                try {
                    var provinces = JSON.parse(provinceSelectedOption === null || provinceSelectedOption === void 0 ? void 0 : provinceSelectedOption.getAttribute("data-provinces"));
                    provinceSelector === null || provinceSelector === void 0 ? void 0 : provinceSelector.replaceChildren();
                    for (var i = 0; i < provinces.length; i++) {
                        var opt = document.createElement("option");
                        opt.value = provinces[i][0];
                        opt.innerHTML = provinces[i][1];
                        opt.setAttribute("data-ind", "" + i);
                        provinceSelector.appendChild(opt);
                    }
                    var defaultProvince = provinceSelector.getAttribute("data-default");
                    var defaultProvinceEl = provinceSelector.querySelector('option[value="'.concat(defaultProvince, '"]'));
                    var provinceOptions = provinceSelector === null || provinceSelector === void 0 ? void 0 : provinceSelector.querySelectorAll("option");
                    var selectedOption = defaultProvince ? defaultProvinceEl : provinceOptions[0];
                    provinceSelector.value = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
                    provinceSelector.selectedIndex = parseInt(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.getAttribute("data-ind"));
                    provinceOptions === null || provinceOptions === void 0 ? void 0 : provinceOptions.forEach(function(provinceOption) {
                        provinceOption === null || provinceOption === void 0 ? void 0 : provinceOption.removeAttribute("selected");
                    });
                    if (!!selectedOption) {
                        selectedOption.selected = true;
                        selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.setAttribute("selected", "selected");
                    }
                } catch (e) {
                    console.error(e);
                    var provinceWrapper_1 = _this_1.generalMethods.getClosestByClass(provinceSelector, _this_1.classConfig.classNameProvinceWrapper);
                    if (!!provinceWrapper_1) {
                        provinceWrapper_1.classList.add("st_hidden");
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountAddresses;
    }(st_module_48.StModule);
    exports.StAccountAddresses = StAccountAddresses;
});

define("core/connector-app/_shared/models/customer/account/customer.account.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("core/shopify-app/st-modules/account/blocks/personal-info/personal-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_49, notification_7) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfo = void 0;
    var StAccountPersonalInfo = function(_super) {
        __extends(StAccountPersonalInfo, _super);
        function StAccountPersonalInfo(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountPersonalInfo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.editPersonalInfo();
                    _this_1.setupFormatPhoneNumber();
                });
            };
            _this_1.editPersonalInfo = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorPersonalInfoForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        _this.submitPersonalInfo(this);
                    });
                }
            };
            _this_1.submitPersonalInfo = function(form) {
                var _this = _this_1;
                var data = _this.form.collectFormData(form);
                var formData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    phoneNumber: data.phoneNumber,
                    shopifyId: data.shopifyId,
                    email: data.email
                };
                var submitBtn = form.querySelector(_this_1.classConfig.selectorSubmitButton);
                _this.buttonActions.prevent(submitBtn);
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["updatePersonalInfo"],
                    method: "post",
                    contentType: "json",
                    data: formData,
                    callback: function(response) {
                        try {
                            var editPersonalInfoResponse = JSON.parse(response.response);
                            var validationProperties = editPersonalInfoResponse.data;
                            if (editPersonalInfoResponse.status === 200) {
                                _this.buttonActions.allow(submitBtn);
                                _this.form.markValidationResults(form, validationProperties);
                                _this.notification.showNotification(notification_7.ENotificationType.success, "Success", "You have successfully modified your information.");
                                _this.updatePersonalInfoWrapperIfExist(form, formData);
                            } else if (editPersonalInfoResponse.status === 400) {
                                _this.form.markValidationResults(form, validationProperties);
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", "Some fields are invalid.");
                            } else {
                                _this.buttonActions.allow(submitBtn);
                                _this.notification.showNotification(notification_7.ENotificationType.error, "An Error Occurred", editPersonalInfoResponse.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_7.ENotificationType.error, "Server Error", error);
                            _this.buttonActions.allow(submitBtn);
                        }
                    }
                });
            };
            _this_1.updatePersonalInfoWrapperIfExist = function(formSelector, formData) {
                var accountPage = _this_1.generalMethods.getClosestByClass(formSelector, _this_1.classConfig.classNameAccountPage);
                if (!!accountPage) {
                    var selectorBusinessContent = accountPage.querySelector(_this_1.classConfig.selectorBusinessContent);
                    if (!!selectorBusinessContent) {
                        var nameSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentName);
                        var emailSelector = selectorBusinessContent.querySelector(_this_1.classConfig.selectorBusinessContentEmail);
                        if (!!emailSelector) {
                            emailSelector.innerHTML = formData.email;
                        }
                        if (!!nameSelector) {
                            nameSelector.innerHTML = formData.firstName + " " + formData.lastName;
                        }
                    }
                }
            };
            _this_1.setupFormatPhoneNumber = function() {
                var phoneNumberInputs = document.querySelectorAll('input[name="phoneNumber"]');
                _this_1.formFormatting.setupFormatting(phoneNumberInputs, _this_1.formFormatting.formatPhoneNumber);
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.formFormatting = formFormatting;
            _this_1.buttonActions = buttonActions;
            _this_1.notification = notification;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountPersonalInfo;
    }(st_module_49.StModule);
    exports.StAccountPersonalInfo = StAccountPersonalInfo;
});

define("core/shopify-app/st-modules/account/blocks/order-history/order-history", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_50) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistory = void 0;
    var StAccountOrderHistory = function(_super) {
        __extends(StAccountOrderHistory, _super);
        function StAccountOrderHistory(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountOrderHistory";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.openSingleOrder();
                    _this_1.backToHistoryOrders();
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var singleOrderTriggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                singleOrderTriggers.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderId = order.getAttribute("data-order-id");
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var singleOrderWrapper = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="' + orderId + '"]');
                        singleOrderWrapper.style.display = "block";
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var orderHistory = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                orderHistory.forEach(function(order) {
                    order.addEventListener("click", function(e) {
                        e.preventDefault();
                        var singleOrderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        singleOrderWrapper.style.display = "none";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountOrderHistory;
    }(st_module_50.StModule);
    exports.StAccountOrderHistory = StAccountOrderHistory;
});

define("extension/shopify-app/st-modules/webalias/webalias.extended", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/webalias/webalias" ], function(require, exports, _features_config_8, webalias_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasExtended = void 0;
    var StWebAliasExtended = function(_super) {
        __extends(StWebAliasExtended, _super);
        function StWebAliasExtended(classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) {
            var _this = _super.call(this, classConfig, browserHistory, objectFormatting, cookies, customerType, generalMethods, injectRepresentativeInfo, cartComponent, searchSponsorGuard, accountPersonalSite) || this;
            _this.className = "WebAliasExtended";
            _this.cookieNameEmail = "email";
            _this._fallbackTried = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initWebAliasFlow();
                    _this.initSponsorCheck();
                    _this.getCustomerInformation();
                    //window.setTimeout(function() {
                        _this.getSponsorInformation();
                    //}, 300);
                });
            };
            _this.initWebAliasFlow = function() {
                var _a;
                var win = window;
                var customerTypeFromMeta = (_a = win.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerType;
                var customerTags = win.customerTags;
                var hasRetailTag = Array.isArray(customerTags) ? customerTags.some(function(tag) {
                    return tag && tag.toLowerCase() === "retail";
                }) : false;
                if (customerTypeFromMeta === "consultant" && hasRetailTag) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerRepresentative) {
                    _this.representativeAliasFlow();
                    return;
                }
                if (_this.isCustomerRetail) {
                    _this.retailAliasFlow();
                    return;
                }
                if (_this.isCustomerGuest) {
                    _this.guestAliasFlow();
                }
            };
            _this.representativeAliasFlow = function() {
                _this.getRepresentativesOwnInfo(_this.customerIdFromMetafields);
                var retailLine = document.querySelector(".st_retail_JS");
                var consultantLine = document.querySelector(".st_consultant_JS");
                if (retailLine) {
                    retailLine.classList.add("st_hidden");
                }
                if (consultantLine) {
                    consultantLine.classList.add("st_hidden");
                }
            };
            _this.guestAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_8.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                console.log(urlAliasExists);
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                if (urlAliasExists && _this.isValidAliasOrId(currentAlias)) {
                    _this.getRepresentativesOwnInfo(currentAlias.trim());
                    return;
                }
                if (cookieAliasExists) {
                    _this.injectRepInfoFromCookie();
                    return;
                }
                _this.injectDefaultRepInfo();
            };
            _this.retailAliasFlow = function() {
                var urlParams = _this.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_8.aliasQueryParam];
                var urlAliasExists = !!currentAlias;
                var cookieAliasExists = !!_this.cookies.getCookie("webAlias");
                var isLocked = _features_config_8.lockedRepresentativeSite;
                if (isLocked) {
                    var customerIdOrAls = _this.customerIdFromMetafields;
                    _this.getCustomersRepresentativeInfo(customerIdOrAls);
                    return;
                }
                if (!isLocked) {
                    if (urlAliasExists && _this.isValidAliasOrId(currentAlias)) {
                        _this.getRepresentativesOwnInfo(currentAlias.trim());
                        return;
                    } else {
                        if (cookieAliasExists) {
                            _this.injectRepInfoFromCookie();
                            return;
                        } else {
                            _this.injectDefaultRepInfo();
                            return;
                        }
                    }
                }
            };
            _this.handleRepresentativeInfoResponse = function(response) {
                var _a, _b;
                var _c = response || {}, data = _c.data, status = _c.status;
                if (status === 200 && data) {
                    var webAliasRaw = ((_a = data.webAlias) !== null && _a !== void 0 ? _a : "").toString().trim();
                    var repIdRaw = ((_b = data.repId) !== null && _b !== void 0 ? _b : "").toString().trim();
                    var fixedWebAlias = _this.isValidAliasOrId(webAliasRaw) ? webAliasRaw : repIdRaw;
                    if (!_this.isValidAliasOrId(fixedWebAlias)) {
                        _this.fallbackAfterBadRepLookup();
                        return;
                    }
                    _this.updateCurrentRepInfo(__assign(__assign({}, data), {
                        webAlias: fixedWebAlias
                    }));
                    return;
                }
                _this.fallbackAfterBadRepLookup();
            };
            _this.getRepresentativesOwnInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
                var customerIdOrAls = window.customerInfoMetafields.representativeId;
            };
            _this.handleRepsRepInfo = function(response) {
                var consultantName = document.querySelector(".st_consultant_JS");
                var retailName = document.querySelector(".st_retail_JS");
                if (!!consultantName && !!retailName) {
                    consultantName.classList.remove("st_hidden");
                    retailName.classList.add("st_hidden");
                }
                var data = response.data, status = response.status;
                if (data.firstName == "" && data.lastName == "" || !data.firstName && !data.lastName) {
                    var consultantsRep = document.querySelector(".st_representatives-rep-fullname_JS");
                    if (!!consultantsRep) {
                        consultantsRep.innerHTML = _features_config_8.corporationName;
                    }
                } else {
                    var consultantsRep = document.querySelector(".st_representatives-rep-fullname_JS");
                    if (!!consultantsRep) {
                        consultantsRep.innerHTML = data.firstName + " " + data.lastName;
                    }
                }
            };
            _this.getCustomersRepresentativeInfo = function(customerIdOrAlias) {
                _this.getRepresentativeInfo({
                    customerIdOrAlias: customerIdOrAlias,
                    isOwnInfo: true
                }, _this.handleRepresentativeInfoResponse);
            };
            _this.getRepresentativeInfo = function(webAliasRequest, handleResponse) {
                try {
                    _this.ajax.send({
                        endpoint: _this.endpoint["webalias"]["repSite"],
                        method: "post",
                        contentType: "json",
                        data: webAliasRequest,
                        callback: function(response) {
                            try {
                                var representativeInfoRes = JSON.parse(response.response);
                                handleResponse(representativeInfoRes);
                            } catch (error) {
                                _this.nonExistentRepresentativeFlow();
                                console.log("Response Error ------\x3e" + error);
                            }
                        }
                    });
                } catch (error) {
                    console.log("Request Error ------\x3e" + error);
                }
            };
            _this.getSponsorInformation = function() {
                var _a;
                var repIdMetafield = (_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.representativeId;
                if (window.customerShopifyId === 0) return;
                if (!_this.isValidAliasOrId(repIdMetafield)) return;
                var webAliasRequestedData = {
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                };
                _this.getRepresentativeInfo(webAliasRequestedData, _this.handleSponsorInfoResponse);
            };
            _this.getCustomerInformation = function() {
                var win = window;
                var info = win.customerPublic;
                _this.handleCustomerInfoResponse(info);
            };
            _this.handleCustomerInfoResponse = function(info) {
                var _a, _b;
                var targets = document.querySelectorAll(".st_customer-fullname_JS");
                if (!targets.length) return;
                if (!info) {
                    targets.forEach(function(t) {
                        return t.textContent = "";
                    });
                    return;
                }
                var firstName = info.firstName || info.first_name || info.FirstName || ((_a = info.customer) === null || _a === void 0 ? void 0 : _a.firstName) || "";
                var lastName = info.lastName || info.last_name || info.LastName || ((_b = info.customer) === null || _b === void 0 ? void 0 : _b.lastName) || "";
                var fullName = [ firstName, lastName ].filter(Boolean).join(" ").trim();
                targets.forEach(function(t) {
                    return t.textContent = fullName;
                });
            };
            _this.handleSponsorInfoResponse = function(response) {
                if (response.status === 200) {
                    var sponsorInfo = response.data;
                    _this.injectRepresentativeInfo.injectSponsorInfoToField(sponsorInfo.firstName, sponsorInfo.lastName);
                    _this.accountPersonalSite.createLinkWithRef(sponsorInfo.webAlias);
                    _this.accountPersonalSite.includePromoCode(sponsorInfo.webAlias);
                } else {
                    _this.injectRepresentativeInfo.injectSponsorInfoToField("", "");
                }
            };
            _this.isDataEqualToStored = function(repInfo) {
                return repInfo.webAlias === _this.cookies.getCookie("webAlias") && repInfo.firstName === _this.cookies.getCookie("firstName") && repInfo.lastName === _this.cookies.getCookie("lastName") && (repInfo.email || "") === (_this.cookies.getCookie("email") || "");
            };
            _this.updateCurrentRepInfo = function(repInfo) {
                var webAlias = repInfo.webAlias;
                var shouldUpdateBanner = false;
                if (!_this.isDataEqualToStored(repInfo)) {
                    _this.setRepresentativeCookies(repInfo);
                    shouldUpdateBanner = true;
                }
                if (!_this.isAliasEqualToUrlAlias(webAlias)) {
                    _this.setNewAliasInUrl(webAlias);
                    shouldUpdateBanner = true;
                }
                if (shouldUpdateBanner) {
                    try {
                        _this.injectRepresentativeInfo.injectToFields(repInfo);
                    } catch (e) {
                        console.warn("[WebAlias] injectToFields immediate failed:", e);
                    }
                }
                var callbackFired = false;
                var finalize = function() {
                    _this.searchSponsorGuard.toggleCantGoUnderCorporateSite(webAlias === _features_config_8.defaultWebAlias);
                    try {
                        _this.injectRepresentativeInfo.injectToFields(repInfo);
                    } catch (e) {
                        console.warn("[WebAlias] injectToFields finalize failed:", e);
                    }
                };
                try {
                    _this.cartComponent.updateCartItemsPropertiesCB(repInfo, function() {
                        callbackFired = true;
                        finalize();
                    });
                } catch (e) {
                    console.warn("[WebAlias] updateCartItemsPropertiesCB failed:", e);
                }
                window.setTimeout(function() {
                    if (!callbackFired) finalize();
                }, 1500);
            };
            _this.cartShouldUpdate = function(existingSponsorInfo, sponsorInfo) {
                var existingSponsorInfoObj;
                if (!!existingSponsorInfo) {
                    existingSponsorInfoObj = JSON.parse(existingSponsorInfo);
                }
                return !existingSponsorInfo || !!existingSponsorInfo && existingSponsorInfoObj["firstName"] !== sponsorInfo["firstName"] && existingSponsorInfoObj["lastName"] !== sponsorInfo["lastName"];
            };
            _this.nonExistentRepresentativeFlow = function() {
                if (!_this.isCustomerRetail) {
                    _this.injectDefaultRepInfo();
                    return;
                }
                _this.injectRepInfoFromCookie();
            };
            _this.injectRepInfoFromCookie = function() {
                var repInfo = {
                    firstName: _this.cookies.getCookie(_this.cookieNameFirstName),
                    lastName: _this.cookies.getCookie(_this.cookieNameLastName),
                    webAlias: _this.cookies.getCookie(_this.cookieNameWebAlias),
                    repId: _this.cookies.getCookie(_this.cookieNameRepId),
                    email: _this.cookies.getCookie(_this.cookieNameEmail)
                };
                var imageUrl = _this.cookies.getCookie(_this.cookieNameImageUrl);
                if (!!imageUrl && _features_config_8.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: imageUrl
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.injectDefaultRepInfo = function() {
                var repInfo = {
                    webAlias: _features_config_8.defaultWebAlias,
                    firstName: _features_config_8.corporationName,
                    lastName: "",
                    email: _features_config_8.defaultEmail
                };
                if (_features_config_8.additionalRepInfo) {
                    repInfo = __assign(__assign({}, repInfo), {
                        imageUrl: _features_config_8.defaultCorporationImage
                    });
                }
                _this.updateCurrentRepInfo(repInfo);
            };
            _this.setRepresentativeCookies = function(repInfo) {
                _this.cookies.setCookies(_this.cookieNameWebAlias, repInfo.webAlias);
                _this.cookies.setCookies(_this.cookieNameRepId, repInfo.repId);
                _this.cookies.setCookies(_this.cookieNameFirstName, repInfo.firstName);
                _this.cookies.setCookies(_this.cookieNameLastName, repInfo.lastName);
                _this.cookies.setCookies(_this.cookieNameEmail, repInfo.email);
                if (_features_config_8.additionalRepInfo) {
                    _this.cookies.setCookies(_this.cookieNameImageUrl, repInfo.imageUrl);
                }
            };
            return _this;
        }
        Object.defineProperty(StWebAliasExtended.prototype, "isOnCartPage", {
            get: function() {
                return window.location.pathname.includes("cart");
            },
            enumerable: false,
            configurable: true
        });
        StWebAliasExtended.prototype.isNonEmptyString = function(v) {
            return typeof v === "string" && v.trim().length > 0;
        };
        StWebAliasExtended.prototype.isValidAliasOrId = function(v) {
            if (!this.isNonEmptyString(v)) return false;
            var s = v.trim().toLowerCase();
            return s !== "null" && s !== "undefined";
        };
        StWebAliasExtended.prototype.fallbackAfterBadRepLookup = function() {
            var _a;
            var repIdMetafield = (_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.representativeId;
            if (!this._fallbackTried && this.isValidAliasOrId(repIdMetafield)) {
                this._fallbackTried = true;
                this.getRepresentativeInfo({
                    customerIdOrAlias: repIdMetafield,
                    isOwnInfo: true
                }, this.handleRepresentativeInfoResponse);
                return;
            }
            this.nonExistentRepresentativeFlow();
        };
        return StWebAliasExtended;
    }(webalias_1.StWebAlias);
    exports.StWebAliasExtended = StWebAliasExtended;
});

define("extension/shopify-app/st-modules/cart/cart", [ "require", "exports", "core/shopify-app/st-modules/cart/cart" ], function(require, exports, cart_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCart = void 0;
    var StCart = function(_super) {
        __extends(StCart, _super);
        function StCart() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.className = "StCart";
            _this.updateCartAttributesWithPartyId = function(updateData, responseHandle) {
                try {
                    _this.ajax.send({
                        endpoint: _this.shopifyCartApiEndpoints["update-cart"],
                        method: "POST",
                        contentType: "json",
                        data: updateData,
                        callback: function(res) {
                            console.log("Party Id added");
                            _this.handleChangeCartResponseGenericNoRefresh(res, responseHandle);
                        }
                    });
                } catch (err) {
                    console.log("Update Cart ---\x3e Error:", err);
                }
            };
            _this.handleChangeCartResponseGenericNoRefresh = function(res, handleFunc) {
                try {
                    _this.getCart(function(cartObj) {
                        _this.handleChangeCartInterceptor(cartObj);
                        handleFunc(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGenericNoRefresh ---\x3e Error: ", err);
                }
            };
            _this.handleChangeCartResponseGeneric = function(res, handleFunc, cartRefresh) {
                if (handleFunc === void 0) {
                    handleFunc = function() {};
                }
                if (cartRefresh === void 0) {
                    cartRefresh = false;
                }
                try {
                    _this.getCart(function(cartObj) {
                        _this.setShopifyCartData(cartObj);
                        if (cartRefresh) {
                            _this.requestCartRefresh(cartObj);
                        }
                        _this.fireAllCallbacks(cartObj);
                        handleFunc(cartObj);
                    });
                } catch (err) {
                    console.log("handleChangeCartResponseGeneric ---\x3e Error: ", err);
                }
            };
            _this.overrideFreeSamples = function(chosenFreeSamplesList) {
                var freeSampleCollectionProducts = window.freeSampleCollectionProducts;
                var freeSamplesSkuList = [];
                freeSampleCollectionProducts.forEach(function(freeSample) {
                    freeSamplesSkuList.push(freeSample.variants[0].sku);
                });
                var cart = _this.getShopifyCartData;
                var cartItems = cart.items;
                var updateCartData = {
                    updates: {}
                };
                var addCartData = {
                    items: []
                };
                chosenFreeSamplesList.forEach(function(chosenFreeSample) {
                    addCartData.items.push({
                        id: chosenFreeSample.variantId,
                        quantity: chosenFreeSample.quantity,
                        properties: {
                            _isFreeSample: true
                        }
                    });
                });
                cartItems.forEach(function(lineItem, index) {
                    if (!freeSamplesSkuList.includes(lineItem.sku)) {
                        return;
                    }
                    if (lineItem.properties._isFreeSample) {
                        updateCartData.updates["".concat(lineItem.id)] = 0;
                    }
                });
                if (Object.keys(updateCartData.updates).length > 0) {
                    _this.updateCart(updateCartData, function(updatedCart) {
                        setTimeout(function() {
                            _this.addCart(addCartData, function(fullCart) {
                                sessionStorage.setItem("openCartAfterReload", "true");
                                window.location.reload(true);
                            });
                        }, 100);
                    });
                } else {
                    _this.addCart(addCartData, function(fullCart) {
                        sessionStorage.setItem("openCartAfterReload", "true");
                        window.location.reload(true);
                    });
                }
            };
            _this.removeFreeSamplesFromCart = function(shouldReload, afterUpdateCallback) {
                var freeSampleCollectionProducts = window.freeSampleCollectionProducts;
                if (!Array.isArray(freeSampleCollectionProducts) || freeSampleCollectionProducts.length === 0) {
                    if (!!afterUpdateCallback) afterUpdateCallback();
                    return;
                }
                var freeSamplesSkuList = [];
                freeSampleCollectionProducts.forEach(function(freeSample) {
                    freeSamplesSkuList.push(freeSample.variants[0].sku);
                });
                var cart = _this.getShopifyCartData;
                var cartItems = cart.items;
                var preparedItemsData = {
                    updates: {}
                };
                var shouldUpdate = false;
                cartItems.forEach(function(lineItem, index) {
                    if (freeSamplesSkuList.includes(lineItem.sku)) {
                        if (lineItem.properties._isFreeSample) {
                            preparedItemsData.updates["".concat(lineItem.id)] = 0;
                            shouldUpdate = true;
                        }
                    }
                });
                if (shouldUpdate) {
                    _this.updateCart(preparedItemsData, function(updatedCart) {
                        sessionStorage.setItem("openCartAfterReload", "true");
                        if (shouldReload) {
                            window.location.reload(true);
                        } else {
                            if (!!afterUpdateCallback) afterUpdateCallback();
                        }
                    });
                }
            };
            _this.updateCartItemsPropertiesCB = function(repInfo, responseHandle) {
                var attributes = {
                    sponsorInfo: {},
                    sponsorWebAlias: !!repInfo.webAlias ? repInfo.webAlias : ""
                };
                var sponsorInfo = {};
                sponsorInfo["firstName"] = !!repInfo.firstName ? repInfo.firstName : "";
                sponsorInfo["lastName"] = !!repInfo.lastName ? repInfo.lastName : "";
                sponsorInfo["sponsorWebAlias"] = !!repInfo.webAlias ? repInfo.webAlias : "";
                attributes.sponsorInfo = JSON.stringify(sponsorInfo);
                var updateAttributes = {
                    attributes: attributes
                };
                if (_this.doesShopifyCartDataContainNecessaryAttributes(attributes)) {
                    console.log("No update to cart for webAlias");
                    if (!!responseHandle) responseHandle();
                } else {
                    console.log("Update to cart for webAlias", updateAttributes);
                    _this.updateCartAttributesOrNote(updateAttributes, function(cartRes) {
                        if (!!responseHandle) responseHandle();
                    });
                }
            };
            _this.doesShopifyCartDataContainNecessaryAttributes = function(attributes) {
                var isSame = true;
                var currentCart = _this.getShopifyCartData.attributes;
                if (currentCart.sponsorWebAlias !== attributes.sponsorWebAlias) {
                    isSame = false;
                }
                if (currentCart.sponsorInfo !== attributes.sponsorInfo) {
                    isSame = false;
                }
                return isSame;
            };
            _this.addOrEditPropertiesForWebAlias = function(cartItems, alias, responseHandle) {
                var _a;
                var updateCartProperties = false;
                var item = {};
                var itemWithProperties = cartItems.find(function(item) {
                    var _a;
                    return ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== undefined;
                });
                var duplicateItem = cartItems.find(function(item) {
                    var _a;
                    return item.sku === (itemWithProperties === null || itemWithProperties === void 0 ? void 0 : itemWithProperties.sku) && ((_a = item.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) === undefined;
                });
                if (!itemWithProperties && cartItems.length > 0) {
                    item = cartItems[cartItems.length - 1];
                    updateCartProperties = true;
                } else if (duplicateItem) {
                    item = duplicateItem;
                    updateCartProperties = true;
                } else if (itemWithProperties && ((_a = itemWithProperties.properties) === null || _a === void 0 ? void 0 : _a._sponsorWebAlias) !== alias) {
                    item = itemWithProperties;
                    updateCartProperties = true;
                }
                var refreshCart = !!duplicateItem;
                if (updateCartProperties) {
                    _this.updateItemProperties(item, alias, refreshCart);
                }
                if (!!responseHandle) responseHandle();
            };
            return _this;
        }
        return StCart;
    }(cart_1.StCart);
    exports.StCart = StCart;
});

define("core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_51) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentRepeatPasswordValidation = void 0;
    var StEnrollmentRepeatPasswordValidation = function(_super) {
        __extends(StEnrollmentRepeatPasswordValidation, _super);
        function StEnrollmentRepeatPasswordValidation(classConfig) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentRepeatPassword";
            _this.validateOnSite = function() {
                var wrp = document.querySelector(_this.classConfig.selectorEnrollmentAccountPageWrp);
                var output = [];
                if (!!wrp) {
                    var inputs = wrp.querySelectorAll(_this.classConfig.selectorEnrollmentAccountRepeatPassword);
                    inputs.forEach(function(input) {
                        var fieldName = input.getAttribute("name");
                        var isValid = input.value === input.value;
                        output[fieldName] = {
                            isValid: isValid,
                            message: !isValid ? "Your passwords are not matching!" : ""
                        };
                    });
                }
                return output;
            };
            _this.classConfig = classConfig;
            return _this;
        }
        return StEnrollmentRepeatPasswordValidation;
    }(st_module_51.StModule);
    exports.StEnrollmentRepeatPasswordValidation = StEnrollmentRepeatPasswordValidation;
});

define("core/shopify-app/st-modules/account-register/account-register-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_52) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterClassConfig = void 0;
    var StAccountRegisterClassConfig = function(_super) {
        __extends(StAccountRegisterClassConfig, _super);
        function StAccountRegisterClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classAccountRegisterForm = "st_account-register-form_JS";
            _this.selectorAccountRegisterForm = "." + _this.classAccountRegisterForm;
            _this.classAccountRegisterFormPreventDefault = "st_prevent-form-default_JS";
            _this.selectorAccountRegisterFormPreventDefault = "." + _this.classAccountRegisterFormPreventDefault;
            _this.classRepresentativeAlias = "st_representative-alias_JS";
            _this.selectorRepresentativeAlias = "." + _this.classRepresentativeAlias;
            _this.classRegisterPasswordInput = "st_register-password-input_JS";
            _this.selectorRegisterPasswordInput = "." + _this.classRegisterPasswordInput;
            return _this;
        }
        return StAccountRegisterClassConfig;
    }(st_module_52.StModule);
    exports.StAccountRegisterClassConfig = StAccountRegisterClassConfig;
});

define("core/shopify-app/st-modules/account-register/account-register", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_53, notification_8, _features_config_9) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegister = void 0;
    var StAccountRegister = function(_super) {
        __extends(StAccountRegister, _super);
        function StAccountRegister(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AccountRegister";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.onSubmit();
                    _this_1.formatPhoneNumber();
                });
            };
            _this_1.format = function(value) {
                var digits = value.replace(/\D/g, "").substring(0, 10);
                var len = digits.length;
                if (len <= 3) return digits;
                if (len <= 6) return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3));
                return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
            };
            _this_1.formatPhoneNumber = function() {
                var phoneInput = document.querySelector(".lbr_crate-account-phone_JS");
                if (!phoneInput) return;
                phoneInput.addEventListener("input", function(e) {
                    var input = e.target;
                    var currentValue = input.value;
                    var formatted = _this_1.format(currentValue);
                    input.value = formatted;
                });
                phoneInput.addEventListener("keypress", function(e) {
                    if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                    }
                });
            };
            _this_1.onSubmit = function() {
                var _this = _this_1;
                var form = document.querySelector(_this_1.classConfig.selectorAccountRegisterForm);
                if (!!form) {
                    form.addEventListener("submit", function(e) {
                        _this.validateAccountCreation(this, e);
                    });
                }
            };
            _this_1.prepareErrorArray = function(validationData) {
                var validationDataKeys = Object.keys(validationData);
                var errorArray = [];
                validationDataKeys.forEach(function(key) {
                    if (!validationData[key].isValid) {
                        errorArray.push(validationData[key].message);
                    }
                });
                return errorArray;
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                var loginPayload = {};
                loginPayload.form_type = "customer_login";
                loginPayload["customer[email]"] = formData.email;
                loginPayload["customer[password]"] = formData.password;
                _this.ajax.send({
                    endpoint: window.location.protocol + "//" + window.location.hostname + "/account/login",
                    method: "post",
                    contentType: "form",
                    data: loginPayload,
                    callback: function(response) {
                        try {
                            if (response.status == 200) {
                                var redirectUrlResponse = response.responseURL.toString();
                                if (redirectUrlResponse.includes("/account/login")) {
                                    window.location.reload();
                                    _this.revertSubmitButtonToDefault();
                                    _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                                } else {
                                    window.location.assign(redirectUrlResponse);
                                }
                            } else {
                                window.location.reload();
                                _this.revertSubmitButtonToDefault();
                                _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", "Incorrect email or password.", 3e3, false);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.registerCustomer = function(customerPayload) {
                var _this = _this_1;
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["enrollment"]["createAccount"],
                    method: "post",
                    contentType: "json",
                    data: customerPayload,
                    callback: function(response) {
                        try {
                            _this.loginCustomer(customerPayload);
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                });
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_9.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_9.defaultWebAlias) {
                        _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                    } else {
                        var payload_1 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            password: formData["customer[password]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"]
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_1,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.revertSubmitButtonToDefault();
                                        } else {
                                            _this.registerCustomer(payload_1);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_8.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_8.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                }
            };
            _this_1.revertSubmitButtonToDefault = function() {
                var submitBtn = document.querySelector('[type="submit"]');
                if (!!submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                }
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StAccountRegister;
    }(st_module_53.StModule);
    exports.StAccountRegister = StAccountRegister;
});

define("extension/connector-app/market-type/models/generic.market.type.model", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account-register/zipCodeValidation", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.isFiveDigitZip = exports.normalizeZip = void 0;
    var normalizeZip = function(value) {
        return value !== null && value !== void 0 ? value : "";
    };
    exports.normalizeZip = normalizeZip;
    var isFiveDigitZip = function(value) {
        return /^\d{5}$/.test(value);
    };
    exports.isFiveDigitZip = isFiveDigitZip;
});

define("extension/shopify-app/st-modules/account-register/account-register-extend", [ "require", "exports", "_features.config", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/account-register/account-register" ], function(require, exports, _features_config_10, notification_9, account_register_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountRegisterExtended = void 0;
    var StAccountRegisterExtended = function(_super) {
        __extends(StAccountRegisterExtended, _super);
        function StAccountRegisterExtended(form, notification, buttonActions, classConfig, generalMethods) {
            var _this_1 = _super.call(this, form, notification, buttonActions, classConfig, generalMethods) || this;
            _this_1.className = "AccountRegisterExtended";
            _this_1.lastZipQueried = "";
            _this_1.pendingLookup = false;
            _this_1.zipDebounceTimer = null;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.form.liveTrim();
                    _this_1.cacheAddress();
                    _this_1.disableSelects(true);
                    _this_1.bindZipHandlers();
                    _this_1.onSubmit();
                    _this_1.formatPhoneNumber();
                    _this_1.passwordListener();
                    _this_1.togglePassword();
                    _this_1.bindConfirmPasswordWatcher();
                });
            };
            _this_1.cacheAddress = function() {
                _this_1.zipInput = document.querySelector("#RegisterForm-ZipCode");
                _this_1.street1Input = document.querySelector("#RegisterForm-StreetAddress");
                _this_1.citySelect = document.querySelector("#RegisterForm-City");
                _this_1.stateSelect = document.querySelector("#RegisterForm-State");
                _this_1.countySelect = document.querySelector("#RegisterForm-County");
            };
            _this_1.t = function(key) {
                try {
                    var translations = window.stTranslations || {};
                    var value = translations[key];
                    return typeof value === "string" ? value : "";
                } catch (_a) {
                    return "";
                }
            };
            _this_1.disableSelects = function(hardClear) {
                if (hardClear === void 0) {
                    hardClear = false;
                }
                [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].forEach(function(selectElement) {
                    if (!selectElement) return;
                    selectElement.disabled = true;
                    if (hardClear) {
                        var placeholderStateLabel = _this_1.t("selectState");
                        var placeholderCityLabel = _this_1.t("selectCity");
                        var placeholderCountyLabel = _this_1.t("selectCounty");
                        selectElement.innerHTML = "";
                        var placeholderOption = document.createElement("option");
                        placeholderOption.value = "";
                        placeholderOption.disabled = true;
                        placeholderOption.selected = true;
                        placeholderOption.textContent = selectElement.id.includes("State") ? placeholderStateLabel : selectElement.id.includes("City") ? placeholderCityLabel : placeholderCountyLabel;
                        selectElement.appendChild(placeholderOption);
                    }
                });
            };
            _this_1.enableSelects = function() {
                [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].forEach(function(selectElement) {
                    if (!selectElement) return;
                    selectElement.disabled = false;
                });
            };
            _this_1.onZipInputDebounced = function() {
                if (_this_1.zipDebounceTimer) window.clearTimeout(_this_1.zipDebounceTimer);
                _this_1.zipDebounceTimer = window.setTimeout(function() {
                    _this_1.onZipChanged();
                }, 150);
            };
            _this_1.bindZipHandlers = function() {
                if (!_this_1.zipInput) return;
                _this_1.zipInput.addEventListener("change", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("blur", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("keyup", function(e) {
                    if (e.key === "Enter") _this_1.onZipChanged();
                });
                _this_1.zipInput.addEventListener("input", _this_1.onZipChanged);
                _this_1.zipInput.addEventListener("paste", function() {
                    setTimeout(_this_1.onZipChanged, 0);
                });
            };
            _this_1.onZipChanged = function() {
                if (!_this_1.zipInput) return;
                var zip = _this_1.getNormalizedZipFromInput();
                if (_this_1.shouldSkipZipLookup(zip)) return;
                _this_1.pendingLookup = true;
                _this_1.disableSelects(false);
                _this_1.performPostalLookup(zip).then(function(data) {
                    return _this_1.applyPostalData(zip, data);
                }).catch(function() {
                    return _this_1.handleZipLookupError();
                }).finally(function() {
                    return _this_1.finalizeZipLookup();
                });
            };
            _this_1.getNormalizedZipFromInput = function() {
                var _a;
                return _this_1.zipInput ? (_a = _this_1.zipInput.value) !== null && _a !== void 0 ? _a : "" : "";
            };
            _this_1.isSelectPopulated = function(sel) {
                return !sel ? true : !sel.disabled && sel.options.length > 1;
            };
            _this_1.areAddressSelectsPopulated = function() {
                return [ _this_1.stateSelect, _this_1.citySelect, _this_1.countySelect ].every(_this_1.isSelectPopulated);
            };
            _this_1.shouldSkipZipLookup = function(zip) {
                if (_this_1.pendingLookup) return true;
                var sameZip = zip === _this_1.lastZipQueried;
                var selectsReady = _this_1.areAddressSelectsPopulated();
                return sameZip && selectsReady;
            };
            _this_1.performPostalLookup = function(zip) {
                return _this_1.getGeoCodeAddresses(zip);
            };
            _this_1.applyPostalData = function(zip, data) {
                _this_1.lastZipQueried = zip;
                _this_1.populateSelect(_this_1.stateSelect, (data === null || data === void 0 ? void 0 : data.States) || [], _this_1.t("selectState"));
                _this_1.populateSelect(_this_1.citySelect, (data === null || data === void 0 ? void 0 : data.Cities) || [], _this_1.t("selectCity"));
                _this_1.populateSelect(_this_1.countySelect, (data === null || data === void 0 ? void 0 : data.Counties) || [], _this_1.t("selectCounty"));
                _this_1.autoSelectIfSingle(_this_1.stateSelect);
                _this_1.autoSelectIfSingle(_this_1.citySelect);
                _this_1.autoSelectIfSingle(_this_1.countySelect);
                _this_1.enableSelects();
            };
            _this_1.handleZipLookupError = function() {
                _this_1.disableSelects(true);
            };
            _this_1.finalizeZipLookup = function() {
                _this_1.pendingLookup = false;
            };
            _this_1.populateSelect = function(selectElement, items, placeholderLabel) {
                if (!selectElement) return;
                var previousValue = selectElement.value;
                selectElement.innerHTML = "";
                var placeholderOption = document.createElement("option");
                placeholderOption.value = "";
                placeholderOption.disabled = true;
                placeholderOption.selected = true;
                placeholderOption.textContent = placeholderLabel;
                selectElement.appendChild(placeholderOption);
                items.forEach(function(itemValue) {
                    var optionElement = document.createElement("option");
                    optionElement.value = itemValue;
                    optionElement.textContent = itemValue;
                    selectElement.appendChild(optionElement);
                });
                var canRestore = Array.from(selectElement.options).some(function(option) {
                    return option.value === previousValue;
                });
                if (canRestore) selectElement.value = previousValue;
            };
            _this_1.autoSelectIfSingle = function(selectElement) {
                if (!selectElement) return;
                var nonEmptyOptions = Array.from(selectElement.options).filter(function(option) {
                    return option.value !== "";
                });
                if (nonEmptyOptions.length === 1) selectElement.value = nonEmptyOptions[0].value;
            };
            _this_1.getGeoCodeAddresses = function(postalCode) {
                return new Promise(function(resolve, reject) {
                    _this_1.ajax.send({
                        endpoint: _this_1.endpoint["customer"]["postal-code"],
                        method: "post",
                        contentType: "json",
                        data: {
                            postalCode: postalCode
                        },
                        callback: function(response) {
                            try {
                                var parsed = typeof response.response === "string" ? JSON.parse(response.response) : response.response;
                                var payload = (parsed === null || parsed === void 0 ? void 0 : parsed.data) ? parsed.data : parsed;
                                resolve(payload);
                            } catch (e) {
                                reject(e);
                            }
                        }
                    });
                });
            };
            _this_1.setProgress = function(msg) {
                var row = document.querySelector(".lbri_registration_progress_JS");
                var txt = document.querySelector(".lbri_registration_progress_text_JS");
                if (!row || !txt) return;
                txt.textContent = msg;
                row.classList.remove("st_hidden");
            };
            _this_1.clearProgress = function() {
                var row = document.querySelector(".lbri_registration_progress_JS");
                var txt = document.querySelector(".lbri_registration_progress_text_JS");
                if (!row || !txt) return;
                txt.textContent = "";
                row.classList.add("st_hidden");
            };
            _this_1.validateAccountCreation = function(form, submitEvent) {
                var _this = _this_1;
                _this_1.confirmPasswordValidation();
                if (form.classList.contains(_this_1.classConfig.classAccountRegisterFormPreventDefault)) {
                    submitEvent.preventDefault();
                    var validatingMessage = _this_1.t("loaderMsg1");
                    _this_1.setProgress(validatingMessage);
                    _this_1.toggleLoader(true, validatingMessage);
                    var formData = _this.form.collectFormData(form);
                    var hiddenAlsInput = form.querySelector(_this_1.classConfig.selectorRepresentativeAlias);
                    if (!(hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) || !_features_config_10.canGoUnderCorporateSite && (hiddenAlsInput === null || hiddenAlsInput === void 0 ? void 0 : hiddenAlsInput.value) === _features_config_10.defaultWebAlias) {
                        _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Web alias not entered or invalid");
                        _this.revertSubmitButtonToDefault();
                        _this.clearProgress();
                        _this.toggleLoader(false);
                    } else {
                        var payload_2 = {
                            email: formData["customer[email]"],
                            firstName: formData["customer[first_name]"],
                            lastName: formData["customer[last_name]"],
                            phone: formData["customer[phone]"],
                            password: formData["customer[password]"],
                            repeatPassword: formData["customer[password_confirmation]"],
                            sponsorsWebAlias: formData["customer[note][sponsorWebAlias]"],
                            referralMarketType: formData["customer[note][referralMarketTypeID]"],
                            referralMarketTypeInput: formData["customer[note][referralMarketTypeInput]"],
                            streetAddress: (formData["customer[note][streetAddress]"] || "").toString().trim(),
                            streetAddress2: (formData["customer[note][streetAddress2]"] || "").toString().trim(),
                            city: (formData["customer[note][city]"] || "").toString().trim(),
                            state: (formData["customer[note][state]"] || "").toString().trim(),
                            zipCode: (formData["customer[note][zipCode]"] || "").toString().trim(),
                            county: (formData["customer[note][county]"] || "").toString().trim(),
                            country: (formData["customer[note][country]"] || "").toString().trim()
                        };
                        var passwordInputElement = document.querySelector('input[name="customer[password]"]');
                        var repeatPasswordInputElement = document.querySelector('input[name="repeatPassword"]');
                        if (passwordInputElement.value.length > 40) {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Password cannot contain more than 40 characters!");
                            _this.revertSubmitButtonToDefault();
                            _this.clearProgress();
                            _this.toggleLoader(false);
                        } else if (passwordInputElement.value === (repeatPasswordInputElement === null || repeatPasswordInputElement === void 0 ? void 0 : repeatPasswordInputElement.value) || !repeatPasswordInputElement) {
                            _this.ajax.send({
                                endpoint: _this.endpoint["enrollment"]["validate-data"],
                                method: "post",
                                contentType: "json",
                                data: payload_2,
                                callback: function(response) {
                                    try {
                                        var validationResponse = JSON.parse(response.response);
                                        var validationErrors = _this.prepareErrorArray(validationResponse.data);
                                        if (validationErrors.length !== 0) {
                                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", validationErrors);
                                            _this.toggleLoader(false);
                                            _this.revertSubmitButtonToDefault();
                                            _this.clearProgress();
                                        } else {
                                            var creatingMsg = _this.t("loaderMsg1");
                                            _this.setProgress(creatingMsg);
                                            _this.toggleLoader(true, creatingMsg);
                                            _this.registerCustomer(payload_2);
                                            var msg2 = _this.t("loaderMsg2");
                                            _this.setProgress(msg2);
                                        }
                                    } catch (error) {
                                        console.error(error);
                                        _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", error);
                                        _this.revertSubmitButtonToDefault();
                                        _this.toggleLoader(false);
                                        _this.clearProgress();
                                    }
                                }
                            });
                        } else {
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Validation Error", "Passwords not matching!");
                            _this.revertSubmitButtonToDefault();
                            _this.toggleLoader(false);
                            _this.clearProgress();
                        }
                    }
                } else {
                    form.classList.add(_this.classConfig.classAccountRegisterFormPreventDefault);
                    _this.toggleLoader(false);
                    _this.clearProgress();
                }
            };
            _this_1.confirmPasswordValidation = function() {
                var password = document.querySelector(".st_register-password-input_JS");
                var confirmation = document.querySelector(".st_register-repeat-password_JS");
                var errorMsg = document.getElementById("error-msg");
                if (!password || !confirmation || !errorMsg) return;
                var pass = (password.value || "").trim();
                var rep = (confirmation.value || "").trim();
                if (rep.length === 0) {
                    errorMsg.textContent = "";
                    errorMsg.classList.add("st_hidden");
                    return;
                }
                if (pass !== rep) {
                    errorMsg.textContent = "Passwords do not match.";
                    errorMsg.classList.remove("st_hidden");
                } else {
                    errorMsg.textContent = "";
                    errorMsg.classList.add("st_hidden");
                }
            };
            _this_1.validatePassword = function(password) {
                var regex = /^.{5,40}$/;
                return regex.test(password);
            };
            _this_1.passwordListener = function() {
                var _this = _this_1;
                var passwordInput = document.querySelector(".st_register-password-input_JS");
                var errorMsg = document.querySelector("#error-msg-pass");
                if (!passwordInput) return;
                passwordInput.addEventListener("input", function() {
                    var currentPassword = passwordInput.value;
                    var isValid = _this.validatePassword(currentPassword);
                    if (!isValid) {
                        errorMsg.innerHTML = '\n                    <div style="display: flex; align-items: center; color: red; font-weight: 500; margin-bottom: 5px; font-size: 16px;">\n                      <span style="margin-right: 5px;">\n                        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M2 21C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7H3V5C3 3.61667 3.4875 2.4375 4.4625 1.4625C5.4375 0.4875 6.61667 0 8 0C9.38333 0 10.5625 0.4875 11.5375 1.4625C12.5125 2.4375 13 3.61667 13 5V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V19C16 19.55 15.8042 20.0208 15.4125 20.4125C15.0208 20.8042 14.55 21 14 21H2ZM2 19H14V9H2V19ZM8 16C8.55 16 9.02083 15.8042 9.4125 15.4125C9.80417 15.0208 10 14.55 10 14C10 13.45 9.80417 12.9792 9.4125 12.5875C9.02083 12.1958 8.55 12 8 12C7.45 12 6.97917 12.1958 6.5875 12.5875C6.19583 12.9792 6 13.45 6 14C6 14.55 6.19583 15.0208 6.5875 15.4125C6.97917 15.8042 7.45 16 8 16ZM5 7H11V5C11 4.16667 10.7083 3.45833 10.125 2.875C9.54167 2.29167 8.83333 2 8 2C7.16667 2 6.45833 2.29167 5.875 2.875C5.29167 3.45833 5 4.16667 5 5V7Z" fill="#FF0202"/>\n                        </svg>\n                      </span> \n                      Your password:\n                    </div>\n                    \n                    <div style="border: 1px solid red; padding: 10px 15px; display: flex; max-width: 600px;">\n                      <div>\n                        <ul style="padding-left: 14px; margin: 0; font-size: 12px; color: black; text-align: left; list-style-type: disc;">\n                          <li>Must be at least 5 characters, no more than 40.</li>\n                        </ul>\n                      </div>\n                    </div>\n      ';
                    } else {
                        errorMsg.innerHTML = "";
                    }
                });
            };
            _this_1.togglePassword = function() {
                var inputs = Array.from(document.querySelectorAll(".lbri_login-password-input_JS, .st_register-password-input_JS, .st_register-repeat-password_JS"));
                inputs.forEach(function(input) {
                    var wrapper = input.closest("label.form__field.lbri-input") || input.parentElement;
                    if (!wrapper) return;
                    var btn = wrapper.querySelector(".lbri_toggle-password-visibility-button_JS");
                    if (!btn) return;
                    if (btn._lbriBound === "1") return;
                    btn._lbriBound = "1";
                    if (getComputedStyle(wrapper).position === "static") {
                        wrapper.style.position = "relative";
                    }
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var isPassword = input.getAttribute("type") === "password";
                        input.setAttribute("type", isPassword ? "text" : "password");
                        btn.classList.toggle("lbri_password-visible", isPassword);
                        btn.setAttribute("aria-pressed", isPassword ? "true" : "false");
                        btn.setAttribute("aria-label", isPassword ? "Hide password" : "Show password");
                        input.focus();
                    });
                });
            };
            _this_1.bindConfirmPasswordWatcher = function() {
                var password = document.querySelector(".st_register-password-input_JS");
                var confirmation = document.querySelector(".st_register-repeat-password_JS");
                var errorMsg = document.getElementById("error-msg");
                if (!password || !confirmation || !errorMsg) return;
                var handler = function() {
                    return _this_1.confirmPasswordValidation();
                };
                password.addEventListener("input", handler);
                confirmation.addEventListener("input", handler);
                password.addEventListener("blur", handler);
                confirmation.addEventListener("blur", handler);
            };
            _this_1.loginCustomer = function(formData) {
                var _this = _this_1;
                _this.ajax.send({
                    endpoint: _this.endpoint["customer"]["customer-login"],
                    method: "post",
                    contentType: "json",
                    data: {
                        emailOrId: formData.email,
                        password: formData.password,
                        loginAsRetail: true
                    },
                    callback: function(resp) {
                        var _a;
                        try {
                            var payload = (resp === null || resp === void 0 ? void 0 : resp.responseText) ? JSON.parse(resp.responseText) : resp;
                            if ((payload === null || payload === void 0 ? void 0 : payload.status) === 200 && ((_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.url)) {
                                window.location.assign(payload.data.url);
                                return;
                            }
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Login failed", (payload === null || payload === void 0 ? void 0 : payload.message) || "Incorrect email or password.", 3e3, false);
                        } catch (e) {
                            console.error(e);
                            _this.revertSubmitButtonToDefault();
                            _this.notification.showNotification(notification_9.ENotificationType.error, "Server Error", "Unexpected response from login endpoint.");
                        }
                    }
                });
            };
            _this_1.form = form;
            _this_1.notification = notification;
            _this_1.buttonActions = buttonActions;
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        StAccountRegisterExtended.prototype.toggleLoader = function(show, message) {
            var loader = document.querySelector(".lbri_registration_loader_JS");
            var submitBtn = loader === null || loader === void 0 ? void 0 : loader.closest("button");
            var createAccountDiv = document.querySelector(".lbri_registration_login_link_JS");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                submitBtn && (submitBtn.disabled = true);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.add("opacity-50", "cursor-not-allowed");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "none";
                    createAccountDiv.style.opacity = "0.5";
                }
                if (message) this.setProgress(message);
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "auto";
                    createAccountDiv.style.opacity = "1";
                }
                submitBtn && (submitBtn.disabled = false);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.remove("opacity-50", "cursor-not-allowed");
            }
        };
        return StAccountRegisterExtended;
    }(account_register_1.StAccountRegister);
    exports.StAccountRegisterExtended = StAccountRegisterExtended;
});

define("core/shopify-app/st-modules/main/auto-apply-promo", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "_features.config" ], function(require, exports, st_module_54, _features_config_11, _features_config_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAutoApplyPromo = void 0;
    var StAutoApplyPromo = function(_super) {
        __extends(StAutoApplyPromo, _super);
        function StAutoApplyPromo() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "AutoApplyPromo";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _a, _b;
                    var promoCode = (_b = (_a = window.stAppConfig) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.repPromoCode;
                    if (promoCode) {
                        _this_1.setupRepDiscount(promoCode);
                        _this_1.removeCodeOnLogout(promoCode);
                        if (_features_config_12.shareRefCodeFunctionality) {
                            _this_1.applyRefPromoCode();
                        }
                    }
                });
            };
            _this_1.setupRepDiscount = function(promoCode) {
                var _a, _b;
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var repType = (_b = (_a = window.stAppConfig.options) === null || _a === void 0 ? void 0 : _a.customerType) === null || _b === void 0 ? void 0 : _b.representative;
                var currentCustomerType = window.customerInfoMetafields.customerType;
                if (currentCustomerType === repType && _features_config_11.repDiscountWithPromoCode) {
                    _this_1.applyPromoCodeIfNeeded(promoCode);
                }
            };
            _this_1.applyRefPromoCode = function() {
                document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                var refCode = localStorage.getItem("ref");
                if (!!refCode || refCode !== "null") {
                    _this_1.applyPromoCodeIfNeeded(refCode);
                }
            };
            _this_1.applyPromoCodeIfNeeded = function(promoCode) {
                if (!_this_1.isRepPromoApplied(promoCode)) {
                    var body = document.querySelector("body");
                    var iframeHolder = document.createElement("div");
                    iframeHolder.classList.add("st-autoapply-promocode");
                    var iframe = document.createElement("iframe");
                    iframe.classList.add("st_hidden");
                    iframe.src = "".concat(window.location.origin, "/discount/").concat(promoCode);
                    iframeHolder.appendChild(iframe);
                    body.insertBefore(iframeHolder, body.firstChild);
                }
            };
            _this_1.isRepPromoApplied = function(promoCode) {
                var alreadyApplied = false;
                var x = document.cookie.split("; ");
                for (var i = 0; i < x.length; i++) {
                    var c = x[i].split("=");
                    if (c[0] === "discount_code" || c[0] === "discount_code" && c[1] === promoCode) {
                        alreadyApplied = true;
                        break;
                    }
                }
                return alreadyApplied;
            };
            _this_1.removeCodeOnLogout = function(promoCode) {
                var _this = _this_1;
                var logoutLinks = document.querySelectorAll('[href*="account/logout"]');
                logoutLinks.forEach(function(logoutLink) {
                    logoutLink.addEventListener("click", function(e) {
                        if (_this.isRepPromoApplied(promoCode)) {
                            document.cookie = "discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                        }
                    });
                });
            };
            return _this_1;
        }
        return StAutoApplyPromo;
    }(st_module_54.StModule);
    exports.StAutoApplyPromo = StAutoApplyPromo;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_55) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectClassConfig = void 0;
    var StRepresentativeRedirectClassConfig = function(_super) {
        __extends(StRepresentativeRedirectClassConfig, _super);
        function StRepresentativeRedirectClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "representativeRedirectClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            return _this;
        }
        return StRepresentativeRedirectClassConfig;
    }(st_module_55.StModule);
    exports.StRepresentativeRedirectClassConfig = StRepresentativeRedirectClassConfig;
});

define("core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_56) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StRepresentativeRedirectPage = void 0;
    var StRepresentativeRedirectPage = function(_super) {
        __extends(StRepresentativeRedirectPage, _super);
        function StRepresentativeRedirectPage(classConfig, generalMethods) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "RepresentativeRedirectPage";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.copyToClipboard();
                });
            };
            _this_1.copyToClipboard = function() {
                var _this = _this_1;
                var copyRepSiteButtonAll = document.querySelectorAll(_this_1.classConfig.selectorRepRedirectIconCopyText);
                if (copyRepSiteButtonAll && copyRepSiteButtonAll.length > 0) {
                    for (var i = 0; i < copyRepSiteButtonAll.length; i++) {
                        var copyRepSiteButton = copyRepSiteButtonAll[i];
                        copyRepSiteButton.addEventListener("click", function(e) {
                            e.preventDefault();
                            var copyText = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                            if (!!copyText) {
                                var copyText_1 = document.querySelector(_this.classConfig.selectorRepRedirectLabel);
                                copyText_1.select();
                                copyText_1.setSelectionRange(0, 99999);
                                navigator.clipboard.writeText(copyText_1.value);
                                copyText_1.style.backgroundColor = "rgb(217, 218, 220)";
                                copyText_1.style.transition = "0.5s";
                                setTimeout(function() {
                                    copyText_1.style.backgroundColor = "rgb(249, 249, 249)";
                                    copyText_1.style.transition = "0.5s";
                                }, 1e3);
                            }
                        });
                    }
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            return _this_1;
        }
        return StRepresentativeRedirectPage;
    }(st_module_56.StModule);
    exports.StRepresentativeRedirectPage = StRepresentativeRedirectPage;
});

define("core/shopify-app/st-modules/account-login/account-login-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_57) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLoginClassConfig = void 0;
    var StAccountLoginClassConfig = function(_super) {
        __extends(StAccountLoginClassConfig, _super);
        function StAccountLoginClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "EnrollmentAccountClassConfig";
            _this.classLoginPasswordInput = "st_login-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            _this.classLoginPasswordFormControl = "st_login-password-form-control_JS";
            _this.selectorLoginPasswordFormControl = "." + _this.classLoginPasswordFormControl;
            return _this;
        }
        return StAccountLoginClassConfig;
    }(st_module_57.StModule);
    exports.StAccountLoginClassConfig = StAccountLoginClassConfig;
});

define("core/shopify-app/st-modules/account-login/account-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_58) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountLogin = void 0;
    var StAccountLogin = function(_super) {
        __extends(StAccountLogin, _super);
        function StAccountLogin(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "AccountLogin";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StAccountLogin;
    }(st_module_58.StModule);
    exports.StAccountLogin = StAccountLogin;
});

define("core/shopify-app/st-modules/reset-password/reset-password-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_59) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPasswordClassConfig = void 0;
    var StResetPasswordClassConfig = function(_super) {
        __extends(StResetPasswordClassConfig, _super);
        function StResetPasswordClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPasswordClassConfig";
            _this.classLoginPasswordInput = "st_reset-password-input_JS";
            _this.selectorLoginPasswordInput = "." + _this.classLoginPasswordInput;
            return _this;
        }
        return StResetPasswordClassConfig;
    }(st_module_59.StModule);
    exports.StResetPasswordClassConfig = StResetPasswordClassConfig;
});

define("core/shopify-app/st-modules/reset-password/reset-password", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_60) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StResetPassword = void 0;
    var StResetPassword = function(_super) {
        __extends(StResetPassword, _super);
        function StResetPassword(form, notification, buttonActions, classConfig, generalMethods) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ResetPassword";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.form.liveTrim();
                });
            };
            _this.form = form;
            _this.notification = notification;
            _this.buttonActions = buttonActions;
            _this.classConfig = classConfig;
            _this.generalMethods = generalMethods;
            return _this;
        }
        return StResetPassword;
    }(st_module_60.StModule);
    exports.StResetPassword = StResetPassword;
});

define("core/shopify-app/st-modules/referral/referral", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification", "_features.config" ], function(require, exports, st_module_61, notification_10, _features_config_13) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReferral = void 0;
    var StReferral = function(_super) {
        __extends(StReferral, _super);
        function StReferral(generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "Referral";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.checkTags();
                    _this_1.handlerRefBanner();
                });
            };
            _this_1.checkTags = function() {
                if (_features_config_13.shareRefCodeFunctionality) {
                    var customerTagsWrapper = document.querySelector(".st_customer-tags");
                    if (!!customerTagsWrapper) {
                        var tags = customerTagsWrapper.getAttribute("data-tags");
                        var isLogged = customerTagsWrapper.getAttribute("data-customer-id");
                        var splitStr = tags.split(",");
                        var retail = splitStr.find(function(ret) {
                            return ret.includes("retail");
                        });
                        var noOrder = splitStr.find(function(el) {
                            return el.includes("no_order");
                        });
                        if (isLogged) {
                            if (retail && noOrder) {
                                _this_1.getRefFromLink();
                                _this_1.setRefInLink();
                            } else {
                                _this_1.deleteRefCode();
                            }
                        } else {
                            _this_1.getRefFromLink();
                            _this_1.setRefInLink();
                        }
                    }
                } else {
                    _this_1.deleteRefCode();
                    _this_1.hideRef();
                }
            };
            _this_1.getRefFromLink = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (!!ref) {
                    localStorage.setItem("ref", ref);
                }
            };
            _this_1.getCode = function() {
                var tagFromNav = document.querySelector(".st_referral-code-div_JS");
                if (!!tagFromNav) {
                    return tagFromNav.getAttribute("data-customer-tags");
                }
            };
            _this_1.setRefInLink = function() {
                var refCode = localStorage.getItem("ref");
                var refCodeFromTag = _this_1.getCode();
                if (!refCode || refCode === "null" || refCode === " " || refCode === "undefined" || refCode === "") {
                    _this_1.deleteRefCode();
                } else {
                    if (refCode === refCodeFromTag) {
                        _this_1.deleteRefCode();
                    } else {
                        var params = new URLSearchParams(window.location.search);
                        if (!params.get("ref")) {
                            params.append("ref", refCode);
                        }
                        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
                        window.history.replaceState({
                            path: newUrl
                        }, "", newUrl);
                    }
                }
            };
            _this_1.deleteRefCode = function() {
                var params = new URLSearchParams(window.location.search);
                params.delete("ref");
                var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                if (!!params.toString()) {
                    newUrl += "?" + params;
                }
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
                localStorage.removeItem("ref");
            };
            _this_1.handlerRefBanner = function() {
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var ref = urlParams.ref;
                if (_features_config_13.shareRefCodeFunctionality) {
                    if (!!ref) {
                        _this_1.getReferralsData();
                    } else {
                        _this_1.hideRef();
                    }
                } else {
                    _this_1.hideRef();
                }
            };
            _this_1.showRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.remove("st_hidden");
                    }
                }
            };
            _this_1.hideRef = function() {
                var refWrapper = document.querySelector(".st_referred-by-banner_JS");
                if (!!refWrapper) {
                    if (!refWrapper.classList.contains("st_hidden")) {
                        refWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.getReferralsData = function() {
                var _this = _this_1;
                var referralCode = localStorage.getItem("ref");
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_13.aliasQueryParam];
                var refCode = {
                    promoCode: referralCode,
                    webAlias: currentAlias
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["getReferralInfo"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getReferralInfo = JSON.parse(response.response);
                            if (getReferralInfo.status === 200) {
                                var refType = getReferralInfo.data.customerType;
                                if (refType === "retail") {
                                    _this.showRef();
                                    var fullname = getReferralInfo.data.firstName + " " + getReferralInfo.data.lastName;
                                    _this.writeRefName(fullname);
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "representative") {
                                    if (getReferralInfo.data.customerSponsorMatch === false) {
                                        _this.deleteRefCode();
                                        _this.hideRef();
                                    }
                                }
                                if (refType === "") {
                                    console.log("INVALID REF CODE !!!!!!!!!!!");
                                    _this.deleteRefCode();
                                    _this.hideRef();
                                }
                            } else {
                                _this.notification.showNotification(notification_10.ENotificationType.error, "An Error Occurred", getReferralInfo.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_10.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.writeRefName = function(fullname) {
                var refNameSpan = document.querySelector(".st_referral-fullname_JS");
                if (!!refNameSpan) {
                    refNameSpan.innerHTML = fullname;
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        return StReferral;
    }(st_module_61.StModule);
    exports.StReferral = StReferral;
});

define("core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_62, _features_config_14) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCouponCodes = void 0;
    var StCouponCodes = function(_super) {
        __extends(StCouponCodes, _super);
        function StCouponCodes() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CouponCodes";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.blockHandle();
                });
            };
            _this_1.blockHandle = function() {
                var mainWrapper = document.querySelector(".st_account-coupon-codes_wrapper_JS");
                if (!!mainWrapper) {
                    if (_features_config_14.shareRefCodeFunctionality) {
                        mainWrapper.classList.remove("st_hidden");
                        _this_1.toggleInputs();
                        _this_1.copyCode();
                        _this_1.earnedCouponCodes();
                        _this_1.redeemedCouponCodes();
                        var showInactive = false;
                        _this_1.filterStatus(showInactive);
                    } else {
                        mainWrapper.classList.add("st_hidden");
                    }
                }
            };
            _this_1.toggleInputs = function() {
                var _this = _this_1;
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var showCodeBtn = el.querySelector(".st_table-show-coupon_JS");
                        showCodeBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            _this.showCode(el);
                        });
                    });
                }
            };
            _this_1.showCode = function(el) {
                var showCodeBtnWrapper = el.querySelector(".st_table-coupon-code-show-wrapper_JS");
                var codeWrapper = el.querySelector(".st_table-coupon-code-input-wrapper_JS");
                if (!!showCodeBtnWrapper && !!codeWrapper) {
                    showCodeBtnWrapper.classList.add("st_hidden");
                    codeWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.copyCode = function() {
                var showCodeBtnField = document.querySelectorAll(".st_coupon-codes-table-codes_JS");
                if (!!showCodeBtnField) {
                    showCodeBtnField.forEach(function(el) {
                        var copyCodeBtn = el.querySelector(".st_table-copy-coupon_JS");
                        if (!!copyCodeBtn) {
                            copyCodeBtn.addEventListener("click", function() {
                                var input = el.querySelector(".st_table-coupon-code_JS");
                                if (!!input) {
                                    input.select();
                                    input.setSelectionRange(0, 99999);
                                    navigator.clipboard.writeText(input.value);
                                    input.style.backgroundColor = "rgb(217, 218, 220)";
                                    input.style.transition = "0.2s";
                                    setTimeout(function() {
                                        input.style.backgroundColor = "rgb(249, 249, 249)";
                                    }, 1e3);
                                }
                            });
                        }
                    });
                }
            };
            _this_1.earnedCouponCodes = function() {
                var _this = _this_1;
                var earnedBtn = document.querySelector(".st_earned-coupon-codes_JS");
                if (!!earnedBtn) {
                    earnedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = false;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.redeemedCouponCodes = function() {
                var _this = _this_1;
                var redeemedBtn = document.querySelector(".st_redeemed-coupon-codes_JS");
                if (!!redeemedBtn) {
                    redeemedBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var flag = true;
                        _this.filterStatus(flag);
                    });
                }
            };
            _this_1.filterStatus = function(flag) {
                var _this = _this_1;
                var tableRows = document.querySelectorAll(".st_coupon-codes-table-row_JS");
                if (!!tableRows) {
                    tableRows.forEach(function(el) {
                        var couponStatusEl = el.querySelector(".st_coupon-codes-table-status_JS");
                        var status = couponStatusEl.getAttribute("data-status");
                        if (flag) {
                            if (status === "Active") {
                                el.classList.add("st_hidden");
                            } else {
                                el.classList.remove("st_hidden");
                            }
                        } else {
                            if (status === "Active") {
                                el.classList.remove("st_hidden");
                            } else {
                                el.classList.add("st_hidden");
                            }
                        }
                        _this.adjustTableHeader(flag);
                        _this.adjustTableForInactive(status, el);
                    });
                }
            };
            _this_1.adjustTableForInactive = function(status, el) {
                var copyBtn = el.querySelector(".st_table-copy-coupon_JS");
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (status === "Active") {
                        copyBtn.classList.remove("st_hidden");
                    } else {
                        copyBtn.classList.add("st_hidden");
                        _this_1.showCode(el);
                    }
                }
            };
            _this_1.adjustTableHeader = function(flag) {
                var columnNameEl = document.querySelector(".st_table-head-actions_JS");
                if (!!columnNameEl) {
                    if (flag) {
                        columnNameEl.innerHTML = "Used Promo Code";
                    } else {
                        columnNameEl.innerHTML = "Actions";
                    }
                }
            };
            return _this_1;
        }
        return StCouponCodes;
    }(st_module_62.StModule);
    exports.StCouponCodes = StCouponCodes;
});

define("extension/shopify-app/st-modules/webalias/webalias-class-config.extended", [ "require", "exports", "core/shopify-app/st-modules/webalias/webalias-class-config" ], function(require, exports, webalias_class_config_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StWebAliasClassConfigExtended = void 0;
    var StWebAliasClassConfigExtended = function(_super) {
        __extends(StWebAliasClassConfigExtended, _super);
        function StWebAliasClassConfigExtended() {
            var _this = _super.call(this) || this;
            _this.className = "StWebAliasClassConfigExtended";
            _this.classNameRepId = "st_representative-id_JS";
            _this.selectorRepId = "." + _this.classNameRepId;
            _this.classNameRepAlias = "st_representative-alias_JS";
            _this.selectorRepAlias = "." + _this.classNameRepAlias;
            _this.classNameRepFullName = "st_representative-fullname_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepInitials = "st_representative-initials_JS";
            _this.selectorRepInitials = "." + _this.classNameRepInitials;
            _this.classNameRepSite = "st_representative-site_JS";
            _this.selectorRepSite = "." + _this.classNameRepSite;
            _this.classNameRepBio = "st_representative-site-bio_JS";
            _this.selectorRepBio = "." + _this.classNameRepBio;
            _this.classNameRepAddress = "st_representative-address_JS";
            _this.selectorRepAddress = "." + _this.classNameRepAddress;
            _this.classNameNonSponsor = "st_non-sponsor_JS";
            _this.selectorNonSponsor = "." + _this.classNameNonSponsor;
            _this.classRepresentativeBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepresentativeBannerWrapper = "." + _this.classRepresentativeBannerWrapper;
            _this.classNameBusinessContentRepName = "st_account-business--rep-name_JS";
            _this.selectorBusinessContentRepName = "." + _this.classNameBusinessContentRepName;
            _this.classNamePersonalInfoForm = "st_personal-info-form_JS";
            _this.selectorPersonalInfoForm = "." + _this.classNamePersonalInfoForm;
            _this.classNamePersonalInfoRepFullName = "st_representative-info-fullname_JS";
            _this.selectorPersonalInfoRepFullName = "." + _this.classNamePersonalInfoRepFullName;
            _this.classNameRepBannerImage = "st_representative_image_JS";
            _this.selectorRepBannerImage = "." + _this.classNameRepBannerImage;
            _this.classNameRepDefaultImage = "st_representative_image_default_JS";
            _this.selectorRepDefaultImage = "." + _this.classNameRepDefaultImage;
            _this.classNameRepEmail = "st_representative_email_JS";
            _this.selectorRepEmail = "." + _this.classNameRepEmail;
            _this.classNameRepAboutMe = "st_representative_about_me_JS";
            _this.selectorRepAboutMe = "." + _this.classNameRepAboutMe;
            _this.classNameRepJoinMyTeam = "st_representative_join_my_team_JS";
            _this.selectorRepJoinMyTeam = "." + _this.classNameRepJoinMyTeam;
            _this.classNameRepBannerWrapper = "st_representative-banner--wrapper_JS";
            _this.selectorRepBannerWrapper = "." + _this.classNameRepBannerWrapper;
            _this.classNameRepSponsorField = "st_print-sponsor-field_JS";
            _this.selectorRepSponsorField = "." + _this.classNameRepSponsorField;
            return _this;
        }
        return StWebAliasClassConfigExtended;
    }(webalias_class_config_1.StWebAliasClassConfig);
    exports.StWebAliasClassConfigExtended = StWebAliasClassConfigExtended;
});

define("extension/shopify-app/st-modules/rep-site-detail/rep-site-detail-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_63) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReplicatedSiteDetailClassConfig = void 0;
    var StReplicatedSiteDetailClassConfig = function(_super) {
        __extends(StReplicatedSiteDetailClassConfig, _super);
        function StReplicatedSiteDetailClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "replicatedSiteDetailClassConfig";
            _this.classNameRepRedirectCopyText = "st_copy-repsite_JS";
            _this.selectorRepRedirectIconCopyText = "." + _this.classNameRepRedirectCopyText;
            _this.classNameRepRedirectCopyTextWrapper = "st_copy-repsite--wrapper_JS";
            _this.selectorRepRedirectCopyTextWrapper = "." + _this.classNameRepRedirectCopyTextWrapper;
            _this.classNameRepRedirectLabel = "st_representative-site_JS";
            _this.selectorRepRedirectLabel = "." + _this.classNameRepRedirectLabel;
            _this.classNameRepFullName = "st_rep-site-detail-full-name_JS";
            _this.selectorRepFullName = "." + _this.classNameRepFullName;
            _this.classNameRepDetailRank = "st_rep-site-detail-rank_JS";
            _this.selectorRepDetailRank = "." + _this.classNameRepDetailRank;
            _this.classNameRepDetailDetails = "st_rep-site-detail-details_JS";
            _this.selectorRepDetailDetails = "." + _this.classNameRepDetailDetails;
            _this.classNameRepDetailEmail = "st_rep-site-detail-email_JS";
            _this.selectorRepDetailEmail = "." + _this.classNameRepDetailEmail;
            _this.classNameRepDetailPhone = "st_rep-site-detail-phone_JS";
            _this.selectorRepDetailPhone = "." + _this.classNameRepDetailPhone;
            _this.classNameRepFacebookSN = "st_rep-site-sn-facebook_JS";
            _this.selectorRepFacebookSN = "." + _this.classNameRepFacebookSN;
            _this.classNameRepXSN = "st_rep-site-sn-X_JS";
            _this.selectorRepXSN = "." + _this.classNameRepXSN;
            _this.classNameRepInstagramSN = "st_rep-site-sn-Instagram_JS";
            _this.selectorRepInstagramSN = "." + _this.classNameRepInstagramSN;
            _this.classNameRepWhatsAppSN = "st_rep-site-sn-WhatsApp_JS";
            _this.selectorRepWhatsAppSN = "." + _this.classNameRepWhatsAppSN;
            _this.classNameLinkedInXSN = "st_rep-site-sn-LinkedIn_JS";
            _this.selectorRepLinkedInSN = "." + _this.classNameLinkedInXSN;
            _this.classNameRepTikTokSN = "st_rep-site-sn-TikTok_JS";
            _this.selectorRepTikTokSN = "." + _this.classNameRepTikTokSN;
            _this.classNameRepPinterestSN = "st_rep-site-sn-Pinterest_JS";
            _this.selectorRepPinterestSN = "." + _this.classNameRepPinterestSN;
            return _this;
        }
        return StReplicatedSiteDetailClassConfig;
    }(st_module_63.StModule);
    exports.StReplicatedSiteDetailClassConfig = StReplicatedSiteDetailClassConfig;
});

define("extension/shopify-app/st-modules/webalias/inject-representative-info", [ "require", "exports", "core/shopify-app/st-modules/webalias/inject-representative-info", "_features.config" ], function(require, exports, inject_representative_info_1, _features_config_15) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInjectRepresentativeInfoExtended = void 0;
    var StInjectRepresentativeInfoExtended = function(_super) {
        __extends(StInjectRepresentativeInfoExtended, _super);
        function StInjectRepresentativeInfoExtended(classConfig, generalMethods) {
            var _this = _super.call(this, classConfig) || this;
            _this.className = "InjectRepresentativeInfoExtended";
            _this.injectToFields = function(repInfo) {
                var repId = repInfo.repId, webAlias = repInfo.webAlias, firstName = repInfo.firstName, lastName = repInfo.lastName, imageUrl = repInfo.imageUrl, email = repInfo.email;
                if (!!repId) {
                    _this.appendIdToField(repInfo.repId);
                }
                if (!!webAlias) {
                    _this.appendAlsToField(webAlias);
                    _this.appendRepSiteUrlToField(webAlias);
                }
                if (!!firstName || !!lastName) {
                    _this.appendRepFullNameToFieldV2(repInfo);
                }
                if (!!imageUrl && _features_config_15.additionalRepInfo) {
                    _this.appendRepBioToField(imageUrl);
                }
            };
            _this.appendRepFullNameToFieldV2 = function(repInfo) {
                var repFullNameFields = document.querySelectorAll(_this.classConfig.selectorRepFullName);
                var fullName = _this.getFullNameV2(repInfo);
                var repImage = document.querySelector(_this.classConfig.selectorRepBannerImage);
                var repImages = document.querySelectorAll(_this.classConfig.selectorRepBannerImage);
                var repImagesDefault = document.querySelectorAll(_this.classConfig.selectorRepDefaultImage);
                repImage === null || repImage === void 0 ? void 0 : repImage.classList.add("st_hidden");
                if (repFullNameFields.length > 0) {
                    _this.appendValueToFields(repFullNameFields, fullName);
                }
                if (repInfo.imageUrl) {
                    repImages.forEach(function(repImageTemp) {
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("src", repInfo.imageUrl);
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.classList.remove("st_hidden");
                        repImageTemp === null || repImageTemp === void 0 ? void 0 : repImageTemp.setAttribute("srcset", "");
                    });
                    repImagesDefault.forEach(function(repImageDefaultTemp) {
                        repImageDefaultTemp === null || repImageDefaultTemp === void 0 ? void 0 : repImageDefaultTemp.classList.add("st_hidden");
                    });
                }
                _this.showBannerContent(repImage);
                var emailField = document.querySelector(_this.classConfig.selectorRepEmail);
                if (!!emailField) {
                    emailField.innerText = repInfo.email;
                }
                var aboutMeField = document.querySelector(_this.classConfig.selectorRepAboutMe);
                if (!!aboutMeField) {
                    aboutMeField.addEventListener("click", function(e) {
                        window.location.href = window.location.origin + "/pages/replicated-site-detail-page";
                    });
                }
                var joinMyTeamField = document.querySelector(_this.classConfig.selectorRepJoinMyTeam);
                if (!!joinMyTeamField) {
                    joinMyTeamField.addEventListener("click", function(e) {
                        var repId = window.localStorage.getItem("repId");
                        console.log(repId, typeof repId);
                        if (repId === "400560") {
                            window.location.href = "https://extranet.lbri.com/Lbri/SignUp/EnrollNew_Ask.asp?ReturnURL=&Products=";
                        }
                        else if (repId != "undefined") {
                            window.location.href = "https://extranet.lbri.com/lbri/Personal/Signup/EnrollNew_Custom.asp?RepID=" + repId;
                        }
                         else {
                            window.location.href = "https://extranet.lbri.com/Lbri/SignUp/EnrollNew_Ask.asp?ReturnURL=&Products=";
                        }
                    });
                }
            };
            _this.showBannerContent = function(repImage) {
                var _a, _b;
                repImage.onerror = function() {
                    console.warn("Representative image not found → fallback to SVG");
                    var wrapper = repImage.closest(".st_repbar_avatar");
                    if (!wrapper) return;
                    var defaultSvg = wrapper.querySelector(".st_representative_image_default_JS");
                    repImage.classList.add("st_hidden");
                    defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
                };
                var innerWrapper = _this.generalMethods.getClosestByClass(repImage, _this.classConfig.classNameRepBannerWrapper);
                if (innerWrapper) {
                    (_a = innerWrapper.querySelector(".st_loader")) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
                    (_b = innerWrapper.querySelector(_this.classConfig.selectorRepSponsorField)) === null || _b === void 0 ? void 0 : _b.classList.remove("st_hidden");
                }
            };
            _this.getFullNameV2 = function(repInfo) {
                var fullName = "";
                if (!!repInfo.firstName) {
                    fullName = repInfo.firstName;
                    if (!!repInfo.lastName) {
                        fullName += " " + repInfo.lastName;
                    }
                }
                if (repInfo.webAlias === _features_config_15.defaultWebAlias || repInfo.repId === _features_config_15.defaultWebAlias) {
                    fullName = _features_config_15.corporationName;
                }
                return fullName;
            };
            _this.generalMethods = generalMethods;
            _this.classConfig = classConfig;
            return _this;
        }
        return StInjectRepresentativeInfoExtended;
    }(inject_representative_info_1.StInjectRepresentativeInfo);
    exports.StInjectRepresentativeInfoExtended = StInjectRepresentativeInfoExtended;
});

define("extension/shopify-app/st-modules/rep-site-detail/rep-site-detail", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_64, _features_config_16, notification_11) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StReplicatedSiteDetail = void 0;
    var StReplicatedSiteDetail = function(_super) {
        __extends(StReplicatedSiteDetail, _super);
        function StReplicatedSiteDetail(classConfig, generalMethods, objectFormatting, notification) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StReplicatedSiteDetail";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getRepSiteData();
                });
            };
            _this_1.getRepSiteData = function() {
                var _this = _this_1;
                var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                var currentAlias = urlParams[_features_config_16.aliasQueryParam];
                if (!currentAlias) {
                    currentAlias = window.localStorage.getItem("webAlias");
                }
                var refCode = {
                    customerIdOrAlias: currentAlias,
                    isOwnInfo: true
                };
                _this_1.ajax.send({
                    endpoint: _this_1.endpoint["customer"]["get-rep-details"],
                    method: "post",
                    contentType: "json",
                    data: refCode,
                    callback: function(response) {
                        try {
                            var getRepDetails = JSON.parse(response.response);
                            if (getRepDetails.status === 200) {
                                _this.setDataToPage(getRepDetails);
                            } else {
                                _this.notification.showNotification(notification_11.ENotificationType.error, "An Error Occurred", getRepDetails.message);
                            }
                        } catch (error) {
                            console.error(error);
                            _this.notification.showNotification(notification_11.ENotificationType.error, "Server Error", error);
                        }
                    }
                });
            };
            _this_1.setDataToPage = function(getRepDetails) {
                var _a, _b, _c, _d, _e, _f, _g;
                var setupElements = [ {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepFullName,
                    data: getRepDetails.data.firstName + " " + getRepDetails.data.lastName
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailRank,
                    data: getRepDetails.data.repRank.rankDescription
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailDetails,
                    data: getRepDetails.data.replicatedSiteText
                }, {
                    function: "setElementInnerHTML",
                    selector: _this_1.classConfig.selectorRepDetailEmail,
                    data: getRepDetails.data.email
                }, {
                    function: "setPhone",
                    selector: _this_1.classConfig.selectorRepDetailPhone,
                    data: getRepDetails.data
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepFacebookSN,
                    data: (_a = getRepDetails.data.socialNetworks) === null || _a === void 0 ? void 0 : _a.facebook
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepXSN,
                    data: (_b = getRepDetails.data.socialNetworks) === null || _b === void 0 ? void 0 : _b.twitter
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepInstagramSN,
                    data: (_c = getRepDetails.data.socialNetworks) === null || _c === void 0 ? void 0 : _c.instagram
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepWhatsAppSN,
                    data: (_d = getRepDetails.data.socialNetworks) === null || _d === void 0 ? void 0 : _d.WhatsAppSN
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepLinkedInSN,
                    data: (_e = getRepDetails.data.socialNetworks) === null || _e === void 0 ? void 0 : _e.linkedIn
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepTikTokSN,
                    data: (_f = getRepDetails.data.socialNetworks) === null || _f === void 0 ? void 0 : _f.tikTok
                }, {
                    function: "setSocialMediaIcon",
                    selector: _this_1.classConfig.selectorRepPinterestSN,
                    data: (_g = getRepDetails.data.socialNetworks) === null || _g === void 0 ? void 0 : _g.pinterest
                } ];
                setupElements.forEach(function(el) {
                    _this_1[el.function](document.querySelector(el.selector), el.data);
                });
                var repImages = document.querySelectorAll(".st_rep-site-detail-image_JS");
                if (repImages === null || repImages === void 0 ? void 0 : repImages.length) {
                    repImages.forEach(function(img) {
                        if (!img) return;
                        _this_1.bindRepImageFallback(img);
                        img.setAttribute("src", getRepDetails.data.imageUrl || "");
                        img.removeAttribute("srcset");
                    });
                }
                var mainLoader = document.querySelector(".st_rep-site-detail-main-loader_JS");
                mainLoader === null || mainLoader === void 0 ? void 0 : mainLoader.classList.add("st_hidden");
                var mainContainer = document.querySelector(".st_rep-site-detail-wrapper");
                mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.classList.remove("st_hidden");
            };
            _this_1.setElementInnerHTML = function(SNElement, SNdata) {
                if (SNElement && SNdata) {
                    SNElement.innerHTML = SNdata;
                }
            };
            _this_1.setSocialMediaIcon = function(SNElement, SNdata) {
                console.log("SNElement", SNElement);
                console.log("SNdata", SNdata);
                if (SNElement && SNdata && SNdata.isValid) {
                    SNElement.href = SNdata.url;
                    SNElement === null || SNElement === void 0 ? void 0 : SNElement.classList.remove("st_hidden");
                }
            };
            _this_1.setPhone = function(SNElement, SNdata) {
                var determinedPhone = "/";
                if (SNElement && SNdata) {
                    if (!!SNdata.phone1) {
                        determinedPhone = SNdata.phone1;
                    } else if (!!SNdata.phone2) {
                        determinedPhone = SNdata.phone2;
                    } else if (!!SNdata.phone3) {
                        determinedPhone = SNdata.phone3;
                    } else if (!!SNdata.phone4) {
                        determinedPhone = SNdata.phone4;
                    } else if (!!SNdata.phone5) {
                        determinedPhone = SNdata.phone5;
                    } else if (!!SNdata.phone6) {
                        determinedPhone = SNdata.phone6;
                    }
                    SNElement.innerHTML = determinedPhone;
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.generalMethods = generalMethods;
            _this_1.objectFormatting = objectFormatting;
            _this_1.notification = notification;
            return _this_1;
        }
        StReplicatedSiteDetail.prototype.bindRepImageFallback = function(repImage) {
            if (repImage.__fallbackBound) return;
            repImage.__fallbackBound = true;
            var wrapper = repImage.closest(".st_repbar_avatar") || repImage.parentElement;
            var defaultSvg = wrapper === null || wrapper === void 0 ? void 0 : wrapper.querySelector(".st_representative_image_default_JS");
            repImage.classList.add("st_hidden");
            defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
            repImage.onload = function() {
                defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.add("st_hidden");
                repImage.classList.remove("st_hidden");
            };
            repImage.onerror = function() {
                repImage.classList.add("st_hidden");
                defaultSvg === null || defaultSvg === void 0 ? void 0 : defaultSvg.classList.remove("st_hidden");
                repImage.removeAttribute("srcset");
            };
        };
        return StReplicatedSiteDetail;
    }(st_module_64.StModule);
    exports.StReplicatedSiteDetail = StReplicatedSiteDetail;
});

define("extension/shopify-app/st-modules/webalias/shopining-with/party-banner-info", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_65) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyBannerInfo = void 0;
    var StPartyBannerInfo = function(_super) {
        __extends(StPartyBannerInfo, _super);
        function StPartyBannerInfo(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyBannerInfo";
            _this_1.init = function() {
                _this_1.checkIfPartyExist();
                _this_1.listenForPageChanges();
            };
            _this_1.checkIfPartyExist = function() {
                var _this = _this_1;
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(location.search);
                var als = queryParams.als, partyId = queryParams.partyId;
                if (!!partyId) {
                    _this_1.getPartyBannerInformation(partyId, als);
                } else {
                    _this.renderNoParty();
                }
            };
            _this_1.getPartyBannerInformation = function(party, webAlias) {
                var _this = _this_1;
                var partyBannerWrapper = document.querySelector(".st_representative-party-name_JS");
                if (!!partyBannerWrapper) {
                    var partyBannerInformationEndpoint = _this.endpoint["party"]["party-banner-information"];
                    try {
                        _this_1.ajax.send({
                            endpoint: partyBannerInformationEndpoint,
                            method: "POST",
                            contentType: "json",
                            data: {
                                sponsorAlias: webAlias,
                                partyId: party
                            },
                            callback: function(res) {
                                var resp = JSON.parse(res.response);
                                if (resp.status === 200) {
                                    var partyName = resp.data.partyName;
                                    var partyHostName = resp.data.partyHostName;
                                    _this.renderHostName(partyHostName);
                                    _this.renderPartyName(partyName, partyHostName);
                                } else {
                                    console.log(resp.message);
                                }
                            }
                        });
                    } catch (err) {
                        console.log("getPartyBannerInformation---\x3e Error:", err);
                    }
                }
            };
            _this_1.renderHostName = function(hostName) {
                var hostNameEls = document.querySelectorAll(".st_referral-party-host-name_JS");
                if (!!hostNameEls) {
                    hostNameEls.forEach(function(el) {
                        el.textContent = hostName;
                    });
                }
            };
            _this_1.renderPartyName = function(partyName, hostName) {
                var partyNameEls = document.querySelectorAll(".st_representative-party-name_JS");
                if (!!partyNameEls) {
                    var trimmedHost = hostName.trim();
                    var lastChar = trimmedHost.charAt(trimmedHost.length - 1);
                    var possessive = lastChar === "s" ? "".concat(trimmedHost, "'") : "".concat(trimmedHost, "'s");
                    var fullPartyName_1 = "".concat(possessive, " ").concat(partyName.trim());
                    partyNameEls.forEach(function(el) {
                        el.textContent = fullPartyName_1;
                    });
                }
            };
            _this_1.renderNoParty = function() {
                var hostEls = document.querySelectorAll(".st_referral-party-host-name_JS");
                var nameEls = document.querySelectorAll(".st_representative-party-name_JS");
                hostEls.forEach(function(el) {
                    return el.textContent = "";
                });
                nameEls.forEach(function(el) {
                    return el.textContent = "";
                });
            };
            _this_1.listenForPageChanges = function() {
                var _this = _this_1;
                window.addEventListener("popstate", function() {
                    _this.checkIfPartyExist();
                });
                (function(history) {
                    var pushState = history.pushState;
                    var replaceState = history.replaceState;
                    history.pushState = function() {
                        var result = pushState.apply(history, arguments);
                        window.dispatchEvent(new Event("pushstate"));
                        window.dispatchEvent(new Event("locationchange"));
                        return result;
                    };
                    history.replaceState = function() {
                        var result = replaceState.apply(history, arguments);
                        window.dispatchEvent(new Event("replacestate"));
                        window.dispatchEvent(new Event("locationchange"));
                        return result;
                    };
                })(window.history);
                window.addEventListener("locationchange", function() {
                    _this.checkIfPartyExist();
                });
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyBannerInfo;
    }(st_module_65.StModule);
    exports.StPartyBannerInfo = StPartyBannerInfo;
});

define("extension/connector-app/_shared/models/party/party.validation.request", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/connector-app/_shared/models/party/party.validataion.response", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/party/party-service", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_66) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyService = void 0;
    var StPartyService = function(_super) {
        __extends(StPartyService, _super);
        function StPartyService(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyService";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {});
            };
            _this_1.partyValidation = function(partyValidationReq, responseHandle) {
                var _this = _this_1;
                var partyValidationEndpoint = _this.endpoint["party"]["party-validation"];
                _this_1.ajax.send({
                    endpoint: partyValidationEndpoint,
                    method: "POST",
                    contentType: "json",
                    data: partyValidationReq,
                    callback: function(res) {
                        try {
                            res = JSON.parse(res.response);
                            responseHandle(res);
                        } catch (err) {
                            console.log("Error: partyValidation --\x3e", err);
                        }
                    }
                });
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyService;
    }(st_module_66.StModule);
    exports.StPartyService = StPartyService;
});

define("extension/shopify-app/st-modules/party/party", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_67) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StParty = void 0;
    var StParty = function(_super) {
        __extends(StParty, _super);
        function StParty(objectFormatting, partyService, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StParty";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.initPersistParty();
                });
            };
            _this.initPersistParty = function() {
                var rawTags = window.customerTags;
                var tags = [];
                if (Array.isArray(rawTags)) {
                    tags = rawTags;
                } else if (typeof rawTags === "string") {
                    tags = rawTags.split(",").map(function(tag) {
                        return tag.trim();
                    }).filter(Boolean);
                }
                var hasTagInfo = rawTags !== undefined && rawTags !== null;
                var isPartyAllowed = tags.includes("Shopping_on_behalf") || tags.includes("retail");
                if (hasTagInfo && !isPartyAllowed) {
                    _this.removePartyId();
                    _this.removePartyFromQuery();
                    return;
                }
                var partyFromUrl = _this.getPartyFromQuery;
                var lsParty = localStorage.getItem("partyId");
                var als = localStorage.getItem("webAlias");
                var partyId = lsParty || partyFromUrl || null;
                if (partyId !== null && partyId !== "") {
                    var safePartyId_1 = partyId;
                    _this.validateParty(safePartyId_1, function(isPartyOpen) {
                        if (isPartyOpen) {
                            var currentLsParty = localStorage.getItem("partyId");
                            if (!currentLsParty || currentLsParty === safePartyId_1) {
                                localStorage.setItem("partyId", safePartyId_1);
                                _this.insertPartyInQuery();
                            }
                        } else {
                            _this.removePartyId();
                        }
                    });
                    return;
                }
                partyId = localStorage.getItem("partyId");
                if (partyId && als) {
                    _this.validateParty(partyId, function(isOpen) {
                        if (isOpen) {
                            var currentLsParty = localStorage.getItem("partyId");
                            if (!currentLsParty || currentLsParty === partyId) {
                                localStorage.setItem("partyId", partyId);
                                _this.insertPartyInQuery();
                            }
                        }
                    });
                }
            };
            _this.validateParty = function(partyId, handleFunc) {
                var validationReqObj = {
                    partyId: parseInt(partyId)
                };
                _this.partyService.partyValidation(validationReqObj, function(response) {
                    try {
                        var isPartyOpen = response.data.isPartyOpen;
                        if (isPartyOpen) {
                            var lsParty = localStorage.getItem("partyId") || "";
                            if (lsParty && lsParty !== partyId) {
                                handleFunc(true);
                                return;
                            }
                            _this.addPartyIdToCart(partyId);
                            handleFunc(true);
                        } else {
                            _this.removePartyId();
                            var currentUrl = new URL(window.location.href);
                            currentUrl.searchParams.delete("partyId");
                            window.history.replaceState({}, "", currentUrl);
                            handleFunc(false);
                        }
                    } catch (e) {
                        _this.removePartyId();
                        var currentUrl = new URL(window.location.href);
                        currentUrl.searchParams.delete("partyId");
                        window.history.replaceState({}, "", currentUrl);
                        handleFunc(false);
                    }
                });
            };
            _this.insertPartyInQuery = function() {
                var partyIdLS = localStorage.getItem("partyId");
                var alsLS = localStorage.getItem("webAlias");
                if (!partyIdLS || !alsLS) return;
                var currentUrl = new URL(window.location.href);
                var partyFromUrl = (currentUrl.searchParams.get("partyId") || "").trim();
                var alsFromUrl = (currentUrl.searchParams.get("als") || "").trim();
                if (partyFromUrl && partyFromUrl !== partyIdLS) {
                    return;
                }
                if (!partyFromUrl) {
                    currentUrl.searchParams.set("partyId", partyIdLS);
                }
                if (!alsFromUrl) {
                    currentUrl.searchParams.set("als", alsLS);
                }
                var newUrl = currentUrl.toString();
                window.history.replaceState({
                    path: newUrl
                }, "", newUrl);
            };
            _this.addPartyToCart = function() {
                var partyId = _this.getPartyFromQuery;
                var sponsorAlias = localStorage.getItem("webAlias");
                _this.cartComponent.getCart(function(cartRes) {
                    var attributes = cartRes.attributes;
                    attributes = __assign(__assign({}, attributes), {
                        partyId: !!partyId ? partyId : null,
                        sponsorAlias: !!sponsorAlias ? sponsorAlias : null
                    });
                    _this.cartComponent.updateCartAttributesWithPartyId({
                        attributes: attributes
                    }, function(res) {});
                });
            };
            _this.addPartyIdToCart = function(partyId) {
                var sponsorAlias = localStorage.getItem("webAlias");
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            partyId: partyId,
                            sponsorWebAlias: sponsorAlias
                        }
                    })
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {}).catch(function(error) {
                    console.error("Error adding Party ID to cart:", error);
                });
            };
            _this.removePartyFromQuery = function() {
                var currentUrl = new URL(window.location.href);
                currentUrl.searchParams.delete("partyId");
                history.replaceState({}, "", currentUrl.toString());
            };
            _this.objectFormatting = objectFormatting;
            _this.partyService = partyService;
            _this.cartComponent = cartComponent;
            return _this;
        }
        Object.defineProperty(StParty.prototype, "getPartyFromQuery", {
            get: function() {
                var queryParams = this.objectFormatting.convertQueryStringToObject(location.search);
                var partyId = queryParams.partyId;
                return !!partyId && partyId !== "undefined" ? partyId : "";
            },
            enumerable: false,
            configurable: true
        });
        StParty.prototype.removePartyId = function() {
            if (localStorage.getItem("partyId")) {
                localStorage.removeItem("partyId");
            }
            var currentCart = this.cartComponent.getShopifyCartData;
            if (!!currentCart.attributes.partyId) {
                this.clearPartyAttributesFromCart();
            }
        };
        StParty.prototype.clearPartyAttributesFromCart = function() {
            fetch("/cart.js").then(function(response) {
                return response.json();
            }).then(function(cart) {
                var updatedAttributes = __assign({}, cart.attributes);
                var attributesToRemove = [ "partyId", "sponsorWebAlias" ];
                attributesToRemove.forEach(function(attr) {
                    updatedAttributes[attr] = null;
                });
                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: updatedAttributes
                    })
                });
            }).then(function(res) {
                return res.json();
            }).then(function(data) {}).catch(function(error) {
                console.error("error cleaning cart atributes for Party ", error);
            });
        };
        return StParty;
    }(st_module_67.StModule);
    exports.StParty = StParty;
});

define("extension/shopify-app/st-modules/party/party-check", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_68) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPartyCheck = void 0;
    var StPartyCheck = function(_super) {
        __extends(StPartyCheck, _super);
        function StPartyCheck(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "PartyCheck";
            _this_1.init = function() {
                _this_1.checkIfPartyExist();
                _this_1.subscribeDOMLoaded(function() {
                    window.addEventListener("PartyBannerEvent", _this_1.checkIfPartyExist);
                });
                _this_1.sharePartyLink();
            };
            _this_1.checkIfPartyExist = function() {
                var queryParams = _this_1.objectFormatting.convertQueryStringToObject(location.search);
                var _a = queryParams, als = _a.als, partyId = _a.partyId;
                var lsParty = localStorage.getItem("partyId") || "";
                var lsAls = localStorage.getItem("webAlias") || "";
                if (partyId && als) {
                    if (lsParty !== partyId) {
                        localStorage.setItem("partyId", partyId);
                        localStorage.setItem("webAlias", als);
                    }
                } else {
                    partyId = lsParty || undefined;
                    als = lsAls || undefined;
                }
                if (partyId && als) {
                    _this_1.getPartyBannerInformation(partyId, als);
                }
            };
            _this_1.getPartyBannerInformation = function(party, webAlias) {
                var _this = _this_1;
                var tags = window.customerTags;
                if (!tags) {
                    return;
                }
                if (!tags.includes("Shopping_on_behalf") && !tags.includes("retail")) return;
                var partyBannerWrapper = document.querySelector(".lbri-party-banner_JS");
                if (!partyBannerWrapper) return;
                var loader = partyBannerWrapper.querySelector(".lbri_party_banner_loader_JS");
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                try {
                    _this_1.ajax.send({
                        endpoint: _this.endpoint["party"]["party-validation"],
                        method: "POST",
                        contentType: "json",
                        data: {
                            partyId: party
                        },
                        callback: function(res) {
                            var _a;
                            var resp = JSON.parse(res.response);
                            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isPartyOpen) === true) {
                                var partyBannerInformationEndpoint = _this.endpoint["party"]["party-banner-information"];
                                partyBannerWrapper.style.display = "grid";
                                try {
                                    _this_1.ajax.send({
                                        endpoint: partyBannerInformationEndpoint,
                                        method: "POST",
                                        contentType: "json",
                                        data: {
                                            sponsorAlias: webAlias,
                                            partyId: party
                                        },
                                        callback: function(res) {
                                            var resp = JSON.parse(res.response);
                                            loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                            if (resp.status !== 200) {
                                                if (partyBannerWrapper) {
                                                    partyBannerWrapper.style.display = "none";
                                                }
                                                return;
                                            }
                                            var hostName = resp.data.partyHostName;
                                            _this.renderHostName(hostName);
                                        }
                                    });
                                } catch (err) {
                                    console.log("PartyCheck show banner ---\x3e Error:", err);
                                    loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                }
                            } else {
                                var partyErrorText = window.stTranslations.partyErrorText;
                                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                                partyBannerWrapper.style.display = "grid";
                                var hostNameEl = document.querySelector(".lbri-party-banner__center");
                                var partyHostEl = document.querySelector(".lbri-party-banner__left");
                                var partyshareEl = document.querySelector(".lbri-party-banner__right");
                                if (hostNameEl && partyHostEl && partyshareEl) {
                                    partyHostEl.style.display = "none";
                                    partyshareEl.style.display = "none";
                                    hostNameEl.innerText = partyErrorText;
                                }
                            }
                        }
                    });
                } catch (err) {
                    console.log("PartyCheck Validation party ---\x3e Error:", err);
                    loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                }
            };
            _this_1.renderHostName = function(hostName) {
                var hostNameEl = document.querySelectorAll(".lbri_cart_party_id--host_JS");
                if (!!hostNameEl) {
                    hostNameEl.forEach(function(host) {
                        if (hostName !== " ") {
                            var lastChar = hostName.substring(hostName.length - 1);
                            if (lastChar === "s") {
                                host.innerHTML = hostName + "'";
                            } else {
                                host.innerHTML = hostName + "'s";
                            }
                        } else {
                            host.innerHTML = hostName;
                        }
                    });
                }
            };
            _this_1.sharePartyLink = function() {
                var shareLink = document.getElementById("share-party-link");
                var copiedMessage = document.querySelector(".lbri-party-banner__copied-message");
                if (shareLink && copiedMessage) {
                    shareLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        navigator.clipboard.writeText(window.location.href).then(function() {
                            copiedMessage.classList.add("is-visible");
                            setTimeout(function() {
                                copiedMessage.classList.remove("is-visible");
                            }, 2e3);
                        }).catch(function(err) {
                            console.error("Failed to copy party link:", err);
                        });
                    });
                }
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StPartyCheck;
    }(st_module_68.StModule);
    exports.StPartyCheck = StPartyCheck;
});

define("extension/shopify-app/st-modules/header/header", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_69) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StHeader = void 0;
    var StHeader = function(_super) {
        __extends(StHeader, _super);
        function StHeader(objectFormatting) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StHeader";
            _this_1.init = function() {
                _this_1.getCreditsAmount();
            };
            _this_1.getCreditsAmount = function() {
                var _this = _this_1;
                var customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                if (!customerId) return;
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-customer-ledger"];
                try {
                    _this_1.ajax.send({
                        endpoint: getAllCustomerLedger,
                        method: "POST",
                        contentType: "json",
                        data: {
                            customerId: customerId
                        },
                        callback: function(res) {
                            var resp = JSON.parse(res.response);
                            if (resp.status === 200) {
                                var totalAmount = resp.data.reduce(function(sum, ledger) {
                                    return sum + ledger.Amount;
                                }, 0).toFixed(2);
                                _this.renderTotalAmount(totalAmount);
                            } else {
                                console.log(resp.message);
                            }
                        }
                    });
                } catch (err) {
                    console.log("getCreditsAmount---\x3e Error:", err);
                }
            };
            _this_1.renderTotalAmount = function(totalAmount) {
                var totalAmountEl = document.querySelectorAll(".lbri_header_credit_display--JS");
                if (!!totalAmountEl) {
                    totalAmountEl.forEach(function(el) {
                        var htmlElement = el;
                        htmlElement.classList.remove("st_hidden");
                        htmlElement.innerHTML += totalAmount > 0 ? totalAmount : 0;
                        htmlElement.style.display = "block";
                    });
                }
            };
            _this_1.getCustomerIdFromShopifyAnalytics = function() {
                var _a, _b, _c;
                if ((_c = (_b = (_a = window.ShopifyAnalytics) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.page) === null || _c === void 0 ? void 0 : _c.customerId) {
                    return window.ShopifyAnalytics.meta.page.customerId.toString();
                }
                return null;
            };
            _this_1.objectFormatting = objectFormatting;
            return _this_1;
        }
        return StHeader;
    }(st_module_69.StModule);
    exports.StHeader = StHeader;
});

define("extension/shopify-app/st-modules/free-sample/free-sample-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_70) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeSampleClassConfig = void 0;
    var StFreeSampleClassConfig = function(_super) {
        __extends(StFreeSampleClassConfig, _super);
        function StFreeSampleClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "FreeSampleClassConfig";
            _this.classNameHidden = "st_hidden";
            _this.classNameEnrollmentPage = "st_enrollment--page_JS";
            _this.selectorEnrollmentPage = "." + _this.classNameEnrollmentPage;
            _this.classNameUpsaleEnrollmentDropdown = "lbri_upsale-dropdown-button_JS";
            _this.selectorUpsaleEnrollmentDropdown = "." + _this.classNameUpsaleEnrollmentDropdown;
            _this.classNameUpsaleEnrollmentCollection = "lbri_upsale-enrollment-collection_JS";
            _this.selectorUpsaleEnrollmentCollection = "." + _this.classNameUpsaleEnrollmentCollection;
            _this.classNameOuterDropdownWrapper = "lbri_upsale-outer-wrapper_JS";
            _this.selectorOuterDropdownWrapper = "." + _this.classNameOuterDropdownWrapper;
            _this.classNameInnerDropdownWrapper = "lbri_upsale-inner-wrapper_JS";
            _this.selectorInnerDropdownWrapper = "." + _this.classNameInnerDropdownWrapper;
            _this.classNameConfirmButton = "lbri_choose_samples-popup-confirm-button_JS";
            _this.selectorConfirmButton = "." + _this.classNameConfirmButton;
            _this.classNameConfirmButtonDisabled = "lbri_choose_samples-popup-confirm-button-disabled";
            _this.classNameConfirmLoader = "lbri_choose_samples-popup-confirm-loader_JS";
            _this.selectorConfirmLoader = "." + _this.classNameConfirmLoader;
            _this.classNameConfirmText = "lbri_choose_samples-popup-confirm-text_JS";
            _this.selectorConfirmText = "." + _this.classNameConfirmText;
            return _this;
        }
        return StFreeSampleClassConfig;
    }(st_module_70.StModule);
    exports.StFreeSampleClassConfig = StFreeSampleClassConfig;
});

define("extension/shopify-app/st-modules/free-sample/free-sample", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_71) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeSample = void 0;
    var StFreeSample = function(_super) {
        __extends(StFreeSample, _super);
        function StFreeSample(classConfig, form, generalMethods, cartComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "FreeSample";
            _this_1.guardBypass = false;
            _this_1.reminderOverlayEl = null;
            _this_1.reminderWrapperEl = null;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var currentCart = _this_1.cartComponent.getShopifyCartData;
                    _this_1.initialization();
                    _this_1.populateInputsFromCart(currentCart);
                    _this_1.attachChangeSamplesOnCart();
                    if (window.customerShopifyId === 0) {
                        console.warn("IS GUEST REMOVE FREE SAMPLES FROM CART");
                        _this_1.removeFreeSamplesFromCart();
                    }
                    _this_1.cacheReminder();
                    _this_1.wireCheckoutGuard();
                    _this_1.cartComponent.subscribeChangeCart(function(newCart) {
                        var chooseSponsorPopupWrapper = document.querySelector(".lbri_free-sample-wrapper_JS");
                        if (!chooseSponsorPopupWrapper) return;
                        if (!chooseSponsorPopupWrapper.classList.contains("active")) {
                            _this_1.populateInputsFromCart(newCart);
                        }
                        _this_1.attachChangeSamplesOnCart();
                        if (window.customerShopifyId === 0) {
                            console.warn("IS GUEST REMOVE FREE SAMPLES FROM CART");
                            _this_1.removeFreeSamplesFromCart();
                        }
                        _this_1.wireCheckoutGuard();
                    });
                    if (sessionStorage.getItem("openCartAfterReload") === "true") {
                        sessionStorage.removeItem("openCartAfterReload");
                        _this_1.openCartDrawer();
                    }
                    setTimeout(function() {
                        _this_1.removeHiddenSetup();
                    }, 1e3);
                });
            };
            _this_1.openCartDrawer = function() {
                var cartDrawer = _this_1.cartDrawer();
                var counter = 0;
                var iterativeTimeoutOpenDrawer = function(counter) {
                    if (counter > 10) return;
                    if (!!cartDrawer && cartDrawer.toggleDrawerClasses) {
                        cartDrawer.toggleDrawerClasses();
                        return;
                    }
                    setTimeout(iterativeTimeoutOpenDrawer, 100, counter++);
                };
                if (window.location.pathname === "/cart" || window.location.pathname === "/account/login") {} else {
                    setTimeout(iterativeTimeoutOpenDrawer, 100, counter++);
                }
            };
            _this_1.initialization = function() {
                _this_1.closeChooseSamplesPopupEventHandle();
                _this_1.buttonClickButtons();
                _this_1.dropDownHandle();
                _this_1.inputEvents();
                _this_1.incrementButton();
                _this_1.decrementButton();
            };
            _this_1.removeHiddenSetup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".lbri_free-sample-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".lbri_free-sample-wrapper_JS");
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("st_hidden");
                    chooseSponsorPopupWrapper.classList.remove("st_hidden");
                }
            };
            _this_1.openChooseSponsorPopup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".lbri_free-sample-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".lbri_free-sample-wrapper_JS");
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.add("active");
                    chooseSponsorPopupWrapper.classList.add("active");
                    _this_1.openCartDrawer();
                }
            };
            _this_1.closeChooseSponsorPopup = function() {
                var chooseSponsorPopupOverlay = document.querySelector(".lbri_free-sample-popup-overlay_JS");
                var chooseSponsorPopupWrapper = document.querySelector(".lbri_free-sample-wrapper_JS");
                if (!chooseSponsorPopupWrapper) return;
                if (chooseSponsorPopupOverlay && chooseSponsorPopupWrapper) {
                    chooseSponsorPopupOverlay.classList.remove("active");
                    chooseSponsorPopupWrapper.classList.remove("active");
                    _this_1.openCartDrawer();
                }
            };
            _this_1.attachChangeSamplesOnCart = function() {
                var _this = _this_1;
                var changeSamplesButtons = document.querySelectorAll(".lbri_free_samples_change_samples_JS");
                if (changeSamplesButtons && changeSamplesButtons.length > 0) {
                    changeSamplesButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.openChooseSponsorPopup();
                        });
                    });
                }
            };
            _this_1.closeChooseSamplesPopupEventHandle = function() {
                var _this = _this_1;
                var closePopupButtons = document.querySelectorAll(".lbri_choose_samples-popup_close_JS");
                if (closePopupButtons && closePopupButtons.length > 0) {
                    closePopupButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeChooseSponsorPopup();
                        });
                    });
                }
                var innerPopupOverlay = document.querySelector(".lbri_free-sample-popup-overlay_JS");
                if (innerPopupOverlay) {
                    innerPopupOverlay.addEventListener("click", function() {
                        _this.closeChooseSponsorPopup();
                    });
                }
                var cancelButtons = document.querySelectorAll(".lbri_choose_samples-popup_cancel-button_JS");
                if (cancelButtons && cancelButtons.length > 0) {
                    cancelButtons.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.closeChooseSponsorPopup();
                        });
                    });
                }
            };
            _this_1.dropDownHandle = function() {
                var _this = _this_1;
                var buttons = document.querySelectorAll(".lbri_upsale-dropdown-button_JS");
                buttons.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.upsaleEnrollmentDropDownManipulation(button);
                    });
                });
            };
            _this_1.upsaleEnrollmentDropDownManipulation = function(button) {
                var closestCollection = _this_1.generalMethods.getClosestByClass(button, _this_1.classConfig.classNameUpsaleEnrollmentCollection);
                var currentOuterWrapper = closestCollection.querySelector(_this_1.classConfig.selectorOuterDropdownWrapper);
                var isOpen = button.getAttribute("aria-expanded");
                if (isOpen === "false") {
                    _this_1.toggleClass(currentOuterWrapper);
                    button.setAttribute("aria-expanded", "true");
                } else {
                    _this_1.toggleClass(currentOuterWrapper);
                    button.setAttribute("aria-expanded", "false");
                }
            };
            _this_1.toggleClass = function(el) {
                if (el.classList.contains("active")) {
                    el.classList.add("inactive");
                    el.classList.remove("active");
                } else {
                    el.classList.remove("inactive");
                    el.classList.add("active");
                }
            };
            _this_1.populateInputsFromCart = function(currentCart) {
                var cartItems = currentCart.items;
                var freeSamplesFromCar = [];
                cartItems.forEach(function(cartItem) {
                    if (cartItem.properties._isFreeSample) {
                        freeSamplesFromCar["".concat(cartItem.variant_id)] = cartItem.quantity;
                    }
                });
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!!chooseSamplesSectionWrapper) {
                    var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                    if (!!allInputWrappers) {
                        allInputWrappers.forEach(function(inputWrappers, index) {
                            var input = inputWrappers.querySelector('input[name="quantity"]');
                            if (!input) return;
                            var variantId = inputWrappers.getAttribute("current-variant-id");
                            var quantity = freeSamplesFromCar[variantId];
                            input.value = quantity !== null && quantity !== void 0 ? quantity : 0;
                            _this_1.quantitySetup(input);
                        });
                    }
                }
            };
            _this_1.quantitySetup = function(button) {
                var closestWrapper = button.closest(".lbri_quantity_JS");
                var inputField = closestWrapper.querySelector(".lbri_quantity-input_JS");
                var inputFieldValue = parseInt(inputField.value);
                _this_1.incrementOrDecrement(button, inputField, inputFieldValue);
                _this_1.handleQuantityCases(button, inputField);
            };
            _this_1.incrementOrDecrement = function(button, inputField, inputFieldValue) {
                if (button.classList.contains("lbri_increment_JS")) {
                    var newValue = parseInt(inputFieldValue) + 1;
                    inputField.setAttribute("value", "" + newValue);
                    inputField.value = "" + newValue;
                }
                if (button.classList.contains("lbri_decrement_JS")) {
                    var newValue = parseInt(inputFieldValue) - 1;
                    inputField.setAttribute("value", "" + newValue);
                    inputField.value = "" + newValue;
                }
            };
            _this_1.handleQuantityCases = function(button, inputField) {
                var mainWrapper = button.closest(".lbri_upsale-enrollment-dropdown-content_JS");
                var decrementButton = mainWrapper.querySelector(".lbri_decrement_JS");
                var parsedValue = parseInt(inputField.value);
                if (parsedValue < 0) {
                    inputField.value = "0";
                }
                if (parsedValue === 0) {
                    inputField.setAttribute("value", "0");
                    inputField.value = String(parsedValue);
                    decrementButton.disabled = true;
                    inputField.disabled = false;
                }
                if (parsedValue > 0) {
                    inputField.value = "" + parsedValue;
                    button.disabled = false;
                    inputField.setAttribute("value", "" + parsedValue);
                    decrementButton.disabled = false;
                } else {
                    decrementButton.disabled = true;
                    inputField.setAttribute("value", "" + parsedValue);
                }
                if (inputField.value === "" || isNaN(parseInt(inputField.value))) {
                    inputField.value = "0";
                    inputField.setAttribute("value", "0");
                    inputField.disabled = false;
                }
                var freeSamplesLimit = window.freeShippingLimit.free_samples_limit;
                var sumSampleQuantities = 0;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!chooseSamplesSectionWrapper) {
                    return;
                }
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                if (!allInputWrappers) {
                    return;
                }
                allInputWrappers.forEach(function(inputWrappers, index) {
                    var input = inputWrappers.querySelector('input[name="quantity"]');
                    sumSampleQuantities = sumSampleQuantities + parseInt(input.value);
                });
                var allRemainingCounters = document.querySelectorAll(".lbri_choose_samples-remaining-counter_JS");
                allRemainingCounters.forEach(function(remainingCounters, index) {
                    remainingCounters.innerHTML = " " + (freeSamplesLimit - sumSampleQuantities).toString();
                });
                if (sumSampleQuantities < freeSamplesLimit) {
                    allInputWrappers === null || allInputWrappers === void 0 ? void 0 : allInputWrappers.forEach(function(inputWrappers) {
                        var incrementButton = inputWrappers.querySelector(".lbri_increment_JS");
                        incrementButton.disabled = false;
                    });
                } else {
                    allInputWrappers === null || allInputWrappers === void 0 ? void 0 : allInputWrappers.forEach(function(inputWrappers) {
                        var incrementButton = inputWrappers.querySelector(".lbri_increment_JS");
                        incrementButton.disabled = true;
                    });
                }
                var closestWrapper = _this_1.generalMethods.getClosestByClass(inputField, "lbri_upsale-enrollment-dropdown-content_JS");
                var continueSellingOutOfStock = closestWrapper === null || closestWrapper === void 0 ? void 0 : closestWrapper.getAttribute("out-of-stock");
                if (!!continueSellingOutOfStock) {
                    var maxAvailableQuantity = closestWrapper.getAttribute("product-available-quantity");
                    if (parsedValue > Number(maxAvailableQuantity) && continueSellingOutOfStock === "deny") {
                        inputField.value = maxAvailableQuantity;
                        inputField.setAttribute("value", maxAvailableQuantity);
                    }
                }
            };
            _this_1.inputEvents = function() {
                var _this = _this_1;
                var quantityInputs = document.querySelectorAll(".lbri_quantity-input_JS");
                quantityInputs.forEach(function(quantityInput) {
                    _this.quantitySetup(quantityInput);
                    quantityInput.addEventListener("input", function() {
                        _this.quantitySetup(this);
                        _this.quantityPickerRegexValidation(this);
                    });
                });
            };
            _this_1.quantityPickerRegexValidation = function(inputField) {
                var validStringMatchArray = inputField.value.match(new RegExp(/(^[0-9]*$)/));
                inputField.value = validStringMatchArray && validStringMatchArray.length > 0 ? validStringMatchArray[0] : "";
                inputField.setAttribute("value", String(parseInt(inputField.value)));
                var inputValue = parseInt(inputField.value);
                return inputValue;
            };
            _this_1.incrementButton = function() {
                var _this = _this_1;
                var incrementButtons = document.querySelectorAll(".lbri_increment_JS");
                incrementButtons.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.quantitySetup(this);
                    });
                });
            };
            _this_1.decrementButton = function() {
                var _this = _this_1;
                var decrementButtons = document.querySelectorAll(".lbri_decrement_JS");
                decrementButtons.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.quantitySetup(this);
                    });
                });
            };
            _this_1.updateCartWithFreeSamples = function() {
                var freeSampleList = [];
                var freeSampleTotalQuantity = 0;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                allInputWrappers.forEach(function(inputWrapper) {
                    var input = inputWrapper.querySelector('input[name="quantity"]');
                    if (parseInt(input.value) > 0) {
                        freeSampleTotalQuantity += parseInt(input.value);
                        freeSampleList.push({
                            variantId: inputWrapper.getAttribute("current-variant-id"),
                            sku: inputWrapper.getAttribute("current-variant-sku"),
                            quantity: parseInt(input.value)
                        });
                    }
                });
                var confirmButton = document.querySelector(_this_1.classConfig.selectorConfirmButton);
                var freeSamplesLimit = window.freeShippingLimit.free_samples_limit;
                var isInvalidAmountOfFreeSamples = freeSampleTotalQuantity > freeSamplesLimit;
                if (isInvalidAmountOfFreeSamples) {
                    var allRemainingCounters = document.querySelectorAll(".lbri_choose_samples-remaining-counter_JS");
                    allRemainingCounters.forEach(function(remainingCounters, index) {
                        remainingCounters.classList.add("lbri_choose_samples-remaining-counter-error");
                        setTimeout(function() {
                            remainingCounters.classList.remove("lbri_choose_samples-remaining-counter-error");
                            confirmButton.classList.remove(_this_1.classConfig.classNameConfirmButtonDisabled);
                            _this_1.toggleSearchingBtnLoader(false);
                        }, 3e3);
                    });
                    var chooseSamplesTexts = document.querySelectorAll(".lbri_choose_samples-popup-text_JS");
                    chooseSamplesTexts.forEach(function(chooseSamplesText, index) {
                        chooseSamplesText.classList.add("lbri_choose_samples-popup-text-error");
                        setTimeout(function() {
                            chooseSamplesText.classList.remove("lbri_choose_samples-popup-text-error");
                            confirmButton.classList.remove(_this_1.classConfig.classNameConfirmButtonDisabled);
                            _this_1.toggleSearchingBtnLoader(false);
                        }, 3e3);
                    });
                } else {
                    _this_1.cartComponent.overrideFreeSamples(freeSampleList);
                }
            };
            _this_1.buttonClickButtons = function() {
                var buttonChooseSamples = document.querySelectorAll(_this_1.classConfig.selectorConfirmButton);
                buttonChooseSamples.forEach(function(button) {
                    button.addEventListener("click", function(e) {
                        e.preventDefault();
                        console.log("CLICKED buttonClickButtons");
                        console.log("button.classList.contains(this.classConfig.classNameConfirmButtonDisabled)", button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled));
                        if (!button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled)) {
                            button.classList.add(_this_1.classConfig.classNameConfirmButtonDisabled);
                            console.log("button.classList.contains(this.classConfig.classNameConfirmButtonDisabled)", button.classList.contains(_this_1.classConfig.classNameConfirmButtonDisabled));
                            console.log("CLICKED buttonClickButtons does not contain disabled");
                            _this_1.toggleSearchingBtnLoader(true);
                            _this_1.updateCartWithFreeSamples();
                        }
                    });
                });
            };
            _this_1.removeFreeSamplesFromCart = function() {
                _this_1.cartComponent.removeFreeSamplesFromCart(true, function() {});
            };
            _this_1.toggleSearchingBtnLoader = function(isLoading) {
                var btnLoader = document.querySelector(_this_1.classConfig.selectorConfirmLoader);
                if (!btnLoader) return;
                var btnLabel = document.querySelector(_this_1.classConfig.selectorConfirmText);
                if (!btnLabel) return;
                var chooseSamplesSectionWrapper = document.querySelector(".lbri_choose_samples-section-wrapper");
                if (!chooseSamplesSectionWrapper) {
                    return;
                }
                var allInputWrappers = chooseSamplesSectionWrapper.querySelectorAll('div[name="inputs-wrapper"]');
                if (!allInputWrappers) {
                    return;
                }
                if (isLoading) {
                    btnLoader.classList.remove(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.add(_this_1.classConfig.classNameHidden);
                    allInputWrappers === null || allInputWrappers === void 0 ? void 0 : allInputWrappers.forEach(function(inputWrappers) {
                        var incrementButton = inputWrappers.querySelector(".lbri_increment_JS");
                        incrementButton.disabled = true;
                        var decrementButton = inputWrappers.querySelector(".lbri_decrement_JS");
                        decrementButton.disabled = true;
                    });
                } else {
                    btnLoader.classList.add(_this_1.classConfig.classNameHidden);
                    btnLabel.classList.remove(_this_1.classConfig.classNameHidden);
                }
            };
            _this_1.wireCheckoutGuard = function() {
                var buttons = Array.from(document.querySelectorAll(".wt-cart__cta_JS"));
                buttons.forEach(function(btn) {
                    btn.removeEventListener("click", _this_1.checkoutHandler);
                    btn.addEventListener("click", _this_1.checkoutHandler, {
                        passive: false
                    });
                });
                _this_1.cacheReminder();
            };
            _this_1.checkoutHandler = function(e) {
                if (_this_1.guardBypass) return;
                if (_this_1.shouldShowReminder()) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    _this_1.showReminder();
                }
            };
            _this_1.handleReminderKeydown = function(e) {
                var _a;
                if (e.key === "Enter") {
                    e.preventDefault();
                    (_a = _this_1.noBtnEl) === null || _a === void 0 ? void 0 : _a.click();
                } else if (e.key === "Escape") {
                    e.preventDefault();
                    _this_1.hideReminder();
                }
            };
            _this_1.classConfig = classConfig;
            _this_1.form = form;
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            _this_1.cartDrawer = function() {
                return document.body.querySelector("cart-drawer");
            };
            return _this_1;
        }
        StFreeSample.prototype.shouldShowReminder = function() {
            return this.qualifiesForFreeSamples() && this.countSamplesInCart() === 0;
        };
        StFreeSample.prototype.qualifiesForFreeSamples = function() {
            var _a;
            var windowLimit = (_a = window === null || window === void 0 ? void 0 : window.freeShippingLimit) === null || _a === void 0 ? void 0 : _a.free_shipping_limit;
            var threshold = typeof windowLimit === "number" ? windowLimit : undefined;
            if (threshold === undefined) {
                var progressEl = document.querySelector(".progress-done");
                threshold = Number((progressEl === null || progressEl === void 0 ? void 0 : progressEl.getAttribute("data-limit")) || 0);
            }
            var cart = this.cartComponent.getShopifyCartData;
            var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
            var total = 0;
            items.forEach(function(it) {
                var _a;
                if (!((_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample)) {
                    total += (it.quantity || 0) * ((it.price || 0) / 100);
                }
            });
            return threshold > 0 && total >= threshold;
        };
        StFreeSample.prototype.countSamplesInCart = function() {
            var cart = this.cartComponent.getShopifyCartData;
            var items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
            return items.reduce(function(acc, it) {
                var _a;
                return acc + (((_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample) ? it.quantity || 0 : 0);
            }, 0);
        };
        StFreeSample.prototype.cacheReminder = function() {
            var _this_1 = this;
            var _a;
            this.reminderOverlayEl = document.querySelector('.lbri_free-sample-popup-overlay_JS[data-modal="samples-reminder"]');
            this.reminderWrapperEl = document.querySelector('.lbri_free-sample-wrapper_JS[data-modal="samples-reminder"]');
            if (!this.reminderOverlayEl || !this.reminderWrapperEl) return;
            this.reminderOverlayEl.addEventListener("click", function() {
                return _this_1.hideReminder();
            });
            this.reminderWrapperEl.querySelectorAll('[data-close="true"]').forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this_1.hideReminder();
                });
            });
            this.noBtnEl = this.reminderWrapperEl.querySelector(".lbri_reminder-no_JS, .lbri_cancel-button") || undefined;
            this.yesBtnEl = this.reminderWrapperEl.querySelector('[data-role="samples-reminder-yes"]') || undefined;
            (_a = this.noBtnEl) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                _this_1.hideReminder();
                _this_1.openChooseSponsorPopup();
            });
            if (this.yesBtnEl) {
                this.yesBtnEl.disabled = false;
                this.yesBtnEl.removeAttribute("disabled");
                this.yesBtnEl.removeAttribute("tabindex");
                this.yesBtnEl.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this_1.guardBypass = true;
                    _this_1.hideReminder();
                    var explicitCta = document.querySelector('#CartDrawer-Form [name="checkout"], .cart__footer [name="checkout"]');
                    if (explicitCta) {
                        explicitCta.removeAttribute("disabled");
                        explicitCta.dispatchEvent(new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true
                        }));
                        setTimeout(function() {
                            return _this_1.guardBypass = false;
                        }, 1500);
                        return;
                    }
                    var form = document.getElementById("CartDrawer-Form");
                    if (form) {
                        var hidden = document.createElement("input");
                        hidden.type = "hidden";
                        hidden.name = "checkout";
                        hidden.value = "Checkout";
                        form.appendChild(hidden);
                        try {
                            form.requestSubmit ? form.requestSubmit() : form.submit();
                        } catch (_a) {
                            form.submit();
                        }
                        setTimeout(function() {
                            return _this_1.guardBypass = false;
                        }, 1500);
                        return;
                    }
                    window.location.assign("/checkout");
                    setTimeout(function() {
                        return _this_1.guardBypass = false;
                    }, 1500);
                });
            }
        };
        StFreeSample.prototype.showReminder = function() {
            var _this_1 = this;
            var _a, _b, _c, _d, _e;
            if (!this.reminderOverlayEl || !this.reminderWrapperEl) this.cacheReminder();
            (_a = this.reminderOverlayEl) === null || _a === void 0 ? void 0 : _a.classList.remove("st_hidden");
            (_b = this.reminderWrapperEl) === null || _b === void 0 ? void 0 : _b.classList.remove("st_hidden");
            (_c = this.reminderOverlayEl) === null || _c === void 0 ? void 0 : _c.classList.add("active");
            (_d = this.reminderWrapperEl) === null || _d === void 0 ? void 0 : _d.classList.add("active");
            document.body.classList.add("lbri-modal-open");
            this.yesBtnEl && (this.yesBtnEl.disabled = false);
            (_e = this.reminderWrapperEl) === null || _e === void 0 ? void 0 : _e.addEventListener("keydown", this.handleReminderKeydown, {
                once: true
            });
            setTimeout(function() {
                var _a;
                return (_a = _this_1.noBtnEl) === null || _a === void 0 ? void 0 : _a.focus();
            }, 0);
        };
        StFreeSample.prototype.hideReminder = function() {
            var _a, _b, _c, _d, _e;
            (_a = this.reminderOverlayEl) === null || _a === void 0 ? void 0 : _a.classList.add("st_hidden");
            (_b = this.reminderWrapperEl) === null || _b === void 0 ? void 0 : _b.classList.add("st_hidden");
            (_c = this.reminderOverlayEl) === null || _c === void 0 ? void 0 : _c.classList.remove("active");
            (_d = this.reminderWrapperEl) === null || _d === void 0 ? void 0 : _d.classList.remove("active");
            document.body.classList.remove("lbri-modal-open");
            (_e = this.reminderWrapperEl) === null || _e === void 0 ? void 0 : _e.removeEventListener("keydown", this.handleReminderKeydown);
        };
        return StFreeSample;
    }(st_module_71.StModule);
    exports.StFreeSample = StFreeSample;
});

define("extension/shopify-app/st-modules/samples-set/samples-set-class-config", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_72) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSampleSetClassConfig = void 0;
    var StSampleSetClassConfig = function(_super) {
        __extends(StSampleSetClassConfig, _super);
        function StSampleSetClassConfig() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SampleSetClassConfig";
            _this.classNameSampleButton = "sample-button";
            _this.selectorSampleButton = "." + _this.classNameSampleButton;
            _this.modalBackdropId = "sample-modal";
            _this.modalContinueId = "sample-modal-continue";
            _this.classNameNotAllowed = "not-allowed";
            _this.classNameAlreadyPurchased = "already-purchased";
            _this.classNameSelected = "selected";
            return _this;
        }
        return StSampleSetClassConfig;
    }(st_module_72.StModule);
    exports.StSampleSetClassConfig = StSampleSetClassConfig;
});

define("extension/shopify-app/st-modules/samples-set/samples-set", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_73) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StSampleSet = void 0;
    var StSampleSet = function(_super) {
        __extends(StSampleSet, _super);
        function StSampleSet(config, cartComponent) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "SampleSet";
            _this.selectedVariantId = null;
            _this.selectedButton = null;
            _this.sampleVariants = [];
            _this.customerTags = [];
            _this.customerType = "unknown";
            _this.isLoggedIn = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.sampleVariants = window.SAMPLE_VARIANTS || [];
                    _this.customerTags = window.CUSTOMER_TAGS || [];
                    _this.customerType = window.CUSTOMER_TYPE || "unknown";
                    _this.isLoggedIn = !!window.IS_LOGGED_IN;
                    _this.fetchCartAndSetupButtons();
                    _this.bindModalConfirm();
                });
            };
            _this.config = config;
            _this.cartComponent = cartComponent;
            return _this;
        }
        StSampleSet.prototype.fetchCartAndSetupButtons = function() {
            var cart = this.cartComponent.getShopifyCartData;
            this.setupButtons(cart);
        };
        StSampleSet.prototype.setupButtons = function(cart) {
            var _this = this;
            var sampleInCart = cart.items.find(function(item) {
                return _this.sampleVariants.includes(item.variant_id);
            });
            var buttons = document.querySelectorAll(this.config.selectorSampleButton);
            var userInfo = window.customerInfoMetafields;
            if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.customerType) {
                this.customerType = userInfo.customerType;
            }
            buttons.forEach(function(btn) {
                var variantId = parseInt(btn.dataset.variantId || "0");
                var sku = btn.dataset.sku || "";
                var isSampleInSession = sessionStorage.getItem("sampleInCart") === "true";
                if (isSampleInSession && !_this.sampleVariants.includes(variantId)) {
                    btn.disabled = true;
                    btn.innerText = "NOT ALLOWED";
                    btn.classList.add(_this.config.classNameNotAllowed);
                    return;
                }
                if (!_this.isLoggedIn || _this.customerType !== "retail") {
                    btn.innerText = "ADD SAMPLE";
                    btn.disabled = true;
                    btn.classList.add(_this.config.classNameNotAllowed);
                    return;
                }
                var alreadyPurchased = sku && _this.customerTags.some(function(tag) {
                    return tag.startsWith("LSSF-") && tag.includes(sku);
                });
                if (alreadyPurchased) {
                    btn.innerText = "ALREADY PURCHASED";
                    btn.disabled = true;
                    btn.classList.add(_this.config.classNameAlreadyPurchased);
                    return;
                }
                var newBtn = btn.cloneNode(true);
                btn.replaceWith(newBtn);
                if (sampleInCart && variantId === sampleInCart.variant_id) {
                    _this.transformButtonToRemove(newBtn);
                    newBtn.addEventListener("click", _this.wrapAsyncButton(newBtn, function() {
                        return _this.removeSample(variantId);
                    }));
                } else if (sampleInCart) {
                    newBtn.disabled = true;
                } else {
                    newBtn.innerText = "ADD SAMPLE";
                    newBtn.addEventListener("click", function() {
                        return _this.openModal(variantId, newBtn);
                    });
                }
            });
        };
        StSampleSet.prototype.openModal = function(variantId, button) {
            if (button.classList.contains(this.config.classNameSelected)) return;
            this.selectedVariantId = variantId;
            this.selectedButton = button;
            var modal = document.getElementById(this.config.modalBackdropId);
            if (modal) modal.style.display = "flex";
        };
        StSampleSet.prototype.closeModal = function() {
            var modal = document.getElementById(this.config.modalBackdropId);
            if (modal) modal.style.display = "none";
            this.selectedVariantId = null;
            this.selectedButton = null;
        };
        StSampleSet.prototype.bindModalConfirm = function() {
            var _this = this;
            var _a;
            (_a = document.getElementById(this.config.modalContinueId)) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function() {
                return _this.confirmSample();
            });
        };
        StSampleSet.prototype.confirmSample = function() {
            var _this = this;
            if (!this.selectedVariantId || !this.selectedButton) return;
            this.toggleLoader(true);
            fetch("/cart/clear.js", {
                method: "POST"
            }).then(function() {
                sessionStorage.setItem("sampleInCart", "true");
                return fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        items: [ {
                            id: _this.selectedVariantId,
                            quantity: 1,
                            properties: {
                                _is_sample: "true"
                            }
                        } ]
                    })
                });
            }).then(function() {
                return fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            sampleSetAllowed: "true"
                        }
                    })
                });
            }).then(function() {
                if (_this.selectedButton instanceof HTMLButtonElement) {
                    _this.transformButtonToRemove(_this.selectedButton);
                }
                _this.toggleLoader(false);
                window.location.reload();
            });
        };
        StSampleSet.prototype.removeSample = function(variantId) {
            return __awaiter(this, void 0, void 0, function() {
                var cart, item;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        cart = this.cartComponent.getShopifyCartData;
                        item = cart.items.find(function(i) {
                            return i.variant_id === variantId;
                        });
                        if (!item) throw new Error("Item not found in cart");
                        return [ 4, fetch("/cart/change.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: 0
                            })
                        }) ];

                      case 1:
                        _a.sent();
                        return [ 4, fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                attributes: {
                                    sampleSetAllowed: ""
                                }
                            })
                        }) ];

                      case 2:
                        _a.sent();
                        sessionStorage.removeItem("sampleInCart");
                        window.location.reload();
                        return [ 2 ];
                    }
                });
            });
        };
        StSampleSet.prototype.transformButtonToRemove = function(button) {
            if (!button) return;
            button.innerHTML = '\n      <span class="selected-label">✓ SELECTED</span>\n      <span class="remove-label">✕ REMOVE</span>\n    ';
            button.classList.add("selected");
            button.setAttribute("data-role", "remove-sample");
        };
        StSampleSet.prototype.transformButtonToAdd = function(button) {
            if (!button) return;
            button.innerText = "ADD SAMPLE";
            button.classList.remove("selected");
            button.removeAttribute("data-role");
        };
        StSampleSet.prototype.toggleLoader = function(show) {
            var btn = document.getElementById(this.config.modalContinueId);
            var loader = document.querySelector(".continue_btn_loader_JS");
            if (!btn || !loader) return;
            if (show) {
                btn.disabled = true;
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
            } else {
                btn.disabled = false;
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
            }
        };
        StSampleSet.prototype.setBtnLoading = function(btn, on) {
            if (!btn) return;
            if (on) {
                btn.disabled = true;
                btn.setAttribute("aria-busy", "true");
                btn.classList.add("is-loading");
            } else {
                btn.disabled = false;
                btn.removeAttribute("aria-busy");
                btn.classList.remove("is-loading");
            }
        };
        StSampleSet.prototype.wrapAsyncButton = function(btn, fn) {
            var _this = this;
            return function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var err_1;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!btn || btn.disabled) return [ 2 ];
                            this.setBtnLoading(btn, true);
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 3, , 4 ]);
                            return [ 4, fn() ];

                          case 2:
                            _a.sent();
                            return [ 3, 4 ];

                          case 3:
                            err_1 = _a.sent();
                            console.error(err_1);
                            this.setBtnLoading(btn, false);
                            alert("Error removing Item");
                            return [ 3, 4 ];

                          case 4:
                            return [ 2 ];
                        }
                    });
                });
            };
        };
        return StSampleSet;
    }(st_module_73.StModule);
    exports.StSampleSet = StSampleSet;
});

define("extension/shopify-app/st-modules/free-shipping/free-shipping", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_74) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StFreeShipping = void 0;
    var StFreeShipping = function(_super) {
        __extends(StFreeShipping, _super);
        function StFreeShipping(generalMethods, cart, freeSamples) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StFreeShipping";
            _this_1.cartChangeTimer = null;
            _this_1.lastCartChangeAt = 0;
            _this_1.cleanupTimer = null;
            _this_1.isCleanupRunning = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.progressBar();
                    _this_1.openChooseSamplesPopupEventHandle();
                    _this_1.cart.subscribeChangeCart(function() {
                        _this_1.lastCartChangeAt = Date.now();
                        if (_this_1.cartChangeTimer) window.clearTimeout(_this_1.cartChangeTimer);
                        _this_1.cartChangeTimer = window.setTimeout(function() {
                            _this_1.progressBar();
                            _this_1.openChooseSamplesPopupEventHandle();
                        }, 200);
                    });
                });
            };
            _this_1.progressBar = function() {
                var _this = _this_1;
                var totalPrice = _this.getCartItems();
                var progress_percentage = _this_1.calculateProgress(totalPrice);
                _this_1.progressBarPercentage(progress_percentage);
            };
            _this_1.progressBarPercentage = function(progress_percentage) {
                var progress = document.querySelector(".progress-done");
                if (!progress) return;
                var width = Math.min(progress_percentage, 100);
                progress.setAttribute("data-done", width.toString());
                progress.style.width = width + "%";
                progress.style.opacity = "1";
                _this_1.displayPercentage(progress_percentage);
                _this_1.displayChooseSamplerButton(progress_percentage);
                _this_1.displayProgressBar(progress_percentage);
            };
            _this_1.displayChooseSamplerButton = function(progress_percentage) {
                var btnWrp = document.querySelector(".lbr_free-shipping-sample_JS");
                if (!btnWrp) return;
                var progressBarWrp = document.querySelector(".lbr_free-shipping-progress-bar_JS");
                if (!progressBarWrp) return;
                if (progress_percentage >= 100) {
                    btnWrp.classList.remove("st_hidden");
                    progressBarWrp.classList.add("st_hidden");
                    return;
                }
                btnWrp.classList.add("st_hidden");
                progressBarWrp.classList.remove("st_hidden");
                if (_this_1.cleanupTimer) window.clearTimeout(_this_1.cleanupTimer);
                _this_1.cleanupTimer = window.setTimeout(function() {
                    var _a, _b;
                    if (Date.now() - _this_1.lastCartChangeAt < 450) return;
                    var items = ((_b = (_a = _this_1.cart) === null || _a === void 0 ? void 0 : _a.getShopifyCartData) === null || _b === void 0 ? void 0 : _b.items) || [];
                    var hasFreeSample = items.some(function(it) {
                        var _a;
                        return (_a = it === null || it === void 0 ? void 0 : it.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
                    });
                    if (!hasFreeSample || _this_1.isCleanupRunning) return;
                    _this_1.isCleanupRunning = true;
                    try {
                        _this_1.freeSamples.removeFreeSamplesFromCart();
                    } finally {
                        setTimeout(function() {
                            _this_1.isCleanupRunning = false;
                        }, 800);
                    }
                }, 500);
            };
            _this_1.displayProgressBar = function(progress_percentage) {
                var progressBarWrp = document.querySelector(".lbr_free-shipping-progress-bar_JS");
                if (!progressBarWrp) return;
                if (progress_percentage >= 100) {
                    progressBarWrp.classList.add("st_hidden");
                } else {
                    progressBarWrp.classList.remove("st_hidden");
                }
            };
            _this_1.displayPercentage = function(percentage) {
                var _this = _this_1;
                var percentageSpan = document.querySelector(".lbr_free-shipping-num_JS");
                if (!percentageSpan) return;
                percentageSpan.innerHTML = percentage;
                if (percentage <= 100) {
                    var progress = document.querySelector(".progress-done");
                    if (!progress) return;
                    var limitFromMetafield = progress.getAttribute("data-limit");
                    var totalPrice = _this.getCartItems();
                    var num = (Number(limitFromMetafield) - Number(totalPrice)).toFixed(2);
                    percentageSpan.innerHTML = "".concat(num);
                }
                if (percentage >= 100) {
                    percentageSpan.innerHTML = "0";
                }
            };
            _this_1.getCartItems = function() {
                var items = _this_1.cart.getShopifyCartData.items;
                var totalPrice = 0;
                items.forEach(function(item) {
                    if (_this_1.excludedCheck(item.id) == false) {
                        if (!item.properties._isFreeSample) {
                            totalPrice += item.quantity * (item.price / 100);
                        }
                    }
                });
                totalPrice = Number(totalPrice.toFixed(2));
                return totalPrice;
            };
            _this_1.excludedCheck = function(id) {
                var progress = document.querySelector(".progress-done");
                if (!progress) return;
                var excludedMetafield = progress.getAttribute("data-excluded").replace(/ /g, ",");
                var arrOfExcludedIds = excludedMetafield.split(",").map(function(item) {
                    return item.trim();
                });
                var theSame = false;
                for (var i = 0; i < arrOfExcludedIds.length; i++) {
                    if (id.toString() == arrOfExcludedIds[i]) {
                        theSame = true;
                    }
                }
                return theSame;
            };
            _this_1.calculateProgress = function(totalPrice) {
                var progress = document.querySelector(".progress-done");
                if (!progress) return;
                var limitFromMetafield = progress.getAttribute("data-limit");
                return Number(totalPrice) * 100 / Number(limitFromMetafield);
            };
            _this_1.openChooseSamplesPopupEventHandle = function() {
                var _this = _this_1;
                var buttonChooseSamples = document.querySelectorAll(".lbr_free-shipping-samples-btn_JS");
                if (buttonChooseSamples && buttonChooseSamples.length > 0) {
                    buttonChooseSamples.forEach(function(button) {
                        button.addEventListener("click", function() {
                            _this.freeSamples.openChooseSponsorPopup();
                        });
                    });
                }
            };
            _this_1.generalMethods = generalMethods;
            _this_1.cart = cart;
            _this_1.freeSamples = freeSamples;
            return _this_1;
        }
        return StFreeShipping;
    }(st_module_74.StModule);
    exports.StFreeShipping = StFreeShipping;
});

define("extension/shopify-app/st-modules/samples-set/cart-guard", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_75) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartGuard = void 0;
    var StCartGuard = function(_super) {
        __extends(StCartGuard, _super);
        function StCartGuard(cartComponent) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "CartGuard";
            _this_1._logoutInProgress = false;
            _this_1.init = function() {
                var logoutBtn = document.querySelector("button.st_logout");
                if (logoutBtn) {
                    logoutBtn.disabled = true;
                    logoutBtn.classList.add("st_hidden");
                }
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.resetClearCartFlagIfLoggedIn();
                    _this_1.injectModalHtml();
                    _this_1.interceptFetch();
                    _this_1.interceptXMLHttpRequest();
                    _this_1.interceptAddToCartButtons();
                    _this_1.attachModalEvents();
                    _this_1.watchCartDrawerSamples();
                    _this_1.setupSampleRemoveInterceptor();
                    _this_1.setupSampleQuantityDecreaseInterceptor();
                    _this_1.autoRemoveSamplesOnLogoutClick();
                    if (logoutBtn) {
                        setTimeout(function() {
                            logoutBtn.disabled = false;
                            logoutBtn.classList.remove("st_hidden");
                        }, 1500);
                    }
                });
            };
            _this_1.watchCartDrawerSamples = function() {
                var observer = new MutationObserver(function() {
                    _this_1.disableSampleControlsImmediately();
                    _this_1.disableSampleQuantityControls();
                });
                var cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer) {
                    observer.observe(cartDrawer, {
                        childList: true,
                        subtree: true
                    });
                    _this_1.disableSampleControlsImmediately();
                    _this_1.disableSampleQuantityControls();
                } else {
                    console.warn("[SampleGuard] cart-drawer not found.");
                }
            };
            _this_1.disableSampleQuantityControls = function() {
                var cart = _this_1.cartComponent.getShopifyCartData;
                cart.items.forEach(function(item) {
                    var _a, _b;
                    if (((_a = item.properties) === null || _a === void 0 ? void 0 : _a._is_sample) === "true") {
                        var input_1 = document.querySelector('input[data-quantity-variant-id="'.concat(item.variant_id, '"]'));
                        if (input_1) {
                            input_1.setAttribute("readonly", "true");
                            input_1.classList.add("readonly-sample");
                            var plusBtn = (_b = input_1.closest(".counter")) === null || _b === void 0 ? void 0 : _b.querySelector("button.js-counter-increase");
                            if (plusBtn) {
                                plusBtn.disabled = true;
                                plusBtn.classList.add("disabled-sample");
                            }
                            var currentQty = parseInt(input_1.value);
                            if (currentQty > 1) {
                                fetch("/cart/change.js", {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({
                                        id: item.key,
                                        quantity: 1
                                    })
                                }).then(function() {
                                    input_1.value = "1";
                                });
                            }
                        }
                    }
                });
            };
            _this_1.setupSampleRemoveInterceptor = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, removeBtn, itemEl, input, variantId, sampleIds;
                        return __generator(this, function(_a) {
                            target = e.target;
                            removeBtn = target.closest(".wt-cart__item__remove");
                            if (!removeBtn) return [ 2 ];
                            itemEl = removeBtn.closest("li.cart-item");
                            input = itemEl === null || itemEl === void 0 ? void 0 : itemEl.querySelector("input[data-quantity-variant-id]");
                            variantId = input === null || input === void 0 ? void 0 : input.dataset.quantityVariantId;
                            if (!variantId) return [ 2 ];
                            sampleIds = window.SAMPLE_VARIANTS || [];
                            if (sampleIds.includes(parseInt(variantId))) {
                                sessionStorage.removeItem("sampleInCart");
                                if (window.location.pathname.includes("/pages/samples")) {
                                    setTimeout(function() {
                                        return window.location.reload();
                                    }, 300);
                                }
                            }
                            return [ 2 ];
                        });
                    });
                });
            };
            _this_1.setupSampleQuantityDecreaseInterceptor = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, minusBtn, counter, input, variantId, sampleIds;
                        var _this_1 = this;
                        return __generator(this, function(_a) {
                            target = e.target;
                            minusBtn = target.closest(".js-counter-decrease");
                            if (!minusBtn) return [ 2 ];
                            counter = minusBtn.closest(".counter");
                            input = counter === null || counter === void 0 ? void 0 : counter.querySelector("input[data-quantity-variant-id]");
                            variantId = input === null || input === void 0 ? void 0 : input.dataset.quantityVariantId;
                            if (!variantId) return [ 2 ];
                            sampleIds = window.SAMPLE_VARIANTS || [];
                            if (sampleIds.includes(parseInt(variantId))) {
                                setTimeout(function() {
                                    return __awaiter(_this_1, void 0, void 0, function() {
                                        var cart, stillInCart;
                                        return __generator(this, function(_a) {
                                            cart = this.cartComponent.getShopifyCartData;
                                            stillInCart = cart.items.find(function(item) {
                                                return item.variant_id === parseInt(variantId);
                                            });
                                            if (!stillInCart) {
                                                sessionStorage.removeItem("sampleInCart");
                                                if (window.location.pathname.includes("/pages/samples")) {
                                                    window.location.reload();
                                                }
                                            }
                                            return [ 2 ];
                                        });
                                    });
                                }, 500);
                            }
                            return [ 2 ];
                        });
                    });
                });
            };
            _this_1.disableSampleControlsImmediately = function() {
                var sampleIds = window.SAMPLE_VARIANTS || [];
                document.querySelectorAll("input[data-quantity-variant-id]").forEach(function(input) {
                    var _a;
                    var variantId = parseInt(input.dataset.quantityVariantId || "0");
                    if (sampleIds.includes(variantId)) {
                        input.setAttribute("readonly", "true");
                        input.classList.add("readonly-sample");
                        var plusBtn = (_a = input.closest(".counter")) === null || _a === void 0 ? void 0 : _a.querySelector("button.js-counter-increase");
                        if (plusBtn) {
                            plusBtn.disabled = true;
                            plusBtn.classList.add("disabled-sample");
                        }
                    }
                });
            };
            _this_1.autoRemoveSamplesIfLoggedOut = function() {
                if (!window.IS_LOGGED_IN) {
                    var cart = _this_1.cartComponent.getShopifyCartData;
                    var updates_1 = {};
                    cart.items.forEach(function(item) {
                        var _a;
                        if (((_a = item.properties) === null || _a === void 0 ? void 0 : _a._is_sample) === "true") {
                            updates_1[item.key] = 0;
                        }
                    });
                    if (Object.keys(updates_1).length > 0) {
                        fetch("/cart/update.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                updates: updates_1
                            })
                        }).then(function() {
                            sessionStorage.removeItem("sampleInCart");
                            window.location.reload();
                        });
                    }
                }
            };
            _this_1.autoRemoveSamplesOnLogoutClick = function() {
                if (_this_1._logoutListenerAttached) return;
                _this_1._logoutListenerAttached = true;
                document.addEventListener("click", function(e) {
                    return __awaiter(_this_1, void 0, void 0, function() {
                        var target, logoutBtn, DEBUG, hasSampleFlag, getCartAsync, changeCartAsync, updateCartAsync, wait, normalizeSkuList, removeSkuList, removeSkuSet_1, shouldRemoveLine_1, collectKeysToRemove, cart, keysToRemove, _i, keysToRemove_1, key, verify, stillThere, _a, stillThere_1, key, err_2;
                        var _this_1 = this;
                        return __generator(this, function(_b) {
                            switch (_b.label) {
                              case 0:
                                target = e.target;
                                logoutBtn = target === null || target === void 0 ? void 0 : target.closest(".st_logout");
                                if (!logoutBtn) return [ 2 ];
                                e.preventDefault();
                                e.stopPropagation();
                                if (typeof e.stopImmediatePropagation === "function") {
                                    e.stopImmediatePropagation();
                                }
                                if (this._logoutInProgress) return [ 2 ];
                                this._logoutInProgress = true;
                                DEBUG = false;
                                _b.label = 1;

                              case 1:
                                _b.trys.push([ 1, 20, 21, 22 ]);
                                hasSampleFlag = sessionStorage.getItem("sampleInCart") === "true";
                                getCartAsync = function() {
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.getCart(function(cartObj) {
                                            return resolve(cartObj);
                                        });
                                    });
                                };
                                changeCartAsync = function(changeData, cartRefresh) {
                                    if (cartRefresh === void 0) {
                                        cartRefresh = true;
                                    }
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.changeCart(changeData, function() {
                                            return resolve();
                                        }, cartRefresh);
                                    });
                                };
                                updateCartAsync = function(updateData) {
                                    return new Promise(function(resolve) {
                                        return _this_1.cartComponent.updateCart(updateData, function() {
                                            return resolve();
                                        });
                                    });
                                };
                                wait = function(ms) {
                                    return new Promise(function(r) {
                                        return setTimeout(r, ms);
                                    });
                                };
                                normalizeSkuList = function(raw) {
                                    try {
                                        if (Array.isArray(raw)) return raw.map(String);
                                        if (typeof raw === "string") {
                                            var s = raw.trim();
                                            if (!s) return [];
                                            if (s.startsWith("[") && s.endsWith("]")) {
                                                var parsed = JSON.parse(s);
                                                return Array.isArray(parsed) ? parsed.map(String) : [];
                                            }
                                            return s.split(",").map(function(x) {
                                                return x.trim();
                                            });
                                        }
                                    } catch (_a) {}
                                    return [];
                                };
                                removeSkuList = normalizeSkuList(window.removeProductOnLogoutSku);
                                removeSkuSet_1 = new Set(removeSkuList.map(function(s) {
                                    return s.trim().toUpperCase();
                                }));
                                shouldRemoveLine_1 = function(item) {
                                    var _a;
                                    var props = (item === null || item === void 0 ? void 0 : item.properties) || {};
                                    var isSample = (props === null || props === void 0 ? void 0 : props._is_sample) === "true" || (props === null || props === void 0 ? void 0 : props._is_sample) === true || (props === null || props === void 0 ? void 0 : props._isFreeSample) === "true" || (props === null || props === void 0 ? void 0 : props._isFreeSample) === true;
                                    var sku = ((_a = item === null || item === void 0 ? void 0 : item.sku) !== null && _a !== void 0 ? _a : "").toString().trim().toUpperCase();
                                    var skuHit = sku && removeSkuSet_1.has(sku);
                                    var should = Boolean(isSample || skuHit);
                                    if (DEBUG) {
                                        console.log("[logout-remove:inspect]", {
                                            title: item === null || item === void 0 ? void 0 : item.title,
                                            key: item === null || item === void 0 ? void 0 : item.key,
                                            sku: sku,
                                            isSample: isSample,
                                            skuHit: skuHit,
                                            should: should,
                                            props: props
                                        });
                                    }
                                    return should;
                                };
                                collectKeysToRemove = function(cart) {
                                    var keys = [];
                                    ((cart === null || cart === void 0 ? void 0 : cart.items) || []).forEach(function(item) {
                                        if ((item === null || item === void 0 ? void 0 : item.key) && shouldRemoveLine_1(item)) keys.push(item.key);
                                    });
                                    return keys;
                                };
                                return [ 4, getCartAsync() ];

                              case 2:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                if (!(keysToRemove.length === 0 && (hasSampleFlag || removeSkuSet_1.size > 0))) return [ 3, 7 ];
                                return [ 4, wait(150) ];

                              case 3:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 4:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                if (!(keysToRemove.length === 0)) return [ 3, 7 ];
                                return [ 4, wait(150) ];

                              case 5:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 6:
                                cart = _b.sent();
                                keysToRemove = collectKeysToRemove(cart);
                                _b.label = 7;

                              case 7:
                                if (DEBUG) console.log("[logout-remove:keys]", keysToRemove);
                                _i = 0, keysToRemove_1 = keysToRemove;
                                _b.label = 8;

                              case 8:
                                if (!(_i < keysToRemove_1.length)) return [ 3, 11 ];
                                key = keysToRemove_1[_i];
                                return [ 4, changeCartAsync({
                                    id: key,
                                    quantity: 0
                                }, false) ];

                              case 9:
                                _b.sent();
                                _b.label = 10;

                              case 10:
                                _i++;
                                return [ 3, 8 ];

                              case 11:
                                if (!(keysToRemove.length > 0)) return [ 3, 17 ];
                                return [ 4, wait(50) ];

                              case 12:
                                _b.sent();
                                return [ 4, getCartAsync() ];

                              case 13:
                                verify = _b.sent();
                                stillThere = collectKeysToRemove(verify);
                                if (DEBUG) console.log("[logout-remove:verify]", stillThere);
                                _a = 0, stillThere_1 = stillThere;
                                _b.label = 14;

                              case 14:
                                if (!(_a < stillThere_1.length)) return [ 3, 17 ];
                                key = stillThere_1[_a];
                                return [ 4, changeCartAsync({
                                    id: key,
                                    quantity: 0
                                }, false) ];

                              case 15:
                                _b.sent();
                                _b.label = 16;

                              case 16:
                                _a++;
                                return [ 3, 14 ];

                              case 17:
                                sessionStorage.removeItem("sampleInCart");
                                return [ 4, updateCartAsync({
                                    attributes: {
                                        sampleSetAllowed: "",
                                        clearCartOnGuest: ""
                                    }
                                }) ];

                              case 18:
                                _b.sent();
                                return [ 4, wait(60) ];

                              case 19:
                                _b.sent();
                                window.location.assign("/account/logout");
                                return [ 3, 22 ];

                              case 20:
                                err_2 = _b.sent();
                                console.error("[logout-remove] unexpected error:", err_2);
                                window.location.assign("/account/logout");
                                return [ 3, 22 ];

                              case 21:
                                this._logoutInProgress = false;
                                return [ 7 ];

                              case 22:
                                return [ 2 ];
                            }
                        });
                    });
                }, {
                    capture: true,
                    passive: false
                });
            };
            _this_1.autoClearCartOnGuest = function() {
                var _a;
                var cart = _this_1.cartComponent.getShopifyCartData;
                var shouldClear = ((_a = cart.attributes) === null || _a === void 0 ? void 0 : _a.clearCartOnGuest) === "true";
                if (!shouldClear) return;
                var updates = {};
                cart.items.forEach(function(item) {
                    updates[item.key] = 0;
                });
                if (Object.keys(updates).length === 0) return;
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        updates: updates
                    })
                }).then(function() {
                    return fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            attributes: {
                                clearCartOnGuest: "",
                                sampleSetAllowed: "",
                                sponsorWebAlias: ""
                            }
                        })
                    });
                }).then(function() {
                    window.location.reload();
                });
            };
            _this_1.resetClearCartFlagIfLoggedIn = function() {
                var _a;
                var isLoggedIn = window.IS_LOGGED_IN;
                if (!isLoggedIn) return;
                var cart = _this_1.cartComponent.getShopifyCartData;
                var flagSet = ((_a = cart.attributes) === null || _a === void 0 ? void 0 : _a.clearCartOnGuest) === "true";
                if (!flagSet) return;
                fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        attributes: {
                            clearCartOnGuest: ""
                        }
                    })
                });
            };
            _this_1.cartComponent = cartComponent;
            return _this_1;
        }
        StCartGuard.prototype.interceptFetch = function() {
            var _this_1 = this;
            var originalFetch = window.fetch;
            window.fetch = function(input, init) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var allow;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (!(typeof input === "string" && input.includes("/cart/add") && !input.includes("/cart/change"))) return [ 3, 2 ];
                            return [ 4, this.canAddProduct() ];

                          case 1:
                            allow = _a.sent();
                            if (!allow) {
                                this.openSampleModal();
                                throw new Error("Blocked adding product because sample is in cart.");
                            }
                            _a.label = 2;

                          case 2:
                            return [ 2, originalFetch(input, init) ];
                        }
                    });
                });
            };
        };
        StCartGuard.prototype.interceptXMLHttpRequest = function() {
            var _this = this;
            var originalOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function(method, url) {
                if (typeof url === "string") {
                    var urlString = url.toString();
                    if (urlString.includes("/cart/change")) {
                        return originalOpen.apply(this, arguments);
                    }
                    if (urlString.includes("/cart/add")) {
                        var xhr_1 = this;
                        xhr_1.addEventListener("readystatechange", function() {
                            return __awaiter(this, void 0, void 0, function() {
                                var allow;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        if (!(xhr_1.readyState === 1)) return [ 3, 2 ];
                                        return [ 4, _this.checkCartBeforeAdd() ];

                                      case 1:
                                        allow = _a.sent();
                                        if (!allow) {
                                            _this.openStaticSampleModal();
                                            xhr_1.abort();
                                        }
                                        _a.label = 2;

                                      case 2:
                                        return [ 2 ];
                                    }
                                });
                            });
                        });
                    }
                }
                return originalOpen.apply(this, arguments);
            };
        };
        StCartGuard.prototype.interceptAddToCartButtons = function() {
            var _this_1 = this;
            document.addEventListener("click", function(e) {
                return __awaiter(_this_1, void 0, void 0, function() {
                    var target, allow;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            target = e.target;
                            if (target.closest('[data-role="remove-sample"]')) {
                                return [ 2 ];
                            }
                            if (!(target.closest('form[action^="/cart/add"]') || target.closest("button[data-variant-id]"))) return [ 3, 2 ];
                            return [ 4, this.canAddProduct() ];

                          case 1:
                            allow = _a.sent();
                            if (!allow) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                this.openSampleModal();
                            }
                            _a.label = 2;

                          case 2:
                            return [ 2 ];
                        }
                    });
                });
            }, true);
        };
        StCartGuard.prototype.canAddProduct = function() {
            return __awaiter(this, void 0, void 0, function() {
                var cart, sampleInCart_1;
                return __generator(this, function(_a) {
                    try {
                        cart = this.cartComponent.getShopifyCartData;
                        sampleInCart_1 = cart.items.some(function(item) {
                            if (sampleInCart_1) {
                                sessionStorage.setItem("sampleInCart", "true");
                            }
                            return item.properties && item.properties._is_sample === "true";
                        });
                        return [ 2, !sampleInCart_1 ];
                    } catch (_b) {
                        return [ 2, true ];
                    }
                    return [ 2 ];
                });
            });
        };
        StCartGuard.prototype.checkCartBeforeAdd = function() {
            return __awaiter(this, void 0, void 0, function() {
                var cart, sampleInCart;
                return __generator(this, function(_a) {
                    try {
                        cart = this.cartComponent.getShopifyCartData;
                        sampleInCart = cart.items.some(function(item) {
                            return item.properties && item.properties._is_sample === "true";
                        });
                        return [ 2, !sampleInCart ];
                    } catch (_b) {
                        return [ 2, true ];
                    }
                    return [ 2 ];
                });
            });
        };
        StCartGuard.prototype.injectModalHtml = function() {
            var modalHtml = '\n    <div id="sample-guard-modal" class="sample-guard-modal-backdrop" style="display:none;">\n        <div class="sample-guard-modal">\n            <h3>Important Notice</h3>\n            <p>You cannot purchase regular products while a sample set is in your cart.<br>Please complete your sample set checkout or remove the sample set from your cart to continue shopping.</p>\n            <div class="sample-guard-modal-actions">\n            <button id="sample-modal-go-cart" class="sample-btn confirm">GO TO CART</button>\n            <button id="sample-modal-cancel" class="sample-btn cancel">CONTINUE SHOPPING</button>\n            </div>\n        </div>\n    </div>\n    ';
            document.body.insertAdjacentHTML("beforeend", modalHtml);
        };
        StCartGuard.prototype.attachModalEvents = function() {
            var _this_1 = this;
            var _a, _b;
            (_a = document.getElementById("sample-modal-go-cart")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function() {
                window.location.href = "/cart";
            });
            (_b = document.getElementById("sample-modal-cancel")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function() {
                _this_1.closeSampleModal();
            });
            document.addEventListener("keydown", function(e) {
                if (e.key === "Escape") {
                    _this_1.closeSampleModal();
                }
            });
        };
        StCartGuard.prototype.openSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "flex";
        };
        StCartGuard.prototype.closeSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "none";
        };
        StCartGuard.prototype.openStaticSampleModal = function() {
            var modal = document.getElementById("sample-guard-modal");
            if (modal) modal.style.display = "flex";
        };
        return StCartGuard;
    }(st_module_75.StModule);
    exports.StCartGuard = StCartGuard;
});

define("extension/shopify-app/st-modules/account-register/st-market-type", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_76) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StMarketTypeLoader = void 0;
    var StMarketTypeLoader = function(_super) {
        __extends(StMarketTypeLoader, _super);
        function StMarketTypeLoader() {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "MarketTypeLoader";
            _this_1.selectId = "marketTypeSelect";
            _this_1.wrapperId = "marketTypeExtraInputWrapper";
            _this_1.inputId = "marketTypeExtraInput";
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    var _this = _this_1;
                    var marketTypeSelect = document.getElementById(_this_1.selectId);
                    var inputWrapper = document.getElementById(_this_1.wrapperId);
                    var inputField = document.getElementById(_this_1.inputId);
                    var labelField = inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.querySelector(".form__field__label");
                    if (!marketTypeSelect || !inputWrapper || !inputField || !labelField) return;
                    marketTypeSelect.required = true;
                    inputWrapper.style.display = "none";
                    inputField.required = false;
                    inputField.value = "";
                    labelField.textContent = "";
                    fetch(_this.endpoint["market-type"]["get-market-type"]).then(function(res) {
                        return res.json();
                    }).then(function(resData) {
                        if (!resData || !Array.isArray(resData.data)) {
                            console.error("[MarketTypeLoader] Invalid response:", resData);
                            return;
                        }
                        var activeItems = resData.data.filter(function(item) {
                            return item.isActive;
                        });
                        var marketTypeMap = {};
                        activeItems.forEach(function(item) {
                            marketTypeMap[item.id] = item;
                            var option = document.createElement("option");
                            var isPlaceholder = /^-?\s*--\s*select\s*one\s*--\s*$/i.test(item.description);
                            option.value = isPlaceholder ? "" : String(item.id);
                            option.textContent = item.description;
                            if (isPlaceholder) {
                                option.disabled = true;
                                option.selected = true;
                            }
                            marketTypeSelect.appendChild(option);
                        });
                        marketTypeSelect.addEventListener("change", function() {
                            var val = this.value;
                            if (!val) {
                                inputWrapper.style.display = "none";
                                inputField.required = false;
                                inputField.value = "";
                                labelField.textContent = "";
                                return;
                            }
                            var selectedItem = marketTypeMap[val];
                            if (selectedItem && selectedItem.inputLabel) {
                                inputWrapper.style.display = "block";
                                inputField.required = true;
                                labelField.textContent = selectedItem.inputLabel || "";
                            } else {
                                inputWrapper.style.display = "none";
                                inputField.required = false;
                                inputField.value = "";
                                labelField.textContent = "";
                            }
                        });
                        marketTypeSelect.dispatchEvent(new Event("change"));
                        var formEl = marketTypeSelect.closest("form");
                        if (formEl) {
                            formEl.addEventListener("submit", function(e) {
                                if (!marketTypeSelect.value) {
                                    e.preventDefault();
                                    marketTypeSelect.reportValidity();
                                } else if (inputField.required && !inputField.value.trim()) {
                                    e.preventDefault();
                                    inputField.reportValidity();
                                }
                            });
                        }
                    }).catch(function(err) {
                        console.error("[MarketTypeLoader] Fetch error:", err);
                    });
                });
            };
            return _this_1;
        }
        return StMarketTypeLoader;
    }(st_module_76.StModule);
    exports.StMarketTypeLoader = StMarketTypeLoader;
});

define("extension/shopify-app/st-modules/cart/cartSaveLoginInterceptor", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_77) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCartInterceptor = void 0;
    var StCartInterceptor = function(_super) {
        __extends(StCartInterceptor, _super);
        function StCartInterceptor() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StCartInterceptor";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            _this.interceptLogoutButton = function() {
                document.addEventListener("click", function(e) {
                    return __awaiter(_this, void 0, void 0, function() {
                        var target, logoutBtn;
                        return __generator(this, function(_a) {
                            target = e.target;
                            logoutBtn = target.closest("button.st_logout");
                            if (!logoutBtn) return [ 2 ];
                            console.log("[StCartInterceptor] Logout button clicked, resetting flag. sessionStorage");
                            sessionStorage.removeItem("cartRestoredOnce");
                            window.location.replace("/cart/clear?return_to=/account/logout");
                            return [ 2 ];
                        });
                    });
                });
            };
            return _this;
        }
        return StCartInterceptor;
    }(st_module_77.StModule);
    exports.StCartInterceptor = StCartInterceptor;
});

define("extension/shopify-app/st-modules/cart/prefilCartOnLogin", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_78) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StPrefilCart = void 0;
    var StPrefilCart = function(_super) {
        __extends(StPrefilCart, _super);
        function StPrefilCart() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StPrefilCart";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {});
            };
            return _this;
        }
        StPrefilCart.prototype.trySaveCartAfterCheckoutReturn = function() {
            return __awaiter(this, void 0, void 0, function() {
                var ref, fromCheckoutRef, customerId, cart, cartId, saveUrl;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        console.log("[StPrefilCart] trySaveCartAfterCheckoutReturn");
                        if (location.pathname.indexOf("/checkouts/") === 0) {
                            console.log("[StPrefilCart] on /checkouts/* => skip");
                            return [ 2 ];
                        }
                        if (this.wasAlreadySaved()) {
                            console.log("[StPrefilCart] already saved in this session => skip");
                            return [ 2 ];
                        }
                        ref = document.referrer || "";
                        fromCheckoutRef = ref.includes("/checkouts/");
                        console.log("[StPrefilCart] referrer:", ref, "fromCheckoutRef:", fromCheckoutRef);
                        if (!fromCheckoutRef) {
                            console.log("[StPrefilCart] not coming from checkout => skip");
                            return [ 2 ];
                        }
                        customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                        console.log("[StPrefilCart] customerShopifyId:", customerId);
                        if (!customerId || customerId === "0") {
                            console.log("[StPrefilCart] customer not logged => skip");
                            return [ 2 ];
                        }
                        return [ 4, this.ajaxGetJson("/cart.js") ];

                      case 1:
                        cart = _a.sent();
                        cartId = String((cart === null || cart === void 0 ? void 0 : cart.token) || (cart === null || cart === void 0 ? void 0 : cart.id) || "").split("?")[0];
                        console.log("[StPrefilCart] cartId:", cartId);
                        if (!cartId) {
                            console.log("[StPrefilCart] missing cartId => skip");
                            return [ 2 ];
                        }
                        saveUrl = this.endpoint["cart"]["save-customer-cart"];
                        console.log("[StPrefilCart] calling save endpoint:", saveUrl);
                        return [ 4, this.ajaxPostJson(saveUrl, {
                            cartId: cartId,
                            customerShopifyId: customerId,
                            customerCartSaved: true
                        }) ];

                      case 2:
                        _a.sent();
                        this.markSaved();
                        console.log("[StPrefilCart] Saved cart after checkout return", {
                            cartId: cartId,
                            customerId: customerId
                        });
                        return [ 2 ];
                    }
                });
            });
        };
        StPrefilCart.prototype.wasAlreadySaved = function() {
            return sessionStorage.getItem("saved_after_checkout") === "1";
        };
        StPrefilCart.prototype.markSaved = function() {
            sessionStorage.setItem("saved_after_checkout", "1");
        };
        StPrefilCart.prototype.ajaxPostJson = function(endpoint, data) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        StPrefilCart.prototype.ajaxGetJson = function(endpoint) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "GET",
                    contentType: "json",
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        return StPrefilCart;
    }(st_module_78.StModule);
    exports.StPrefilCart = StPrefilCart;
});

define("extension/shopify-app/st-modules/account-login/customers-login", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/notification" ], function(require, exports, st_module_79, notification_12) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StOverideLogin = void 0;
    var StOverideLogin = function(_super) {
        __extends(StOverideLogin, _super);
        function StOverideLogin(generalMethods, notification) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StOverideLogin";
            _this.loginAsRetail = true;
            _this.init = function() {
                _this.clickedButtons();
                _this.toggleLoginType(true);
                _this.clickOnSubmit();
                _this.setupFormSwitch();
                _this.bindBecomeConsultant();
                _this.togglePassword();
            };
            _this.setupFormSwitch = function() {
                var loginWrapper = document.getElementById("lbri-login-wrapper");
                var recoveryWrapper = document.getElementById("lbri-recovery-wrapper");
                var recoverLinks = document.querySelectorAll('a[href="#recover"]');
                var cancelLink = document.querySelector('a[href="#login"]');
                var showRecovery = function() {
                    if (loginWrapper) loginWrapper.style.display = "none";
                    if (recoveryWrapper) recoveryWrapper.style.display = "block";
                };
                var showLogin = function() {
                    if (recoveryWrapper) recoveryWrapper.style.display = "none";
                    if (loginWrapper) loginWrapper.style.display = "flex";
                };
                recoverLinks.forEach(function(link) {
                    link.addEventListener("click", function(e) {
                        e.preventDefault();
                        showRecovery();
                        window.location.hash = "#recover";
                    });
                });
                if (cancelLink) {
                    cancelLink.addEventListener("click", function(e) {
                        e.preventDefault();
                        showLogin();
                        window.location.hash = "#login";
                    });
                }
            };
            _this.clickedButtons = function() {
                var customerBtn = document.querySelector(".lbri-retail-login");
                var consultantBtn = document.querySelector(".lbri-consultant-login");
                if (customerBtn && consultantBtn) {
                    customerBtn.addEventListener("click", function() {
                        return _this.toggleLoginType(true);
                    });
                    consultantBtn.addEventListener("click", function() {
                        return _this.toggleLoginType(false);
                    });
                }
            };
            _this.toggleLoginType = function(isRetail) {
                _this.loginAsRetail = isRetail;
                var customerBtn = document.querySelector(".lbri-retail-login");
                var consultantBtn = document.querySelector(".lbri-consultant-login");
                var customerHeader = document.querySelector(".lbri-login-header__customer");
                var consultantHeader = document.querySelector(".lbri-login-header__consultant");
                var signInButton = document.querySelector(".lbri-signin-button");
                var createAccLink = document.querySelector(".lbri-create-account");
                var consultantLink = document.querySelector(".lbri-become-consultant");
                var image = document.querySelector(".lbri_login-image");
                if (isRetail) {
                    customerBtn === null || customerBtn === void 0 ? void 0 : customerBtn.classList.add("active");
                    consultantBtn === null || consultantBtn === void 0 ? void 0 : consultantBtn.classList.remove("active");
                    customerHeader.style.display = "block";
                    consultantHeader.style.display = "none";
                    signInButton.style.backgroundColor = "#4F8643";
                    signInButton.style.color = "white";
                    createAccLink.style.display = "flex";
                    consultantLink.style.display = "none";
                    image === null || image === void 0 ? void 0 : image.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/4892/5370/files/customer.png?v=1749737985");
                } else {
                    customerBtn === null || customerBtn === void 0 ? void 0 : customerBtn.classList.remove("active");
                    consultantBtn === null || consultantBtn === void 0 ? void 0 : consultantBtn.classList.add("active");
                    customerHeader.style.display = "none";
                    consultantHeader.style.display = "block";
                    signInButton.style.backgroundColor = "#C89A60";
                    signInButton.style.color = "white";
                    createAccLink.style.display = "none";
                    consultantLink.style.display = "flex";
                    image === null || image === void 0 ? void 0 : image.setAttribute("src", "https://cdn.shopify.com/s/files/1/0694/4892/5370/files/consultant.png?v=1749738237");
                }
            };
            _this.clickOnSubmit = function() {
                var submitButton = document.querySelector(".lbri_login-submit-btn_JS");
                if (submitButton) {
                    submitButton.addEventListener("click", function(e) {
                        e.preventDefault();
                        _this.loginOveride();
                    });
                }
            };
            _this.getRequestData = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var emailInput, passwordInput, cart, cartId;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            emailInput = document.querySelector(".lbri_login-email-input_JS");
                            passwordInput = document.querySelector(".lbri_login-password-input_JS");
                            console.log("document referrer ", document.referrer);
                            return [ 4, this.ajaxGetJson("/cart.js") ];

                          case 1:
                            cart = _a.sent();
                            cartId = cart.token || cart.id;
                            cartId = String(cartId || "").split("?")[0];
                            return [ 2, {
                                emailOrId: emailInput === null || emailInput === void 0 ? void 0 : emailInput.value,
                                password: passwordInput === null || passwordInput === void 0 ? void 0 : passwordInput.value,
                                loginAsRetail: this.loginAsRetail,
                                url: document.referrer,
                                SHOPIFY_DOMAIN_NAME: window.location.hostname,
                                cartId: cartId
                            } ];
                        }
                    });
                });
            };
            _this.loginOveride = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var requestData, errorBox;
                    var _this = this;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            return [ 4, this.getRequestData() ];

                          case 1:
                            requestData = _a.sent();
                            errorBox = document.querySelector(".lbri-login-error-message");
                            this.toggleLoader(true);
                            this.ajax.send({
                                endpoint: this.endpoint["customer"]["customer-login"],
                                method: "post",
                                contentType: "json",
                                data: requestData,
                                callback: function(response) {
                                    return __awaiter(_this, void 0, void 0, function() {
                                        var loginResponse, customerShopifyId, error_1;
                                        var _a, _b, _c, _d, _e;
                                        return __generator(this, function(_f) {
                                            switch (_f.label) {
                                              case 0:
                                                _f.trys.push([ 0, 4, , 5 ]);
                                                loginResponse = JSON.parse(response.response);
                                                console.log("response ", response);
                                                if (!(loginResponse.status === 200)) return [ 3, 3 ];
                                                if (errorBox) {
                                                    errorBox.style.display = "none";
                                                    errorBox.innerText = "";
                                                }
                                                customerShopifyId = (_a = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _a === void 0 ? void 0 : _a.id;
                                                console.log("Customer Login get Cart Data from response  ", (_b = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _b === void 0 ? void 0 : _b.cartInfo);
                                                if (!((_c = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _c === void 0 ? void 0 : _c.cartInfo)) return [ 3, 2 ];
                                                return [ 4, this.restoreCart((_e = (_d = loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data) === null || _d === void 0 ? void 0 : _d.cartInfo) === null || _e === void 0 ? void 0 : _e.items) ];

                                              case 1:
                                                _f.sent();
                                                console.log("Customer Login get Cart Data ");
                                                _f.label = 2;

                                              case 2:
                                                this.toggleLoader(false);
                                                window.location.assign(loginResponse.data.url);
                                                return [ 2 ];

                                              case 3:
                                                if (errorBox) {
                                                    errorBox.innerText = loginResponse.message || "Invalid credentials or server error.";
                                                    errorBox.style.display = "block";
                                                }
                                                this.toggleLoader(false);
                                                this.notification.showNotification(notification_12.ENotificationType.error, "Login Failed", loginResponse.message || "Invalid credentials.");
                                                return [ 3, 5 ];

                                              case 4:
                                                error_1 = _f.sent();
                                                if (errorBox) {
                                                    errorBox.innerText = "Unexpected error occurred.";
                                                    errorBox.style.display = "block";
                                                }
                                                this.toggleLoader(false);
                                                this.notification.showNotification(notification_12.ENotificationType.error, "Server Error", error_1 instanceof Error ? error_1.message : String(error_1));
                                                return [ 3, 5 ];

                                              case 5:
                                                return [ 2 ];
                                            }
                                        });
                                    });
                                }
                            });
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.getRepIdFromLocalStorage = function() {
                var raw = window.localStorage.getItem("repId");
                if (!raw) return null;
                var val = raw.trim();
                return val || null;
            };
            _this.getRepIdFromUrl = function() {
                var params = new URLSearchParams(window.location.search);
                var raw = params.get("repId");
                var val = raw && raw.trim();
                return val || null;
            };
            _this.buildBdtEnrollUrl = function() {
                var _a;
                var base = "https://extranet.lbri.com/Lbri/Signup/EnrollNew.asp?sponsordid=434475";
                var url = new URL(base);
                var repId = (_a = _this.getRepIdFromLocalStorage()) !== null && _a !== void 0 ? _a : _this.getRepIdFromUrl();
                if (repId) {
                    url.searchParams.set("sponsordid", repId);
                }
                return url.toString();
            };
            _this.bindBecomeConsultant = function() {
                var btn = document.querySelector(".lbri-become-consultant_JS");
                if (!btn) return;
                var el = btn;
                if (el.dataset.bound === "1") return;
                el.dataset.bound = "1";
                btn.addEventListener("click", function(e) {
                    e.preventDefault();
                    var url = _this.buildBdtEnrollUrl();
                    window.location.assign(url);
                });
            };
            _this.togglePassword = function() {
                var inputs = Array.from(document.querySelectorAll(".lbri_login-password-input_JS, .st_reset-password-input_JS"));
                inputs.forEach(function(input) {
                    var wrapper = input.closest("label.form__field.lbri-input") || input.parentElement;
                    if (!wrapper) return;
                    var btn = wrapper.querySelector(".lbri_toggle-password-visibility-button_JS");
                    if (!btn) return;
                    if (btn._lbriBound === "1") return;
                    btn._lbriBound = "1";
                    if (getComputedStyle(wrapper).position === "static") {
                        wrapper.style.position = "relative";
                    }
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var isPassword = input.getAttribute("type") === "password";
                        input.setAttribute("type", isPassword ? "text" : "password");
                        btn.classList.toggle("lbri_password-visible", isPassword);
                        btn.setAttribute("aria-pressed", isPassword ? "true" : "false");
                        btn.setAttribute("aria-label", isPassword ? "Hide password" : "Show password");
                        input.focus();
                    });
                });
            };
            _this.generalMethods = generalMethods;
            _this.notification = notification;
            return _this;
        }
        StOverideLogin.prototype.toggleLoader = function(show) {
            var loader = document.querySelector(".lbri_login_loader_JS");
            var submitBtn = loader === null || loader === void 0 ? void 0 : loader.closest("button");
            var createAccountDiv = document.querySelector(".lbri-create-account-wrapper");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
                submitBtn && (submitBtn.disabled = true);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.add("opacity-50", "cursor-not-allowed");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "none";
                    createAccountDiv.style.opacity = "0.5";
                }
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
                if (createAccountDiv) {
                    createAccountDiv.style.pointerEvents = "auto";
                    createAccountDiv.style.opacity = "1";
                }
                submitBtn && (submitBtn.disabled = false);
                submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.classList.remove("opacity-50", "cursor-not-allowed");
            }
        };
        StOverideLogin.prototype.restoreCart = function(cartData) {
            return __awaiter(this, void 0, void 0, function() {
                var items, clearRes, addRes, addText, cartRes, cart;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        items = this.normalizeCartItems(cartData);
                        console.log("[restoreCart] items payload", items);
                        return [ 4, fetch("/cart/clear.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "same-origin"
                        }) ];

                      case 1:
                        clearRes = _a.sent();
                        console.log("[restoreCart] clear status", clearRes.status);
                        return [ 4, clearRes.text() ];

                      case 2:
                        _a.sent();
                        return [ 4, fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            credentials: "same-origin",
                            body: JSON.stringify({
                                items: items
                            })
                        }) ];

                      case 3:
                        addRes = _a.sent();
                        return [ 4, addRes.text() ];

                      case 4:
                        addText = _a.sent();
                        console.log("[restoreCart] add status", addRes.status, "body", addText);
                        return [ 4, fetch("/cart.js", {
                            credentials: "same-origin"
                        }) ];

                      case 5:
                        cartRes = _a.sent();
                        return [ 4, cartRes.json() ];

                      case 6:
                        cart = _a.sent();
                        console.log("[restoreCart] final cart items", cart === null || cart === void 0 ? void 0 : cart.items);
                        return [ 2 ];
                    }
                });
            });
        };
        StOverideLogin.prototype.normalizeCartItems = function(items) {
            return items.map(function(item) {
                var _a;
                var rawId = item.id;
                var variantId = Number((_a = rawId.split("/").pop()) === null || _a === void 0 ? void 0 : _a.split("?")[0]);
                if (!variantId || Number.isNaN(variantId)) return null;
                return {
                    id: variantId,
                    quantity: Number(item.quantity || 0)
                };
            }).filter(Boolean);
        };
        StOverideLogin.prototype.ajaxGetJson = function(endpoint) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "GET",
                    contentType: "json",
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        StOverideLogin.prototype.ajaxPostJson = function(endpoint, data) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                _this.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status < 200 || request.status >= 300) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            resolve(JSON.parse(request.responseText || "{}"));
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
            });
        };
        return StOverideLogin;
    }(st_module_79.StModule);
    exports.StOverideLogin = StOverideLogin;
});

define("extension/shopify-app/st-modules/shopping-on-behalf/shopping-on-behalf", [ "require", "exports", "core/connector-app/_shared/models/auth/auth.request.model", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, auth_request_model_3, st_module_80) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShoppingOnBehalf = void 0;
    var StShoppingOnBehalf = function(_super) {
        __extends(StShoppingOnBehalf, _super);
        function StShoppingOnBehalf() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StShoppingOnBehalf";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.logout();
                });
            };
            _this.logout = function() {
                var wrp = document.querySelector(".lbri_shopping-on-behalf-wrapper");
                if (!wrp) return;
                var logoutBtns = wrp.querySelectorAll(".lbri_onbehalf-btn");
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                        });
                    });
                }
            };
            _this.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_3.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_3.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_3.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_3.ETokenType.Refresh);
            };
            return _this;
        }
        return StShoppingOnBehalf;
    }(st_module_80.StModule);
    exports.StShoppingOnBehalf = StShoppingOnBehalf;
});

define("extension/shopify-app/st-modules/account/blocks/credit-ledger/credit-ledger", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "core/shopify-app/st-modules/_general-methods/currency" ], function(require, exports, st_module_81, currency_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCreditLedger = void 0;
    var StCreditLedger = function(_super) {
        __extends(StCreditLedger, _super);
        function StCreditLedger(currency) {
            var _this_1 = _super.call(this, arguments) || this;
            _this_1.className = "StCreditLedger";
            _this_1.creditResponseList = [];
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getCreditsAmount();
                });
            };
            _this_1.getCreditsAmount = function() {
                var _this = _this_1;
                var customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                _this.toggleLoader(true);
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-customer-ledger"];
                try {
                    _this_1.ajax.send({
                        endpoint: getAllCustomerLedger,
                        method: "POST",
                        contentType: "json",
                        data: {
                            customerId: customerId
                        },
                        callback: function(res) {
                            return __awaiter(_this_1, void 0, void 0, function() {
                                var resp, _a;
                                return __generator(this, function(_b) {
                                    switch (_b.label) {
                                      case 0:
                                        resp = JSON.parse(res.response);
                                        if (!(resp.status === 200)) return [ 3, 2 ];
                                        _a = _this;
                                        return [ 4, _this.enrichLedgerWithDetails(resp.data, customerId) ];

                                      case 1:
                                        _a.creditResponseList = _b.sent();
                                        _this.toggleLoader(false);
                                        _this.renderCreditTableBody(_this.creditResponseList);
                                        return [ 3, 3 ];

                                      case 2:
                                        console.log("Error fetching credit ledgers", resp.message);
                                        _this.toggleLoader(false);
                                        _b.label = 3;

                                      case 3:
                                        return [ 2 ];
                                    }
                                });
                            });
                        }
                    });
                } catch (err) {
                    console.log("getCreditsAmount---\x3e Error:", err);
                }
            };
            _this_1.getCreditsAmountForLedger = function(customerId, creditAccountID) {
                var _this = _this_1;
                var getAllCustomerLedger = _this.endpoint["order-credits"]["get-all-credits-for-ledger"];
                return new Promise(function(resolve, reject) {
                    try {
                        _this.ajax.send({
                            endpoint: getAllCustomerLedger,
                            method: "POST",
                            contentType: "json",
                            data: {
                                customerShopifyId: customerId,
                                creditAccountID: creditAccountID
                            },
                            callback: function(res) {
                                try {
                                    var resp = JSON.parse(res.response);
                                    if (resp.status === 200) {
                                        resolve(resp);
                                    } else {
                                        console.error("Error fetching ledger for credit id = ".concat(creditAccountID, " "), resp.message);
                                        resolve({
                                            data: []
                                        });
                                    }
                                } catch (parseErr) {
                                    reject(parseErr);
                                }
                            }
                        });
                    } catch (err) {
                        reject(err);
                    }
                });
            };
            _this_1.currency = currency;
            return _this_1;
        }
        StCreditLedger.prototype.enrichLedgerWithDetails = function(ledgerList, customerId) {
            return __awaiter(this, void 0, void 0, function() {
                var ids, blockedIds, filtered, enriched;
                var _this_1 = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        ids = window.creditNotForRetail;
                        blockedIds = ids.map(function(n) {
                            return Number(n);
                        });
                        filtered = ledgerList.filter(function(item) {
                            var id = Number(item.CreditAccountId);
                            return blockedIds.indexOf(id) === -1;
                        });
                        console.log("filtered ", filtered);
                        return [ 4, Promise.all(filtered.map(function(item) {
                            return __awaiter(_this_1, void 0, void 0, function() {
                                var response, firstExpired;
                                return __generator(this, function(_a) {
                                    switch (_a.label) {
                                      case 0:
                                        return [ 4, this.getCreditsAmountForLedger(customerId, item.CreditAccountId) ];

                                      case 1:
                                        response = _a.sent();
                                        firstExpired = this.getNextExpiringCredit(response.data);
                                        return [ 2, __assign(__assign({}, item), {
                                            creditDetails: response.data,
                                            firstNextCreditExpired: firstExpired
                                        }) ];
                                    }
                                });
                            });
                        })) ];

                      case 1:
                        enriched = _a.sent();
                        return [ 2, enriched ];
                    }
                });
            });
        };
        StCreditLedger.prototype.getNextExpiringCredit = function(credits) {
            var today = new Date();
            var upcoming = credits.filter(function(credit) {
                return new Date(credit.dateExpires) >= today;
            }).sort(function(a, b) {
                return new Date(a.dateExpires).getTime() - new Date(b.dateExpires).getTime();
            });
            return upcoming.length > 0 ? upcoming[0] : null;
        };
        StCreditLedger.prototype.renderCreditTableBody = function(creditList) {
            var _this_1 = this;
            var creditBody = document.querySelector(".lbri_credits_table_body_JS");
            if (!creditBody) return;
            var hideDefautlTitleEl = document.querySelectorAll(".st_main-title");
            var creditLedgerMainTitleSt = hideDefautlTitleEl[hideDefautlTitleEl.length - 1];
            if (creditLedgerMainTitleSt) {
                creditLedgerMainTitleSt.classList.add("st_hidden");
            }
            this.renderSumForCredit(creditList);
            creditList.forEach(function(credit, index) {
                var _a, _b, _c, _d;
                var row = document.createElement("tr");
                row.innerHTML = "\n                <td>".concat(credit.Description, "</td>\n                <td>").concat(_this_1.currency.applyFormat(((_a = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _a === void 0 ? void 0 : _a.amount) ? (_b = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _b === void 0 ? void 0 : _b.amount : 0, currency_2.ECurrencyFormatType.withoutCurrency), "</td>\n                <td>").concat(_this_1.formatDate(((_c = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _c === void 0 ? void 0 : _c.dateExpires) ? (_d = credit === null || credit === void 0 ? void 0 : credit.firstNextCreditExpired) === null || _d === void 0 ? void 0 : _d.dateExpires : "N/A"), "</td>\n                <td>").concat(_this_1.currency.applyFormat(credit.Amount, currency_2.ECurrencyFormatType.withoutCurrency), '</td>\n                <td>\n                 <svg class="open-ledger-modal-btn" data-index="').concat(index, '" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <path d="M2.58333 16.75C2.07917 16.75 1.64757 16.5705 1.28854 16.2115C0.929514 15.8524 0.75 15.4208 0.75 14.9167V2.08333C0.75 1.57917 0.929514 1.14757 1.28854 0.788542C1.64757 0.429514 2.07917 0.25 2.58333 0.25H9V2.08333H2.58333V14.9167H15.4167V8.5H17.25V14.9167C17.25 15.4208 17.0705 15.8524 16.7115 16.2115C16.3524 16.5705 15.9208 16.75 15.4167 16.75H2.58333ZM6.89167 11.8917L5.60833 10.6083L14.1333 2.08333H10.8333V0.25H17.25V6.66667H15.4167V3.36667L6.89167 11.8917Z" fill="black"/>\n        </svg>\n                </td>\n            ');
                creditBody.appendChild(row);
            });
            this.bindModalEvents();
        };
        StCreditLedger.prototype.renderSumForCredit = function(creditList) {
            var totalAmount = creditList.reduce(function(sum, ledger) {
                return sum + ledger.Amount;
            }, 0);
            var totalAmountEl = document.querySelector(".lbri_credit_sum_JS");
            if (!totalAmountEl) return;
            totalAmountEl.textContent = this.currency.applyFormat(totalAmount, currency_2.ECurrencyFormatType.withoutCurrency);
        };
        StCreditLedger.prototype.toggleLoader = function(show) {
            var loader = document.querySelector(".lbri_load_credit_data_JS");
            if (!loader) return;
            if (show) {
                loader === null || loader === void 0 ? void 0 : loader.classList.remove("st_hidden");
            } else {
                loader === null || loader === void 0 ? void 0 : loader.classList.add("st_hidden");
            }
        };
        StCreditLedger.prototype.bindModalEvents = function() {
            var _this_1 = this;
            var overlay = document.querySelector(".credit-ledger-modal-overlay");
            var closeBtn = document.querySelector(".modal-close-btn");
            var tbody = overlay.querySelector(".lbri_credit_details_modal_JS");
            var footerBalance = overlay.querySelector(".lbri_current_total_balance_ledger_JS");
            document.querySelectorAll(".open-ledger-modal-btn").forEach(function(btn) {
                btn.addEventListener("click", function(e) {
                    var index = parseInt(e.currentTarget.getAttribute("data-index") || "");
                    var ledger = _this_1.creditResponseList[index];
                    if (!ledger || !ledger.creditDetails) return;
                    var titleLedgerEl = document.querySelector(".lbri_modal_title_ledger_JS");
                    if (titleLedgerEl) {
                        titleLedgerEl.innerHTML = ledger.Description;
                    }
                    tbody.innerHTML = "";
                    ledger.creditDetails.forEach(function(item) {
                        var inflow = item.amount > 0 ? "".concat(item.amount) : "/";
                        var outflow = item.amount < 0 ? "".concat(item.amount) : "/";
                        var expiration = item.dateExpires || "/";
                        var row = document.createElement("tr");
                        row.innerHTML = "\n                        <td>".concat(_this_1.formatDate(item.dateCreated), "</td>\n                        <td>").concat(item.description, '</td>\n                        <td style="color: ').concat(outflow === "/" ? "green" : "inherit", ';">').concat(inflow !== "/" ? _this_1.currency.applyFormat(Number(inflow), currency_2.ECurrencyFormatType.withoutCurrency) : "/", '</td>\n                        <td style="color: ').concat(inflow === "/" ? "red" : "inherit", '; font-weight: 400">').concat(outflow !== "/" ? _this_1.fixNegativeCurrencyFormat(_this_1.currency.applyFormat(Number(outflow), currency_2.ECurrencyFormatType.withoutCurrency)) : "/", "</td>\n                        <td>").concat(_this_1.formatDate(expiration), "</td>\n                        <td>").concat(_this_1.currency.applyFormat(item.balance, currency_2.ECurrencyFormatType.withoutCurrency), "</td>\n                    ");
                        tbody.appendChild(row);
                    });
                    footerBalance.textContent = "".concat(_this_1.currency.applyFormat(ledger.Amount, currency_2.ECurrencyFormatType.withoutCurrency));
                    overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove("hidden");
                });
            });
            closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function() {
                overlay === null || overlay === void 0 ? void 0 : overlay.classList.add("hidden");
            });
            overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener("click", function(e) {
                if (e.target === overlay) {
                    overlay.classList.add("hidden");
                }
            });
        };
        StCreditLedger.prototype.formatDate = function(dateStr) {
            if (!dateStr || dateStr.trim().toUpperCase() === "N/A") return "/";
            var date = new Date(dateStr);
            if (isNaN(date.getTime())) return "/";
            var day = String(date.getDate()).padStart(2, "0");
            var month = String(date.getMonth() + 1).padStart(2, "0");
            var year = date.getFullYear();
            return "".concat(month, "/").concat(day, "/").concat(year);
        };
        StCreditLedger.prototype.fixNegativeCurrencyFormat = function(value) {
            var match = value.match(/^(.)(-)([\d.,]+)/);
            if (match) {
                var currency = match[1];
                var amount = match[3];
                return "-".concat(currency).concat(amount);
            }
            return value;
        };
        return StCreditLedger;
    }(st_module_81.StModule);
    exports.StCreditLedger = StCreditLedger;
});

define("extension/shopify-app/st-modules/consultant-discount-banner/consultant-discount-banner", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module", "_features.config" ], function(require, exports, st_module_82, _features_config_17) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StConsultantDiscountBanner = void 0;
    var StConsultantDiscountBanner = function(_super) {
        __extends(StConsultantDiscountBanner, _super);
        function StConsultantDiscountBanner(generalMethods, cart) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StConsultantDiscountBanner";
            _this.variantCvCache = new Map();
            _this._lastTotalCV = 0;
            _this._updating = false;
            _this._cartUpdateTimeout = null;
            _this._observer = null;
            _this._isRefreshing = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.observeBannerContainer();
                    _this.safeRefresh();
                    _this.cart.subscribeChangeCart(function() {
                        _this.safeRefresh();
                    });
                    _this._refreshIntervalId = window.setInterval(function() {
                        _this.safeRefresh();
                    }, 1200);
                });
            };
            _this.observeBannerContainer = function() {
                if (_this._observer) return;
                var root = document.querySelector(".cart__items") || document.querySelector(".cart") || document.body;
                if (!root) return;
                _this._observer = new MutationObserver(function() {
                    var wrapper = document.querySelector(".lbr_consultant-discount-main-wrp_JS");
                    if (wrapper && _this.hasPlaceholders()) {
                        _this.safeRefresh();
                    }
                });
                _this._observer.observe(root, {
                    childList: true,
                    subtree: true
                });
            };
            _this.hasPlaceholders = function() {
                var reach = document.querySelector(".lbr_consultant-discount-reach_JS");
                var get = document.querySelector(".lbr_consultant-discount-get_JS");
                var missing = document.querySelector(".lbr_consultant-discount-missing_JS");
                var isPlaceholder = function(el) {
                    if (!el) return true;
                    var text = el.innerText.trim();
                    return text === "_" || text === "" || text === "$_" || text === "$";
                };
                return isPlaceholder(reach) || isPlaceholder(get) || isPlaceholder(missing);
            };
            _this.progressBar = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var totalCV, progress_percentage;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            return [ 4, this.getCartCVTotal() ];

                          case 1:
                            totalCV = _a.sent();
                            this._lastTotalCV = totalCV;
                            progress_percentage = this.calculateProgress(totalCV);
                            this.progressBarPercentage(progress_percentage);
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.progressBarPercentage = function(progress_percentage) {
                var progress = document.querySelector(".lbr_consultant-discount-progress-done");
                if (!progress) return;
                var width = Math.min(progress_percentage, 100);
                progress.setAttribute("data-done", String(width));
                progress.style.width = width + "%";
                progress.style.opacity = "1";
                _this.displayPercentage(progress_percentage);
            };
            _this.displayPercentage = function(percentage) {
                var percentageSpan = document.querySelector(".lbr_consultant-discount-num_JS");
                if (!percentageSpan) return;
                var progress = document.querySelector(".lbr_consultant-discount-progress-done");
                if (!progress) return;
                var limit = Number(progress.getAttribute("data-limit") || 0);
                if (percentage < 100) {
                    var missing = Math.max(0, limit - _this._lastTotalCV);
                    percentageSpan.innerHTML = missing.toFixed(2);
                } else {
                    percentageSpan.innerHTML = "0";
                }
            };
            _this.calculateProgress = function(totalCV) {
                var _a, _b, _c;
                var progress = document.querySelector(".lbr_consultant-discount-progress-done");
                if (!progress) return 0;
                var limit = Number((_c = (_b = (_a = window.rankLevels) === null || _a === void 0 ? void 0 : _a.discounfOver) !== null && _b !== void 0 ? _b : progress.getAttribute("data-limit")) !== null && _c !== void 0 ? _c : 0);
                if (!Number.isFinite(limit) || limit <= 0) return 0;
                return Number(totalCV) * 100 / limit;
            };
            _this.getCustomersRank = function() {
                var rank = "";
                var wrapperEl = document.querySelectorAll(".lbr_consultant-discount-main-wrp_JS");
                var rankLevels = window.rankLevels;
                if (!rankLevels || !Array.isArray(rankLevels.ranks)) {
                    return rank;
                }
                if (wrapperEl === null || wrapperEl === void 0 ? void 0 : wrapperEl.length) {
                    wrapperEl.forEach(function(wrp) {
                        var tagsString = (wrp === null || wrp === void 0 ? void 0 : wrp.getAttribute("data-customer-tags")) || "";
                        var tagArray = tagsString.split(",").map(function(tag) {
                            return tag.trim();
                        }).filter(Boolean);
                        var matches = _this.findMatchingRanks(tagArray, rankLevels);
                        var match = matches.length > 0 ? matches[matches.length - 1] : null;
                        if (match === null || match === void 0 ? void 0 : match.title) {
                            rank = match.title;
                        }
                    });
                }
                return rank;
            };
            _this.findMatchingRanks = function(titlesToCheck, rankData) {
                if (!rankData || !Array.isArray(rankData.ranks)) {
                    return [];
                }
                var titleArray = Array.isArray(titlesToCheck) ? titlesToCheck : [ titlesToCheck ];
                var normalizedSet = new Set(titleArray.map(function(t) {
                    return String(t || "").toLowerCase().trim();
                }).filter(Boolean));
                return rankData.ranks.filter(function(r) {
                    var lcTitle = String(r.title || "").toLowerCase().trim();
                    return normalizedSet.has(lcTitle) || normalizedSet.has("rank[".concat(lcTitle, "]"));
                });
            };
            _this.getDataByRankName = function(data, rankName) {
                var _a;
                var match = (_a = data === null || data === void 0 ? void 0 : data.ranks) === null || _a === void 0 ? void 0 : _a.find(function(r) {
                    return r.title === rankName;
                });
                if (!match) {
                    console.warn('Rank "'.concat(rankName, '" not found.'));
                    return null;
                }
                var id = match.id, title = match.title, personallySponsoredQualifiedLines = match.personallySponsoredQualifiedLines, groupVolume = match.groupVolume, commission = match.commission, discountOn150Plus = match.discountOn150Plus, sponsoringBonus = match.sponsoringBonus, cashPromotionBonus = match.cashPromotionBonus;
                return {
                    id: id,
                    title: title,
                    personallySponsoredQualifiedLines: personallySponsoredQualifiedLines,
                    groupVolume: groupVolume,
                    commission: commission,
                    discountOn150Plus: discountOn150Plus,
                    sponsoringBonus: sponsoringBonus,
                    cashPromotionBonus: cashPromotionBonus
                };
            };
            _this.safeRefresh = function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var bannerRoot, e_1;
                    return __generator(this, function(_a) {
                        switch (_a.label) {
                          case 0:
                            if (this._isRefreshing) return [ 2 ];
                            this._isRefreshing = true;
                            _a.label = 1;

                          case 1:
                            _a.trys.push([ 1, 4, 5, 6 ]);
                            bannerRoot = document.querySelector(".lbr_consultant-discount-main-wrp_JS");
                            if (!bannerRoot) {
                                this._isRefreshing = false;
                                return [ 2 ];
                            }
                            return [ 4, this.progressBar() ];

                          case 2:
                            _a.sent();
                            return [ 4, this.writeIntoBanner() ];

                          case 3:
                            _a.sent();
                            return [ 3, 6 ];

                          case 4:
                            e_1 = _a.sent();
                            console.error("[ConsultantDiscountBanner] Failed to refresh banner", e_1);
                            return [ 3, 6 ];

                          case 5:
                            this._isRefreshing = false;
                            return [ 7 ];

                          case 6:
                            return [ 2 ];
                        }
                    });
                });
            };
            _this.generalMethods = generalMethods;
            _this.cart = cart;
            return _this;
        }
        Object.defineProperty(StConsultantDiscountBanner.prototype, "storefrontToken", {
            get: function() {
                var storefrontKey = window.storefrontKey;
                return storefrontKey;
            },
            enumerable: false,
            configurable: true
        });
        StConsultantDiscountBanner.prototype.getCartCVTotal = function() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function() {
                var items, cvItems, variantIds, total;
                var _this = this;
                return __generator(this, function(_c) {
                    switch (_c.label) {
                      case 0:
                        items = (_b = (_a = this.cart.getShopifyCartData) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
                        if (!Array.isArray(items) || items.length === 0) {
                            return [ 2, 0 ];
                        }
                        cvItems = items.filter(function(item) {
                            if (!item) return false;
                            if (_this.isSampleItem(item)) return false;
                            if (_this.isFreeGift(item)) return false;
                            return _this.getVariantId(item) !== null;
                        });
                        if (cvItems.length === 0) {
                            return [ 2, 0 ];
                        }
                        variantIds = Array.from(new Set(cvItems.map(function(item) {
                            return _this.getVariantId(item);
                        })));
                        return [ 4, this.ensureVariantCVsLoaded(variantIds) ];

                      case 1:
                        _c.sent();
                        total = cvItems.reduce(function(sum, item) {
                            var _a;
                            var vid = _this.getVariantId(item);
                            if (vid === null) return sum;
                            var cvPerUnit = (_a = _this.variantCvCache.get(vid)) !== null && _a !== void 0 ? _a : 0;
                            var qty = Number(item.quantity || 0);
                            return sum + cvPerUnit * qty;
                        }, 0);
                        return [ 2, Number(total.toFixed(2)) ];
                    }
                });
            });
        };
        StConsultantDiscountBanner.prototype.ensureVariantCVsLoaded = function(variantIds) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function() {
                var idsToFetch, ids, query, res, _e, _f, _g, json, nodes, _i, nodes_1, node, rawId, cv, e_2;
                var _this = this;
                return __generator(this, function(_h) {
                    switch (_h.label) {
                      case 0:
                        idsToFetch = variantIds.filter(function(id) {
                            return Number.isFinite(id) && !_this.variantCvCache.has(id);
                        });
                        if (idsToFetch.length === 0) return [ 2 ];
                        ids = idsToFetch.map(function(id) {
                            return "gid://shopify/ProductVariant/".concat(id);
                        });
                        query = "\n          query VariantCV($ids: [ID!]!, $ns: String!, $key: String!) {\n            nodes(ids: $ids) {\n              ... on ProductVariant {\n                id\n                metafield(namespace: $ns, key: $key) { value }\n              }\n            }\n          }\n        ";
                        _h.label = 1;

                      case 1:
                        _h.trys.push([ 1, 6, , 7 ]);
                        return [ 4, fetch("/api/".concat(StConsultantDiscountBanner.SF_API_VERSION, "/graphql.json"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": this.storefrontToken || ""
                            },
                            body: JSON.stringify({
                                query: query,
                                variables: {
                                    ids: ids,
                                    ns: StConsultantDiscountBanner.CV_META_NAMESPACE,
                                    key: StConsultantDiscountBanner.CV_META_KEY
                                }
                            })
                        }) ];

                      case 2:
                        res = _h.sent();
                        if (!!res.ok) return [ 3, 4 ];
                        _f = (_e = console).error;
                        _g = [ "[CV] Storefront GraphQL error:", res.status ];
                        return [ 4, res.text() ];

                      case 3:
                        _f.apply(_e, _g.concat([ _h.sent() ]));
                        idsToFetch.forEach(function(id) {
                            return _this.variantCvCache.set(id, 0);
                        });
                        return [ 2 ];

                      case 4:
                        return [ 4, res.json() ];

                      case 5:
                        json = _h.sent();
                        nodes = (_b = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : [];
                        if (!Array.isArray(nodes)) {
                            console.warn("[CV] Unexpected nodes format", nodes);
                            idsToFetch.forEach(function(id) {
                                return _this.variantCvCache.set(id, 0);
                            });
                            return [ 2 ];
                        }
                        for (_i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
                            node = nodes_1[_i];
                            if (!node) continue;
                            rawId = Number(String((node === null || node === void 0 ? void 0 : node.id) || "").split("/").pop());
                            cv = Number.parseFloat((_d = (_c = node === null || node === void 0 ? void 0 : node.metafield) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "0");
                            if (Number.isFinite(rawId)) this.variantCvCache.set(rawId, Number.isFinite(cv) ? cv : 0);
                        }
                        return [ 3, 7 ];

                      case 6:
                        e_2 = _h.sent();
                        console.error("[CV] Failed to load variant CVs:", e_2);
                        idsToFetch.forEach(function(id) {
                            return _this.variantCvCache.set(id, 0);
                        });
                        return [ 3, 7 ];

                      case 7:
                        return [ 2 ];
                    }
                });
            });
        };
        StConsultantDiscountBanner.prototype.writeIntoBanner = function() {
            var _a, _b, _c, _d, _e;
            return __awaiter(this, void 0, void 0, function() {
                var rankLevels, rankName, percentage, totalCV, reachCV, need, subtitleEl, consultant_achieved;
                return __generator(this, function(_f) {
                    switch (_f.label) {
                      case 0:
                        rankLevels = window.rankLevels;
                        (_a = document.querySelectorAll(".lbr_consultant-discount-reach_JS")) === null || _a === void 0 ? void 0 : _a.forEach(function(el) {
                            var _a;
                            el.innerHTML = "$" + ((_a = rankLevels === null || rankLevels === void 0 ? void 0 : rankLevels.discounfOver) !== null && _a !== void 0 ? _a : "");
                        });
                        rankName = this.getCustomersRank();
                        percentage = (_b = this.getDataByRankName(rankLevels, rankName)) === null || _b === void 0 ? void 0 : _b.discountOn150Plus;
                        console.log("rankName rankName ", rankName);
                        console.log("percentage percentage ", percentage);
                        console.log("getDataByRankName getDataByRankName ", this.getDataByRankName(rankLevels, rankName));
                        (_c = document.querySelectorAll(".lbr_consultant-discount-get_JS")) === null || _c === void 0 ? void 0 : _c.forEach(function(el) {
                            el.innerHTML = "".concat(percentage !== null && percentage !== void 0 ? percentage : 0, "%");
                        });
                        return [ 4, this.getCartCVTotal() ];

                      case 1:
                        totalCV = _f.sent();
                        this._lastTotalCV = totalCV;
                        reachCV = Number((_d = rankLevels === null || rankLevels === void 0 ? void 0 : rankLevels.discounfOver) !== null && _d !== void 0 ? _d : 0);
                        need = Math.max(0, reachCV - totalCV);
                        subtitleEl = document.querySelector(".lbr_consultant-discount-subtitle-wrp");
                        if (totalCV >= reachCV) {
                            consultant_achieved = (_e = window.stTranslations) === null || _e === void 0 ? void 0 : _e.consultant_achieved;
                            if (subtitleEl && consultant_achieved) {
                                subtitleEl.innerHTML = consultant_achieved;
                            }
                            return [ 2 ];
                        }
                        if (subtitleEl) {
                            subtitleEl.innerHTML = 'Just <span class="lbr_consultant-discount-missing_JS">$'.concat(need.toFixed(2), "</span> in retail volume to go");
                        }
                        return [ 2 ];
                    }
                });
            });
        };
        StConsultantDiscountBanner.prototype.isSampleItem = function(item) {
            var _a;
            var flag = (_a = item === null || item === void 0 ? void 0 : item.properties) === null || _a === void 0 ? void 0 : _a._isFreeSample;
            return flag === true || flag === "true";
        };
        StConsultantDiscountBanner.prototype.getItemPrice = function(item) {
            var _a, _b, _c;
            return Number((_c = (_b = (_a = item === null || item === void 0 ? void 0 : item.price) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.line_price) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.original_price) !== null && _c !== void 0 ? _c : 0);
        };
        StConsultantDiscountBanner.prototype.isFreeGift = function(item) {
            return this.getItemPrice(item) === 0;
        };
        StConsultantDiscountBanner.prototype.getVariantId = function(item) {
            var _a;
            var id = Number((_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.variant_id);
            return Number.isFinite(id) ? id : null;
        };
        StConsultantDiscountBanner.CV_META_NAMESPACE = "global";
        StConsultantDiscountBanner.CV_META_KEY = _features_config_17.productVolumesConfig.cvMetafieldKey;
        StConsultantDiscountBanner.SF_API_VERSION = _features_config_17.STORE_FRONT_API_VERSION;
        return StConsultantDiscountBanner;
    }(st_module_82.StModule);
    exports.StConsultantDiscountBanner = StConsultantDiscountBanner;
});

define("extension/shopify-app/st-modules/newsletter-popup/newsletter-popup", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_83) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StNewsletterPopup = void 0;
    var StNewsletterPopup = function(_super) {
        __extends(StNewsletterPopup, _super);
        function StNewsletterPopup() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StNewsletterPopup";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this._handlePopup();
                });
            };
            _this._handlePopup = function() {
                var popup = document.querySelector(".newsletter-popup_JS");
                var closeBtn = document.querySelector(".close-popup_JS");
                var form = document.querySelector(".newsletter-form_JS");
                var formWrapper = document.querySelector(".popup-form-wrapper_JS");
                var thankYouMessage = document.querySelector(".thank-you-message_JS");
                var urlParams = new URLSearchParams(window.location.search);
                var als = urlParams.get("als");
                var alreadySubscribed = localStorage.getItem("newsletterPopupShown");
                if (!als || als === "400560" || als.toLowerCase() === "lbricorp") {
                    if (alreadySubscribed === "true") {
                        popup === null || popup === void 0 ? void 0 : popup.classList.add("st_hidden");
                        return;
                    }
                    popup === null || popup === void 0 ? void 0 : popup.classList.remove("st_hidden");
                    closeBtn === null || closeBtn === void 0 ? void 0 : closeBtn.addEventListener("click", function() {
                        localStorage.setItem("newsletterPopupShown", "true");
                        popup.classList.add("st_hidden");
                        formWrapper.classList.remove("st_hidden");
                        thankYouMessage.classList.add("st_hidden");
                    });
                    form === null || form === void 0 ? void 0 : form.addEventListener("submit", function(e) {
                        e.preventDefault();
                        var emailInput = form.querySelector("input[name='contact[email]']");
                        var email = emailInput.value.trim();
                        if (!email || !email.includes("@")) {
                            alert("Please enter a valid email address.");
                            return;
                        }
                        var formData = new FormData(form);
                        fetch("/contact", {
                            method: "POST",
                            body: formData
                        }).then(function() {
                            localStorage.setItem("newsletterPopupShown", "true");
                            formWrapper.classList.add("st_hidden");
                            thankYouMessage.classList.remove("st_hidden");
                            form.reset();
                            history.replaceState(null, "", window.location.pathname + window.location.search);
                        }).catch(function() {
                            alert("Something went wrong. Please try again.");
                        });
                    });
                }
            };
            return _this;
        }
        return StNewsletterPopup;
    }(st_module_83.StModule);
    exports.StNewsletterPopup = StNewsletterPopup;
});

define("extension/shopify-app/st-modules/catalog-page/product-category", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_84) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StCatalogPage = void 0;
    var StCatalogPage = function(_super) {
        __extends(StCatalogPage, _super);
        function StCatalogPage(objectFormatting) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "CatalogPage";
            _this.mql = null;
            _this.collapsibleWired = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    var _a, _b;
                    _this.rememberOpenOnLink();
                    _this.configureForMode();
                    _this.mql = window.matchMedia("(min-width: 992px)");
                    (_b = (_a = _this.mql).addEventListener) === null || _b === void 0 ? void 0 : _b.call(_a, "change", _this.configureForMode);
                });
            };
            _this.configureForMode = function() {
                if (_this.isDesktop()) {
                    _this.wireCollapsible();
                    _this.restoreOpenState();
                    _this.ensureOpenWhenActive();
                } else {
                    _this.closeAll();
                }
            };
            _this.objectFormatting = objectFormatting;
            return _this;
        }
        StCatalogPage.prototype.isDesktop = function() {
            return window.matchMedia("(min-width: 992px)").matches;
        };
        StCatalogPage.prototype.getSidebarEl = function() {
            return document.querySelector(".lbri-cat-sidebar");
        };
        StCatalogPage.prototype.getGroups = function(host) {
            return host.querySelectorAll(".lbri-cat-group[data-handle]");
        };
        StCatalogPage.prototype.open = function(g, yes) {
            g.classList.toggle("is-open", yes);
            var btn = g.querySelector(".lbri-cat-group__toggle");
            if (btn) btn.setAttribute("aria-expanded", yes ? "true" : "false");
        };
        StCatalogPage.prototype.closeAll = function() {
            var _this = this;
            var host = this.getSidebarEl();
            if (!host) return;
            this.getGroups(host).forEach(function(g) {
                return _this.open(g, false);
            });
        };
        StCatalogPage.prototype.wireCollapsible = function() {
            var _this = this;
            var host = this.getSidebarEl();
            if (!host || this.collapsibleWired) return;
            this.collapsibleWired = true;
            host.addEventListener("click", function(ev) {
                var toggle = ev.target.closest(".lbri-cat-group__toggle");
                if (!toggle) return;
                ev.preventDefault();
                var group = toggle.closest(".lbri-cat-group");
                if (!group) return;
                var groups = _this.getGroups(host);
                var willOpen = !group.classList.contains("is-open");
                if (willOpen) {
                    groups.forEach(function(g) {
                        if (g !== group) {
                            _this.open(g, false);
                            try {
                                localStorage.setItem("lbriCatOpen:".concat(g.dataset.handle || ""), "0");
                            } catch (_a) {}
                        }
                    });
                }
                _this.open(group, willOpen);
                try {
                    localStorage.setItem("lbriCatOpen:".concat(group.dataset.handle || ""), willOpen ? "1" : "0");
                } catch (_a) {}
            });
        };
        StCatalogPage.prototype.rememberOpenOnLink = function() {
            var _this = this;
            var host = this.getSidebarEl();
            if (!host) return;
            var links = host.querySelectorAll(".lbri-cat-group__link, .lbri-cat-group__head--link, .lbri-cat-sub__link");
            links.forEach(function(a) {
                a.addEventListener("click", function() {
                    var parent = a.closest(".lbri-cat-group");
                    if (!parent) return;
                    _this.getGroups(host).forEach(function(g) {
                        try {
                            localStorage.setItem("lbriCatOpen:".concat(g.dataset.handle || ""), "0");
                        } catch (_a) {}
                    });
                    var handle = parent.dataset.handle || "";
                    var hasSubs = parent.dataset.hasSubs === "1";
                    try {
                        localStorage.setItem("lbriCatOpen:".concat(handle), hasSubs ? "1" : "0");
                    } catch (_a) {}
                });
            });
        };
        StCatalogPage.prototype.restoreOpenState = function() {
            var _this = this;
            var host = this.getSidebarEl();
            if (!host) return;
            var groups = Array.from(this.getGroups(host));
            var forced = groups.find(function(g) {
                return g.dataset.forceOpen === "1";
            });
            if (forced) {
                groups.forEach(function(g) {
                    return _this.open(g, g === forced);
                });
                try {
                    localStorage.setItem("lbriCatOpen:".concat(forced.dataset.handle || ""), "1");
                } catch (_a) {}
                return;
            }
            var opened = false;
            groups.forEach(function(g) {
                var wantOpen = false;
                try {
                    wantOpen = localStorage.getItem("lbriCatOpen:".concat(g.dataset.handle || "")) === "1";
                } catch (_a) {}
                if (wantOpen && !opened) {
                    _this.open(g, true);
                    opened = true;
                } else {
                    _this.open(g, false);
                }
            });
        };
        StCatalogPage.prototype.ensureOpenWhenActive = function() {
            var _this = this;
            var host = this.getSidebarEl();
            if (!host) return;
            var groups = Array.from(this.getGroups(host));
            var withActiveChild = groups.find(function(g) {
                return !!g.querySelector(".lbri-cat-sub__item.is-active");
            });
            if (withActiveChild) {
                groups.forEach(function(g) {
                    return _this.open(g, g === withActiveChild);
                });
                try {
                    localStorage.setItem("lbriCatOpen:".concat(withActiveChild.dataset.handle || ""), "1");
                } catch (_a) {}
            }
        };
        return StCatalogPage;
    }(st_module_84.StModule);
    exports.StCatalogPage = StCatalogPage;
});

define("extension/shopify-app/st-modules/account/header/nav/account-nav.extended", [ "require", "exports", "core/shopify-app/st-modules/account/header/nav/account-nav", "core/connector-app/_shared/models/auth/auth.request.model" ], function(require, exports, account_nav_1, auth_request_model_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountNavExtended = void 0;
    var StAccountNavExtended = function(_super) {
        __extends(StAccountNavExtended, _super);
        function StAccountNavExtended(classConfig, objectFormatting, browserHistory, generalMethods, cartComponent) {
            var _this_1 = _super.call(this, classConfig, objectFormatting, browserHistory, generalMethods) || this;
            _this_1.className = "AccountNavExtended";
            _this_1.logout = function() {
                var _this = _this_1;
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var logoutBtns = wrp.querySelectorAll(_this_1.classConfig.selectorAccountLogout);
                _this_1.removeTokens();
                window.localStorage.setItem("customerCartSaved", "false");
                window.localStorage.setItem("customerCartSaved", "false");
                if (!!logoutBtns) {
                    logoutBtns.forEach(function(btn) {
                        btn.addEventListener("click", function(e) {
                            e.preventDefault();
                            try {
                                var current = localStorage.getItem("customerCartSaved");
                                console.log("current  current current ", current);
                                if (current !== null) {
                                    localStorage.setItem("customerCartSaved", "false");
                                } else {
                                    localStorage.setItem("customerCartSaved", "false");
                                }
                            } catch (err) {
                                console.warn("Failed to reset customerCartSaved flag", err);
                            }
                            _this.cartComponent.removeFreeSamplesFromCart(false, function() {
                                window.location.assign(window.location.protocol + "//" + window.location.hostname + "/account/logout");
                            });
                        });
                    });
                }
            };
            _this_1.openPage = function(pageIndex) {
                var wrp = document.querySelector(_this_1.classConfig.selectorAccountPage);
                var alreadyOpen = wrp.querySelector(_this_1.classConfig.selectorAccountSection + ".st_show");
                var accountSections = wrp.querySelectorAll(_this_1.classConfig.selectorAccountSection);
                if (typeof pageIndex === "undefined") {
                    var urlParams = _this_1.objectFormatting.convertQueryStringToObject(window.location.search);
                    var maxTab = accountSections.length - 1;
                    var tabIndex = urlParams.tab ? parseInt(urlParams.tab) : 0;
                    pageIndex = isNaN(tabIndex) ? 0 : tabIndex;
                    pageIndex = tabIndex > maxTab ? maxTab : tabIndex;
                }
                var navHolder = wrp.querySelector(_this_1.classConfig.selectorAccountNavHolder);
                var AccountNavElements = navHolder.querySelectorAll(_this_1.classConfig.selectorAccountNavHolderSingle);
                if (!!alreadyOpen) {
                    alreadyOpen.classList.remove("st_show");
                }
                if (accountSections.length > pageIndex) {
                    accountSections[pageIndex].classList.add("st_show");
                } else {
                    console.error("Invalid page index supplied to Account nav openPage method!");
                }
                var activeSection = accountSections[pageIndex];
                if (activeSection) {
                    _this_1.scrollToTarget(activeSection);
                }
                AccountNavElements.forEach(function(navElement, index) {
                    navElement.classList.remove("current");
                    if (index === pageIndex) {
                        _this_1.updateTabToUrl("" + pageIndex);
                        navElement.classList.add("current");
                    }
                });
            };
            _this_1.getStickyHeaderOffset = function() {
                var selectors = [ ".shopify-section-header-sticky", ".site-header", "header.sticky-header", ".header--sticky" ];
                for (var _i = 0, selectors_1 = selectors; _i < selectors_1.length; _i++) {
                    var sel = selectors_1[_i];
                    var el = document.querySelector(sel);
                    if (el) return el.offsetHeight || 0;
                }
                return 0;
            };
            _this_1.scrollToTarget = function(el, extraOffset) {
                if (extraOffset === void 0) {
                    extraOffset = 0;
                }
                if (!el) return;
                var rect = el.getBoundingClientRect();
                var pageY = window.pageYOffset + rect.top;
                var offset = _this_1.getStickyHeaderOffset() + extraOffset;
                window.scrollTo({
                    top: Math.max(0, pageY - offset - 8),
                    behavior: "smooth"
                });
            };
            _this_1.removeTokens = function() {
                var token = window.localStorage.getItem(auth_request_model_4.ETokenType.Access);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_4.ETokenType.Access);
                token = window.localStorage.getItem(auth_request_model_4.ETokenType.Refresh);
                if (!!token && token.length > 0) window.localStorage.removeItem(auth_request_model_4.ETokenType.Refresh);
            };
            _this_1.classConfig = classConfig;
            _this_1.objectFormatting = objectFormatting;
            _this_1.browserHistory = browserHistory;
            _this_1.generalMethods = generalMethods;
            _this_1.cartComponent = cartComponent;
            return _this_1;
        }
        return StAccountNavExtended;
    }(account_nav_1.StAccountNav);
    exports.StAccountNavExtended = StAccountNavExtended;
});

define("extension/shopify-app/st-modules/account/blocks/order-history/order-params", [ "require", "exports" ], function(require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
});

define("extension/shopify-app/st-modules/account/blocks/order-history/order-history-extend", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/order-history/order-history" ], function(require, exports, order_history_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountOrderHistoryExtended = void 0;
    var StAccountOrderHistoryExtended = function(_super) {
        __extends(StAccountOrderHistoryExtended, _super);
        function StAccountOrderHistoryExtended(cfg, gm) {
            var _this_1 = _super.call(this, cfg, gm) || this;
            _this_1.className = "AccountOrderHistoryExtended";
            _this_1.bdtOrders = [];
            _this_1.downloadHandlerBound = false;
            _this_1.pageSize = 5;
            _this_1.currentPage = 1;
            _this_1.paginationBound = false;
            _this_1.init = function() {
                _this_1.subscribeDOMLoaded(function() {
                    _this_1.getOrdersFromBDT();
                    _this_1.downloadInvoice();
                    _this_1.observeOrdersSectionVisibility();
                });
            };
            _this_1.getOrdersFromBDT = function() {
                var _a;
                var _this = _this_1;
                var customerId = Number((_a = window === null || window === void 0 ? void 0 : window.customerInfoMetafields) === null || _a === void 0 ? void 0 : _a.customerId);
                if (!customerId) {
                    console.error("Missing customerId in window.customerInfoMetafields");
                    return;
                }
                var shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
                if (!shopifyCustomerId) {
                    console.error("Missing shopifyCustomerId in window");
                    return;
                }
                var consultantRetailId = window === null || window === void 0 ? void 0 : window.consultantRetailId;
                if (consultantRetailId) {
                    customerId = consultantRetailId;
                }
                var listEndpoint = _this.endpoint["order"]["orders-from-bdt"];
                if (!listEndpoint) {
                    console.error("orders-from-bdt endpoint not found");
                    return;
                }
                _this_1.toggleOrdersLoader(true);
                _this_1.ajax.send({
                    endpoint: listEndpoint,
                    method: "POST",
                    contentType: "json",
                    data: {
                        customerId: customerId,
                        shopifyCustomerId: shopifyCustomerId
                    },
                    callback: function(res) {
                        var _a;
                        try {
                            var resp = JSON.parse(res.response);
                            if (resp.status === 200) {
                                _this_1.bdtOrders = ((_a = resp.data) !== null && _a !== void 0 ? _a : []).slice();
                                _this_1.currentPage = 1;
                                _this_1.renderOrdersFromBDT(_this_1.getPagedOrders());
                                _this_1.renderPagination();
                                _this_1.bindPaginationHandlers();
                                _this_1.openSingleOrder();
                                _this_1.backToHistoryOrders();
                            } else {
                                _this_1.renderOrdersFromBDT([]);
                                _this_1.renderPagination();
                            }
                        } catch (e) {
                            console.error("Parse error:", e);
                            _this_1.renderOrdersFromBDT([]);
                        } finally {
                            _this_1.toggleOrdersLoader(false);
                        }
                    }
                });
            };
            _this_1.openSingleOrder = function() {
                var _this = _this_1;
                var triggers = document.querySelectorAll(_this.classConfig.selectorOpenSingleOrderButton);
                triggers.forEach(function(el) {
                    el.addEventListener("click", function(e) {
                        e.preventDefault();
                        var orderIdStr = el.getAttribute("data-order-id") || "0";
                        var orderId = Number(orderIdStr);
                        var totalPrice = Number(el.getAttribute("data-total-price") || "0");
                        var description = el.getAttribute("data-description") || "";
                        var orderWrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        orderWrapper.classList.add(_this.classConfig.classNameOpenOrderCSSClass);
                        var single = orderWrapper.querySelector(_this.classConfig.selectorSingleOrder + '[data-order-id="'.concat(orderIdStr, '"]'));
                        if (single) {
                            single.style.display = "block";
                            var singleOrder = single.querySelector(".bdt-order-status");
                            if (singleOrder) singleOrder.textContent = description || "";
                            var t = single.querySelector(".bdt-total");
                            if (t) t.textContent = _this.formatMoney(totalPrice || 0);
                            _this.fetchAndFillOrderDetails(orderId, single, totalPrice, description);
                        }
                    });
                });
            };
            _this_1.backToHistoryOrders = function() {
                var _this = _this_1;
                var backs = document.querySelectorAll(_this.classConfig.selectorBackToHistoryOrders);
                backs.forEach(function(btn) {
                    btn.addEventListener("click", function(e) {
                        e.preventDefault();
                        var single = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameSingleOrder);
                        if (single) single.style.display = "none";
                        var wrapper = _this.generalMethods.getClosestByClass(this, _this.classConfig.classNameOrderHistory);
                        wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove(_this.classConfig.classNameOpenOrderCSSClass);
                    });
                });
            };
            _this_1.downloadInvoice = function() {
                if (_this_1.downloadHandlerBound) return;
                _this_1.downloadHandlerBound = true;
                document.addEventListener("click", function(e) {
                    return _this_1.handleInvoiceClick(e);
                });
            };
            _this_1.classConfig = cfg;
            _this_1.generalMethods = gm;
            return _this_1;
        }
        StAccountOrderHistoryExtended.prototype.renderOrdersFromBDT = function(bdtOrders) {
            var _this_1 = this;
            var _a;
            var content = document.querySelector(".st_orders--content");
            if (!content) return;
            content.querySelectorAll(".st_orders--row, .st_single-order_JS, .st_single-order").forEach(function(n) {
                return n.remove();
            });
            if (!bdtOrders || !bdtOrders.length) {
                var empty = content.querySelector(".st_order-title");
                if (!empty) {
                    empty = document.createElement("div");
                    empty.className = "st_order-title";
                    content.appendChild(empty);
                }
                empty.innerHTML = "<i>".concat(this.translateNone(), "</i>");
                return;
            } else {
                (_a = content.querySelector(".st_order-title")) === null || _a === void 0 ? void 0 : _a.remove();
            }
            var tpl = document.getElementById("bdt-single-order-template");
            if (!tpl) {
                console.error("bdt-single-order-template missing");
                return;
            }
            var frag = document.createDocumentFragment();
            bdtOrders.forEach(function(o) {
                var _a, _b, _c;
                var btn = document.createElement("button");
                btn.className = "st_orders--row st_orders--main-row st_flex st_align " + _this_1.classConfig.classNameOpenSingleOrderButton;
                btn.type = "button";
                btn.setAttribute("data-order-id", String(o.orderId));
                btn.setAttribute("data-total-price", String((_a = o.totalPrice) !== null && _a !== void 0 ? _a : 0));
                btn.setAttribute("data-description", (_b = o.description) !== null && _b !== void 0 ? _b : "");
                btn.innerHTML = '\n        <span class="st_col st_id">#'.concat(o.orderId, '</span>\n        <span class="st_col">').concat(_this_1.formatMMMddYYYY(o.orderDate), '</span>\n        <span class="st_col st_order-change">').concat(o.description || "", '</span>\n        <span class="st_col st_align-variation"><span class="money">').concat(_this_1.formatMoney(o.totalPrice), "</span></span>\n      ");
                var node = ((_c = tpl.content) !== null && _c !== void 0 ? _c : tpl).cloneNode(true);
                var single = node.querySelector(".st_single-order");
                single.setAttribute("data-order-id", String(o.orderId));
                var idEl = single.querySelector(".bdt-order-id");
                if (idEl) idEl.textContent = "#".concat(o.orderId);
                var dateEl = single.querySelector(".bdt-order-date");
                if (dateEl) dateEl.textContent = _this_1.formatMMMddYYYY(o.orderDate);
                var singleOrderStatus = single.querySelector(".bdt-order-status");
                if (singleOrderStatus) singleOrderStatus.textContent = o.description || "";
                var singleOrderTotal = single.querySelector(".bdt-total");
                if (singleOrderTotal) singleOrderTotal.textContent = _this_1.formatMoney(o.totalPrice);
                var contentFrag = document.createDocumentFragment();
                contentFrag.appendChild(btn);
                contentFrag.appendChild(single);
                frag.appendChild(contentFrag);
            });
            content.appendChild(frag);
        };
        StAccountOrderHistoryExtended.prototype.fetchAndFillOrderDetails = function(orderId, container, totalPrice, description) {
            var _this_1 = this;
            var _this = this;
            var detailsEndpoint = _this.endpoint["order"]["orders-details-from-bdt"];
            if (!detailsEndpoint) {
                console.error("orders-details-from-bdt endpoint not found");
                return;
            }
            var shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
            if (!shopifyCustomerId) {
                console.error("Missing shopifyCustomerId in window");
                return;
            }
            this.toggleSingleOrderLoading(container, true);
            this.ajax.send({
                endpoint: detailsEndpoint,
                method: "POST",
                contentType: "json",
                data: {
                    orderId: orderId,
                    totalPrice: totalPrice,
                    description: description,
                    shopifyCustomerId: shopifyCustomerId
                },
                callback: function(res) {
                    try {
                        var resp = JSON.parse(res.response);
                        if (resp.status === 200 && resp.data) {
                            var data = resp.data;
                            var idEl = container.querySelector(".bdt-order-id");
                            if (idEl) idEl.textContent = "#".concat(data.orderId);
                            var dateEl = container.querySelector(".bdt-order-date");
                            if (dateEl && data.orderDate) dateEl.textContent = _this_1.formatMMMddYYYY(data.orderDate);
                            var shipName = container.querySelector(".bdt-ship-name");
                            if (shipName) shipName.textContent = data.shipName || "";
                            var shipStreet = container.querySelector(".bdt-ship-street");
                            if (shipStreet) shipStreet.textContent = data.shipStreet || "";
                            var shipCity = container.querySelector(".bdt-ship-city");
                            if (shipCity) shipCity.textContent = data.shipCity || "";
                            var shipState = container.querySelector(".bdt-ship-state");
                            if (shipState) shipState.textContent = data.shipState || "";
                            var shipPostal = container.querySelector(".bdt-ship-postal");
                            if (shipPostal) shipPostal.textContent = data.shipPostalCode || "";
                            var shipCountry = container.querySelector(".bdt-ship-country");
                            if (shipCountry) shipCountry.textContent = data.shipCountry || "";
                            var consultant = container.querySelector(".bdt-consultant");
                            if (consultant) {
                                var first = data.repFirstName || "";
                                var last = data.repLastName || "";
                                var full = [ first, last ].filter(Boolean).join(" ");
                                consultant.textContent = full;
                            }
                            var subEl = container.querySelector(".bdt-subtotal");
                            if (subEl) subEl.textContent = _this_1.formatMoney(data.subtotal || 0);
                            var shipEl = container.querySelector(".bdt-shipping");
                            if (shipEl) shipEl.textContent = _this_1.formatMoney(data.shippingPrice || 0);
                            var totalEl = container.querySelector(".bdt-total");
                            if (totalEl) totalEl.textContent = _this_1.formatMoney(data.totalPrice);
                            var taxEl = container.querySelector(".bdt-total-tax");
                            if (taxEl) taxEl.textContent = _this_1.formatMoney(data.totalTax || 0);
                            var itemsWrap_1 = container.querySelector(".bdt-lineitems");
                            var rowTpl_1 = document.getElementById("bdt-lineitem-template");
                            if (itemsWrap_1) {
                                itemsWrap_1.innerHTML = "";
                                if (rowTpl_1 && Array.isArray(data.lineItems)) {
                                    data.lineItems.forEach(function(li) {
                                        var _a;
                                        var frag = ((_a = rowTpl_1.content) !== null && _a !== void 0 ? _a : rowTpl_1).cloneNode(true);
                                        var nameElement = frag.querySelector(".bdt-li-name");
                                        if (nameElement) nameElement.textContent = li.productName || "";
                                        var sku = frag.querySelector(".bdt-li-sku");
                                        if (sku) sku.textContent = li.sku || "";
                                        var price = frag.querySelector(".bdt-li-price");
                                        if (price) price.textContent = _this_1.formatMoney(li.price || 0);
                                        var qty = frag.querySelector(".bdt-li-qty");
                                        if (qty) qty.textContent = String(li.quantity || 0);
                                        var tot = frag.querySelector(".bdt-li-total");
                                        if (tot) tot.textContent = _this_1.formatMoney(li.total || 0);
                                        itemsWrap_1.appendChild(frag);
                                    });
                                }
                            }
                            _this_1.fillPartyInfo(container, data.partyId, data.partyHostName);
                        } else {
                            _this_1.showSingleOrderError(container, "Failed to load order details.");
                        }
                    } catch (e) {
                        _this_1.showSingleOrderError(container, "Failed to parse order details.");
                    } finally {
                        _this_1.toggleSingleOrderLoading(container, false);
                    }
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.fillPartyInfo = function(container, partyId, partyHostName) {
            var wrap = container.querySelector(".st_party-info");
            if (!wrap) return;
            var isValidId = typeof partyId === "number" && partyId !== 0;
            var hasHost = false;
            if (Array.isArray(partyHostName)) {
                hasHost = partyHostName.filter(Boolean).length > 0;
            } else if (typeof partyHostName === "string") {
                hasHost = partyHostName.trim().length > 0;
            }
            var shouldShow = isValidId || hasHost;
            if (!shouldShow) {
                wrap.classList.add("st_hidden");
                return;
            }
            var idEl = container.querySelector(".bdt-party-id");
            var hostEl = container.querySelector(".bdt-party-host");
            if (idEl) {
                idEl.textContent = isValidId ? String(partyId) : "";
            }
            if (hostEl) {
                if (Array.isArray(partyHostName)) {
                    hostEl.textContent = partyHostName.join(", ");
                } else {
                    hostEl.textContent = hasHost ? String(partyHostName) : "";
                }
            }
            wrap.classList.remove("st_hidden");
        };
        StAccountOrderHistoryExtended.prototype.toggleOrdersLoader = function(show) {
            var el = document.querySelector(".lbri_load_orders_JS");
            if (el) el.classList.toggle("st_hidden", !show);
        };
        StAccountOrderHistoryExtended.prototype.toggleSingleOrderLoading = function(container, show) {
            var singleOrder = container.querySelector(".st_single-order__loading");
            if (!singleOrder) {
                singleOrder = document.createElement("div");
                singleOrder.className = "st_single-order__loading";
                singleOrder.innerHTML = "<em>Loading…</em>";
                container.appendChild(singleOrder);
            }
            singleOrder.classList.toggle("st_hidden", !show);
        };
        StAccountOrderHistoryExtended.prototype.formatMMMddYYYY = function(dateStr) {
            var date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";
            return date.toLocaleDateString(undefined, {
                month: "short",
                day: "2-digit",
                year: "numeric"
            });
        };
        StAccountOrderHistoryExtended.prototype.formatMoney = function(n) {
            var sign = n < 0 ? "-" : "";
            var abs = Math.abs(n);
            return "".concat(sign, "$").concat(abs.toFixed(2));
        };
        StAccountOrderHistoryExtended.prototype.translateNone = function() {
            return "You haven't placed any orders yet.";
        };
        StAccountOrderHistoryExtended.prototype.showSingleOrderError = function(container, message) {
            container.innerHTML = '<div class="st_order-title"><i>'.concat(message, "</i></div>");
        };
        StAccountOrderHistoryExtended.prototype.saveBlob = function(blob, fileName) {
            var url = URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        };
        StAccountOrderHistoryExtended.prototype.parseFilename = function(cd) {
            if (!cd) return null;
            var match1 = cd.match(/filename\*=(?:UTF-8''|)([^;]+)/i);
            if (match1 === null || match1 === void 0 ? void 0 : match1[1]) return decodeURIComponent(match1[1].replace(/["']/g, ""));
            var match2 = cd.match(/filename="?([^";]+)"?/i);
            return (match2 === null || match2 === void 0 ? void 0 : match2[1]) || null;
        };
        StAccountOrderHistoryExtended.prototype.getOrderContextFromTarget = function(target) {
            var _a;
            var btn = (_a = target === null || target === void 0 ? void 0 : target.closest) === null || _a === void 0 ? void 0 : _a.call(target, ".st_download_invoice_JS");
            if (!btn) return null;
            var container = this.generalMethods.getClosestByClass(btn, this.classConfig.classNameSingleOrder);
            var orderIdStr = (container === null || container === void 0 ? void 0 : container.getAttribute("data-order-id")) || "";
            var orderId = Number(orderIdStr);
            if (!orderId || !container) return null;
            return {
                container: container,
                orderId: orderId
            };
        };
        StAccountOrderHistoryExtended.prototype.ajaxPostPdfBlob = function(endpoint, data) {
            var _this_1 = this;
            return new Promise(function(resolve, reject) {
                var req = _this_1.ajax.send({
                    endpoint: endpoint,
                    method: "POST",
                    contentType: "json",
                    data: data,
                    callback: function(request) {
                        try {
                            if (request.status !== 200) {
                                return reject(new Error("HTTP ".concat(request.status)));
                            }
                            var blob = request.response;
                            if (!(blob instanceof Blob)) {
                                return reject(new Error("Expected Blob response (check responseType timing)."));
                            }
                            resolve({
                                blob: blob,
                                xhr: request
                            });
                        } catch (e) {
                            reject(e);
                        }
                    }
                });
                try {
                    req.responseType = "blob";
                    req.setRequestHeader("Accept", "application/pdf");
                } catch (e) {
                    console.error("Error download Invoice ", e);
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.handleInvoiceClick = function(e) {
            return __awaiter(this, void 0, void 0, function() {
                var endpoint, shopifyCustomerId, target, ctx, container, orderId, _a, blob, xhr, contentType, disposition, fileName, err_3;
                return __generator(this, function(_b) {
                    switch (_b.label) {
                      case 0:
                        endpoint = this.endpoint["order"]["order-invoice"];
                        if (!endpoint) {
                            console.error("order-invoice endpoint not found");
                            return [ 2 ];
                        }
                        shopifyCustomerId = Number(window === null || window === void 0 ? void 0 : window.customerShopifyId);
                        if (!shopifyCustomerId) {
                            console.error("Missing shopifyCustomerId in window");
                            return [ 2 ];
                        }
                        target = e.target;
                        ctx = this.getOrderContextFromTarget(target);
                        if (!ctx) return [ 2 ];
                        e.preventDefault();
                        container = ctx.container, orderId = ctx.orderId;
                        this.toggleSingleOrderLoading(container, true);
                        _b.label = 1;

                      case 1:
                        _b.trys.push([ 1, 3, 4, 5 ]);
                        this.toggleSingleOrderLoading(container, true);
                        return [ 4, this.ajaxPostPdfBlob(endpoint, {
                            orderId: orderId,
                            shopifyCustomerId: shopifyCustomerId
                        }) ];

                      case 2:
                        _a = _b.sent(), blob = _a.blob, xhr = _a.xhr;
                        contentType = xhr.getResponseHeader("content-type") || "";
                        if (!contentType.includes("application/pdf")) {
                            throw new Error("Unexpected content-type: ".concat(contentType));
                        }
                        disposition = xhr.getResponseHeader("Content-Disposition") || "";
                        fileName = this.parseFilename(disposition) || "invoice_".concat(orderId, ".pdf");
                        this.saveBlob(blob, fileName);
                        return [ 3, 5 ];

                      case 3:
                        err_3 = _b.sent();
                        console.error("Invoice download failed:", err_3);
                        this.showSingleOrderError(container, "Failed to download invoice.");
                        return [ 3, 5 ];

                      case 4:
                        this.toggleSingleOrderLoading(container, false);
                        return [ 7 ];

                      case 5:
                        return [ 2 ];
                    }
                });
            });
        };
        Object.defineProperty(StAccountOrderHistoryExtended.prototype, "totalPages", {
            get: function() {
                var _a, _b;
                return Math.max(1, Math.ceil(((_b = (_a = this.bdtOrders) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) / this.pageSize));
            },
            enumerable: false,
            configurable: true
        });
        StAccountOrderHistoryExtended.prototype.getPagedOrders = function() {
            var _a;
            var start = (this.currentPage - 1) * this.pageSize;
            return ((_a = this.bdtOrders) !== null && _a !== void 0 ? _a : []).slice(start, start + this.pageSize);
        };
        StAccountOrderHistoryExtended.prototype.goToPage = function(n) {
            var max = this.totalPages;
            var next = Math.min(max, Math.max(1, n));
            if (next === this.currentPage) return;
            this.currentPage = next;
            this.renderOrdersFromBDT(this.getPagedOrders());
            this.renderPagination();
            this.openSingleOrder();
            this.backToHistoryOrders();
        };
        StAccountOrderHistoryExtended.prototype.renderPagination = function() {
            var root = document.querySelector(".st_pagination") || function() {
                var _a;
                var divElement = document.createElement("div");
                divElement.className = "st_pagination";
                (_a = document.querySelector(".st_orders--wrapper")) === null || _a === void 0 ? void 0 : _a.appendChild(divElement);
                return divElement;
            }();
            root.innerHTML = "";
            var total = this.totalPages;
            if (total <= 1) {
                root.style.display = "none";
                return;
            }
            root.style.display = "";
            var mkBtn = function(label, role, disabled) {
                var buttonElement = document.createElement("button");
                buttonElement.type = "button";
                buttonElement.className = "st_pag-btn";
                buttonElement.setAttribute("data-role", role);
                buttonElement.disabled = disabled;
                buttonElement.textContent = label;
                return buttonElement;
            };
            var first = mkBtn("«", "first", this.currentPage === 1);
            var prev = mkBtn("‹", "prev", this.currentPage === 1);
            var indicator = document.createElement("span");
            indicator.className = "st_pag-indicator";
            indicator.setAttribute("aria-live", "polite");
            indicator.textContent = String(this.currentPage);
            indicator.title = "of ".concat(total);
            var next = mkBtn("›", "next", this.currentPage === total);
            var last = mkBtn("»", "last", this.currentPage === total);
            root.appendChild(first);
            root.appendChild(prev);
            root.appendChild(indicator);
            root.appendChild(next);
            root.appendChild(last);
        };
        StAccountOrderHistoryExtended.prototype.bindPaginationHandlers = function() {
            var _this_1 = this;
            if (this.paginationBound) return;
            this.paginationBound = true;
            document.addEventListener("click", function(e) {
                var targetElement = e.target;
                if (!(targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest)) return;
                var btn = targetElement.closest(".st_pagination .st_pag-btn");
                if (!btn) return;
                var role = btn.getAttribute("data-role");
                if (!role) return;
                e.preventDefault();
                switch (role) {
                  case "first":
                    _this_1.goToPage(1);
                    break;

                  case "prev":
                    _this_1.goToPage(_this_1.currentPage - 1);
                    break;

                  case "next":
                    _this_1.goToPage(_this_1.currentPage + 1);
                    break;

                  case "last":
                    _this_1.goToPage(_this_1.totalPages);
                    break;
                }
            });
        };
        StAccountOrderHistoryExtended.prototype.resetOrdersView = function(section) {
            var scope = section || document;
            var wrapper = scope.querySelector ? scope.querySelector(".st_orders-main--wrapper") : document.querySelector(".st_orders-main--wrapper");
            if (!wrapper) return;
            wrapper.classList.remove(this.classConfig.classNameOpenOrderCSSClass);
            wrapper.querySelectorAll(this.classConfig.selectorSingleOrder).forEach(function(el) {
                el.style.display = "none";
            });
        };
        StAccountOrderHistoryExtended.prototype.findOrdersSection = function() {
            var wrapper = document.querySelector(".st_orders-main--wrapper");
            if (!wrapper) return null;
            var p = wrapper.parentElement;
            while (p) {
                if (p.matches && p.matches(this.classConfig.selectorAccountSection)) return p;
                p = p.parentElement;
            }
            return null;
        };
        StAccountOrderHistoryExtended.prototype.observeOrdersSectionVisibility = function() {
            var _this_1 = this;
            var section = this.findOrdersSection();
            if (!section) return;
            var obs = new MutationObserver(function(muts) {
                for (var _i = 0, muts_1 = muts; _i < muts_1.length; _i++) {
                    var m = muts_1[_i];
                    if (m.type === "attributes" && m.attributeName === "class") {
                        if (section.classList.contains("st_show")) _this_1.resetOrdersView(section);
                    }
                }
            });
            obs.observe(section, {
                attributes: true,
                attributeFilter: [ "class" ]
            });
        };
        return StAccountOrderHistoryExtended;
    }(order_history_1.StAccountOrderHistory);
    exports.StAccountOrderHistoryExtended = StAccountOrderHistoryExtended;
});

define("extension/shopify-app/st-modules/account/blocks/personal-info/personal-info-extend", [ "require", "exports", "core/shopify-app/st-modules/account/blocks/personal-info/personal-info" ], function(require, exports, personal_info_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountPersonalInfoExtended = void 0;
    var StAccountPersonalInfoExtended = function(_super) {
        __extends(StAccountPersonalInfoExtended, _super);
        function StAccountPersonalInfoExtended(classConfig, form, formFormatting, buttonActions, notification, generalMethods) {
            var _this = _super.call(this, classConfig, form, formFormatting, buttonActions, notification, generalMethods) || this;
            _this.className = "AccountPersonalInfoExtended";
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.editPersonalInfo();
                    _this.setupFormatPhoneNumber();
                });
            };
            return _this;
        }
        return StAccountPersonalInfoExtended;
    }(personal_info_1.StAccountPersonalInfo);
    exports.StAccountPersonalInfoExtended = StAccountPersonalInfoExtended;
});

define("extension/shopify-app/st-modules/account/blocks/addresses/addresses-extend", [ "require", "exports", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/account/blocks/addresses/addresses" ], function(require, exports, notification_13, addresses_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAccountAddressesExtended = void 0;
    var StAccountAddressesExtended = function(_super) {
        __extends(StAccountAddressesExtended, _super);
        function StAccountAddressesExtended(classConfig, generalMethods, buttonActions, notification) {
            var _this = _super.call(this, classConfig, generalMethods) || this;
            _this.className = "StAccountAddressesExtended";
            _this.shippingEndpoint = _this.endpoint["customer"]["address-my-account-shipping"];
            _this.billingEndpoint = _this.endpoint["customer"]["address-my-account-billing"];
            _this.shippingCurr = {
                address1: "",
                address2: "",
                city: "",
                state: "",
                zip: "",
                id: "",
                county: "",
                country: "USA"
            };
            _this.shippingView = {
                line1: null,
                line2: null,
                zipCityState: null
            };
            _this.billingView = {
                line1: null,
                line2: null,
                zipCityState: null,
                select: null
            };
            _this.lastShipZip = "";
            _this.lastBillZip = "";
            _this.pendingShipLookup = false;
            _this.pendingBillLookup = false;
            _this.init = function() {
                _this.subscribeDOMLoaded(function() {
                    _this.openAddressDropDown();
                    _this.setupAddressEdit();
                    _this.setupAddressProvinceField();
                    _this.initShippingModal();
                    _this.initBillingModal();
                    _this.initReadonlyView();
                    _this.initZipLookups();
                    _this.setMastheadOffset();
                    window.addEventListener("load", _this.setMastheadOffset);
                    window.addEventListener("resize", _this.setMastheadOffset);
                    window.addEventListener("scroll", _this.setMastheadOffset);
                });
            };
            _this.openModal = function(modal) {
                if (!modal) return;
                modal.setAttribute("aria-hidden", "false");
                _this.lockScroll(true);
            };
            _this.closeModal = function(modal) {
                if (!modal) return;
                modal.setAttribute("aria-hidden", "true");
                _this.lockScroll(false);
            };
            _this.setMastheadOffset = function() {
                var header = document.querySelector(".shopify-section-header") || document.querySelector("header.site-header") || document.querySelector(".st_header");
                var offset = header ? header.getBoundingClientRect().bottom + window.scrollY : 0;
                document.documentElement.style.setProperty("--masthead-offset", "".concat(offset, "px"));
            };
            _this.getTranslate = function(key) {
                try {
                    var translations = window.stTranslations || {};
                    var value = translations[key];
                    return typeof value === "string" ? value : "";
                } catch (_a) {
                    return "";
                }
            };
            _this.getGeoCodeAddresses = function(postalCode) {
                return new Promise(function(resolve, reject) {
                    _this.ajax.send({
                        endpoint: _this.endpoint["customer"]["postal-code"],
                        method: "post",
                        contentType: "json",
                        data: {
                            postalCode: postalCode
                        },
                        callback: function(response) {
                            try {
                                var parsed = typeof response.response === "string" ? JSON.parse(response.response) : response.response;
                                var payload = (parsed === null || parsed === void 0 ? void 0 : parsed.data) ? parsed.data : parsed;
                                resolve(payload);
                            } catch (e) {
                                reject(e);
                            }
                        }
                    });
                });
            };
            _this.buttonActions = buttonActions;
            _this.notification = notification;
            return _this;
        }
        StAccountAddressesExtended.prototype.initShippingModal = function() {
            var _this = this;
            this.dataEl = document.getElementById("st-address-data_JS");
            if (!this.dataEl) return;
            this.shippingCurr = {
                address1: this.attr("shippingAddress1"),
                address2: this.attr("shippingAddress2"),
                city: this.attr("shippingCity"),
                state: (this.attr("shippingState") || "").toUpperCase().slice(0, 2),
                zip: this.attr("shippingZip"),
                id: this.attr("shippingId"),
                county: this.attr("shippingCounty") || "",
                country: this.normalizeCountry(this.attr("shippingCountry"))
            };
            this.modalShipping = document.querySelector(".st_modal-shipping_JS");
            this.shippingForm = document.querySelector(".st_shipping-form_JS");
            this.shippingSaveBtn = document.querySelector(".st_save-shipping_JS");
            if (this.shippingSaveBtn) {
                this.shippingSaveBtn.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.submitShipping();
                });
            }
            if (this.shippingForm) {
                this.shippingForm.setAttribute("novalidate", "");
                this.shippingForm.addEventListener("submit", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    _this.submitShipping();
                }, true);
                this.shippingForm.addEventListener("keydown", function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        _this.submitShipping();
                    }
                });
            }
            var openBtn = document.querySelector(".st_open-shipping_JS");
            if (openBtn) {
                openBtn.addEventListener("click", function() {
                    _this.prefillForm(_this.shippingForm, _this.shippingCurr);
                    _this.syncFloatingLabels(_this.shippingForm);
                    _this.openModal(_this.modalShipping);
                });
            }
            document.querySelectorAll(".st_close-modal_JS").forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this.closeModal(_this.modalShipping);
                });
            });
            if (this.shippingForm) {
                this.shippingForm.setAttribute("novalidate", "");
                this.shippingForm.addEventListener("submit", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.submitShipping();
                });
                this.shippingForm.addEventListener("keydown", function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        _this.submitShipping();
                    }
                });
            }
        };
        StAccountAddressesExtended.prototype.submitShipping = function() {
            return __awaiter(this, void 0, void 0, function() {
                var customerId, address, payload, err_4;
                var _this = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        customerId = window === null || window === void 0 ? void 0 : window.customerShopifyId;
                        address = this.collectShippingPayload();
                        if (!address) {
                            return [ 2 ];
                        }
                        payload = {
                            StreetAddress: address.address1,
                            StreetAddress2: address.address2,
                            City: address.city,
                            State: address.state,
                            ZIPCode: address.zip,
                            County: address.county,
                            Country: address.country,
                            addressId: address.id,
                            customerId: customerId
                        };
                        if (!payload) return [ 2 ];
                        if (this.shippingSaveBtn) this.buttonActions.prevent(this.shippingSaveBtn);
                        _a.label = 1;

                      case 1:
                        _a.trys.push([ 1, 3, 4, 5 ]);
                        return [ 4, new Promise(function(resolve, reject) {
                            _this.ajax.send({
                                endpoint: _this.shippingEndpoint,
                                method: "post",
                                contentType: "json",
                                data: payload,
                                callback: function(resp) {
                                    try {
                                        var json = JSON.parse(resp.response || "{}");
                                        var ok = json.status === 200;
                                        if (ok) {
                                            _this.notification.showNotification(notification_13.ENotificationType.success, "Saved", "Address has been successfully updated.");
                                            _this.paintShipping(address);
                                            if (_this.dataEl) {
                                                _this.dataEl.setAttribute("data-shipping-address1", address.address1);
                                                _this.dataEl.setAttribute("data-shipping-address2", address.address2 || "");
                                                _this.dataEl.setAttribute("data-shipping-city", address.city);
                                                _this.dataEl.setAttribute("data-shipping-state", address.state);
                                                _this.dataEl.setAttribute("data-shipping-zip", address.zip);
                                                if (address.id) _this.dataEl.setAttribute("data-shipping-id", address.id);
                                            }
                                            _this.setButtonMode(document.querySelector(".st_open-shipping_JS"), "edit");
                                            resolve();
                                        } else {
                                            var msg = (json === null || json === void 0 ? void 0 : json.message) || "Unable to save address.";
                                            _this.notification.showNotification(notification_13.ENotificationType.error, "Address Error", msg);
                                            reject(new Error(msg));
                                        }
                                    } catch (e) {
                                        _this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (e === null || e === void 0 ? void 0 : e.message) || "Unable to save address.");
                                        reject(e);
                                    }
                                }
                            });
                        }) ];

                      case 2:
                        _a.sent();
                        this.shippingCurr = address;
                        this.closeModal(this.modalShipping);
                        return [ 3, 5 ];

                      case 3:
                        err_4 = _a.sent();
                        console.error("[Shipping save] error:", err_4);
                        this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (err_4 === null || err_4 === void 0 ? void 0 : err_4.message) || "Unable to save address.");
                        return [ 3, 5 ];

                      case 4:
                        if (this.shippingSaveBtn) this.buttonActions.allow(this.shippingSaveBtn);
                        return [ 7 ];

                      case 5:
                        return [ 2 ];
                    }
                });
            });
        };
        StAccountAddressesExtended.prototype.collectShippingPayload = function() {
            if (!this.shippingForm) return null;
            var fd = new FormData(this.shippingForm);
            var payload = {
                address1: String(fd.get("address1") || "").trim(),
                address2: String(fd.get("address2") || "").trim(),
                city: String(fd.get("city") || "").trim(),
                state: this.normalizeState(String(fd.get("state") || "")),
                zip: String(fd.get("zip") || "").trim(),
                id: String(fd.get("id") || this.shippingCurr.id || "").trim(),
                county: String(fd.get("county") || "").trim(),
                country: String(fd.get("country") || "").trim() || "USA"
            };
            if (!payload.address1 || !payload.city || payload.state.length !== 2 || !this.isValidZip(payload.zip)) {
                this.notification.showNotification(notification_13.ENotificationType.error, "Invalid address", "Please enter a valid address (2-letter state and 5-digit ZIP).");
                return null;
            }
            return payload;
        };
        StAccountAddressesExtended.prototype.prefillForm = function(form, data) {
            if (!form) return;
            [ "address1", "address2", "city", "state", "zip", "id", "county", "country" ].forEach(function(n) {
                var el = form.querySelector('[name="'.concat(n, '"]'));
                if (!el) return;
                var rawVal = data[n];
                if ((n === "country" || n === "county") && (!rawVal || String(rawVal).trim() === "")) {
                    return;
                }
                var val = rawVal || "";
                if (n === "city" && el instanceof HTMLSelectElement) {
                    el.setAttribute("data-original-value", val);
                }
                el.value = val;
                el.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                el.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            });
            this.syncFloatingLabels(form);
        };
        StAccountAddressesExtended.prototype.attr = function(key) {
            if (!this.dataEl) return "";
            var k = key.replace(/[A-Z]/g, function(m) {
                return "-".concat(m.toLowerCase());
            });
            var v = this.dataEl.getAttribute("data-".concat(k));
            return (v || "").trim();
        };
        StAccountAddressesExtended.prototype.lockScroll = function(onScroll) {
            document.body.style.overflow = onScroll ? "hidden" : "";
        };
        StAccountAddressesExtended.prototype.normalizeState = function(state) {
            return (state || "").toUpperCase().slice(0, 2);
        };
        StAccountAddressesExtended.prototype.isValidZip = function(zipCode) {
            return /^\d{5}(-\d{4})?$/.test(zipCode || "");
        };
        StAccountAddressesExtended.prototype.initBillingModal = function() {
            var _this = this;
            var _a;
            this.modalBilling = document.querySelector(".st_modal-billing_JS");
            this.billingForm = document.querySelector(".st_billing-form_JS");
            this.billingSaveBtn = document.querySelector(".st_save-billing_JS");
            this.billingSelect = document.querySelector(".st_billing-select_JS");
            var openBtn = document.querySelector(".st_open-billing_JS");
            if (openBtn) openBtn.addEventListener("click", function() {
                var _a, _b;
                var openModal = (_b = (_a = _this.billingSelect) === null || _a === void 0 ? void 0 : _a.selectedOptions) === null || _b === void 0 ? void 0 : _b[0];
                if (openModal) _this.fillBillingFromOption(openModal);
                _this.syncFloatingLabels(_this.billingForm);
                _this.openModal(_this.modalBilling);
            });
            (_a = this.billingSelect) === null || _a === void 0 ? void 0 : _a.addEventListener("change", function() {
                var openModal = _this.billingSelect.selectedOptions[0];
                if (openModal) _this.fillBillingFromOption(openModal);
            });
            if (this.billingForm) {
                this.billingForm.setAttribute("novalidate", "");
                this.billingForm.addEventListener("submit", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }, true);
                this.billingForm.addEventListener("keydown", function(e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }
            if (this.billingSaveBtn) {
                this.billingSaveBtn.addEventListener("click", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this.submitBilling();
                });
            }
            document.querySelectorAll(".st_close-modal_JS").forEach(function(el) {
                el.addEventListener("click", function() {
                    return _this.closeModal(_this.modalBilling);
                });
            });
        };
        StAccountAddressesExtended.prototype.fillBillingFromOption = function(o) {
            var _this = this;
            if (!this.billingForm) return;
            var id = this.normalizeShopifyAddressId(o.value || "");
            var addr1 = o.getAttribute("data-address1") || "";
            var addr2 = o.getAttribute("data-address2") || "";
            var city = o.getAttribute("data-city") || "";
            var state = (o.getAttribute("data-state") || "").toUpperCase().slice(0, 2);
            var zip = o.getAttribute("data-zip") || "";
            var county = o.getAttribute("data-county") || "";
            var countryRaw = o.getAttribute("data-country") || "";
            var country = this.normalizeCountry(countryRaw);
            var set = function(elName, elValue) {
                var el = _this.billingForm.querySelector('[name="'.concat(elName, '"]'));
                if (!el) return;
                if ((elName === "country" || elName === "county") && (!elValue || elValue.trim() === "")) {
                    return;
                }
                if (elName === "city" && el instanceof HTMLSelectElement) {
                    el.setAttribute("data-original-value", elValue);
                }
                el.value = elValue;
                el.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                el.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            };
            set("id", id);
            set("address1", addr1);
            set("address2", addr2);
            set("city", city);
            set("state", state);
            set("zip", zip);
            set("county", county);
            set("country", country);
        };
        StAccountAddressesExtended.prototype.collectBillingPayload = function() {
            if (!this.billingForm) return null;
            var formData = new FormData(this.billingForm);
            var payload = {
                addressId: String(formData.get("id") || "").trim(),
                address1: String(formData.get("address1") || "").trim(),
                address2: String(formData.get("address2") || "").trim(),
                city: String(formData.get("city") || "").trim(),
                state: this.normalizeState(String(formData.get("state") || "")),
                zip: String(formData.get("zip") || "").trim(),
                customerId: window === null || window === void 0 ? void 0 : window.customerShopifyId,
                county: String(formData.get("county") || "").trim(),
                country: String(formData.get("country") || "").trim() || "USA"
            };
            if (!payload.address1 || !payload.city || payload.state.length !== 2 || !this.isValidZip(payload.zip)) {
                this.notification.showNotification(notification_13.ENotificationType.error, "Invalid address", "Please enter a valid address.");
                return null;
            }
            payload.id = payload.addressId;
            return payload;
        };
        StAccountAddressesExtended.prototype.submitBilling = function() {
            return __awaiter(this, void 0, void 0, function() {
                var address, payload, err_5;
                var _this = this;
                return __generator(this, function(_a) {
                    switch (_a.label) {
                      case 0:
                        address = this.collectBillingPayload();
                        if (!address) return [ 2 ];
                        payload = {
                            StreetAddress: address.address1,
                            StreetAddress2: address.address2,
                            City: address.city,
                            State: address.state,
                            ZIPCode: address.zip,
                            County: address.county,
                            Country: address.country,
                            addressId: address.addressId,
                            customerId: address.customerId
                        };
                        if (this.billingSaveBtn) this.buttonActions.prevent(this.billingSaveBtn);
                        _a.label = 1;

                      case 1:
                        _a.trys.push([ 1, 3, 4, 5 ]);
                        return [ 4, new Promise(function(resolve, reject) {
                            _this.ajax.send({
                                endpoint: _this.billingEndpoint,
                                method: "post",
                                contentType: "json",
                                data: payload,
                                callback: function(resp) {
                                    var _a, _b;
                                    try {
                                        var json = JSON.parse(resp.response || "{}");
                                        var ok = (json === null || json === void 0 ? void 0 : json.status) === 200;
                                        if (ok) {
                                            var newId = ((_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.addressId) || (json === null || json === void 0 ? void 0 : json.addressId) || ((_b = json === null || json === void 0 ? void 0 : json.data) === null || _b === void 0 ? void 0 : _b.id) || (json === null || json === void 0 ? void 0 : json.id);
                                            _this.notification.showNotification(notification_13.ENotificationType.success, "Saved", "Address has been successfully updated.");
                                            _this.updateSelectedBillingOption(address, newId);
                                            var normalized = {
                                                addressId: String(newId || address.addressId),
                                                address1: address.address1,
                                                address2: address.address2,
                                                city: address.city,
                                                state: address.state,
                                                zip: address.zip,
                                                county: address.county,
                                                country: address.country
                                            };
                                            _this.upsertBillingOption(normalized);
                                            _this.syncBillingViewOption(normalized);
                                            _this.setButtonMode(document.querySelector(".st_open-billing_JS"), "edit");
                                            resolve();
                                        } else {
                                            var msg = (json === null || json === void 0 ? void 0 : json.message) || "Unable to save address.";
                                            _this.notification.showNotification(notification_13.ENotificationType.error, "Address Error", msg);
                                            reject(new Error(msg));
                                        }
                                    } catch (e) {
                                        reject(e);
                                    }
                                }
                            });
                        }) ];

                      case 2:
                        _a.sent();
                        this.closeModal(this.modalBilling);
                        return [ 3, 5 ];

                      case 3:
                        err_5 = _a.sent();
                        console.error("[Billing save] error:", err_5);
                        this.notification.showNotification(notification_13.ENotificationType.error, "An Error Occurred", (err_5 === null || err_5 === void 0 ? void 0 : err_5.message) || "Unable to save.");
                        return [ 3, 5 ];

                      case 4:
                        if (this.billingSaveBtn) this.buttonActions.allow(this.billingSaveBtn);
                        return [ 7 ];

                      case 5:
                        return [ 2 ];
                    }
                });
            });
        };
        StAccountAddressesExtended.prototype.updateSelectedBillingOption = function(addr, newId) {
            var _a, _b;
            if (!this.billingSelect) return;
            var opt = (_a = this.billingSelect.selectedOptions) === null || _a === void 0 ? void 0 : _a[0];
            if (!opt) return;
            var id = String(newId || addr.addressId || opt.value || "");
            opt.value = id;
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            var parts = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean);
            opt.textContent = parts.join(", ");
            var hiddenId = (_b = this.billingForm) === null || _b === void 0 ? void 0 : _b.querySelector('[name="id"]');
            if (hiddenId) hiddenId.value = id;
        };
        StAccountAddressesExtended.prototype.setButtonMode = function(btn, mode) {
            if (!btn) return;
            var addText = btn.getAttribute("data-text-add") || "Add";
            var editText = btn.getAttribute("data-text-edit") || "Edit";
            btn.textContent = mode === "edit" ? editText : addText;
        };
        StAccountAddressesExtended.prototype.ensureBillingSelect = function() {
            var _this = this;
            var _a, _b;
            if (this.billingSelect) return this.billingSelect;
            var row = document.createElement("div");
            row.className = "st_form__row st_mb-12 st_billing-select-row_JS";
            var label = document.createElement("label");
            label.className = "st_form__field";
            label.style.width = "100%";
            var span = document.createElement("span");
            span.textContent = (window === null || window === void 0 ? void 0 : window.i18nChooseAddress) || "Choose address";
            var sel = document.createElement("select");
            sel.className = "st_billing-select_JS";
            label.appendChild(span);
            label.appendChild(sel);
            row.appendChild(label);
            (_b = (_a = this.billingForm) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.insertBefore(row, this.billingForm);
            this.billingSelect = sel;
            this.billingSelect.addEventListener("change", function() {
                var option = _this.billingSelect.selectedOptions[0];
                if (option) _this.fillBillingFromOption(option);
            });
            return this.billingSelect;
        };
        StAccountAddressesExtended.prototype.upsertBillingOption = function(addr) {
            var sel = this.ensureBillingSelect();
            if (!sel) return;
            var id = String(addr.addressId);
            var opt = Array.from(sel.options).find(function(o) {
                return o.value === id;
            });
            if (!opt) {
                opt = document.createElement("option");
                opt.value = id;
                sel.appendChild(opt);
            }
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            opt.textContent = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean).join(", ");
            opt.selected = true;
        };
        StAccountAddressesExtended.prototype.normalizeShopifyAddressId = function(id) {
            var searchString = String(id || "");
            var matchId = searchString.match(/\d{5,}/);
            return matchId ? matchId[0] : searchString;
        };
        StAccountAddressesExtended.prototype.initReadonlyView = function() {
            var _this = this;
            var _a, _b;
            this.shippingView.line1 = document.querySelector(".st_shipping-line1_JS");
            this.shippingView.zipCityState = document.querySelector(".st_shipping-zipcitystate_JS");
            this.billingView.line1 = document.querySelector(".st_billing-line1_JS");
            this.billingView.zipCityState = document.querySelector(".st_billing-zipcitystate_JS");
            this.billingView.select = document.querySelector(".st_billing-view-select_JS");
            this.shippingView.line2 = document.querySelector(".st_shipping-line2_JS");
            this.billingView.line2 = document.querySelector(".st_billing-line2_JS");
            if (this.dataEl) {
                this.paintShipping({
                    address1: this.attr("shippingAddress1"),
                    address2: this.attr("shippingAddress2"),
                    city: this.attr("shippingCity"),
                    state: (this.attr("shippingState") || "").toUpperCase().slice(0, 2),
                    zip: this.attr("shippingZip")
                });
            }
            if ((_a = this.billingView.select) === null || _a === void 0 ? void 0 : _a.selectedOptions[0]) this.paintBillingFromOption(this.billingView.select.selectedOptions[0]);
            (_b = this.billingView.select) === null || _b === void 0 ? void 0 : _b.addEventListener("change", function() {
                var opt = _this.billingView.select.selectedOptions[0];
                if (opt) _this.paintBillingFromOption(opt);
            });
        };
        StAccountAddressesExtended.prototype.paintShipping = function(address) {
            var _a;
            if (this.shippingView.line1) this.shippingView.line1.textContent = address.address1 || "—";
            if (this.shippingView.line2) this.shippingView.line2.textContent = address.address2 || "—";
            var combo = [ (_a = address.zip) === null || _a === void 0 ? void 0 : _a.toUpperCase(), address.city ? " ".concat(address.city, ",") : "", address.state ].filter(Boolean).join("");
            if (this.shippingView.zipCityState) this.shippingView.zipCityState.textContent = combo || "—";
        };
        StAccountAddressesExtended.prototype.paintBilling = function(address) {
            var _a;
            if (this.billingView.line1) this.billingView.line1.textContent = address.address1 || "—";
            if (this.billingView.line2) this.billingView.line2.textContent = address.address2 || "—";
            var combo = [ (_a = address.zip) === null || _a === void 0 ? void 0 : _a.toUpperCase(), address.city ? " ".concat(address.city, ",") : "", address.state ].filter(Boolean).join("");
            if (this.billingView.zipCityState) this.billingView.zipCityState.textContent = combo || "—";
        };
        StAccountAddressesExtended.prototype.paintBillingFromOption = function(optionData) {
            var addr1 = optionData.getAttribute("data-address1") || "";
            var addr2 = optionData.getAttribute("data-address2") || "";
            var city = optionData.getAttribute("data-city") || "";
            var state = (optionData.getAttribute("data-state") || "").toUpperCase().slice(0, 2);
            var zip = optionData.getAttribute("data-zip") || "";
            this.paintBilling({
                address1: addr1,
                address2: addr2,
                city: city,
                state: state,
                zip: zip
            });
        };
        StAccountAddressesExtended.prototype.initZipLookups = function() {
            this.shipZipInput = document.querySelector("#ShippingForm-ZipCode");
            this.shipCitySelect = document.querySelector("#ShippingForm-City");
            this.shipStateSelect = document.querySelector("#ShippingForm-State");
            this.shipCountySelect = document.querySelector("#ShippingForm-County");
            this.billZipInput = document.querySelector("#BillingForm-ZipCode");
            this.billCitySelect = document.querySelector("#BillingForm-City");
            this.billStateSelect = document.querySelector("#BillingForm-State");
            this.billCountySelect = document.querySelector("#BillingForm-County");
            this.disableSelects(true, "shipping");
            this.disableSelects(true, "billing");
            this.bindZipHandlers("shipping");
            this.bindZipHandlers("billing");
        };
        StAccountAddressesExtended.prototype.disableSelects = function(hardClear, scope) {
            var _this = this;
            if (hardClear === void 0) {
                hardClear = false;
            }
            var selects = scope === "shipping" ? [ this.shipStateSelect, this.shipCitySelect, this.shipCountySelect ] : [ this.billStateSelect, this.billCitySelect, this.billCountySelect ];
            selects.forEach(function(selectElement) {
                if (!selectElement) return;
                selectElement.disabled = true;
                if (hardClear) {
                    selectElement.removeAttribute("data-original-value");
                    var placeholderStateLabel = _this.getTranslate("selectState") || "-- Select State --";
                    var placeholderCityLabel = _this.getTranslate("selectCity") || "-- Select City --";
                    var placeholderCountyLabel = _this.getTranslate("selectCounty") || "-- Select County --";
                    selectElement.innerHTML = "";
                    var placeholderOption = document.createElement("option");
                    placeholderOption.value = "";
                    placeholderOption.disabled = true;
                    placeholderOption.selected = true;
                    placeholderOption.textContent = selectElement.id.includes("State") ? placeholderStateLabel : selectElement.id.includes("City") ? placeholderCityLabel : placeholderCountyLabel;
                    selectElement.appendChild(placeholderOption);
                    var wrapper = selectElement.closest(".form__field");
                    if (wrapper) wrapper.classList.remove("form__field--filled");
                }
            });
        };
        StAccountAddressesExtended.prototype.enableSelects = function(scope) {
            var selects = scope === "shipping" ? [ this.shipStateSelect, this.shipCitySelect, this.shipCountySelect ] : [ this.billStateSelect, this.billCitySelect, this.billCountySelect ];
            selects.forEach(function(selectElement) {
                if (!selectElement) return;
                selectElement.disabled = false;
            });
        };
        StAccountAddressesExtended.prototype.bindZipHandlers = function(scope) {
            var _this = this;
            var zipInput = scope === "shipping" ? this.shipZipInput : this.billZipInput;
            if (!zipInput) return;
            var handler = function() {
                return _this.onZipChanged(scope);
            };
            zipInput.addEventListener("change", handler);
            zipInput.addEventListener("blur", handler);
            zipInput.addEventListener("keyup", function(e) {
                if (e.key === "Enter") handler();
            });
            zipInput.addEventListener("input", handler);
            zipInput.addEventListener("paste", function() {
                setTimeout(handler, 0);
            });
        };
        StAccountAddressesExtended.prototype.onZipChanged = function(scope) {
            var _this = this;
            var zipInput = scope === "shipping" ? this.shipZipInput : this.billZipInput;
            if (!zipInput) return;
            var zip = (zipInput.value || "").trim();
            if (!zip || !this.isValidZip(zip)) {
                this.disableSelects(true, scope);
                if (scope === "shipping") {
                    this.syncFloatingLabels(this.shippingForm);
                } else {
                    this.syncFloatingLabels(this.billingForm);
                }
                return;
            }
            var lastZip = scope === "shipping" ? this.lastShipZip : this.lastBillZip;
            var pending = scope === "shipping" ? this.pendingShipLookup : this.pendingBillLookup;
            if (pending || zip === lastZip) return;
            if (scope === "shipping") {
                this.pendingShipLookup = true;
            } else {
                this.pendingBillLookup = true;
            }
            this.disableSelects(false, scope);
            this.getGeoCodeAddresses(zip).then(function(data) {
                return _this.applyPostalData(scope, zip, data);
            }).catch(function() {
                return _this.handleZipLookupError(scope);
            }).finally(function() {
                return _this.finalizeZipLookup(scope);
            });
        };
        StAccountAddressesExtended.prototype.applyPostalData = function(scope, zip, data) {
            if (scope === "shipping") this.lastShipZip = zip; else this.lastBillZip = zip;
            var stateSelect = scope === "shipping" ? this.shipStateSelect : this.billStateSelect;
            var citySelect = scope === "shipping" ? this.shipCitySelect : this.billCitySelect;
            var countySelect = scope === "shipping" ? this.shipCountySelect : this.billCountySelect;
            this.populateSelect(stateSelect, (data === null || data === void 0 ? void 0 : data.States) || [], this.getTranslate("selectState") || "-- Select State --");
            this.populateSelect(citySelect, (data === null || data === void 0 ? void 0 : data.Cities) || [], this.getTranslate("selectCity") || "-- Select City --");
            this.populateSelect(countySelect, (data === null || data === void 0 ? void 0 : data.Counties) || [], this.getTranslate("selectCounty") || "-- Select County --");
            this.autoSelectIfSingle(stateSelect);
            this.autoSelectIfSingle(citySelect);
            this.autoSelectIfSingle(countySelect);
            this.enableSelects(scope);
            if (scope === "shipping") {
                this.syncFloatingLabels(this.shippingForm);
            } else {
                this.syncFloatingLabels(this.billingForm);
            }
        };
        StAccountAddressesExtended.prototype.handleZipLookupError = function(scope) {
            this.disableSelects(true, scope);
            if (scope === "shipping") {
                this.syncFloatingLabels(this.shippingForm);
            } else {
                this.syncFloatingLabels(this.billingForm);
            }
        };
        StAccountAddressesExtended.prototype.finalizeZipLookup = function(scope) {
            if (scope === "shipping") this.pendingShipLookup = false; else this.pendingBillLookup = false;
        };
        StAccountAddressesExtended.prototype.populateSelect = function(selectElement, items, placeholderLabel) {
            if (!selectElement) return;
            var desiredRaw = (selectElement.getAttribute("data-original-value") || "").trim();
            var previousValue = desiredRaw || (selectElement.value || "").trim();
            selectElement.innerHTML = "";
            var placeholderOption = document.createElement("option");
            placeholderOption.value = "";
            placeholderOption.disabled = true;
            placeholderOption.selected = true;
            placeholderOption.textContent = placeholderLabel;
            selectElement.appendChild(placeholderOption);
            items.forEach(function(itemValue) {
                var optionElement = document.createElement("option");
                optionElement.value = itemValue;
                optionElement.textContent = itemValue;
                selectElement.appendChild(optionElement);
            });
            if (!previousValue) return;
            var options = Array.from(selectElement.options).filter(function(option) {
                return option.value !== "";
            });
            var match;
            match = options.find(function(option) {
                return option.value === previousValue;
            });
            var prevLower = previousValue.toLowerCase();
            if (!match) {
                match = options.find(function(option) {
                    return option.value.toLowerCase() === prevLower;
                });
            }
            if (!match) {
                match = options.find(function(option) {
                    return option.value.toLowerCase().startsWith(prevLower);
                });
            }
            if (match) {
                selectElement.value = match.value;
                selectElement.setAttribute("data-original-value", match.value);
            }
        };
        StAccountAddressesExtended.prototype.autoSelectIfSingle = function(selectElement) {
            if (!selectElement) return;
            var nonEmptyOptions = Array.from(selectElement.options).filter(function(option) {
                return option.value !== "";
            });
            if (nonEmptyOptions.length === 1) selectElement.value = nonEmptyOptions[0].value;
        };
        StAccountAddressesExtended.prototype.syncFloatingLabels = function(form) {
            var root = form || document;
            var fields = Array.from(root.querySelectorAll(".form__field__input, .form__field__select"));
            fields.forEach(function(el) {
                var wrapper = el.closest(".form__field");
                if (!wrapper) return;
                if (el instanceof HTMLSelectElement) {
                    wrapper.classList.add("form__field--filled");
                    return;
                }
                var hasValue = !!(el.value || "").trim();
                if (hasValue) {
                    wrapper.classList.add("form__field--filled");
                } else {
                    wrapper.classList.remove("form__field--filled");
                }
            });
        };
        StAccountAddressesExtended.prototype.normalizeCountry = function(country) {
            var valueCountry = (country || "").trim();
            if (!valueCountry) return "";
            var up = valueCountry.toUpperCase();
            if (up === "UNITED STATES" || up === "UNITED STATES OF AMERICA") return "USA";
            return valueCountry;
        };
        StAccountAddressesExtended.prototype.syncBillingViewOption = function(addr) {
            var sel = this.billingView.select;
            var id = String(addr.addressId);
            if (!sel) {
                this.paintBilling({
                    address1: addr.address1,
                    address2: addr.address2,
                    city: addr.city,
                    state: addr.state,
                    zip: addr.zip
                });
                return;
            }
            var opt = Array.from(sel.options).find(function(option) {
                return option.value === id;
            });
            if (!opt) {
                opt = sel.selectedOptions[0] || sel.options[0];
            }
            if (!opt) {
                opt = document.createElement("option");
                sel.appendChild(opt);
            }
            opt.value = id;
            opt.setAttribute("data-address1", addr.address1);
            opt.setAttribute("data-address2", addr.address2 || "");
            opt.setAttribute("data-city", addr.city);
            opt.setAttribute("data-state", this.normalizeState(addr.state));
            opt.setAttribute("data-zip", addr.zip);
            opt.setAttribute("data-county", addr.county || "");
            opt.setAttribute("data-country", addr.country || "");
            opt.textContent = [ [ addr.address1, addr.address2 ].filter(Boolean).join(" ").trim(), addr.city, this.normalizeState(addr.state), addr.zip ].filter(Boolean).join(", ");
            opt.selected = true;
            this.paintBillingFromOption(opt);
        };
        return StAccountAddressesExtended;
    }(addresses_1.StAccountAddresses);
    exports.StAccountAddressesExtended = StAccountAddressesExtended;
});

define("_shopify.app.di.container", [ "require", "exports", "core/shopify-app/st-modules/_static/static", "core/shopify-app/st-modules/account/account", "core/shopify-app/st-modules/enrollment/enrollment", "core/shopify-app/st-modules/_general-methods/browser-history", "core/shopify-app/st-modules/_general-methods/form/cart-manipulation", "core/shopify-app/st-modules/_general-methods/cookies/cookies", "core/shopify-app/st-modules/_general-methods/form/customer-type", "core/shopify-app/st-modules/_general-methods/form/loader", "core/shopify-app/st-modules/_general-methods/general-methods", "core/shopify-app/st-modules/_general-methods/button/button-actions", "core/shopify-app/st-modules/_general-methods/form/form", "core/shopify-app/st-modules/_general-methods/notification", "core/shopify-app/st-modules/_general-methods/object-formatting", "core/shopify-app/st-modules/_di-container/di.container.public", "core/shopify-app/st-modules/enrollment/page-header/nav/enrollment-nav", "core/shopify-app/st-modules/enrollment/page/enrollment-submit", "core/shopify-app/st-modules/enrollment/_general/enrollment-class-config", "core/shopify-app/st-modules/_general-methods/form/fields/date-input", "core/shopify-app/st-modules/_general-methods/form/form-class-config", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation", "core/shopify-app/st-modules/enrollment/blocks/review-privacy/enrollment-section-review-privacy", "core/shopify-app/st-modules/enrollment/blocks/account-details/enrollment-section-account-details", "core/shopify-app/st-modules/enrollment/blocks/business-info/enrollment-section-business-details", "core/shopify-app/st-modules/enrollment/_validation/enrollment-validation-setup", "core/shopify-app/st-modules/account/_general/account-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor", "core/shopify-app/st-modules/search-sponsor/sponsor-search-class-config", "core/shopify-app/st-modules/enrollment-account/enrollment-account", "core/shopify-app/st-modules/enrollment-account/enrollment-account-class-config", "core/shopify-app/st-modules/enrollment/blocks/optional-kits/enrollment-section-optional-kits", "core/shopify-app/st-modules/enrollment/blocks/required-kits/enrollment-section-required-kits", "core/shopify-app/st-modules/enrollment/_general/enrollment-store", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review", "core/shopify-app/st-modules/enrollment/page/enrollment-page", "core/shopify-app/st-modules/_general-methods/currency", "core/shopify-app/st-modules/enrollment/blocks/review-info/enrollment-review-cart", "core/shopify-app/st-modules/_general-methods/form/formatting", "core/shopify-app/st-modules/enrollment/blocks/account-details/account-details-helpers", "core/shopify-app/st-modules/enrollment/blocks/business-info/business-details-helpers", "core/shopify-app/st-modules/account/header/backoffice-sso/backoffice-sso", "core/shopify-app/st-modules/account/blocks/web-alias-edit/web-alias-edit", "core/shopify-app/st-modules/account/blocks/personal-site/personal-site", "core/shopify-app/st-modules/account/blocks/order-history/order-history", "extension/shopify-app/st-modules/cart/cart", "core/shopify-app/st-modules/enrollment-account/enrollment-account-repeat-password-validation", "extension/shopify-app/st-modules/account-register/account-register-extend", "core/shopify-app/st-modules/main/auto-apply-promo", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page", "core/shopify-app/st-modules/representative-redirect-page/representative-redirect-page-class-config", "core/shopify-app/st-modules/account-register/account-register-class-config", "core/shopify-app/st-modules/account-login/account-login", "core/shopify-app/st-modules/account-login/account-login-class-config", "core/shopify-app/st-modules/search-sponsor/search-sponsor-guard", "core/shopify-app/st-modules/search-sponsor/search-sponsor-service", "core/shopify-app/st-modules/reset-password/reset-password-class-config", "core/shopify-app/st-modules/reset-password/reset-password", "core/shopify-app/st-modules/enrollment/enrollment-cleanup", "core/shopify-app/st-modules/referral/referral", "core/shopify-app/st-modules/account/blocks/coupon-codes/coupon-codes", "core/shopify-app/st-modules/auth/auth", "extension/shopify-app/st-modules/webalias/inject-representative-info", "extension/shopify-app/st-modules/rep-site-detail/rep-site-detail", "extension/shopify-app/st-modules/rep-site-detail/rep-site-detail-class-config", "extension/shopify-app/st-modules/webalias/webalias-class-config.extended", "extension/shopify-app/st-modules/webalias/webalias.extended", "extension/shopify-app/st-modules/webalias/shopining-with/party-banner-info", "extension/shopify-app/st-modules/party/party", "extension/shopify-app/st-modules/party/party-check", "extension/shopify-app/st-modules/party/party-service", "extension/shopify-app/st-modules/header/header", "extension/shopify-app/st-modules/free-sample/free-sample", "extension/shopify-app/st-modules/free-sample/free-sample-class-config", "extension/shopify-app/st-modules/samples-set/samples-set", "extension/shopify-app/st-modules/samples-set/samples-set-class-config", "extension/shopify-app/st-modules/free-shipping/free-shipping", "extension/shopify-app/st-modules/samples-set/cart-guard", "extension/shopify-app/st-modules/account-register/st-market-type", "extension/shopify-app/st-modules/cart/cartSaveLoginInterceptor", "extension/shopify-app/st-modules/cart/prefilCartOnLogin", "extension/shopify-app/st-modules/account-login/customers-login", "extension/shopify-app/st-modules/shopping-on-behalf/shopping-on-behalf", "extension/shopify-app/st-modules/account/blocks/credit-ledger/credit-ledger", "extension/shopify-app/st-modules/consultant-discount-banner/consultant-discount-banner", "extension/shopify-app/st-modules/newsletter-popup/newsletter-popup", "extension/shopify-app/st-modules/catalog-page/product-category", "extension/shopify-app/st-modules/account/header/nav/account-nav.extended", "extension/shopify-app/st-modules/account/blocks/order-history/order-history-extend", "extension/shopify-app/st-modules/account/blocks/personal-info/personal-info-extend", "extension/shopify-app/st-modules/account/blocks/addresses/addresses-extend" ], function(require, exports, static_3, account_1, enrollment_1, browser_history_1, cart_manipulation_1, cookies_1, customer_type_1, loader_1, general_methods_1, button_actions_2, form_1, notification_14, object_formatting_1, di_container_public_1, enrollment_nav_1, enrollment_submit_1, enrollment_class_config_1, date_input_1, form_class_config_1, enrollment_validation_1, enrollment_section_review_privacy_1, enrollment_section_account_details_1, enrollment_section_business_details_1, enrollment_validation_setup_1, account_class_config_1, search_sponsor_1, sponsor_search_class_config_1, enrollment_account_1, enrollment_account_class_config_1, enrollment_section_optional_kits_1, enrollment_section_required_kits_1, enrollment_store_1, enrollment_review_1, enrollment_page_1, currency_3, enrollment_review_cart_1, formatting_1, account_details_helpers_1, business_details_helpers_1, backoffice_sso_1, web_alias_edit_1, personal_site_1, order_history_2, cart_2, enrollment_account_repeat_password_validation_1, account_register_extend_1, auto_apply_promo_1, representative_redirect_page_1, representative_redirect_page_class_config_1, account_register_class_config_1, account_login_1, account_login_class_config_1, search_sponsor_guard_1, search_sponsor_service_1, reset_password_class_config_1, reset_password_1, enrollment_cleanup_1, referral_1, coupon_codes_1, auth_1, inject_representative_info_2, rep_site_detail_1, rep_site_detail_class_config_1, webalias_class_config_extended_1, webalias_extended_1, party_banner_info_1, party_1, party_check_1, party_service_1, header_1, free_sample_1, free_sample_class_config_1, samples_set_1, samples_set_class_config_1, free_shipping_1, cart_guard_1, st_market_type_1, cartSaveLoginInterceptor_1, prefilCartOnLogin_1, customers_login_1, shopping_on_behalf_1, credit_ledger_1, consultant_discount_banner_1, newsletter_popup_1, product_category_1, account_nav_extended_1, order_history_extend_1, personal_info_extend_1, addresses_extend_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StAppDIConfig = void 0;
    var StAppDIConfig = function() {
        function StAppDIConfig() {
            var _this = this;
            this.className = "AppDIConfig";
            this.init = function() {};
            this.components = function() {
                _this.StStaticComponent = static_3.StStatic.Instance();
                _this.StAuthComponent = new auth_1.StAuth();
                _this.DiContainerPublicComponent = new di_container_public_1.DiContainerPublic();
                _this.StObjectFormattingComponent = new object_formatting_1.StObjectFormatting();
                _this.StBrowserHistoryComponent = new browser_history_1.StBrowserHistory(_this.StObjectFormattingComponent);
                _this.StCartManipulationComponent = new cart_manipulation_1.StCartManipulation();
                _this.StCookiesComponent = new cookies_1.StCookies();
                _this.StCustomerTypeComponent = new customer_type_1.StCustomerType();
                _this.StLoaderComponent = new loader_1.StLoader();
                _this.StButtonActionsComponent = new button_actions_2.StButtonActions();
                _this.StNotificationComponent = new notification_14.StNotification();
                _this.StFormConfigComponent = new form_class_config_1.StFormClassConfig();
                _this.StGeneralMethodsComponent = new general_methods_1.StGeneralMethods();
                _this.StCurrencyComponent = new currency_3.StCurrency();
                _this.StFormattingComponent = new formatting_1.StFormFormatting();
                _this.StAutoApplyPromoComponent = new auto_apply_promo_1.StAutoApplyPromo();
                _this.StCartComponent = new cart_2.StCart();
                _this.StEnrollmentClassConfigComponent = new enrollment_class_config_1.StEnrollmentClassConfig();
                _this.StEnrollmentAccountClassConfigComponent = new enrollment_account_class_config_1.StEnrollmentAccountClassConfig();
                _this.StEnrollmentSectionPrivacyComponent = new enrollment_section_review_privacy_1.StEnrollmentSectionPrivacy(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentAccountDetailsHelpersComponent = new account_details_helpers_1.StEnrollmentAccountDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentBusinessDetailsHelpersComponent = new business_details_helpers_1.StEnrollmentBusinessDetailsHelpers(_this.StFormattingComponent, _this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentSectionAccountDetailsComponent = new enrollment_section_account_details_1.StEnrollmentSectionAccountDetails();
                _this.StEnrollmentSectionBusinessDetailsComponent = new enrollment_section_business_details_1.StEnrollmentSectionBusinessDetails();
                _this.StEnrollmentStoreComponent = new enrollment_store_1.StEnrollmentStore(_this.StEnrollmentClassConfigComponent, _this.StCartComponent);
                _this.StEnrollmentPageComponent = new enrollment_page_1.StEnrollmentPage(_this.StEnrollmentClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountClassConfigComponent = new account_class_config_1.StAccountClassConfig();
                _this.StSearchSponsorClassConfigComponent = new sponsor_search_class_config_1.StSearchSponsorClassConfig();
                _this.StDateInputComponent = new date_input_1.StDateInput(_this.StFormConfigComponent);
                _this.StFormComponent = new form_1.StForm(_this.StFormConfigComponent, _this.StDateInputComponent);
                _this.StWebAliasClassConfigComponent = new webalias_class_config_extended_1.StWebAliasClassConfigExtended();
                _this.StInjectRepresentativeInfoComponent = new inject_representative_info_2.StInjectRepresentativeInfoExtended(_this.StWebAliasClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StSearchSponsorGuardComponent = new search_sponsor_guard_1.StSearchSponsorGuard(_this.StSearchSponsorClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StAccountPersonalSiteComponent = new personal_site_1.StAccountPersonalSite(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StWebAliasComponent = new webalias_extended_1.StWebAliasExtended(_this.StWebAliasClassConfigComponent, _this.StBrowserHistoryComponent, _this.StObjectFormattingComponent, _this.StCookiesComponent, _this.StCustomerTypeComponent, _this.StGeneralMethodsComponent, _this.StInjectRepresentativeInfoComponent, _this.StCartComponent, _this.StSearchSponsorGuardComponent, _this.StAccountPersonalSiteComponent);
                _this.StSearchSponsorService = new search_sponsor_service_1.StSearchSponsorService();
                _this.StSearchSponsorComponent = new search_sponsor_1.StSearchSponsor(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StSearchSponsorClassConfigComponent, _this.StCookiesComponent, _this.StCartComponent, _this.StSearchSponsorService);
                _this.StEnrollmentValidationComponent = new enrollment_validation_1.StEnrollmentValidation(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentValidationSetupComponent = new enrollment_validation_setup_1.StEnrollmentValidationSetup(_this.StEnrollmentValidationComponent, _this.StEnrollmentSectionPrivacyComponent, _this.StEnrollmentSectionAccountDetailsComponent, _this.StEnrollmentSectionBusinessDetailsComponent);
                _this.StEnrollmentReviewCartComponent = new enrollment_review_cart_1.StEnrollmentReviewCart(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StCurrencyComponent);
                _this.StEnrollmentOptionalKitsComponent = new enrollment_section_optional_kits_1.StEnrollmentOptionalKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentRequiredKitsComponent = new enrollment_section_required_kits_1.StEnrollmentRequiredKits(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentReviewComponent = new enrollment_review_1.StEnrollmentReview(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentStoreComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentPageComponent, _this.StCurrencyComponent, _this.StFormComponent, _this.StEnrollmentReviewCartComponent);
                _this.StEnrollmentActionsComponent = new enrollment_submit_1.StEnrollmentActions(_this.StEnrollmentClassConfigComponent, _this.StNotificationComponent);
                _this.StEnrollmentNavComponent = new enrollment_nav_1.StEnrollmentNav(_this.StEnrollmentClassConfigComponent, _this.StEnrollmentActionsComponent, _this.StEnrollmentOptionalKitsComponent, _this.StEnrollmentRequiredKitsComponent, _this.StEnrollmentStoreComponent, _this.StFormComponent, _this.StButtonActionsComponent, _this.StEnrollmentValidationComponent, _this.StEnrollmentValidationSetupComponent, _this.StNotificationComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentPageComponent);
                _this.StEnrollmentComponent = new enrollment_1.StEnrollment(_this.StEnrollmentClassConfigComponent);
                _this.StEnrollmentCleanupComponent = new enrollment_cleanup_1.StEnrollmentCleanup(_this.StCartComponent);
                _this.StEnrollmentAccountComponent = new enrollment_account_1.StEnrollmentAccount(_this.StEnrollmentAccountClassConfigComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StEnrollmentCleanupComponent, _this.StCartComponent);
                _this.StAccountNavComponent = new account_nav_extended_1.StAccountNavExtended(_this.StAccountClassConfigComponent, _this.StObjectFormattingComponent, _this.StBrowserHistoryComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StBackofficeSSOComponent = new backoffice_sso_1.StBackofficeSSO(_this.StAccountClassConfigComponent, _this.StNotificationComponent);
                _this.StAccountWebAliasEditComponent = new web_alias_edit_1.StAccountWebAliasEdit(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StFormComponent, _this.StFormattingComponent);
                _this.StAccountAddressesComponent = new addresses_extend_1.StAccountAddressesExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent, _this.StButtonActionsComponent, _this.StNotificationComponent);
                _this.StAccountPersonalInfoComponent = new personal_info_extend_1.StAccountPersonalInfoExtended(_this.StAccountClassConfigComponent, _this.StFormComponent, _this.StFormattingComponent, _this.StButtonActionsComponent, _this.StNotificationComponent, _this.StGeneralMethodsComponent);
                _this.StAccountOrderHistoryComponent = new order_history_2.StAccountOrderHistory(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StOrderHistoryComponent = new order_history_extend_1.StAccountOrderHistoryExtended(_this.StAccountClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountComponent = new account_1.StAccount(_this.StFormComponent);
                _this.StFreeSampleClassConfig = new free_sample_class_config_1.StFreeSampleClassConfig();
                _this.StFreeSampleComponent = new free_sample_1.StFreeSample(_this.StFreeSampleClassConfig, _this.StFormComponent, _this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StSampleSetClassConfig = new samples_set_class_config_1.StSampleSetClassConfig();
                _this.StSampleSetComponent = new samples_set_1.StSampleSet(_this.StSampleSetClassConfig, _this.StCartComponent);
                _this.StCartGuardComponent = new cart_guard_1.StCartGuard(_this.StCartComponent);
                _this.StMarketTypeLoader = new st_market_type_1.StMarketTypeLoader();
                _this.StCartInterceptor = new cartSaveLoginInterceptor_1.StCartInterceptor();
                _this.StPrefilCart = new prefilCartOnLogin_1.StPrefilCart();
                _this.StAccountLoginClassConfigComponent = new account_login_class_config_1.StAccountLoginClassConfig();
                _this.StAccountLoginComponent = new account_login_1.StAccountLogin(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountLoginClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StAccountRegisterClassConfigComponent = new account_register_class_config_1.StAccountRegisterClassConfig();
                _this.StAccountRegisterComponent = new account_register_extend_1.StAccountRegisterExtended(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StAccountRegisterClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StResetPasswordClassConfigComponent = new reset_password_class_config_1.StResetPasswordClassConfig();
                _this.StResetPasswordComponent = new reset_password_1.StResetPassword(_this.StFormComponent, _this.StNotificationComponent, _this.StButtonActionsComponent, _this.StResetPasswordClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StEnrollmentRepeatPasswordValidationComponent = new enrollment_account_repeat_password_validation_1.StEnrollmentRepeatPasswordValidation(_this.StEnrollmentAccountClassConfigComponent);
                _this.StRepresentativeRedirectClassConfigComponent = new representative_redirect_page_class_config_1.StRepresentativeRedirectClassConfig();
                _this.StRepresentativeRedirectComponent = new representative_redirect_page_1.StRepresentativeRedirectPage(_this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent);
                _this.StReferralComponent = new referral_1.StReferral(_this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StCouponCodesComponent = new coupon_codes_1.StCouponCodes();
                _this.StReplicatedSiteDetailClassConfig = new rep_site_detail_class_config_1.StReplicatedSiteDetailClassConfig();
                _this.StReplicatedSiteDetail = new rep_site_detail_1.StReplicatedSiteDetail(_this.StReplicatedSiteDetailClassConfig, _this.StGeneralMethodsComponent, _this.StObjectFormattingComponent, _this.StNotificationComponent);
                _this.StPartyBannerInfoComponent = new party_banner_info_1.StPartyBannerInfo(_this.StObjectFormattingComponent);
                _this.StPartyService = new party_service_1.StPartyService(_this.StObjectFormattingComponent);
                _this.StPartyComponent = new party_1.StParty(_this.StObjectFormattingComponent, _this.StPartyService, _this.StCartComponent);
                _this.StPartyCheckComponent = new party_check_1.StPartyCheck(_this.StObjectFormattingComponent);
                _this.StHeaderComponent = new header_1.StHeader(_this.StObjectFormattingComponent);
                _this.StFreeShippingComponent = new free_shipping_1.StFreeShipping(_this.StGeneralMethodsComponent, _this.StCartComponent, _this.StFreeSampleComponent);
                _this.StOverideLoginComponent = new customers_login_1.StOverideLogin(_this.StGeneralMethodsComponent, _this.StNotificationComponent);
                _this.StShoppingOnBehalfComponent = new shopping_on_behalf_1.StShoppingOnBehalf();
                _this.StCreditLedger = new credit_ledger_1.StCreditLedger(_this.StCurrencyComponent);
                _this.StConsultantDiscountBannerComponent = new consultant_discount_banner_1.StConsultantDiscountBanner(_this.StGeneralMethodsComponent, _this.StCartComponent);
                _this.StNewsLetterComponent = new newsletter_popup_1.StNewsletterPopup();
                _this.StCatalogPageComponent = new product_category_1.StCatalogPage(_this.StObjectFormattingComponent);
            };
            this.hierarchy = function(appName) {
                var hierarchy = [ _this.DiContainerPublicComponent, _this.StStaticComponent ];
                switch (appName) {
                  case "main":
                    hierarchy = hierarchy.concat([ _this.StBackofficeSSOComponent, _this.StAuthComponent, _this.StAutoApplyPromoComponent, _this.StWebAliasComponent, _this.StSearchSponsorGuardComponent, _this.StSearchSponsorComponent, _this.StReferralComponent, _this.StPartyComponent, _this.StPartyService, _this.StPartyCheckComponent, _this.StPartyBannerInfoComponent, _this.StHeaderComponent, _this.StFreeShippingComponent, _this.StFreeSampleComponent, _this.StSampleSetComponent, _this.StCartGuardComponent, _this.StCartInterceptor, _this.StPrefilCart, _this.StMarketTypeLoader, _this.StShoppingOnBehalfComponent, _this.StConsultantDiscountBannerComponent, _this.StNewsLetterComponent, _this.StCatalogPageComponent ]);
                    break;

                  case "account":
                    hierarchy = hierarchy.concat([ _this.StAccountComponent, _this.StAccountNavComponent, _this.StAccountWebAliasEditComponent, _this.StAccountPersonalSiteComponent, _this.StAccountAddressesComponent, _this.StAccountPersonalInfoComponent, _this.StAccountOrderHistoryComponent, _this.StCouponCodesComponent, _this.StCreditLedger, _this.StOrderHistoryComponent ]);
                    break;

                  case "account-login":
                    hierarchy = hierarchy.concat([ _this.StAccountLoginComponent, _this.StOverideLoginComponent ]);
                    break;

                  case "account-register":
                    hierarchy = hierarchy.concat([ _this.StAccountRegisterComponent ]);
                    break;

                  case "reset-password":
                    hierarchy = hierarchy.concat([ _this.StResetPasswordComponent ]);
                    break;

                  case "enrollment":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentComponent, _this.StEnrollmentReviewComponent, _this.StEnrollmentNavComponent, _this.StEnrollmentAccountDetailsHelpersComponent, _this.StEnrollmentBusinessDetailsHelpersComponent ]);
                    break;

                  case "enrollment-account":
                    hierarchy = hierarchy.concat([ _this.StEnrollmentAccountComponent, _this.StEnrollmentRepeatPasswordValidationComponent ]);
                    break;

                  case "checkout":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "representative-redirect-page":
                    hierarchy = hierarchy.concat([ _this.StRepresentativeRedirectComponent, _this.StRepresentativeRedirectClassConfigComponent, _this.StGeneralMethodsComponent ]);
                    break;

                  case "enrollment-thank-you":
                    hierarchy = hierarchy.concat([]);
                    break;

                  case "rep-site-detail":
                    hierarchy = hierarchy.concat([ _this.StReplicatedSiteDetail, _this.StReplicatedSiteDetailClassConfig ]);
                    break;

                  default:
                    console.error("Unrecognized app provided to st-app. App name: " + appName);
                }
                return hierarchy;
            };
            this.components();
        }
        Object.defineProperty(StAppDIConfig, "Instance", {
            get: function() {
                return this._instance || (this._instance = new this());
            },
            enumerable: false,
            configurable: true
        });
        return StAppDIConfig;
    }();
    exports.StAppDIConfig = StAppDIConfig;
});

define("core/shopify-app/st-modules/_di-container/di.container", [ "require", "exports", "_shopify.app.di.container", "core/shopify-app/st-modules/_di-container/di.container.setup" ], function(require, exports, _shopify_app_di_container_1, di_container_setup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StDIContainer = void 0;
    var StDIContainer = function() {
        function StDIContainer() {
            this.className = "DI";
        }
        StDIContainer.run = function(appName) {
            new di_container_setup_1.StDIContainerSetup(appName, _shopify_app_di_container_1.StAppDIConfig);
        };
        return StDIContainer;
    }();
    exports.StDIContainer = StDIContainer;
});

define("core/shopify-app/st-modules/_general-methods/init-retry", [ "require", "exports", "core/shopify-app/st-modules/_static/static" ], function(require, exports, static_4) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StInitRetry = void 0;
    var StInitRetry = function() {
        function StInitRetry() {
            var _this_1 = this;
            this.className = "InitRetry";
            this.recursiveInitRetry = 0;
            this.timeout = 200;
            this.init = function() {};
            this.initWithCondition = function(params) {
                var _this = _this_1;
                var def = {
                    conditionGeneratorParams: [],
                    callbackParams: [],
                    noOfRetries: 6
                };
                var completeParams = __assign(__assign({}, def), params);
                var initCondition = completeParams.conditionGenerator.apply(_this, completeParams.conditionGeneratorParams);
                if (initCondition) {
                    completeParams.callback.apply(_this, completeParams.callbackParams);
                } else {
                    setTimeout(function() {
                        if (_this.recursiveInitRetry < completeParams.noOfRetries) {
                            _this.recursiveInitRetry++;
                            _this.initWithCondition(completeParams);
                        }
                    }, _this_1.timeout);
                }
            };
            this.endpoint = static_4.StStatic.Instance().obtainStaticEndpoints();
        }
        StInitRetry.Instance = function() {
            return this._instance || (this._instance = new this());
        };
        return StInitRetry;
    }();
    exports.StInitRetry = StInitRetry;
});

define("core/shopify-app/st-modules/_general-methods/shopify-ajax", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_85) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StShopifyAjax = void 0;
    var StShopifyAjax = function(_super) {
        __extends(StShopifyAjax, _super);
        function StShopifyAjax() {
            var _this = _super.call(this, arguments) || this;
            _this.className = "ShopifyAjax";
            _this.updateCartAttributes = function(attributes, callback, callbackParams) {
                if (callback === void 0) {
                    callback = function() {};
                }
                if (callbackParams === void 0) {
                    callbackParams = [];
                }
                if (!!attributes) {
                    var fnReference_1 = _this;
                    var request_2 = new XMLHttpRequest();
                    request_2.open("POST", "/cart/update.js", true);
                    request_2.withCredentials = true;
                    request_2.setRequestHeader("Content-Type", "application/json");
                    request_2.onreadystatechange = function() {
                        if (request_2.readyState === 4) {
                            try {
                                var resp = JSON.parse(request_2.response);
                                callbackParams.unshift(resp);
                                callback.apply(fnReference_1, callbackParams);
                            } catch (e) {
                                console.error(e);
                                console.error("Failed to update shopify cart attributes!");
                            }
                        }
                    };
                    request_2.send(JSON.stringify({
                        attributes: attributes
                    }));
                }
            };
            return _this;
        }
        return StShopifyAjax;
    }(st_module_85.StModule);
    exports.StShopifyAjax = StShopifyAjax;
});

define("core/shopify-app/st-modules/enrollment/enrollment-cleanup-checkout", [ "require", "exports", "core/shopify-app/st-modules/_di-container/st.module" ], function(require, exports, st_module_86) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.StEnrollmentCleanupCheckout = void 0;
    var StEnrollmentCleanupCheckout = function(_super) {
        __extends(StEnrollmentCleanupCheckout, _super);
        function StEnrollmentCleanupCheckout(enrollmentCleanup) {
            var _this = _super.call(this, arguments) || this;
            _this.className = "StEnrollmentCleanupCheckout";
            _this.init = function() {
                _this.enrollmentCleanup.clearCartAttributes();
            };
            _this.enrollmentCleanup = enrollmentCleanup;
            return _this;
        }
        return StEnrollmentCleanupCheckout;
    }(st_module_86.StModule);
    exports.StEnrollmentCleanupCheckout = StEnrollmentCleanupCheckout;
});

(function() {
    "use strict";
    class StApp extends HTMLElement {
        static get observedAttributes() {
            return [ "app" ];
        }
        constructor() {
            super();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "app" && oldValue !== newValue) {
                this.initApp(newValue);
            }
        }
        initApp(appName) {
            require([ "core/shopify-app/st-modules/_di-container/di.container" ], function(module) {
                module.StDIContainer.run(appName);
            });
        }
    }
    customElements.define("st-app", StApp);
})();

window.define = null;